(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[990],{

/***/ 5794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ Navigation; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/events/index.js
var events = __webpack_require__(6322);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 3 modules
var CSSTransition = __webpack_require__(6743);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-controllable/index.js
var use_controllable = __webpack_require__(9276);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-unique-id/index.js
var use_unique_id = __webpack_require__(6081);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/keycode.js
var keycode = __webpack_require__(6221);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/expandable-section/styles.scoped.css
var styles_scoped = __webpack_require__(2457);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/expandable-section/styles.css.js

/* harmony default export */ var styles_css = ({
    "content-enter": "awsui_content-enter_gwq0h_19ecb_97",
    "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_gwq0h_19ecb_1",
    "trigger-expanded": "awsui_trigger-expanded_gwq0h_19ecb_119",
    "icon": "awsui_icon_gwq0h_19ecb_133",
    "root": "awsui_root_gwq0h_19ecb_151",
    "expanded": "awsui_expanded_gwq0h_19ecb_169",
    "icon-container": "awsui_icon-container_gwq0h_19ecb_173",
    "trigger": "awsui_trigger_gwq0h_19ecb_119",
    "trigger-default": "awsui_trigger-default_gwq0h_19ecb_188",
    "trigger-footer": "awsui_trigger-footer_gwq0h_19ecb_191",
    "trigger-navigation": "awsui_trigger-navigation_gwq0h_19ecb_197",
    "trigger-container": "awsui_trigger-container_gwq0h_19ecb_209",
    "header": "awsui_header_gwq0h_19ecb_219",
    "header-container": "awsui_header-container_gwq0h_19ecb_222",
    "header-container-button": "awsui_header-container-button_gwq0h_19ecb_238",
    "header-navigation": "awsui_header-navigation_gwq0h_19ecb_246",
    "content": "awsui_content_gwq0h_19ecb_97",
    "content-default": "awsui_content-default_gwq0h_19ecb_282",
    "content-footer": "awsui_content-footer_gwq0h_19ecb_285",
    "content-expanded": "awsui_content-expanded_gwq0h_19ecb_288",
    "focusable": "awsui_focusable_gwq0h_19ecb_292"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/container/internal.js + 1 modules
var internal = __webpack_require__(7887);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/expandable-section/expandable-section-container.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var ExpandableSectionContainer = function(_a) {
    var className = _a.className, children = _a.children, header = _a.header, variant = _a.variant, expanded = _a.expanded, disableContentPaddings = _a.disableContentPaddings, __internalRootRef = _a.__internalRootRef, rest = (0,tslib_es6/* __rest */._T)(_a, [
        "className",
        "children",
        "header",
        "variant",
        "expanded",
        "disableContentPaddings",
        "__internalRootRef"
    ]);
    if (variant === "container") {
        return /*#__PURE__*/ react.createElement(internal/* default */.Z, (0,tslib_es6/* __assign */.pi)({}, rest, {
            className: className,
            header: header,
            variant: "default",
            disableContentPaddings: disableContentPaddings || !expanded,
            disableHeaderPaddings: true,
            __hiddenContent: !expanded,
            __internalRootRef: __internalRootRef
        }), children);
    }
    return /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({
        className: className
    }, rest, {
        ref: __internalRootRef
    }), header, children);
}; //# sourceMappingURL=expandable-section-container.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/focus-visible/index.js
var focus_visible = __webpack_require__(9297);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/icon/internal.js + 2 modules
var icon_internal = __webpack_require__(776);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/header/internal.js + 1 modules
var header_internal = __webpack_require__(8782);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/screenreader-only/index.js + 1 modules
var screenreader_only = __webpack_require__(1304);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/is-development.js
var is_development = __webpack_require__(5856);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/logging.js
var logging = __webpack_require__(3742);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/expandable-section/expandable-section-header.js











var ExpandableDefaultHeader = function(_a) {
    var id = _a.id, className = _a.className, onClick = _a.onClick, ariaLabel = _a.ariaLabel, ariaControls = _a.ariaControls, expanded = _a.expanded, children = _a.children, icon = _a.icon, onKeyUp = _a.onKeyUp, onKeyDown = _a.onKeyDown;
    var focusVisible = (0,focus_visible/* default */.Z)();
    return /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({
        id: id,
        role: "button",
        className: className,
        tabIndex: 0,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        onClick: onClick,
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": expanded
    }, focusVisible), /*#__PURE__*/ react.createElement("div", {
        className: styles_css["icon-container"]
    }, icon), children);
};
var ExpandableNavigationHeader = function(_a) {
    var id = _a.id, className = _a.className, onClick = _a.onClick, ariaLabelledBy = _a.ariaLabelledBy, ariaLabel = _a.ariaLabel, ariaControls = _a.ariaControls, expanded = _a.expanded, children = _a.children, icon = _a.icon;
    var focusVisible = (0,focus_visible/* default */.Z)();
    return /*#__PURE__*/ react.createElement("div", {
        id: id,
        className: className,
        onClick: onClick
    }, /*#__PURE__*/ react.createElement("button", (0,tslib_es6/* __assign */.pi)({
        className: styles_css["icon-container"],
        "aria-labelledby": ariaLabelledBy,
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": expanded
    }, focusVisible), icon), children);
};
var ExpandableContainerHeader = function(_a) {
    var id = _a.id, className = _a.className, onClick = _a.onClick, ariaLabel = _a.ariaLabel, ariaControls = _a.ariaControls, expanded = _a.expanded, children = _a.children, icon = _a.icon, headerDescription = _a.headerDescription, headerCounter = _a.headerCounter, headingTagOverride = _a.headingTagOverride, onKeyUp = _a.onKeyUp, onKeyDown = _a.onKeyDown;
    var focusVisible = (0,focus_visible/* default */.Z)();
    var screenreaderContentId = (0,use_unique_id/* generateUniqueId */.l)("expandable-section-header-content-");
    return /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({
        id: id,
        className: className,
        onClick: onClick
    }, focusVisible), /*#__PURE__*/ react.createElement(header_internal/* default */.Z, {
        variant: "h2",
        description: headerDescription,
        counter: headerCounter,
        headingTagOverride: headingTagOverride
    }, /*#__PURE__*/ react.createElement("span", {
        className: styles_css["header-container-button"],
        role: "button",
        tabIndex: 0,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabel ? undefined : screenreaderContentId,
        "aria-controls": ariaControls,
        "aria-expanded": expanded
    }, /*#__PURE__*/ react.createElement("span", {
        className: styles_css["icon-container"]
    }, icon), /*#__PURE__*/ react.createElement("span", null, children))), /*#__PURE__*/ react.createElement(screenreader_only/* default */.Z, {
        id: screenreaderContentId
    }, children, " ", headerCounter, " ", headerDescription));
};
var ExpandableSectionHeader = function(_a) {
    var id = _a.id, className = _a.className, variant = _a.variant, header = _a.header, headerText = _a.headerText, headerDescription = _a.headerDescription, headerCounter = _a.headerCounter, headingTagOverride = _a.headingTagOverride, expanded = _a.expanded, ariaControls = _a.ariaControls, ariaLabel = _a.ariaLabel, ariaLabelledBy = _a.ariaLabelledBy, onKeyUp = _a.onKeyUp, onKeyDown = _a.onKeyDown, onClick = _a.onClick;
    var icon = /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
        size: variant === "container" ? "medium" : "normal",
        className: (0,clsx_m/* default */.Z)(styles_css.icon, expanded && styles_css.expanded),
        name: "caret-down-filled"
    });
    var defaultHeaderProps = {
        id: id,
        icon: icon,
        expanded: expanded,
        ariaControls: ariaControls,
        ariaLabel: ariaLabel,
        onClick: onClick
    };
    var triggerClassName = (0,clsx_m/* default */.Z)(styles_css.trigger, styles_css["trigger-".concat(variant)], expanded && styles_css["trigger-expanded"]);
    if (variant === "navigation") {
        return /*#__PURE__*/ react.createElement(ExpandableNavigationHeader, (0,tslib_es6/* __assign */.pi)({
            className: (0,clsx_m/* default */.Z)(className, triggerClassName),
            ariaLabelledBy: ariaLabelledBy
        }, defaultHeaderProps), headerText !== null && headerText !== void 0 ? headerText : header);
    }
    if (variant === "container" && headerText) {
        return /*#__PURE__*/ react.createElement(ExpandableContainerHeader, (0,tslib_es6/* __assign */.pi)({
            className: (0,clsx_m/* default */.Z)(className, triggerClassName, expanded && styles_css.expanded),
            headerDescription: headerDescription,
            headerCounter: headerCounter,
            headingTagOverride: headingTagOverride,
            onKeyUp: onKeyUp,
            onKeyDown: onKeyDown
        }, defaultHeaderProps), headerText);
    }
    if (variant === "container" && header && is_development/* isDevelopment */.y) {
        (0,logging/* warnOnce */.O)("ExpandableSection", "Use `headerText` instead of `header` to provide the button within the heading for a11y.");
    }
    return /*#__PURE__*/ react.createElement(ExpandableDefaultHeader, (0,tslib_es6/* __assign */.pi)({
        className: (0,clsx_m/* default */.Z)(className, triggerClassName, styles_css.focusable, expanded && styles_css.expanded),
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown
    }, defaultHeaderProps), headerText !== null && headerText !== void 0 ? headerText : header);
}; //# sourceMappingURL=expandable-section-header.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/expandable-section/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0











function InternalExpandableSection(_a) {
    var controlledExpanded = _a.expanded, defaultExpanded = _a.defaultExpanded, onChange = _a.onChange, _b = _a.variant, variant = _b === void 0 ? "default" : _b, children = _a.children, header = _a.header, headerText = _a.headerText, headerCounter = _a.headerCounter, headerDescription = _a.headerDescription, headingTagOverride = _a.headingTagOverride, disableContentPaddings = _a.disableContentPaddings, headerAriaLabel = _a.headerAriaLabel, __internalRootRef = _a.__internalRootRef, props = (0,tslib_es6/* __rest */._T)(_a, [
        "expanded",
        "defaultExpanded",
        "onChange",
        "variant",
        "children",
        "header",
        "headerText",
        "headerCounter",
        "headerDescription",
        "headingTagOverride",
        "disableContentPaddings",
        "headerAriaLabel",
        "__internalRootRef"
    ]);
    var ref = (0,react.useRef)(null);
    var controlId = (0,use_unique_id/* useUniqueId */.L)();
    var triggerControlId = "".concat(controlId, "-trigger");
    var baseProps = (0,base_component/* getBaseProps */.j)(props);
    var _c = (0,use_controllable/* useControllable */.q)(controlledExpanded, onChange, defaultExpanded, {
        componentName: "ExpandableSection",
        controlledProp: "expanded",
        changeHandler: "onChange"
    }), expanded = _c[0], setExpanded = _c[1];
    var onExpandChange = (0,react.useCallback)(function(expanded) {
        setExpanded(expanded);
        (0,events/* fireNonCancelableEvent */.B4)(onChange, {
            expanded: expanded
        });
    }, [
        onChange,
        setExpanded
    ]);
    var onClick = (0,react.useCallback)(function() {
        onExpandChange(!expanded);
    }, [
        onExpandChange,
        expanded
    ]);
    var onKeyUp = (0,react.useCallback)(function(event) {
        var interactionKeys = [
            keycode/* KeyCode.enter */.V.enter,
            keycode/* KeyCode.space */.V.space
        ];
        if (interactionKeys.indexOf(event.keyCode) !== -1) {
            onExpandChange(!expanded);
        }
    }, [
        onExpandChange,
        expanded
    ]);
    var onKeyDown = (0,react.useCallback)(function(event) {
        if (event.keyCode === keycode/* KeyCode.space */.V.space) {
            // Prevent the page from scrolling when toggling the component with the space bar.
            event.preventDefault();
        }
    }, []);
    var triggerProps = {
        ariaControls: controlId,
        ariaLabel: headerAriaLabel,
        ariaLabelledBy: headerAriaLabel ? undefined : triggerControlId,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        onClick: onClick
    };
    return /*#__PURE__*/ react.createElement(ExpandableSectionContainer, (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        expanded: expanded,
        className: (0,clsx_m/* default */.Z)(baseProps.className, styles_css.root),
        variant: variant,
        disableContentPaddings: disableContentPaddings,
        header: /*#__PURE__*/ react.createElement(ExpandableSectionHeader, (0,tslib_es6/* __assign */.pi)({
            id: triggerControlId,
            className: (0,clsx_m/* default */.Z)(styles_css.header, styles_css["header-".concat(variant)]),
            variant: variant,
            expanded: !!expanded,
            header: header,
            headerText: headerText,
            headerDescription: headerDescription,
            headerCounter: headerCounter,
            headingTagOverride: headingTagOverride
        }, triggerProps)),
        __internalRootRef: __internalRootRef
    }), /*#__PURE__*/ react.createElement(CSSTransition/* default */.Z, {
        "in": expanded,
        timeout: 30,
        classNames: {
            enter: styles_css["content-enter"]
        },
        nodeRef: ref
    }, /*#__PURE__*/ react.createElement("div", {
        id: controlId,
        ref: ref,
        className: (0,clsx_m/* default */.Z)(styles_css.content, styles_css["content-".concat(variant)], expanded && styles_css["content-expanded"]),
        role: "group",
        "aria-label": triggerProps.ariaLabel,
        "aria-labelledby": triggerProps.ariaLabelledBy
    }, children)));
} //# sourceMappingURL=internal.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/side-navigation/styles.scoped.css
var side_navigation_styles_scoped = __webpack_require__(6931);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/side-navigation/styles.css.js

/* harmony default export */ var side_navigation_styles_css = ({
    "root": "awsui_root_l0dv0_18rr4_93",
    "header": "awsui_header_l0dv0_18rr4_107",
    "header-link": "awsui_header-link_l0dv0_18rr4_112",
    "header-link--has-logo": "awsui_header-link--has-logo_l0dv0_18rr4_120",
    "header-link-text": "awsui_header-link-text_l0dv0_18rr4_120",
    "header-logo": "awsui_header-logo_l0dv0_18rr4_124",
    "header-logo--stretched": "awsui_header-logo--stretched_l0dv0_18rr4_130",
    "list-container": "awsui_list-container_l0dv0_18rr4_135",
    "list": "awsui_list_l0dv0_18rr4_135",
    "list-variant-root": "awsui_list-variant-root_l0dv0_18rr4_145",
    "list-variant-expandable-link-group": "awsui_list-variant-expandable-link-group_l0dv0_18rr4_151",
    "list-item": "awsui_list-item_l0dv0_18rr4_155",
    "section": "awsui_section_l0dv0_18rr4_161",
    "expandable-link-group": "awsui_expandable-link-group_l0dv0_18rr4_162",
    "section-header": "awsui_section-header_l0dv0_18rr4_175",
    "link": "awsui_link_l0dv0_18rr4_180",
    "link-active": "awsui_link-active_l0dv0_18rr4_187",
    "info": "awsui_info_l0dv0_18rr4_219",
    "external-icon": "awsui_external-icon_l0dv0_18rr4_223",
    "divider": "awsui_divider_l0dv0_18rr4_227",
    "divider-default": "awsui_divider-default_l0dv0_18rr4_232",
    "divider-header": "awsui_divider-header_l0dv0_18rr4_236"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/side-navigation/util.js

function hasActiveLink(items, activeHref) {
    for(var _i = 0, items_1 = items; _i < items_1.length; _i++){
        var item = items_1[_i];
        if ((item.type === "link" || item.type === "link-group" || item.type === "expandable-link-group") && item.href === activeHref) {
            return true;
        }
        if ((item.type === "section" || item.type === "link-group" || item.type === "expandable-link-group") && hasActiveLink(item.items, activeHref)) {
            return true;
        }
    }
    return false;
}
function generateExpandableItemsMapping(items, mapping, expandableParents) {
    if (mapping === void 0) {
        mapping = new WeakMap();
    }
    if (expandableParents === void 0) {
        expandableParents = [];
    }
    items.forEach(function(item) {
        var nextLevelParents = expandableParents.slice();
        if (item.type === "section" || item.type === "expandable-link-group") {
            mapping.set(item, expandableParents);
            nextLevelParents.unshift(item);
        }
        if (item.type === "section" || item.type === "link-group" || item.type === "expandable-link-group") {
            generateExpandableItemsMapping(item.items, mapping, nextLevelParents);
        }
    });
    return mapping;
}
function checkDuplicateHrefs(items) {
    var hrefs = new Set();
    var queue = items.slice();
    while(queue.length > 0){
        // We just checked that there's items in the queue.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var item = queue.shift();
        // Check duplicated hrefs
        if ("href" in item) {
            if (hrefs.has(item.href)) {
                (0,logging/* warnOnce */.O)("SideNavigation", 'duplicate href in "'.concat(item.text, '": ').concat(item.href));
            }
            hrefs.add(item.href);
        }
        if ("items" in item) {
            queue.push.apply(queue, item.items);
        }
    }
} //# sourceMappingURL=util.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/check-safe-url.js
var check_safe_url = __webpack_require__(2903);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/side-navigation/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0









function Header(_a) {
    var _b, _c;
    var definition = _a.definition, activeHref = _a.activeHref, fireFollow = _a.fireFollow;
    (0,check_safe_url/* checkSafeUrl */.J)("SideNavigation", definition.href);
    var focusVisible = (0,focus_visible/* default */.Z)();
    var onClick = (0,react.useCallback)(function(event) {
        if ((0,events/* isPlainLeftClick */.p_)(event)) {
            fireFollow(definition, event);
        }
    }, [
        fireFollow,
        definition
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("div", {
        className: side_navigation_styles_css.header
    }, /*#__PURE__*/ react.createElement("a", (0,tslib_es6/* __assign */.pi)({}, focusVisible, {
        href: definition.href,
        className: (0,clsx_m/* default */.Z)(side_navigation_styles_css["header-link"], (_b = {}, _b[side_navigation_styles_css["header-link--has-logo"]] = !!definition.logo, _b)),
        "aria-current": definition.href === activeHref ? "page" : undefined,
        onClick: onClick
    }), definition.logo && /*#__PURE__*/ react.createElement("img", (0,tslib_es6/* __assign */.pi)({
        className: (0,clsx_m/* default */.Z)(side_navigation_styles_css["header-logo"], (_c = {}, _c[side_navigation_styles_css["header-logo--stretched"]] = !definition.text, _c))
    }, definition.logo)), /*#__PURE__*/ react.createElement("span", {
        className: side_navigation_styles_css["header-link-text"]
    }, definition.text))), /*#__PURE__*/ react.createElement(Divider, {
        variant: "header"
    }));
}
function ItemList(_a) {
    var variant = _a.variant, items = _a.items, activeHref = _a.activeHref, fireChange = _a.fireChange, fireFollow = _a.fireFollow;
    return /*#__PURE__*/ react.createElement("ul", {
        className: (0,clsx_m/* default */.Z)(side_navigation_styles_css.list, side_navigation_styles_css["list-variant-".concat(variant)])
    }, items.map(function(item, i) {
        return /*#__PURE__*/ react.createElement("li", {
            key: i,
            className: side_navigation_styles_css["list-item"]
        }, item.type === "divider" && /*#__PURE__*/ react.createElement(Divider, {
            variant: "default"
        }), item.type === "link" && /*#__PURE__*/ react.createElement(Link, {
            definition: item,
            activeHref: activeHref,
            fireChange: fireChange,
            fireFollow: fireFollow
        }), item.type === "section" && /*#__PURE__*/ react.createElement(Section, {
            definition: item,
            activeHref: activeHref,
            fireChange: fireChange,
            fireFollow: fireFollow
        }), item.type === "link-group" && /*#__PURE__*/ react.createElement(LinkGroup, {
            definition: item,
            activeHref: activeHref,
            fireChange: fireChange,
            fireFollow: fireFollow
        }), item.type === "expandable-link-group" && /*#__PURE__*/ react.createElement(ExpandableLinkGroup, {
            definition: item,
            activeHref: activeHref,
            fireChange: fireChange,
            fireFollow: fireFollow
        }));
    }));
}
function Divider(_a) {
    var _b = _a.variant, variant = _b === void 0 ? "default" : _b;
    return /*#__PURE__*/ react.createElement("hr", {
        className: (0,clsx_m/* default */.Z)(side_navigation_styles_css.divider, side_navigation_styles_css["divider-".concat(variant)])
    });
}
function Link(_a) {
    var _b;
    var definition = _a.definition, expanded = _a.expanded, activeHref = _a.activeHref, fireFollow = _a.fireFollow;
    (0,check_safe_url/* checkSafeUrl */.J)("SideNavigation", definition.href);
    var isActive = definition.href === activeHref;
    var focusVisible = (0,focus_visible/* default */.Z)();
    var onClick = (0,react.useCallback)(function(event) {
        // Prevent the click event from toggling outer expandable sections.
        event.stopPropagation();
        if ((0,events/* isPlainLeftClick */.p_)(event)) {
            fireFollow(definition, event);
        }
    }, [
        fireFollow,
        definition
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("a", (0,tslib_es6/* __assign */.pi)({}, focusVisible, {
        href: definition.href,
        className: (0,clsx_m/* default */.Z)(side_navigation_styles_css.link, (_b = {}, _b[side_navigation_styles_css["link-active"]] = isActive, _b)),
        target: definition.external ? "_blank" : undefined,
        rel: definition.external ? "noopener noreferrer" : undefined,
        "aria-expanded": expanded,
        "aria-current": definition.href === activeHref ? "page" : undefined,
        onClick: onClick
    }), definition.text, definition.external && /*#__PURE__*/ react.createElement("span", {
        "aria-label": definition.externalIconAriaLabel,
        role: definition.externalIconAriaLabel ? "img" : undefined
    }, /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
        name: "external",
        className: side_navigation_styles_css["external-icon"]
    }))), definition.info && /*#__PURE__*/ react.createElement("span", {
        className: side_navigation_styles_css.info
    }, definition.info));
}
function Section(_a) {
    var _b;
    var definition = _a.definition, activeHref = _a.activeHref, fireFollow = _a.fireFollow, fireChange = _a.fireChange;
    var _c = (0,react.useState)((_b = definition.defaultExpanded) !== null && _b !== void 0 ? _b : true), expanded = _c[0], setExpanded = _c[1];
    var onExpandedChange = (0,react.useCallback)(function(e) {
        fireChange(definition, e.detail.expanded);
        setExpanded(e.detail.expanded);
    }, [
        definition,
        fireChange
    ]);
    (0,react.useEffect)(function() {
        var _a;
        setExpanded((_a = definition.defaultExpanded) !== null && _a !== void 0 ? _a : true);
    }, [
        definition
    ]);
    return /*#__PURE__*/ react.createElement(InternalExpandableSection, {
        variant: "footer",
        expanded: expanded,
        onChange: onExpandedChange,
        className: side_navigation_styles_css.section,
        headerText: definition.text
    }, /*#__PURE__*/ react.createElement(ItemList, {
        variant: "section",
        items: definition.items,
        fireFollow: fireFollow,
        fireChange: fireChange,
        activeHref: activeHref
    }));
}
function LinkGroup(_a) {
    var definition = _a.definition, activeHref = _a.activeHref, fireFollow = _a.fireFollow, fireChange = _a.fireChange;
    (0,check_safe_url/* checkSafeUrl */.J)("SideNavigation", definition.href);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Link, {
        definition: {
            type: "link",
            href: definition.href,
            text: definition.text
        },
        fireFollow: function(_, event) {
            return fireFollow(definition, event);
        },
        fireChange: fireChange,
        activeHref: activeHref
    }), /*#__PURE__*/ react.createElement(ItemList, {
        variant: "link-group",
        items: definition.items,
        fireFollow: fireFollow,
        fireChange: fireChange,
        activeHref: activeHref
    }));
}
function ExpandableLinkGroup(_a) {
    var definition = _a.definition, fireFollow = _a.fireFollow, fireChange = _a.fireChange, activeHref = _a.activeHref;
    // Check whether the definition contains an active link and memoize it to avoid
    // rechecking every time.
    var containsActiveLink = (0,react.useMemo)(function() {
        return activeHref ? hasActiveLink(definition.items, activeHref) : false;
    }, [
        activeHref,
        definition.items
    ]);
    var _b = (0,react.useState)(function() {
        var _a;
        return (_a = definition.defaultExpanded) !== null && _a !== void 0 ? _a : definition.href === activeHref || containsActiveLink;
    }), expanded = _b[0], setExpanded = _b[1];
    var _c = (0,react.useState)(), userExpanded = _c[0], setUserExpanded = _c[1];
    // Reset user expansion status when the items property is updated.
    (0,react.useEffect)(function() {
        return setUserExpanded(undefined);
    }, [
        definition
    ]);
    // By default, the expandable section is open when there's an active link inside.
    (0,react.useEffect)(function() {
        setExpanded(definition.href === activeHref || containsActiveLink);
    }, [
        definition.href,
        containsActiveLink,
        activeHref
    ]);
    // If the definition object itself is updated, reset the expansion state to default.
    (0,react.useEffect)(function() {
        if (definition.defaultExpanded !== undefined) {
            setExpanded(definition.defaultExpanded);
        }
    }, [
        definition
    ]);
    var onExpandedChange = (0,react.useCallback)(function(e) {
        fireChange(definition, e.detail.expanded);
        setUserExpanded(e.detail.expanded);
    }, [
        definition,
        fireChange
    ]);
    var onHeaderFollow = function(_, event) {
        fireFollow(definition, event);
        setUserExpanded(true);
        if (!expanded) {
            fireChange(definition, true);
        }
    };
    return /*#__PURE__*/ react.createElement(InternalExpandableSection, {
        className: side_navigation_styles_css["expandable-link-group"],
        variant: "navigation",
        expanded: userExpanded !== null && userExpanded !== void 0 ? userExpanded : expanded,
        onChange: onExpandedChange,
        headerText: /*#__PURE__*/ react.createElement(Link, {
            definition: {
                type: "link",
                href: definition.href,
                text: definition.text
            },
            expanded: userExpanded !== null && userExpanded !== void 0 ? userExpanded : expanded,
            fireFollow: onHeaderFollow,
            fireChange: fireChange,
            activeHref: activeHref
        })
    }, /*#__PURE__*/ react.createElement(ItemList, {
        variant: "expandable-link-group",
        items: definition.items,
        fireFollow: fireFollow,
        fireChange: fireChange,
        activeHref: activeHref
    }));
} //# sourceMappingURL=internal.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/apply-display-name.js
var apply_display_name = __webpack_require__(1651);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-base-component/index.js + 2 modules
var use_base_component = __webpack_require__(4656);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/side-navigation/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0










function SideNavigation(_a) {
    var header = _a.header, activeHref = _a.activeHref, _b = _a.items, items = _b === void 0 ? [] : _b, onFollow = _a.onFollow, onChange = _a.onChange, props = (0,tslib_es6/* __rest */._T)(_a, [
        "header",
        "activeHref",
        "items",
        "onFollow",
        "onChange"
    ]);
    var __internalRootRef = (0,use_base_component/* default */.Z)("SideNavigation").__internalRootRef;
    var baseProps = (0,base_component/* getBaseProps */.j)(props);
    var parentMap = (0,react.useMemo)(function() {
        return generateExpandableItemsMapping(items);
    }, [
        items
    ]);
    if (is_development/* isDevelopment */.y) {
        // This code should be wiped in production anyway.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0,react.useEffect)(function() {
            return checkDuplicateHrefs(items);
        }, [
            items
        ]);
    }
    var onChangeHandler = (0,react.useCallback)(function(item, expanded) {
        // generateExpandableItemsMapping walks through the entire tree, so we're certain about getting a value.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0,events/* fireNonCancelableEvent */.B4)(onChange, {
            item: item,
            expanded: expanded,
            expandableParents: parentMap.get(item)
        });
    }, [
        onChange,
        parentMap
    ]);
    var onFollowHandler = (0,react.useCallback)(function(item, sourceEvent) {
        (0,events/* fireCancelableEvent */.y1)(onFollow, item, sourceEvent);
    }, [
        onFollow
    ]);
    return /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        className: (0,clsx_m/* default */.Z)(side_navigation_styles_css.root, baseProps.className),
        ref: __internalRootRef
    }), header && /*#__PURE__*/ react.createElement(Header, {
        definition: header,
        activeHref: activeHref,
        fireChange: onChangeHandler,
        fireFollow: onFollowHandler
    }), items && /*#__PURE__*/ react.createElement("div", {
        className: side_navigation_styles_css["list-container"]
    }, /*#__PURE__*/ react.createElement(ItemList, {
        variant: "root",
        items: items,
        fireFollow: onFollowHandler,
        fireChange: onChangeHandler,
        activeHref: activeHref
    })));
}
(0,apply_display_name/* applyDisplayName */.b)(SideNavigation, "SideNavigation"); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/react-focus-lock/dist/es2015/index.js + 31 modules
var es2015 = __webpack_require__(3299);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-merge-refs/index.js
var use_merge_refs = __webpack_require__(5912);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/button/internal.js + 6 modules
var button_internal = __webpack_require__(8145);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/portal/index.js
var portal = __webpack_require__(1712);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/container-queries/use-container-breakpoints.js
var use_container_breakpoints = __webpack_require__(8289);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-visual-mode/index.js
var use_visual_mode = __webpack_require__(753);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/modal/styles.scoped.css
var modal_styles_scoped = __webpack_require__(4200);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/modal/styles.css.js

/* harmony default export */ var modal_styles_css = ({
    "dialog": "awsui_dialog_1d2i7_1q6b4_105",
    "modal-slide-up": "awsui_modal-slide-up_1d2i7_1q6b4_1",
    "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1d2i7_1q6b4_1",
    "refresh": "awsui_refresh_1d2i7_1q6b4_128",
    "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_1d2i7_1q6b4_1",
    "root": "awsui_root_1d2i7_1q6b4_161",
    "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_1d2i7_1q6b4_1",
    "hidden": "awsui_hidden_1d2i7_1q6b4_224",
    "focus-lock": "awsui_focus-lock_1d2i7_1q6b4_228",
    "small": "awsui_small_1d2i7_1q6b4_246",
    "medium": "awsui_medium_1d2i7_1q6b4_249",
    "large": "awsui_large_1d2i7_1q6b4_252",
    "max": "awsui_max_1d2i7_1q6b4_255",
    "breakpoint-xs": "awsui_breakpoint-xs_1d2i7_1q6b4_255",
    "container": "awsui_container_1d2i7_1q6b4_260",
    "content": "awsui_content_1d2i7_1q6b4_284",
    "no-paddings": "awsui_no-paddings_1d2i7_1q6b4_287",
    "header": "awsui_header_1d2i7_1q6b4_291",
    "header--text": "awsui_header--text_1d2i7_1q6b4_298",
    "footer": "awsui_footer_1d2i7_1q6b4_302",
    "dismiss-control": "awsui_dismiss-control_1d2i7_1q6b4_312",
    "modal-open": "awsui_modal-open_1d2i7_1q6b4_316"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/calculate-once.js
var calculate_once = __webpack_require__(4014);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/utils/browser-scrollbar-size.js
/*
 * ** Detect scrollbar width (blog post); version N/A -- https://davidwalsh.name/detect-scrollbar-width
 *
 * MIT License
 *
 * Copyright (c) 2007-2021 David Walsh
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ /* eslint-disable header/header */ 
var browserScrollbarSize = (0,calculate_once/* calculateOnce */.k)(function() {
    if (typeof document === "undefined") {
        return {
            width: 0,
            height: 0
        };
    }
    var scrollDiv = document.createElement("div");
    scrollDiv.style.overflow = "scroll";
    scrollDiv.style.height = "100px";
    scrollDiv.style.width = "100px";
    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    scrollDiv.style.left = "-9999px";
    document.body.appendChild(scrollDiv);
    var width = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    var height = scrollDiv.offsetHeight - scrollDiv.clientHeight;
    document.body.removeChild(scrollDiv);
    return {
        width: width,
        height: height
    };
}); //# sourceMappingURL=browser-scrollbar-size.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/modal/body-scroll.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var initialBodyPaddingRightStyle = undefined;
function disableBodyScrolling() {
    setBodyScrollbarPadding();
    document.body.classList.add(modal_styles_css["modal-open"]);
}
function enableBodyScrolling() {
    document.body.classList.remove(modal_styles_css["modal-open"]);
    restoreBodyScrollbarPadding();
}
function setBodyScrollbarPadding() {
    if (bodyHasScrollbar()) {
        initialBodyPaddingRightStyle = document.body.style.paddingRight;
        var initialBodyPaddingRight = computedBodyPaddingRightPixels();
        var scrollbarWidth = browserScrollbarSize().width;
        var newBodyPaddingRight = initialBodyPaddingRight + scrollbarWidth;
        document.body.style.paddingRight = newBodyPaddingRight + "px";
    }
}
function computedBodyPaddingRightPixels() {
    return parseInt(window.getComputedStyle(document.body).paddingRight, 10);
}
function restoreBodyScrollbarPadding() {
    if (initialBodyPaddingRightStyle) {
        document.body.style.setProperty("padding-right", initialBodyPaddingRightStyle);
    } else {
        document.body.style.removeProperty("padding-right");
    }
    initialBodyPaddingRightStyle = undefined;
}
function bodyHasScrollbar() {
    // Unfortunately this difference doesn't appear to match the scrollbar width during testing,
    // otherwise we could remove browserScrollbarSize().  Bootstrap also doesn't use this difference
    // directly.
    return document.body.clientWidth < window.innerWidth;
} //# sourceMappingURL=body-scroll.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/focus-lock/utils.js
var utils = __webpack_require__(5500);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/modal/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
















function InternalModal(_a) {
    var _b, _c;
    var size = _a.size, visible = _a.visible, closeAriaLabel = _a.closeAriaLabel, header = _a.header, children = _a.children, footer = _a.footer, disableContentPaddings = _a.disableContentPaddings, onDismiss = _a.onDismiss, modalRoot = _a.modalRoot, _d = _a.__internalRootRef, __internalRootRef = _d === void 0 ? null : _d, rest = (0,tslib_es6/* __rest */._T)(_a, [
        "size",
        "visible",
        "closeAriaLabel",
        "header",
        "children",
        "footer",
        "disableContentPaddings",
        "onDismiss",
        "modalRoot",
        "__internalRootRef"
    ]);
    var instanceUniqueId = (0,use_unique_id/* useUniqueId */.L)();
    var headerId = "".concat(rest.id || instanceUniqueId, "-header");
    var focusLockRef = (0,react.useRef)(null);
    var lastMouseDownElementRef = (0,react.useRef)(null);
    var _e = (0,use_container_breakpoints/* useContainerBreakpoints */.d)([
        "xs"
    ]), breakpoint = _e[0], breakpointsRef = _e[1];
    var refObject = (0,react.useRef)(null);
    var mergedRef = (0,use_merge_refs/* useMergeRefs */.q)(breakpointsRef, refObject, __internalRootRef);
    var isRefresh = (0,use_visual_mode/* useVisualRefresh */.LV)();
    var baseProps = (0,base_component/* getBaseProps */.j)(rest);
    // enable body scroll and restore focus if unmounting while visible
    (0,react.useEffect)(function() {
        return function() {
            enableBodyScrolling();
        };
    }, []);
    // enable / disable body scroll
    (0,react.useEffect)(function() {
        if (visible) {
            disableBodyScrolling();
        } else {
            enableBodyScrolling();
        }
    }, [
        visible
    ]);
    // Because we hide the element with styles (and not actually detach it from DOM), we need to scroll to top
    (0,react.useEffect)(function() {
        if (visible && refObject.current) {
            refObject.current.scrollTop = 0;
        }
    }, [
        visible
    ]);
    // Imitate autoFocus=true when the modal opens but not when a focused element inside modal gets removed.
    var onFocusActivation = function() {
        var _a;
        focusLockRef.current && ((_a = (0,utils/* getFirstFocusable */.ft)(focusLockRef.current)) === null || _a === void 0 ? void 0 : _a.focus());
    };
    var dismiss = function(reason) {
        return (0,events/* fireNonCancelableEvent */.B4)(onDismiss, {
            reason: reason
        });
    };
    var onOverlayMouseDown = function(event) {
        lastMouseDownElementRef.current = event.target;
    };
    var onOverlayClick = function(event) {
        var overlay = refObject.current;
        var lastClicked = lastMouseDownElementRef.current;
        if (event.target === overlay && lastClicked === overlay) {
            dismiss("overlay");
        }
    };
    var onCloseButtonClick = function() {
        return dismiss("closeButton");
    };
    var escKeyHandler = function(event) {
        if (event.keyCode === keycode/* KeyCode.escape */.V.escape) {
            dismiss("keyboard");
        }
    };
    return /*#__PURE__*/ react.createElement(portal/* default */.Z, {
        container: modalRoot
    }, /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        className: (0,clsx_m/* default */.Z)(modal_styles_css.root, (_b = {}, _b[modal_styles_css.hidden] = !visible, _b), baseProps.className, isRefresh && modal_styles_css.refresh),
        role: "dialog",
        "aria-modal": true,
        "aria-labelledby": headerId,
        onMouseDown: onOverlayMouseDown,
        onClick: onOverlayClick,
        ref: mergedRef
    }), /*#__PURE__*/ react.createElement(es2015/* default */.ZP, {
        disabled: !visible,
        autoFocus: false,
        returnFocus: true,
        className: modal_styles_css["focus-lock"],
        ref: focusLockRef,
        onActivation: onFocusActivation
    }, /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(modal_styles_css.dialog, modal_styles_css[size], modal_styles_css["breakpoint-".concat(breakpoint)], isRefresh && modal_styles_css.refresh),
        onKeyDown: escKeyHandler,
        tabIndex: -1
    }, /*#__PURE__*/ react.createElement("div", {
        className: modal_styles_css.container
    }, /*#__PURE__*/ react.createElement("div", {
        className: modal_styles_css.header
    }, /*#__PURE__*/ react.createElement(header_internal/* default */.Z, {
        variant: "h2",
        __disableActionsWrapping: true,
        actions: /*#__PURE__*/ react.createElement(button_internal/* InternalButton */.l, {
            ariaLabel: closeAriaLabel,
            className: modal_styles_css["dismiss-control"],
            variant: "modal-dismiss",
            iconName: "close",
            formAction: "none",
            onClick: onCloseButtonClick
        })
    }, /*#__PURE__*/ react.createElement("span", {
        id: headerId,
        className: modal_styles_css["header--text"]
    }, header))), /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(modal_styles_css.content, (_c = {}, _c[modal_styles_css["no-paddings"]] = disableContentPaddings, _c))
    }, children), footer && /*#__PURE__*/ react.createElement("div", {
        className: modal_styles_css.footer
    }, footer))))));
} //# sourceMappingURL=internal.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/modal/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




function Modal(_a) {
    var _b = _a.size, size = _b === void 0 ? "medium" : _b, _c = _a.closeAriaLabel, closeAriaLabel = _c === void 0 ? "" : _c, props = (0,tslib_es6/* __rest */._T)(_a, [
        "size",
        "closeAriaLabel"
    ]);
    var baseComponentProps = (0,use_base_component/* default */.Z)("Modal");
    return /*#__PURE__*/ react.createElement(InternalModal, (0,tslib_es6/* __assign */.pi)({
        size: size,
        closeAriaLabel: closeAriaLabel
    }, props, baseComponentProps));
}
(0,apply_display_name/* applyDisplayName */.b)(Modal, "Modal"); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/box/internal.js + 1 modules
var box_internal = __webpack_require__(918);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/box/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




function Box(_a) {
    var _b = _a.variant, variant = _b === void 0 ? "div" : _b, _c = _a.margin, margin = _c === void 0 ? {} : _c, _d = _a.padding, padding = _d === void 0 ? {} : _d, props = (0,tslib_es6/* __rest */._T)(_a, [
        "variant",
        "margin",
        "padding"
    ]);
    var baseComponentProps = (0,use_base_component/* default */.Z)("Box");
    return /*#__PURE__*/ react.createElement(box_internal/* default */.Z, (0,tslib_es6/* __assign */.pi)({
        variant: variant,
        margin: margin,
        padding: padding
    }, props, baseComponentProps));
}
(0,apply_display_name/* applyDisplayName */.b)(Box, "Box"); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/space-between/index.js + 2 modules
var space_between = __webpack_require__(1456);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/button/index.js
var components_button = __webpack_require__(7140);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/form-field/index.js + 5 modules
var form_field = __webpack_require__(575);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/tiles/styles.scoped.css
var tiles_styles_scoped = __webpack_require__(5405);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/tiles/styles.css.js

/* harmony default export */ var tiles_styles_css = ({
    "column-layout": "awsui_column-layout_vj6p7_gvt2c_93",
    "grid": "awsui_grid_vj6p7_gvt2c_104",
    "grid-no-gutters": "awsui_grid-no-gutters_vj6p7_gvt2c_109",
    "grid-variant-text-grid": "awsui_grid-variant-text-grid_vj6p7_gvt2c_112",
    "grid-breakpoint-default": "awsui_grid-breakpoint-default_vj6p7_gvt2c_119",
    "grid-columns-1": "awsui_grid-columns-1_vj6p7_gvt2c_122",
    "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vj6p7_gvt2c_122",
    "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vj6p7_gvt2c_125",
    "grid-columns-2": "awsui_grid-columns-2_vj6p7_gvt2c_128",
    "grid-columns-3": "awsui_grid-columns-3_vj6p7_gvt2c_134",
    "grid-columns-4": "awsui_grid-columns-4_vj6p7_gvt2c_140",
    "grid-vertical-borders": "awsui_grid-vertical-borders_vj6p7_gvt2c_153",
    "grid-horizontal-borders": "awsui_grid-horizontal-borders_vj6p7_gvt2c_186",
    "root": "awsui_root_vj6p7_gvt2c_240",
    "tile-container": "awsui_tile-container_vj6p7_gvt2c_255",
    "has-metadata": "awsui_has-metadata_vj6p7_gvt2c_265",
    "selected": "awsui_selected_vj6p7_gvt2c_268",
    "disabled": "awsui_disabled_vj6p7_gvt2c_272",
    "columns": "awsui_columns_vj6p7_gvt2c_287",
    "column-1": "awsui_column-1_vj6p7_gvt2c_292",
    "breakpoint-xs": "awsui_breakpoint-xs_vj6p7_gvt2c_299",
    "breakpoint-xxs": "awsui_breakpoint-xxs_vj6p7_gvt2c_304",
    "column-2": "awsui_column-2_vj6p7_gvt2c_309",
    "column-3": "awsui_column-3_vj6p7_gvt2c_326",
    "column-4": "awsui_column-4_vj6p7_gvt2c_343",
    "control": "awsui_control_vj6p7_gvt2c_361",
    "no-image": "awsui_no-image_vj6p7_gvt2c_365",
    "image": "awsui_image_vj6p7_gvt2c_369"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/context/form-field-context.js
var form_field_context = __webpack_require__(2308);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/abstract-switch/index.js + 1 modules
var abstract_switch = __webpack_require__(7230);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/radio-group/styles.scoped.css
var radio_group_styles_scoped = __webpack_require__(8559);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/radio-group/styles.css.js

/* harmony default export */ var radio_group_styles_css = ({
    "root": "awsui_root_1mabk_1y9l8_93",
    "radio": "awsui_radio_1mabk_1y9l8_105",
    "radio--has-description": "awsui_radio--has-description_1mabk_1y9l8_113",
    "radio-control": "awsui_radio-control_1mabk_1y9l8_117",
    "outline": "awsui_outline_1mabk_1y9l8_125",
    "styled-circle-border": "awsui_styled-circle-border_1mabk_1y9l8_144",
    "styled-circle-disabled": "awsui_styled-circle-disabled_1mabk_1y9l8_148",
    "styled-circle-fill": "awsui_styled-circle-fill_1mabk_1y9l8_153",
    "styled-circle-checked": "awsui_styled-circle-checked_1mabk_1y9l8_159"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/radio-group/radio-button.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0







/* harmony default export */ var radio_button = (/*#__PURE__*/react.forwardRef(function RadioButton(_a, ref) {
    var _b, _c;
    var name = _a.name, label = _a.label, value = _a.value, checked = _a.checked, description = _a.description, disabled = _a.disabled, controlId = _a.controlId, onChange = _a.onChange;
    var isVisualRefresh = (0,use_visual_mode/* useVisualRefresh */.LV)();
    var radioButtonRef = (0,react.useRef)(null);
    var mergedRefs = (0,use_merge_refs/* useMergeRefs */.q)(radioButtonRef, ref);
    return /*#__PURE__*/ react.createElement(abstract_switch/* default */.Z, {
        className: (0,clsx_m/* default */.Z)(radio_group_styles_css.radio, description && radio_group_styles_css["radio--has-description"]),
        controlClassName: radio_group_styles_css["radio-control"],
        outlineClassName: radio_group_styles_css.outline,
        label: label,
        description: description,
        disabled: disabled,
        controlId: controlId,
        nativeControl: function(nativeControlProps) {
            return /*#__PURE__*/ react.createElement("input", (0,tslib_es6/* __assign */.pi)({}, nativeControlProps, {
                type: "radio",
                ref: mergedRefs,
                name: name,
                value: value,
                checked: checked,
                // empty handler to suppress React controllability warning
                onChange: function() {}
            }));
        },
        onClick: function() {
            var _a;
            (_a = radioButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            if (checked) {
                return;
            }
            (0,events/* fireNonCancelableEvent */.B4)(onChange, {
                value: value
            });
        },
        styledControl: /*#__PURE__*/ react.createElement("svg", {
            viewBox: "0 0 100 100",
            focusable: "false",
            "aria-hidden": "true"
        }, /*#__PURE__*/ react.createElement("circle", {
            className: (0,clsx_m/* default */.Z)(radio_group_styles_css["styled-circle-border"], (_b = {}, _b[radio_group_styles_css["styled-circle-disabled"]] = disabled, _b)),
            strokeWidth: isVisualRefresh ? 12 : 8,
            cx: 50,
            cy: 50,
            r: isVisualRefresh ? 44 : 46
        }), /*#__PURE__*/ react.createElement("circle", {
            className: (0,clsx_m/* default */.Z)(radio_group_styles_css["styled-circle-fill"], (_c = {}, _c[radio_group_styles_css["styled-circle-disabled"]] = disabled, _c[radio_group_styles_css["styled-circle-checked"]] = checked, _c)),
            strokeWidth: 30,
            cx: 50,
            cy: 50,
            r: 35
        }))
    });
})); //# sourceMappingURL=radio-button.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/tiles/tile.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0






var Tile = /*#__PURE__*/ react.forwardRef(function(_a, forwardedRef) {
    var _b, _c, _d, _e, _f;
    var item = _a.item, selected = _a.selected, name = _a.name, breakpoint = _a.breakpoint, onChange = _a.onChange;
    var internalRef = (0,react.useRef)(null);
    var controlId = item.controlId || "".concat(name, "-value-").concat(item.value);
    var mergedRef = (0,use_merge_refs/* useMergeRefs */.q)(internalRef, forwardedRef);
    return /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(tiles_styles_css["tile-container"], (_b = {}, _b[tiles_styles_css["has-metadata"]] = item.description || item.image, _b), (_c = {}, _c[tiles_styles_css.selected] = selected, _c), (_d = {}, _d[tiles_styles_css.disabled] = !!item.disabled, _d), tiles_styles_css["breakpoint-".concat(breakpoint)]),
        "data-value": item.value,
        onClick: function() {
            var _a;
            if (item.disabled) {
                return;
            }
            (_a = internalRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            if (!selected) {
                (0,events/* fireNonCancelableEvent */.B4)(onChange, {
                    value: item.value
                });
            }
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(tiles_styles_css.control, (_e = {}, _e[tiles_styles_css["no-image"]] = !item.image, _e))
    }, /*#__PURE__*/ react.createElement(radio_button, {
        checked: selected,
        ref: mergedRef,
        name: name,
        value: item.value,
        label: item.label,
        description: item.description,
        disabled: item.disabled,
        controlId: controlId
    })), item.image && /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(tiles_styles_css.image, (_f = {}, _f[tiles_styles_css.disabled] = !!item.disabled, _f))
    }, item.image));
}); //# sourceMappingURL=tile.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/hooks/forward-focus/radio-group.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * Focus forwarding helper for radio groups where only the first selected
 * child element should be focused.
 */ function useRadioGroupForwardFocus(forwardedRef, items, value) {
    var itemRef = (0,react.useRef)(null);
    var itemIndex = items && findIndex(items, function(item) {
        return item.value === value;
    });
    (0,react.useImperativeHandle)(forwardedRef, function() {
        return {
            focus: function() {
                var _a;
                (_a = itemRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
        };
    });
    return [
        itemRef,
        itemIndex !== undefined && itemIndex !== -1 ? itemIndex : 0
    ];
}
function findIndex(items, predicate) {
    for(var i = 0; i < items.length; i++){
        if (predicate(items[i])) {
            return i;
        }
    }
    return -1;
} //# sourceMappingURL=radio-group.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/tiles/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0










var COLUMN_TRIGGERS = [
    "default",
    "xxs",
    "xs"
];
var InternalTiles = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var value = _a.value, items = _a.items, ariaLabel = _a.ariaLabel, ariaRequired = _a.ariaRequired, columns = _a.columns, onChange = _a.onChange, _b = _a.__internalRootRef, __internalRootRef = _b === void 0 ? null : _b, rest = (0,tslib_es6/* __rest */._T)(_a, [
        "value",
        "items",
        "ariaLabel",
        "ariaRequired",
        "columns",
        "onChange",
        "__internalRootRef"
    ]);
    var baseProps = (0,base_component/* getBaseProps */.j)(rest);
    var _c = (0,form_field_context/* useFormFieldContext */.e)(rest), ariaDescribedby = _c.ariaDescribedby, ariaLabelledby = _c.ariaLabelledby;
    var generatedName = (0,use_unique_id/* useUniqueId */.L)("awsui-tiles-");
    var _d = useRadioGroupForwardFocus(ref, items, value), tileRef = _d[0], tileRefIndex = _d[1];
    var _e = (0,use_container_breakpoints/* useContainerBreakpoints */.d)(COLUMN_TRIGGERS), breakpoint = _e[0], breakpointRef = _e[1];
    var mergedRef = (0,use_merge_refs/* useMergeRefs */.q)(breakpointRef, __internalRootRef);
    var columnCount = getColumnCount(items, columns);
    return /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({
        role: "radiogroup",
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby,
        "aria-required": ariaRequired
    }, baseProps, {
        className: (0,clsx_m/* default */.Z)(baseProps.className, tiles_styles_css.root),
        ref: mergedRef
    }), /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(tiles_styles_css.columns, tiles_styles_css["column-".concat(columnCount)])
    }, items && items.map(function(item, index) {
        return /*#__PURE__*/ react.createElement(Tile, {
            ref: index === tileRefIndex ? tileRef : undefined,
            key: item.value,
            item: item,
            selected: item.value === value,
            name: generatedName,
            breakpoint: breakpoint,
            onChange: onChange
        });
    })));
});
function getColumnCount(items, columns) {
    if (columns) {
        return columns;
    }
    var nItems = items ? items.length : 0;
    var columnsLookup = {
        0: 1,
        1: 1,
        2: 2,
        4: 2,
        8: 2
    };
    return columnsLookup[nItems] || 3;
}
/* harmony default export */ var tiles_internal = (InternalTiles); //# sourceMappingURL=internal.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/tiles/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




var Tiles = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    var baseComponentProps = (0,use_base_component/* default */.Z)("Tiles");
    return /*#__PURE__*/ react.createElement(tiles_internal, (0,tslib_es6/* __assign */.pi)({
        ref: ref
    }, props, baseComponentProps));
});
(0,apply_display_name/* applyDisplayName */.b)(Tiles, "Tiles");
/* harmony default export */ var tiles = (Tiles); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./components/Navigation.tsx



function Navigation() {
    const [visible, setVisible] = (0,react.useState)(false);
    const [value, setValue] = (0,react.useState)("comfortable");
    (0,react.useEffect)(()=>{
        setValue("comfortable");
    }, []);
    const onFollowHandler = (e)=>{
        // e.preventDefault();
        e.detail.href === "#/density_settings" ? setVisible(true) : null;
    };
    const onDismissHandler = ()=>{
        setValue("comfortable");
        setVisible(false);
    };
    const onSubmit = (value)=>{
        setValue(value);
        setVisible(false);
    };
    const navItems = [
        {
            type: "link",
            text: "Dashboard",
            href: "/"
        },
        {
            text: "JSON Tools",
            type: "section",
            defaultExpanded: true,
            items: [
                {
                    type: "link",
                    text: "Base64 to JSON",
                    href: "/convert?from=base64&to=json"
                },
                {
                    type: "link",
                    text: "URL-escaped string to JSON",
                    href: "/convert?from=urlencoded&to=json"
                },
                {
                    type: "link",
                    text: "JSON to Base64",
                    href: "/convert?from=json&to=base64"
                },
                {
                    type: "link",
                    text: "JSON to URL-escaped string",
                    href: "/convert?from=json&to=urlencoded"
                }
            ]
        },
        {
            text: "String Tools",
            type: "section",
            defaultExpanded: true,
            items: [
                {
                    type: "link",
                    text: "Reverse String",
                    href: "/convert?from=text&to=reverse"
                }
            ]
        },
        {
            text: "QR Code Tools",
            type: "section",
            defaultExpanded: true,
            items: [
                {
                    type: "link",
                    text: "Generate QR Code",
                    href: "/qr"
                },
                {
                    type: "link",
                    text: "Wi-Fi QR Code",
                    href: "/qr/wifi"
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SideNavigation, {
                items: navItems,
                activeHref: "/",
                onFollow: (e)=>onFollowHandler(e)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                onDismiss: ()=>onDismissHandler(),
                visible: visible,
                size: "medium",
                closeAriaLabel: "Close modal",
                footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                    float: "right",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(space_between/* default */.Z, {
                        direction: "horizontal",
                        size: "xs",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                variant: "link",
                                onClick: ()=>onDismissHandler(),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                variant: "primary",
                                onClick: ()=>onSubmit(value),
                                children: "Confirm"
                            })
                        ]
                    })
                }),
                header: "Density settings",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_field/* default */.Z, {
                    label: "Content density",
                    description: "Choose the preferred level of content density for this console.",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tiles, {
                        onChange: (param)=>{
                            let { detail  } = param;
                            return setValue(detail.value);
                        },
                        value: value,
                        items: [
                            {
                                value: "comfortable",
                                label: "Comfortable",
                                description: "Default spacing that optimizes information consumption."
                            },
                            {
                                value: "compact",
                                label: "Compact",
                                description: "Reduced spacing that provides more visibility over content."
                            }
                        ]
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 4210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ TopNav; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./public/firekit.svg
/* harmony default export */ var firekit = ({"src":"/_next/static/media/firekit.2b4f7fd9.svg","height":50,"width":50});
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/apply-display-name.js
var apply_display_name = __webpack_require__(1651);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-base-component/index.js + 2 modules
var use_base_component = __webpack_require__(4656);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/events/index.js
var events = __webpack_require__(6322);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/visual-context/index.js
var visual_context = __webpack_require__(1469);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/portal/index.js
var portal = __webpack_require__(1712);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/focus-visible/index.js
var focus_visible = __webpack_require__(9297);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-effect-on-update.js
var use_effect_on_update = __webpack_require__(9876);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-merge-refs/index.js
var use_merge_refs = __webpack_require__(5912);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/container-queries/use-container-breakpoints.js
var use_container_breakpoints = __webpack_require__(8289);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/container-queries/use-container-query.js
var use_container_query = __webpack_require__(5382);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/top-navigation/styles.scoped.css
var styles_scoped = __webpack_require__(6589);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/top-navigation/styles.css.js

/* harmony default export */ var styles_css = ({
    "icon": "awsui_icon_k5dlb_euv96_93",
    "top-navigation": "awsui_top-navigation_k5dlb_euv96_111",
    "padding-box": "awsui_padding-box_k5dlb_euv96_122",
    "medium": "awsui_medium_k5dlb_euv96_132",
    "narrow": "awsui_narrow_k5dlb_euv96_132",
    "virtual": "awsui_virtual_k5dlb_euv96_143",
    "hidden": "awsui_hidden_k5dlb_euv96_147",
    "	": "awsui_	_k5dlb_euv96_1",
    "identity": "awsui_identity_k5dlb_euv96_159",
    "identity-link": "awsui_identity-link_k5dlb_euv96_162",
    "no-logo": "awsui_no-logo_k5dlb_euv96_179",
    "logo": "awsui_logo_k5dlb_euv96_183",
    "title": "awsui_title_k5dlb_euv96_195",
    "inputs": "awsui_inputs_k5dlb_euv96_208",
    "search": "awsui_search_k5dlb_euv96_215",
    "search-expanded": "awsui_search-expanded_k5dlb_euv96_219",
    "utilities": "awsui_utilities_k5dlb_euv96_223",
    "utility-wrapper": "awsui_utility-wrapper_k5dlb_euv96_234",
    "utility-type-button-link": "awsui_utility-type-button-link_k5dlb_euv96_255",
    "utility-type-menu-dropdown": "awsui_utility-type-menu-dropdown_k5dlb_euv96_259",
    "utility-type-button-primary-button": "awsui_utility-type-button-primary-button_k5dlb_euv96_267",
    "utility-link-icon": "awsui_utility-link-icon_k5dlb_euv96_275",
    "utility-button-external-icon": "awsui_utility-button-external-icon_k5dlb_euv96_279",
    "offset-right-none": "awsui_offset-right-none_k5dlb_euv96_283",
    "offset-right-l": "awsui_offset-right-l_k5dlb_euv96_287",
    "offset-right-xxl": "awsui_offset-right-xxl_k5dlb_euv96_291",
    "overflow-menu-drawer": "awsui_overflow-menu-drawer_k5dlb_euv96_296",
    "overflow-menu": "awsui_overflow-menu_k5dlb_euv96_296",
    "overflow-menu-header": "awsui_overflow-menu-header_k5dlb_euv96_316",
    "overflow-menu-header-text": "awsui_overflow-menu-header-text_k5dlb_euv96_323",
    "overflow-menu-header-text--secondary": "awsui_overflow-menu-header-text--secondary_k5dlb_euv96_332",
    "overflow-menu-header-text--title": "awsui_overflow-menu-header-text--title_k5dlb_euv96_338",
    "overflow-menu-back-button": "awsui_overflow-menu-back-button_k5dlb_euv96_342",
    "overflow-menu-dismiss-button": "awsui_overflow-menu-dismiss-button_k5dlb_euv96_346",
    "overflow-menu-control": "awsui_overflow-menu-control_k5dlb_euv96_350",
    "overflow-menu-list-item-utility": "awsui_overflow-menu-list-item-utility_k5dlb_euv96_365",
    "overflow-menu-control-link": "awsui_overflow-menu-control-link_k5dlb_euv96_372",
    "overflow-menu-control-expandable-menu-trigger": "awsui_overflow-menu-control-expandable-menu-trigger_k5dlb_euv96_375",
    "overflow-menu-list": "awsui_overflow-menu-list_k5dlb_euv96_365",
    "overflow-menu-list-submenu": "awsui_overflow-menu-list-submenu_k5dlb_euv96_406",
    "overflow-menu-list-item": "awsui_overflow-menu-list-item_k5dlb_euv96_365",
    "overflow-menu-list-item-icon": "awsui_overflow-menu-list-item-icon_k5dlb_euv96_414",
    "overflow-menu-list-item-text": "awsui_overflow-menu-list-item-text_k5dlb_euv96_417",
    "overflow-menu-list-item-submenu": "awsui_overflow-menu-list-item-submenu_k5dlb_euv96_424",
    "overflow-menu-list-item-dropdown-menu": "awsui_overflow-menu-list-item-dropdown-menu_k5dlb_euv96_429",
    "overflow-menu-list-item-expandable": "awsui_overflow-menu-list-item-expandable_k5dlb_euv96_432",
    "expanded": "awsui_expanded_k5dlb_euv96_440"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/top-navigation/use-top-navigation.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




// A small buffer to make calculations more lenient against browser lag or padding adjustments.
var RESPONSIVENESS_BUFFER = 20;
function useTopNavigation(_a) {
    var identity = _a.identity, search = _a.search, utilities = _a.utilities;
    // Refs and breakpoints
    var mainRef = (0,react.useRef)(null);
    var virtualRef = (0,react.useRef)(null);
    var _b = (0,use_container_breakpoints/* useContainerBreakpoints */.d)([
        "xxs",
        "s"
    ]), breakpoint = _b[0], breakpointRef = _b[1];
    // Responsiveness state
    // The component works by calculating the possible resize states that it can
    // be in, and having a state variable to track which state we're currently in.
    var hasSearch = !!search;
    var hasTitleWithLogo = identity && !!identity.logo && !!identity.title;
    var responsiveStates = (0,react.useMemo)(function() {
        return generateResponsiveStateKeys(utilities, hasSearch, hasTitleWithLogo);
    }, [
        utilities,
        hasSearch,
        hasTitleWithLogo
    ]);
    // To hide/show elements dynamically, we need to know how much space they take up,
    // even if they're not being rendered. The top navigation elements are hidden/resized
    // based on the available size or if a search bar is open, and they need to be available
    // for calculations so we know where to toggle them. So we render a second, more stable
    // top-nav off screen to do these calculations against.
    //
    // We can't "affix" these values to pixels because they can depend on spacing tokens.
    // It's easier to render all of these utilities separately rather than figuring out
    // spacing token values, icon sizes, text widths, etc.
    var _c = (0,react.useState)(), responsiveState = _c[0], setResponsiveState = _c[1];
    var recalculateFit = (0,react.useCallback)(function() {
        var _a, _b, _c, _d;
        if (!(mainRef === null || mainRef === void 0 ? void 0 : mainRef.current) || !virtualRef.current) {
            setResponsiveState(responsiveStates[0]);
            return;
        }
        // Get available width from the visible top navigation.
        var availableWidth = getContentBoxWidth(mainRef.current.querySelector(".".concat(styles_css["padding-box"])));
        if (availableWidth === 0) {
            // Likely in an SSR or Jest situation.
            setResponsiveState(responsiveStates[0]);
            return;
        }
        var sizeConfiguration = {
            hasSearch: hasSearch,
            availableWidth: availableWidth,
            // Get widths from the hidden top navigation
            fullIdentityWidth: virtualRef.current.querySelector(".".concat(styles_css.identity)).getBoundingClientRect().width,
            titleWidth: (_b = (_a = virtualRef.current.querySelector(".".concat(styles_css.title))) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) !== null && _b !== void 0 ? _b : 0,
            searchSlotWidth: (_d = (_c = virtualRef.current.querySelector(".".concat(styles_css.search))) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().width) !== null && _d !== void 0 ? _d : 0,
            searchUtilityWidth: virtualRef.current.querySelector('[data-utility-special="search"]').getBoundingClientRect().width,
            utilitiesLeftPadding: parseFloat(getComputedStyle(virtualRef.current.querySelector(".".concat(styles_css.utilities))).paddingLeft || "0px"),
            utilityWithLabelWidths: Array.prototype.slice.call(virtualRef.current.querySelectorAll('[data-utility-hide="false"]')).map(function(element) {
                return element.getBoundingClientRect().width;
            }),
            utilityWithoutLabelWidths: Array.prototype.slice.call(virtualRef.current.querySelectorAll('[data-utility-hide="true"]')).map(function(element) {
                return element.getBoundingClientRect().width;
            }),
            menuTriggerUtilityWidth: virtualRef.current.querySelector('[data-utility-special="menu-trigger"]').getBoundingClientRect().width
        };
        setResponsiveState(determineBestResponsiveState(responsiveStates, sizeConfiguration));
    }, [
        responsiveStates,
        hasSearch
    ]);
    var _d = (0,use_container_query/* useContainerQuery */.D)(function() {
        recalculateFit();
    }, [
        recalculateFit
    ]), containerQueryRef = _d[1];
    // Due to being rendered in a portal, the virtual navigation isn't rendered
    // at the same time as the main one.
    var onVirtualMount = (0,react.useCallback)(function(element) {
        virtualRef.current = element;
        recalculateFit();
    }, [
        recalculateFit
    ]);
    // Search slot expansion on small screens
    var _e = (0,react.useState)(true), isSearchMinimized = _e[0], setSearchMinimized = _e[1];
    var isSearchExpanded = !isSearchMinimized && hasSearch && (responsiveState === null || responsiveState === void 0 ? void 0 : responsiveState.hideSearch);
    // If the search was expanded, and then the screen resized so that the
    // expansion is no longer necessary. So we implicitly minimize it.
    (0,react.useEffect)(function() {
        if (!(responsiveState === null || responsiveState === void 0 ? void 0 : responsiveState.hideSearch)) {
            setSearchMinimized(true);
        }
    }, [
        responsiveState
    ]);
    // If the search is expanded after clicking on the search utility, move
    // the focus to the input. Since this is a user-controlled slot, we're just
    // assuming that it contains an input, though it's a pretty safe guess.
    (0,react.useEffect)(function() {
        var _a, _b;
        if (isSearchExpanded) {
            (_b = (_a = mainRef === null || mainRef === void 0 ? void 0 : mainRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(".".concat(styles_css.search, " input"))) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }, [
        isSearchExpanded,
        mainRef
    ]);
    var mergedMainRef = (0,use_merge_refs/* useMergeRefs */.q)(mainRef, containerQueryRef, breakpointRef);
    return {
        mainRef: mergedMainRef,
        virtualRef: onVirtualMount,
        responsiveState: responsiveState !== null && responsiveState !== void 0 ? responsiveState : responsiveStates[0],
        breakpoint: breakpoint !== null && breakpoint !== void 0 ? breakpoint : "default",
        isSearchExpanded: !!isSearchExpanded,
        onSearchUtilityClick: function() {
            return setSearchMinimized(function(isSearchMinimized) {
                return !isSearchMinimized;
            });
        }
    };
}
/**
 * Get the width of the content box (assuming the element's box-sizing is border-box).
 */ function getContentBoxWidth(element) {
    var style = getComputedStyle(element);
    return parseFloat(style.width || "0px") - parseFloat(style.paddingLeft || "0px") - parseFloat(style.paddingRight || "0px");
}
/**
 * Generates the series of responsive steps that can be performed on the header in order.
 */ function generateResponsiveStateKeys(utilities, canHideSearch, canHideTitle) {
    var states = [
        {}
    ];
    if (utilities.some(function(utility) {
        return utility.text;
    })) {
        states.push({
            hideUtilityText: true
        });
    }
    if (canHideSearch) {
        states.push({
            hideUtilityText: true,
            hideSearch: true
        });
    }
    var hiddenUtilties = [];
    for(var i = 0; i < utilities.length; i++){
        if (!utilities[i].disableUtilityCollapse) {
            hiddenUtilties.push(i);
            states.push({
                hideUtilityText: true,
                hideSearch: canHideSearch || undefined,
                hideUtilities: hiddenUtilties.length > 0 ? hiddenUtilties.slice() : undefined
            });
        }
    }
    if (canHideTitle) {
        states.push({
            hideUtilityText: true,
            hideSearch: canHideSearch || undefined,
            hideUtilities: hiddenUtilties.length > 0 ? hiddenUtilties.slice() : undefined,
            hideTitle: true
        });
    }
    return states;
}
/**
 * Determines the best responsive state configuration of the top navigation, based on the given list of possible responsive states
 * and the current sizes of all elements inside the navigation bar.
 */ function determineBestResponsiveState(possibleStates, sizes) {
    var hasSearch = sizes.hasSearch, availableWidth = sizes.availableWidth, utilitiesLeftPadding = sizes.utilitiesLeftPadding, fullIdentityWidth = sizes.fullIdentityWidth, titleWidth = sizes.titleWidth, searchSlotWidth = sizes.searchSlotWidth, searchUtilityWidth = sizes.searchUtilityWidth, utilityWithLabelWidths = sizes.utilityWithLabelWidths, utilityWithoutLabelWidths = sizes.utilityWithoutLabelWidths, menuTriggerUtilityWidth = sizes.menuTriggerUtilityWidth;
    var _loop_1 = function(state) {
        var searchWidth = hasSearch ? state.hideSearch ? searchUtilityWidth : searchSlotWidth : 0;
        var utilitiesWidth = (state.hideUtilityText ? utilityWithoutLabelWidths : utilityWithLabelWidths).filter(function(_width, i) {
            return !state.hideUtilities || state.hideUtilities.indexOf(i) === -1;
        }).reduce(function(sum, width) {
            return sum + width;
        }, 0);
        var menuTriggerWidth = state.hideUtilities ? menuTriggerUtilityWidth : 0;
        var identityWidth = state.hideTitle ? fullIdentityWidth - titleWidth : fullIdentityWidth;
        var expectedInnerWidth = identityWidth + searchWidth + utilitiesLeftPadding + utilitiesWidth + menuTriggerWidth;
        if (expectedInnerWidth <= availableWidth - RESPONSIVENESS_BUFFER) {
            return {
                value: state
            };
        }
    };
    // Iterate through each state and calculate its expected required width.
    for(var _i = 0, possibleStates_1 = possibleStates; _i < possibleStates_1.length; _i++){
        var state = possibleStates_1[_i];
        var state_1 = _loop_1(state);
        if (typeof state_1 === "object") return state_1.value;
    }
    // If nothing matches, pick the smallest possible state.
    return possibleStates[possibleStates.length - 1];
} //# sourceMappingURL=use-top-navigation.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/button/internal.js + 6 modules
var internal = __webpack_require__(8145);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/link/internal.js + 1 modules
var link_internal = __webpack_require__(8791);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/icon/internal.js + 2 modules
var icon_internal = __webpack_require__(776);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/button-dropdown/internal.js + 18 modules
var button_dropdown_internal = __webpack_require__(4699);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/button-dropdown/styles.css.js
var button_dropdown_styles_css = __webpack_require__(3284);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/menu-dropdown/styles.scoped.css
var menu_dropdown_styles_scoped = __webpack_require__(2426);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/menu-dropdown/styles.css.js

/* harmony default export */ var menu_dropdown_styles_css = ({
    "button": "awsui_button_m5h9f_10xh9_93",
    "expanded": "awsui_expanded_m5h9f_10xh9_123",
    "offset-right-none": "awsui_offset-right-none_m5h9f_10xh9_134",
    "offset-right-l": "awsui_offset-right-l_m5h9f_10xh9_137",
    "offset-right-xxl": "awsui_offset-right-xxl_m5h9f_10xh9_140",
    "text": "awsui_text_m5h9f_10xh9_162",
    "icon": "awsui_icon_m5h9f_10xh9_166"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/menu-dropdown/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0









var ButtonTrigger = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var _b;
    var iconName = _a.iconName, iconUrl = _a.iconUrl, iconAlt = _a.iconAlt, iconSvg = _a.iconSvg, badge = _a.badge, ariaLabel = _a.ariaLabel, offsetRight = _a.offsetRight, disabled = _a.disabled, expanded = _a.expanded, children = _a.children, onClick = _a.onClick;
    var focusVisible = (0,focus_visible/* default */.Z)();
    var hasIcon = iconName || iconUrl || iconSvg;
    return /*#__PURE__*/ react.createElement("button", (0,tslib_es6/* __assign */.pi)({}, focusVisible, {
        ref: ref,
        type: "button",
        className: (0,clsx_m/* default */.Z)(menu_dropdown_styles_css.button, menu_dropdown_styles_css["offset-right-".concat(offsetRight)], (_b = {}, _b[menu_dropdown_styles_css.expanded] = expanded, _b)),
        "aria-label": ariaLabel,
        "aria-expanded": !!expanded,
        "aria-haspopup": true,
        disabled: disabled,
        onClick: function(event) {
            event.preventDefault();
            onClick && onClick();
        }
    }), hasIcon && /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
        className: menu_dropdown_styles_css.icon,
        name: iconName,
        url: iconUrl,
        alt: iconAlt,
        svg: iconSvg,
        badge: badge
    }), children && /*#__PURE__*/ react.createElement("span", {
        className: menu_dropdown_styles_css.text
    }, children), children && /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
        name: "caret-down-filled",
        className: expanded ? button_dropdown_styles_css/* default.rotate-up */.Z["rotate-up"] : button_dropdown_styles_css/* default.rotate-down */.Z["rotate-down"]
    }));
});
var MenuDropdown = function(_a) {
    var iconName = _a.iconName, iconUrl = _a.iconUrl, iconAlt = _a.iconAlt, iconSvg = _a.iconSvg, badge = _a.badge, ariaLabel = _a.ariaLabel, offsetRight = _a.offsetRight, children = _a.children, props = (0,tslib_es6/* __rest */._T)(_a, [
        "iconName",
        "iconUrl",
        "iconAlt",
        "iconSvg",
        "badge",
        "ariaLabel",
        "offsetRight",
        "children"
    ]);
    var baseProps = (0,base_component/* getBaseProps */.j)(props);
    var dropdownTrigger = function(clickHandler, ref, isDisabled, isExpanded) {
        return /*#__PURE__*/ react.createElement(ButtonTrigger, {
            ref: ref,
            disabled: isDisabled,
            expanded: isExpanded,
            iconName: iconName,
            iconUrl: iconUrl,
            iconAlt: iconAlt,
            iconSvg: iconSvg,
            badge: badge,
            ariaLabel: ariaLabel,
            offsetRight: offsetRight,
            onClick: clickHandler
        }, children);
    };
    return /*#__PURE__*/ react.createElement(button_dropdown_internal/* default */.Z, (0,tslib_es6/* __assign */.pi)({}, baseProps, props, {
        variant: "navigation",
        customTriggerBuilder: dropdownTrigger,
        preferCenter: true
    }));
};
(0,apply_display_name/* applyDisplayName */.b)(MenuDropdown, "MenuDropdown");
/* harmony default export */ var menu_dropdown = (MenuDropdown); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/check-safe-url.js
var check_safe_url = __webpack_require__(2903);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/strings/join-strings.js
var join_strings = __webpack_require__(4906);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/top-navigation/parts/utility.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0









function Utility(_a) {
    var _b;
    var hideText = _a.hideText, definition = _a.definition, offsetRight = _a.offsetRight;
    var hasIcon = !!definition.iconName || !!definition.iconUrl || !!definition.iconAlt || !!definition.iconSvg;
    var shouldHideText = hideText && !definition.disableTextCollapse && hasIcon;
    var ariaLabel = (_b = definition.ariaLabel) !== null && _b !== void 0 ? _b : definition.text;
    if (definition.type === "button") {
        ariaLabel = definition.ariaLabel ? definition.ariaLabel : (0,join_strings/* joinStrings */.M)(definition.text, definition.externalIconAriaLabel);
        (0,check_safe_url/* checkSafeUrl */.J)("TopNavigation", definition.href);
        if (definition.variant === "primary-button") {
            return /*#__PURE__*/ react.createElement("span", {
                className: styles_css["offset-right-".concat(offsetRight)]
            }, /*#__PURE__*/ react.createElement(internal/* InternalButton */.l, {
                variant: "primary",
                href: definition.href,
                target: definition.external ? "_blank" : undefined,
                onClick: definition.onClick,
                ariaLabel: ariaLabel,
                iconName: definition.iconName,
                iconUrl: definition.iconUrl,
                iconAlt: definition.iconAlt,
                iconSvg: definition.iconSvg
            }, shouldHideText ? null : /*#__PURE__*/ react.createElement(react.Fragment, null, definition.text, definition.external && /*#__PURE__*/ react.createElement(react.Fragment, null, " ", /*#__PURE__*/ react.createElement("span", {
                className: (0,clsx_m/* default */.Z)(styles_css["utility-button-external-icon"], styles_css["offset-right-".concat(offsetRight)]),
                "aria-label": definition.externalIconAriaLabel,
                role: definition.externalIconAriaLabel ? "img" : undefined
            }, /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
                name: "external"
            }))))));
        } else {
            // Link
            return /*#__PURE__*/ react.createElement("span", {
                className: styles_css["offset-right-".concat(offsetRight)]
            }, /*#__PURE__*/ react.createElement(link_internal/* default */.Z, {
                variant: "top-navigation",
                href: definition.href,
                external: definition.external,
                onFollow: definition.onClick,
                ariaLabel: ariaLabel
            }, hasIcon && /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
                name: definition.iconName,
                url: definition.iconUrl,
                alt: definition.iconAlt,
                svg: definition.iconSvg,
                badge: definition.badge
            }), !shouldHideText && definition.text && /*#__PURE__*/ react.createElement("span", {
                className: hasIcon ? styles_css["utility-link-icon"] : undefined
            }, definition.text)));
        }
    } else if (definition.type === "menu-dropdown") {
        var title = definition.title || definition.text;
        var shouldShowTitle = shouldHideText || !definition.text;
        checkSafeUrlRecursively(definition.items);
        return /*#__PURE__*/ react.createElement(menu_dropdown, (0,tslib_es6/* __assign */.pi)({}, definition, {
            title: shouldShowTitle ? title : "",
            ariaLabel: ariaLabel,
            offsetRight: offsetRight
        }), !shouldHideText && definition.text);
    }
    return null;
}
function checkSafeUrlRecursively(itemOrGroup) {
    for(var _i = 0, itemOrGroup_1 = itemOrGroup; _i < itemOrGroup_1.length; _i++){
        var item = itemOrGroup_1[_i];
        (0,check_safe_url/* checkSafeUrl */.J)("TopNavigation", item.href);
        if ("items" in item) {
            checkSafeUrlRecursively(item.items);
        }
    }
} //# sourceMappingURL=utility.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/top-navigation/parts/overflow-menu/router.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var defaultCtx = {
    state: {
        view: "utilities",
        data: null
    },
    setState: function() {}
};
var ViewContext = /*#__PURE__*/ (0,react.createContext)(defaultCtx);
var useNavigate = function() {
    var setState = (0,react.useContext)(ViewContext).setState;
    var navigate = function(view, data) {
        setState({
            view: view,
            data: data
        });
    };
    return navigate;
};
var Route = function(_a) {
    var view = _a.view, element = _a.element;
    var state = (0,react.useContext)(ViewContext).state;
    if (view === state.view) {
        if (typeof element === "function") {
            return element(state.data);
        }
        return /*#__PURE__*/ react.createElement(react.Fragment, null, element);
    }
    return null;
};
var Router = function(_a) {
    var children = _a.children;
    var _b = (0,react.useState)({
        view: "utilities",
        data: null
    }), state = _b[0], setState = _b[1];
    return /*#__PURE__*/ react.createElement(ViewContext.Provider, {
        value: {
            state: state,
            setState: setState
        }
    }, children);
};
/* harmony default export */ var router = (Router); //# sourceMappingURL=router.js.map

// EXTERNAL MODULE: ./node_modules/react-focus-lock/dist/es2015/index.js + 31 modules
var es2015 = __webpack_require__(3299);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/top-navigation/parts/overflow-menu/header.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var Header = function(_a) {
    var children = _a.children, secondaryText = _a.secondaryText, backIconAriaLabel = _a.backIconAriaLabel, dismissIconAriaLabel = _a.dismissIconAriaLabel, onBack = _a.onBack, onClose = _a.onClose;
    return /*#__PURE__*/ react.createElement("div", {
        className: styles_css["overflow-menu-header"]
    }, onBack && /*#__PURE__*/ react.createElement(internal/* default */.Z, {
        // Used for test-utils, which require the selectable element to have a classname.
        // eslint-disable-next-line react/forbid-component-props
        className: styles_css["overflow-menu-back-button"],
        ariaLabel: backIconAriaLabel,
        iconName: "angle-left",
        variant: "icon",
        onClick: function() {
            return onBack();
        }
    }), /*#__PURE__*/ react.createElement("h2", {
        className: styles_css["overflow-menu-header-text"]
    }, /*#__PURE__*/ react.createElement("div", {
        className: styles_css["overflow-menu-header-text--title"]
    }, children), secondaryText && /*#__PURE__*/ react.createElement("div", {
        className: styles_css["overflow-menu-header-text--secondary"]
    }, secondaryText)), /*#__PURE__*/ react.createElement(internal/* default */.Z, {
        // eslint-disable-next-line react/forbid-component-props
        className: styles_css["overflow-menu-dismiss-button"],
        ariaLabel: dismissIconAriaLabel,
        iconName: "close",
        variant: "icon",
        onClick: function() {
            return onClose && onClose();
        }
    }));
};
/* harmony default export */ var header = (Header); //# sourceMappingURL=header.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-unique-id/index.js
var use_unique_id = __webpack_require__(6081);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/top-navigation/parts/overflow-menu/menu-item.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0








var ListItem = function(_a) {
    var children = _a.children, startIcon = _a.startIcon, endIcon = _a.endIcon;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, startIcon && /*#__PURE__*/ react.createElement("span", {
        className: styles_css["overflow-menu-list-item-icon"]
    }, startIcon), /*#__PURE__*/ react.createElement("span", {
        className: styles_css["overflow-menu-list-item-text"]
    }, children), endIcon && endIcon);
};
var LinkItem = /*#__PURE__*/ (0,react.forwardRef)(function(_a, ref) {
    var children = _a.children, external = _a.external, href = _a.href, startIcon = _a.startIcon, endIcon = _a.endIcon, onFollow = _a.onFollow, context = _a.context, testId = _a.testId;
    var focusVisible = (0,focus_visible/* default */.Z)();
    var rel = external ? "noopener noreferrer" : undefined;
    var target = external ? "_blank" : undefined;
    var anchorProps = {
        rel: rel,
        target: target,
        href: href,
        onClick: function(event) {
            if ((0,events/* isPlainLeftClick */.p_)(event)) {
                onFollow === null || onFollow === void 0 ? void 0 : onFollow(event);
            }
        }
    };
    var buttonProps = {
        role: "button",
        tabIndex: 0,
        onKeyDown: function(event) {
            if (event.key === " ") {
                event.preventDefault();
            }
        },
        onKeyUp: function(event) {
            if (event.key === " " || event.key === "Enter") {
                onFollow === null || onFollow === void 0 ? void 0 : onFollow(event);
            }
        },
        onClick: onFollow
    };
    return /*#__PURE__*/ react.createElement("a", (0,tslib_es6/* __assign */.pi)({
        ref: ref,
        className: (0,clsx_m/* default */.Z)(styles_css["overflow-menu-control"], styles_css["overflow-menu-control-link"], context && styles_css["overflow-menu-control-".concat(context)])
    }, typeof href === "string" ? anchorProps : buttonProps, focusVisible, testId ? {
        "data-testid": testId
    } : {}), /*#__PURE__*/ react.createElement(ListItem, {
        startIcon: startIcon,
        endIcon: endIcon
    }, children));
});
var ButtonItem = /*#__PURE__*/ (0,react.forwardRef)(function(_a, ref) {
    var children = _a.children, startIcon = _a.startIcon, endIcon = _a.endIcon, onClick = _a.onFollow, testId = _a.testId;
    var focusVisible = (0,focus_visible/* default */.Z)();
    return /*#__PURE__*/ react.createElement("button", (0,tslib_es6/* __assign */.pi)({
        ref: ref,
        className: styles_css["overflow-menu-control"],
        onClick: onClick
    }, focusVisible, typeof testId === "string" ? {
        "data-testid": testId
    } : {}), /*#__PURE__*/ react.createElement(ListItem, {
        startIcon: startIcon,
        endIcon: endIcon
    }, children));
});
var NavigationItem = /*#__PURE__*/ (0,react.forwardRef)(function(_a, ref) {
    var startIcon = _a.startIcon, children = _a.children, index = _a.index, testId = _a.testId, definition = (0,tslib_es6/* __rest */._T)(_a, [
        "startIcon",
        "children",
        "index",
        "testId"
    ]);
    var navigate = useNavigate();
    return /*#__PURE__*/ react.createElement(ButtonItem, {
        ref: ref,
        startIcon: startIcon,
        endIcon: /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
            name: "angle-right"
        }),
        testId: testId,
        onFollow: function() {
            return navigate("dropdown-menu", {
                definition: definition,
                headerText: definition.text || definition.title,
                headerSecondaryText: definition.description,
                utilityIndex: index
            });
        }
    }, children);
});
var ExpandableItem = function(_a) {
    var children = _a.children, onItemClick = _a.onItemClick, definition = (0,tslib_es6/* __rest */._T)(_a, [
        "children",
        "onItemClick"
    ]);
    var focusVisible = (0,focus_visible/* default */.Z)();
    var _b = (0,react.useState)(false), expanded = _b[0], setExpanded = _b[1];
    var headerId = (0,use_unique_id/* useUniqueId */.L)("overflow-menu-item");
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("button", (0,tslib_es6/* __assign */.pi)({
        className: (0,clsx_m/* default */.Z)(styles_css["overflow-menu-control"], styles_css["overflow-menu-control-expandable-menu-trigger"]),
        onClick: function() {
            return setExpanded(function(value) {
                return !value;
            });
        },
        "aria-expanded": expanded
    }, focusVisible), /*#__PURE__*/ react.createElement(ListItem, {
        endIcon: /*#__PURE__*/ react.createElement("span", {
            className: (0,clsx_m/* default */.Z)(styles_css.icon, expanded && styles_css.expanded)
        }, /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
            name: "caret-up-filled"
        }))
    }, /*#__PURE__*/ react.createElement("span", {
        id: headerId
    }, children))), expanded && /*#__PURE__*/ react.createElement("ul", {
        className: (0,clsx_m/* default */.Z)(styles_css["overflow-menu-list"], styles_css["overflow-menu-list-submenu"]),
        "aria-labelledby": headerId
    }, definition.items.map(function(item, index) {
        var isGroup = typeof item.items !== "undefined";
        return /*#__PURE__*/ react.createElement("li", {
            key: index,
            className: (0,clsx_m/* default */.Z)(styles_css["overflow-menu-list-item"], styles_css["overflow-menu-list-item-dropdown-menu"])
        }, dropdownComponentFactory(item, isGroup, onItemClick));
    })));
};
function utilityComponentFactory(utility, index, ref) {
    var label = utility.text || utility.title;
    var hasIcon = !!utility.iconName || !!utility.iconUrl || !!utility.iconAlt || !!utility.iconSvg;
    var startIcon = hasIcon && /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
        name: utility.iconName,
        url: utility.iconUrl,
        alt: utility.iconAlt,
        svg: utility.iconSvg
    });
    switch(utility.type){
        case "button":
            {
                var handleClick = function(event) {
                    (0,events/* fireCancelableEvent */.y1)(utility.onClick, {}, event);
                };
                if (utility.variant === "primary-button") {
                    return /*#__PURE__*/ react.createElement(ButtonItem, {
                        ref: ref,
                        startIcon: startIcon,
                        onFollow: handleClick,
                        testId: "__".concat(index)
                    }, label);
                }
                return /*#__PURE__*/ react.createElement(LinkItem, {
                    ref: ref,
                    startIcon: startIcon,
                    href: utility.href,
                    external: utility.external,
                    testId: "__".concat(index),
                    onFollow: handleClick
                }, label, utility.external && /*#__PURE__*/ react.createElement(react.Fragment, null, " ", /*#__PURE__*/ react.createElement("span", {
                    "aria-label": utility.externalIconAriaLabel,
                    role: utility.externalIconAriaLabel ? "img" : undefined
                }, /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
                    name: "external",
                    size: "normal"
                }))));
            }
        case "menu-dropdown":
            {
                return /*#__PURE__*/ react.createElement(NavigationItem, (0,tslib_es6/* __assign */.pi)({
                    ref: ref,
                    startIcon: startIcon,
                    index: index
                }, utility, {
                    testId: "__".concat(index)
                }), label);
            }
    }
}
function dropdownComponentFactory(item, expandable, onItemClick) {
    var label = item.text;
    var hasIcon = !!item.iconName || !!item.iconUrl || !!item.iconAlt || !!item.iconSvg;
    var startIcon = hasIcon && /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
        name: item.iconName,
        url: item.iconUrl,
        alt: item.iconAlt,
        svg: item.iconSvg
    });
    if (expandable) {
        return /*#__PURE__*/ react.createElement(ExpandableItem, (0,tslib_es6/* __assign */.pi)({}, item, {
            onItemClick: onItemClick
        }), label);
    }
    return /*#__PURE__*/ react.createElement(LinkItem, {
        startIcon: startIcon,
        href: item.href,
        external: item.external,
        context: "dropdown-menu",
        testId: item.id,
        onFollow: function() {
            return onItemClick(item);
        }
    }, label, item.external && /*#__PURE__*/ react.createElement(react.Fragment, null, " ", /*#__PURE__*/ react.createElement("span", {
        "aria-label": item.externalIconAriaLabel,
        role: item.externalIconAriaLabel ? "img" : undefined
    }, /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
        name: "external",
        size: "normal"
    }))));
}
var UtilityMenuItem = /*#__PURE__*/ (0,react.forwardRef)(function(_a, ref) {
    var index = _a.index, props = (0,tslib_es6/* __rest */._T)(_a, [
        "index"
    ]);
    return /*#__PURE__*/ react.createElement("li", {
        className: (0,clsx_m/* default */.Z)(styles_css["overflow-menu-list-item"], styles_css["overflow-menu-list-item-utility"])
    }, utilityComponentFactory(props, index, ref));
});
var SubmenuItem = function(props) {
    var expandable = typeof props.items !== "undefined";
    return /*#__PURE__*/ react.createElement("li", {
        className: (0,clsx_m/* default */.Z)(styles_css["overflow-menu-list-item"], styles_css["overflow-menu-list-item-submenu"], expandable && styles_css["overflow-menu-list-item-expandable"])
    }, dropdownComponentFactory(props, expandable, props.onItemClick));
}; //# sourceMappingURL=menu-item.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/top-navigation/parts/overflow-menu/views/utilities.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0






var UtilitiesView = function(_a) {
    var headerText = _a.headerText, dismissIconAriaLabel = _a.dismissIconAriaLabel, onClose = _a.onClose, _b = _a.items, items = _b === void 0 ? [] : _b, focusIndex = _a.focusIndex;
    var headerId = (0,use_unique_id/* useUniqueId */.L)("overflow-menu-header");
    var ref = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var _a;
        // A focus index is used to set the focus back to the submenu trigger
        // returning from a submenu.
        if (typeof focusIndex === "number") {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [
        focusIndex
    ]);
    return /*#__PURE__*/ react.createElement(es2015/* default */.ZP, {
        returnFocus: true
    }, /*#__PURE__*/ react.createElement(header, {
        dismissIconAriaLabel: dismissIconAriaLabel,
        onClose: onClose
    }, /*#__PURE__*/ react.createElement("span", {
        id: headerId
    }, headerText)), /*#__PURE__*/ react.createElement("ul", {
        className: styles_css["overflow-menu-list"],
        "aria-labelledby": headerId
    }, items.map(function(utility, index) {
        return /*#__PURE__*/ react.createElement(UtilityMenuItem, (0,tslib_es6/* __assign */.pi)({
            key: index,
            index: index,
            ref: index === focusIndex ? ref : undefined
        }, utility));
    })));
};
/* harmony default export */ var utilities = (UtilitiesView); //# sourceMappingURL=utilities.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/top-navigation/parts/overflow-menu/views/submenu.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0









var SubmenuView = function(_a) {
    var onClose = _a.onClose, utilityIndex = _a.utilityIndex, headerText = _a.headerText, headerSecondaryText = _a.headerSecondaryText, dismissIconAriaLabel = _a.dismissIconAriaLabel, backIconAriaLabel = _a.backIconAriaLabel, definition = _a.definition;
    var navigate = useNavigate();
    var headerId = (0,use_unique_id/* useUniqueId */.L)("overflow-menu-header");
    return /*#__PURE__*/ react.createElement(es2015/* default */.ZP, {
        returnFocus: true
    }, /*#__PURE__*/ react.createElement(header, {
        secondaryText: headerSecondaryText,
        dismissIconAriaLabel: dismissIconAriaLabel,
        backIconAriaLabel: backIconAriaLabel,
        onClose: onClose,
        onBack: function() {
            return navigate("utilities", {
                utilityIndex: utilityIndex
            });
        }
    }, /*#__PURE__*/ react.createElement("span", {
        id: headerId
    }, headerText)), /*#__PURE__*/ react.createElement("ul", {
        className: (0,clsx_m/* default */.Z)(styles_css["overflow-menu-list"], styles_css["overflow-menu-list-submenu"]),
        "aria-labelledby": headerId
    }, definition.items.map(function(item, index) {
        return /*#__PURE__*/ react.createElement(SubmenuItem, (0,tslib_es6/* __assign */.pi)({
            key: index
        }, item, {
            onItemClick: function(item) {
                (0,events/* fireCancelableEvent */.y1)(definition.onItemClick, {
                    id: item.id,
                    href: item.href,
                    external: item.external
                });
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        }));
    })));
};
/* harmony default export */ var submenu = (SubmenuView); //# sourceMappingURL=submenu.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/top-navigation/parts/overflow-menu/index.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





var OverflowMenu = function(_a) {
    var headerText = _a.headerText, dismissIconAriaLabel = _a.dismissIconAriaLabel, backIconAriaLabel = _a.backIconAriaLabel, _b = _a.items, items = _b === void 0 ? [] : _b, onClose = _a.onClose;
    return /*#__PURE__*/ react.createElement("div", {
        className: styles_css["overflow-menu"],
        onKeyUp: function(event) {
            if (event.key === "Escape") {
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        }
    }, /*#__PURE__*/ react.createElement(router, null, /*#__PURE__*/ react.createElement(Route, {
        view: "utilities",
        element: function(data) {
            return /*#__PURE__*/ react.createElement(utilities, {
                headerText: headerText,
                items: items,
                focusIndex: data === null || data === void 0 ? void 0 : data.utilityIndex,
                dismissIconAriaLabel: dismissIconAriaLabel,
                backIconAriaLabel: backIconAriaLabel,
                onClose: onClose
            });
        }
    }), /*#__PURE__*/ react.createElement(Route, {
        view: "dropdown-menu",
        element: function(data) {
            return /*#__PURE__*/ react.createElement(submenu, {
                headerText: data === null || data === void 0 ? void 0 : data.headerText,
                headerSecondaryText: data === null || data === void 0 ? void 0 : data.headerSecondaryText,
                dismissIconAriaLabel: dismissIconAriaLabel,
                backIconAriaLabel: backIconAriaLabel,
                definition: data === null || data === void 0 ? void 0 : data.definition,
                utilityIndex: data === null || data === void 0 ? void 0 : data.utilityIndex,
                onClose: onClose
            });
        }
    })));
};
/* harmony default export */ var overflow_menu = (OverflowMenu); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/top-navigation/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0














function InternalTopNavigation(_a) {
    var __internalRootRef = _a.__internalRootRef, identity = _a.identity, i18nStrings = _a.i18nStrings, utilities = _a.utilities, search = _a.search, restProps = (0,tslib_es6/* __rest */._T)(_a, [
        "__internalRootRef",
        "identity",
        "i18nStrings",
        "utilities",
        "search"
    ]);
    (0,check_safe_url/* checkSafeUrl */.J)("TopNavigation", identity.href);
    var baseProps = (0,base_component/* getBaseProps */.j)(restProps);
    var _b = useTopNavigation({
        identity: identity,
        search: search,
        utilities: utilities
    }), mainRef = _b.mainRef, virtualRef = _b.virtualRef, breakpoint = _b.breakpoint, responsiveState = _b.responsiveState, isSearchExpanded = _b.isSearchExpanded, onSearchUtilityClick = _b.onSearchUtilityClick;
    var _c = (0,react.useState)(false), overflowMenuOpen = _c[0], setOverflowMenuOpen = _c[1];
    var overflowMenuTriggerRef = (0,react.useRef)(null);
    var isNarrowViewport = breakpoint === "default";
    var isMediumViewport = breakpoint === "xxs";
    var isLargeViewport = breakpoint === "s";
    var onIdentityClick = function(event) {
        if ((0,events/* isPlainLeftClick */.p_)(event)) {
            (0,events/* fireCancelableEvent */.y1)(identity.onFollow, {}, event);
        }
    };
    var toggleOverflowMenu = function() {
        setOverflowMenuOpen(function(overflowMenuOpen) {
            return !overflowMenuOpen;
        });
    };
    var focusVisible = (0,focus_visible/* default */.Z)();
    var menuTriggerVisible = !isSearchExpanded && responsiveState.hideUtilities;
    (0,react.useEffect)(function() {
        setOverflowMenuOpen(false);
    }, [
        menuTriggerVisible
    ]);
    (0,use_effect_on_update/* useEffectOnUpdate */.G)(function() {
        var _a;
        if (!overflowMenuOpen) {
            (_a = overflowMenuTriggerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [
        overflowMenuOpen
    ]);
    // Render the top nav twice; once as the top nav that users can see, and another
    // "virtual" top nav used just for calculations. The virtual top nav doesn't react to
    // layout changes and renders two sets of utilities: one with labels and one without.
    var content = function(isVirtual) {
        var _a, _b, _c, _d;
        var _e, _f;
        var Wrapper = isVirtual ? "div" : "header";
        var showIdentity = isVirtual || !isSearchExpanded;
        var showTitle = isVirtual || !responsiveState.hideTitle;
        var showSearchSlot = search && (isVirtual || !responsiveState.hideSearch || isSearchExpanded);
        var showSearchUtility = isVirtual || search && responsiveState.hideSearch;
        var showUtilities = isVirtual || !isSearchExpanded;
        var showMenuTrigger = isVirtual || menuTriggerVisible;
        return /*#__PURE__*/ react.createElement(Wrapper, {
            ref: isVirtual ? virtualRef : mainRef,
            "aria-hidden": isVirtual ? true : undefined,
            // Wrapper is an alias for "div" or "header".
            // eslint-disable-next-line react/forbid-component-props
            className: (0,clsx_m/* default */.Z)(styles_css["top-navigation"], (_a = {}, _a[styles_css.virtual] = isVirtual, _a[styles_css.hidden] = isVirtual, _a[styles_css.narrow] = isNarrowViewport, _a[styles_css.medium] = isMediumViewport, _a))
        }, /*#__PURE__*/ react.createElement("div", {
            className: styles_css["padding-box"]
        }, showIdentity && /*#__PURE__*/ react.createElement("div", {
            className: (0,clsx_m/* default */.Z)(styles_css.identity, !identity.logo && styles_css["no-logo"])
        }, /*#__PURE__*/ react.createElement("a", (0,tslib_es6/* __assign */.pi)({}, focusVisible, {
            className: styles_css["identity-link"],
            href: identity.href,
            onClick: onIdentityClick
        }), identity.logo && /*#__PURE__*/ react.createElement("img", {
            role: "img",
            src: (_e = identity.logo) === null || _e === void 0 ? void 0 : _e.src,
            alt: (_f = identity.logo) === null || _f === void 0 ? void 0 : _f.alt,
            className: (0,clsx_m/* default */.Z)(styles_css.logo, (_b = {}, _b[styles_css.narrow] = isNarrowViewport, _b))
        }), showTitle && /*#__PURE__*/ react.createElement("span", {
            className: styles_css.title
        }, identity.title))), /*#__PURE__*/ react.createElement("div", {
            className: styles_css.inputs
        }, showSearchSlot && /*#__PURE__*/ react.createElement("div", {
            className: (0,clsx_m/* default */.Z)(styles_css.search, !isVirtual && isSearchExpanded && styles_css["search-expanded"])
        }, search)), /*#__PURE__*/ react.createElement("div", {
            className: styles_css.utilities
        }, showSearchUtility && /*#__PURE__*/ react.createElement("div", {
            className: (0,clsx_m/* default */.Z)(styles_css["utility-wrapper"], styles_css["utility-type-button"], styles_css["utility-type-button-link"], (_c = {}, _c[styles_css.narrow] = isNarrowViewport, _c[styles_css.medium] = isMediumViewport, _c)),
            "data-utility-special": "search"
        }, /*#__PURE__*/ react.createElement(Utility, {
            hideText: true,
            definition: {
                type: "button",
                iconName: isSearchExpanded ? "close" : "search",
                ariaLabel: isSearchExpanded ? i18nStrings.searchDismissIconAriaLabel : i18nStrings.searchIconAriaLabel,
                onClick: onSearchUtilityClick
            }
        })), showUtilities && utilities.filter(function(_utility, i) {
            return isVirtual || !responsiveState.hideUtilities || responsiveState.hideUtilities.indexOf(i) === -1;
        }).map(function(utility, i) {
            var _a;
            var _b;
            var hideText = !!responsiveState.hideUtilityText;
            var isLast = (isVirtual || !showMenuTrigger) && i === utilities.length - 1;
            var offsetRight = isLast && isLargeViewport ? "xxl" : isLast ? "l" : undefined;
            return /*#__PURE__*/ react.createElement("div", {
                key: i,
                className: (0,clsx_m/* default */.Z)(styles_css["utility-wrapper"], styles_css["utility-type-".concat(utility.type)], utility.type === "button" && styles_css["utility-type-button-".concat((_b = utility.variant) !== null && _b !== void 0 ? _b : "link")], (_a = {}, _a[styles_css.narrow] = isNarrowViewport, _a[styles_css.medium] = isMediumViewport, _a)),
                "data-utility-index": i,
                "data-utility-hide": "".concat(hideText)
            }, /*#__PURE__*/ react.createElement(Utility, {
                hideText: hideText,
                definition: utility,
                offsetRight: offsetRight
            }));
        }), isVirtual && utilities.map(function(utility, i) {
            var _a;
            var _b;
            var hideText = !responsiveState.hideUtilityText;
            var isLast = !showMenuTrigger && i === utilities.length - 1;
            var offsetRight = isLast && isLargeViewport ? "xxl" : isLast ? "l" : undefined;
            return /*#__PURE__*/ react.createElement("div", {
                key: i,
                className: (0,clsx_m/* default */.Z)(styles_css["utility-wrapper"], styles_css["utility-type-".concat(utility.type)], utility.type === "button" && styles_css["utility-type-button-".concat((_b = utility.variant) !== null && _b !== void 0 ? _b : "link")], (_a = {}, _a[styles_css.narrow] = isNarrowViewport, _a[styles_css.medium] = isMediumViewport, _a)),
                "data-utility-index": i,
                "data-utility-hide": "".concat(hideText)
            }, /*#__PURE__*/ react.createElement(Utility, {
                hideText: hideText,
                definition: utility,
                offsetRight: offsetRight
            }));
        }), showMenuTrigger && /*#__PURE__*/ react.createElement("div", {
            className: (0,clsx_m/* default */.Z)(styles_css["utility-wrapper"], styles_css["utility-type-menu-dropdown"], (_d = {}, _d[styles_css.narrow] = isNarrowViewport, _d[styles_css.medium] = isMediumViewport, _d)),
            "data-utility-special": "menu-trigger"
        }, /*#__PURE__*/ react.createElement(ButtonTrigger, {
            expanded: overflowMenuOpen,
            onClick: toggleOverflowMenu,
            offsetRight: "l",
            ref: !isVirtual ? overflowMenuTriggerRef : undefined
        }, i18nStrings.overflowMenuTriggerText)))));
    };
    return /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        ref: __internalRootRef
    }), /*#__PURE__*/ react.createElement(visual_context/* default */.ZP, {
        contextName: "top-navigation"
    }, content(false), /*#__PURE__*/ react.createElement(portal/* default */.Z, null, content(true)), menuTriggerVisible && overflowMenuOpen && /*#__PURE__*/ react.createElement("div", {
        className: styles_css["overflow-menu-drawer"]
    }, /*#__PURE__*/ react.createElement(overflow_menu, {
        headerText: i18nStrings.overflowMenuTitleText,
        dismissIconAriaLabel: i18nStrings.overflowMenuDismissIconAriaLabel,
        backIconAriaLabel: i18nStrings.overflowMenuBackIconAriaLabel,
        items: utilities.filter(function(utility, i) {
            return (!responsiveState.hideUtilities || responsiveState.hideUtilities.indexOf(i) !== -1) && !utility.disableUtilityCollapse;
        }),
        onClose: toggleOverflowMenu
    }))));
} //# sourceMappingURL=internal.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/top-navigation/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




function TopNavigation(_a) {
    var _b = _a.utilities, utilities = _b === void 0 ? [] : _b, restProps = (0,tslib_es6/* __rest */._T)(_a, [
        "utilities"
    ]);
    var baseComponentProps = (0,use_base_component/* default */.Z)("TopNavigation");
    return /*#__PURE__*/ react.createElement(InternalTopNavigation, (0,tslib_es6/* __assign */.pi)({}, baseComponentProps, {
        utilities: utilities
    }, restProps));
}
(0,apply_display_name/* applyDisplayName */.b)(TopNavigation, "TopNavigation"); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/input/index.js
var input = __webpack_require__(6648);
;// CONCATENATED MODULE: ./components/TopNavigation.tsx




const i18nStrings = {
    searchIconAriaLabel: "Search",
    searchDismissIconAriaLabel: "Close search",
    overflowMenuTriggerText: "More",
    overflowMenuTitleText: "All",
    overflowMenuBackIconAriaLabel: "Back",
    overflowMenuDismissIconAriaLabel: "Close menu"
};
function TopNav() {
    const profileActions = [
        {
            type: "button",
            id: "profile",
            text: "Profile"
        },
        {
            type: "button",
            id: "preferences",
            text: "Preferences"
        },
        {
            type: "button",
            id: "security",
            text: "Security"
        },
        {
            type: "menu-dropdown",
            id: "support-group",
            text: "Support",
            items: [
                {
                    id: "documentation",
                    text: "Documentation",
                    href: "#",
                    external: true,
                    externalIconAriaLabel: " (opens in new tab)"
                },
                {
                    id: "feedback",
                    text: "Feedback",
                    href: "#",
                    external: true,
                    externalIconAriaLabel: " (opens in new tab)"
                },
                {
                    id: "support",
                    text: "Customer support"
                }
            ]
        },
        {
            type: "button",
            id: "signout",
            text: "Sign out"
        }
    ];
    const [searchValue, setSearchValue] = (0,react.useState)("");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TopNavigation, {
        i18nStrings: i18nStrings,
        identity: {
            href: "#",
            title: "firekit",
            logo: {
                src: firekit.src,
                alt: "firekit logo"
            }
        },
        search: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
            ariaLabel: "Input field",
            value: searchValue,
            type: "search",
            placeholder: "Search",
            onChange: (param)=>{
                let { detail  } = param;
                return setSearchValue(detail.value);
            }
        }),
        utilities: [
            {
                type: "button",
                iconName: "notification",
                ariaLabel: "Notifications",
                badge: true,
                disableUtilityCollapse: true
            },
            {
                type: "button",
                iconName: "settings",
                title: "Settings",
                ariaLabel: "Settings"
            },
            {
                type: "menu-dropdown",
                text: "Customer name",
                description: "customer@example.com",
                iconName: "user-profile",
                items: profileActions
            }
        ]
    });
}


/***/ }),

/***/ 6959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ applyDefaults; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(655);

var defaultContentTypeState = {
    navigationOpen: true,
    minContentWidth: 280,
    maxContentWidth: undefined
};
var defaults = {
    "default": (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, defaultContentTypeState),
    cards: {
        navigationOpen: true,
        minContentWidth: 280,
        maxContentWidth: undefined
    },
    form: {
        navigationOpen: false,
        minContentWidth: 280,
        maxContentWidth: 800
    },
    table: {
        navigationOpen: true,
        minContentWidth: 280,
        maxContentWidth: undefined
    },
    wizard: {
        navigationOpen: false,
        minContentWidth: 280,
        maxContentWidth: 1080
    }
};
function applyDefaults(contentType, stateFromProps, isRefresh) {
    var _a, _b, _c, _d;
    var contentTypeDefaults = isRefresh ? (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, defaults[contentType]), {
        maxContentWidth: undefined
    }) : defaults[contentType];
    return {
        maxContentWidth: (_a = stateFromProps.maxContentWidth) !== null && _a !== void 0 ? _a : contentTypeDefaults.maxContentWidth,
        minContentWidth: (_b = stateFromProps.minContentWidth) !== null && _b !== void 0 ? _b : contentTypeDefaults.minContentWidth,
        navigationOpen: (_c = stateFromProps.navigationOpen) !== null && _c !== void 0 ? _c : contentTypeDefaults.navigationOpen,
        toolsOpen: (_d = stateFromProps.toolsOpen) !== null && _d !== void 0 ? _d : contentTypeDefaults.toolsOpen
    };
} //# sourceMappingURL=defaults.js.map


/***/ }),

/***/ 9618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ app_layout; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-controllable/index.js
var use_controllable = __webpack_require__(9276);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-mobile/index.js
var use_mobile = __webpack_require__(6670);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/events/index.js
var events = __webpack_require__(6322);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/app-layout/defaults.js
var app_layout_defaults = __webpack_require__(6959);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/app-layout/notifications/styles.scoped.css
var styles_scoped = __webpack_require__(5038);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/notifications/styles.css.js

/* harmony default export */ var styles_css = ({
    "notifications-sticky": "awsui_notifications-sticky_1hmm4_1qn9j_9"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/notifications/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var Notifications = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var _b, _c;
    var sticky = _a.sticky, props = (0,tslib_es6/* __rest */._T)(_a, [
        "sticky"
    ]);
    return sticky ? /*#__PURE__*/ react.createElement("div", {
        ref: ref,
        className: styles_css["notifications-sticky"],
        style: {
            top: props.topOffset
        }
    }, /*#__PURE__*/ react.createElement("div", {
        role: "region",
        className: (0,clsx_m/* default */.Z)(props.testUtilsClassName),
        "aria-label": (_b = props.labels) === null || _b === void 0 ? void 0 : _b.notifications
    }, props.children)) : /*#__PURE__*/ react.createElement("div", {
        role: "region",
        ref: ref,
        className: (0,clsx_m/* default */.Z)(props.testUtilsClassName),
        "aria-label": (_c = props.labels) === null || _c === void 0 ? void 0 : _c.notifications
    }, props.children);
}); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/button/internal.js + 6 modules
var internal = __webpack_require__(8145);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/app-layout/toggles/styles.scoped.css
var toggles_styles_scoped = __webpack_require__(4496);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/toggles/styles.css.js

/* harmony default export */ var toggles_styles_css = ({
    "close-button": "awsui_close-button_16w0h_1fczy_93"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/toggles/index.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var togglesConfig = {
    navigation: {
        TagName: "nav",
        iconName: "menu",
        getLabels: function(labels) {
            if (labels === void 0) {
                labels = {};
            }
            return {
                mainLabel: labels.navigation,
                openLabel: labels.navigationToggle,
                closeLabel: labels.navigationClose
            };
        }
    },
    tools: {
        TagName: "aside",
        iconName: "status-info",
        getLabels: function(labels) {
            if (labels === void 0) {
                labels = {};
            }
            return {
                mainLabel: labels.tools,
                openLabel: labels.toolsToggle,
                closeLabel: labels.toolsClose
            };
        }
    }
};
var AppLayoutButton = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var className = _a.className, ariaLabel = _a.ariaLabel, ariaExpanded = _a.ariaExpanded, iconName = _a.iconName, disabled = _a.disabled, onClick = _a.onClick;
    return /*#__PURE__*/ react.createElement(internal/* InternalButton */.l, {
        ref: ref,
        className: className,
        ariaLabel: ariaLabel,
        variant: "icon",
        formAction: "none",
        onClick: onClick,
        iconName: iconName,
        disabled: disabled,
        ariaExpanded: ariaExpanded,
        __nativeAttributes: {
            "aria-haspopup": true
        }
    });
});
var CloseButton = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var className = _a.className, ariaLabel = _a.ariaLabel, onClick = _a.onClick, iconName = _a.iconName;
    return /*#__PURE__*/ react.createElement("span", {
        className: toggles_styles_css["close-button"]
    }, /*#__PURE__*/ react.createElement(AppLayoutButton, {
        ref: ref,
        className: className,
        ariaExpanded: true,
        ariaLabel: ariaLabel,
        iconName: iconName,
        onClick: onClick
    }));
}); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/app-layout/mobile-toolbar/styles.scoped.css
var mobile_toolbar_styles_scoped = __webpack_require__(8922);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/mobile-toolbar/styles.css.js

/* harmony default export */ var mobile_toolbar_styles_css = ({
    "block-body-scroll": "awsui_block-body-scroll_19d8l_l5x8d_97",
    "mobile-bar": "awsui_mobile-bar_19d8l_l5x8d_101",
    "mobile-bar-breadcrumbs": "awsui_mobile-bar-breadcrumbs_19d8l_l5x8d_115",
    "mobile-toggle": "awsui_mobile-toggle_19d8l_l5x8d_122"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/app-layout/styles.scoped.css
var app_layout_styles_scoped = __webpack_require__(2672);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/styles.css.js

/* harmony default export */ var app_layout_styles_css = ({
    "root": "awsui_root_lm6vo_hzagk_97",
    "layout-wrapper": "awsui_layout-wrapper_lm6vo_hzagk_98",
    "root-no-scroll": "awsui_root-no-scroll_lm6vo_hzagk_104",
    "layout": "awsui_layout_lm6vo_hzagk_98",
    "layout-no-scroll": "awsui_layout-no-scroll_lm6vo_hzagk_115",
    "layout-main": "awsui_layout-main_lm6vo_hzagk_119",
    "layout-main-scrollable": "awsui_layout-main-scrollable_lm6vo_hzagk_125",
    "unfocusable": "awsui_unfocusable_lm6vo_hzagk_130",
    "navigation-panel": "awsui_navigation-panel_lm6vo_hzagk_134",
    "drawer": "awsui_drawer_lm6vo_hzagk_138",
    "drawer-mobile": "awsui_drawer-mobile_lm6vo_hzagk_144",
    "drawer-closed": "awsui_drawer-closed_lm6vo_hzagk_147",
    "opaque-background": "awsui_opaque-background_lm6vo_hzagk_154",
    "drawer-content": "awsui_drawer-content_lm6vo_hzagk_158",
    "toggle": "awsui_toggle_lm6vo_hzagk_183",
    "visual-refresh-toggle": "awsui_visual-refresh-toggle_lm6vo_hzagk_188",
    "visual-refresh-toggle-type-tools": "awsui_visual-refresh-toggle-type-tools_lm6vo_hzagk_192",
    "visual-refresh-toggle-type-navigation": "awsui_visual-refresh-toggle-type-navigation_lm6vo_hzagk_195",
    "button-toggles-container": "awsui_button-toggles-container_lm6vo_hzagk_205",
    "button-toggles-container-is-hidden": "awsui_button-toggles-container-is-hidden_lm6vo_hzagk_210",
    "breadcrumbs-desktop": "awsui_breadcrumbs-desktop_lm6vo_hzagk_224",
    "content-header-wrapper": "awsui_content-header-wrapper_lm6vo_hzagk_229",
    "content-wrapper": "awsui_content-wrapper_lm6vo_hzagk_233",
    "content-overlapped": "awsui_content-overlapped_lm6vo_hzagk_237",
    "content-extra-top-padding": "awsui_content-extra-top-padding_lm6vo_hzagk_241",
    "navigation-toggle": "awsui_navigation-toggle_lm6vo_hzagk_246",
    "tools-toggle": "awsui_tools-toggle_lm6vo_hzagk_251",
    "navigation": "awsui_navigation_lm6vo_hzagk_134",
    "navigation-close": "awsui_navigation-close_lm6vo_hzagk_263",
    "tools": "awsui_tools_lm6vo_hzagk_251",
    "tools-close": "awsui_tools-close_lm6vo_hzagk_275",
    "notifications": "awsui_notifications_lm6vo_hzagk_279",
    "breadcrumbs": "awsui_breadcrumbs_lm6vo_hzagk_224",
    "content": "awsui_content_lm6vo_hzagk_229",
    "panel-wrapper-outer": "awsui_panel-wrapper-outer_lm6vo_hzagk_291",
    "panel-wrapper-inner": "awsui_panel-wrapper-inner_lm6vo_hzagk_292",
    "mobile": "awsui_mobile_lm6vo_hzagk_301",
    "open": "awsui_open_lm6vo_hzagk_307"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/app-layout/test-classes/styles.scoped.css
var test_classes_styles_scoped = __webpack_require__(1065);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/test-classes/styles.css.js

/* harmony default export */ var test_classes_styles_css = ({
    "root": "awsui_root_1fj9k_avnjw_5",
    "navigation": "awsui_navigation_1fj9k_avnjw_9",
    "navigation-toggle": "awsui_navigation-toggle_1fj9k_avnjw_13",
    "navigation-close": "awsui_navigation-close_1fj9k_avnjw_17",
    "content": "awsui_content_1fj9k_avnjw_21",
    "notifications": "awsui_notifications_1fj9k_avnjw_25",
    "breadcrumbs": "awsui_breadcrumbs_1fj9k_avnjw_29",
    "tools": "awsui_tools_1fj9k_avnjw_33",
    "tools-close": "awsui_tools-close_1fj9k_avnjw_37",
    "tools-toggle": "awsui_tools-toggle_1fj9k_avnjw_41",
    "drawer-closed": "awsui_drawer-closed_1fj9k_avnjw_45",
    "mobile-bar": "awsui_mobile-bar_1fj9k_avnjw_49",
    "disable-body-scroll-root": "awsui_disable-body-scroll-root_1fj9k_avnjw_53"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/mobile-toolbar/index.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0






var MobileToggle = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var className = _a.className, ariaLabels = _a.ariaLabels, type = _a.type, disabled = _a.disabled, onClick = _a.onClick;
    var _b = togglesConfig[type], TagName = _b.TagName, iconName = _b.iconName, getLabels = _b.getLabels;
    var _c = getLabels(ariaLabels), mainLabel = _c.mainLabel, openLabel = _c.openLabel;
    return /*#__PURE__*/ react.createElement(TagName, {
        className: (0,clsx_m/* default */.Z)(mobile_toolbar_styles_css["mobile-toggle"]),
        "aria-hidden": disabled,
        "aria-label": mainLabel,
        onClick: onClick
    }, /*#__PURE__*/ react.createElement(AppLayoutButton, {
        ref: ref,
        className: className,
        iconName: iconName,
        onClick: onClick,
        ariaLabel: openLabel,
        disabled: disabled,
        ariaExpanded: disabled
    }));
});
function MobileToolbar(_a) {
    var _b = _a.ariaLabels, ariaLabels = _b === void 0 ? {} : _b, toggleRefs = _a.toggleRefs, topOffset = _a.topOffset, navigationHide = _a.navigationHide, toolsHide = _a.toolsHide, _c = _a.anyPanelOpen, anyPanelOpen = _c === void 0 ? false : _c, unfocusable = _a.unfocusable, children = _a.children, onNavigationOpen = _a.onNavigationOpen, onToolsOpen = _a.onToolsOpen;
    (0,react.useEffect)(function() {
        if (anyPanelOpen) {
            document.body.classList.add(mobile_toolbar_styles_css["block-body-scroll"]);
            return function() {
                document.body.classList.remove(mobile_toolbar_styles_css["block-body-scroll"]);
            };
        } else {
            document.body.classList.remove(mobile_toolbar_styles_css["block-body-scroll"]);
        }
    }, [
        anyPanelOpen
    ]);
    return /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(mobile_toolbar_styles_css["mobile-bar"], unfocusable && app_layout_styles_css.unfocusable),
        style: {
            top: topOffset
        }
    }, !navigationHide && /*#__PURE__*/ react.createElement(MobileToggle, {
        ref: toggleRefs.navigation,
        type: "navigation",
        className: (0,clsx_m/* default */.Z)(app_layout_styles_css["navigation-toggle"], test_classes_styles_css["navigation-toggle"]),
        ariaLabels: ariaLabels,
        disabled: anyPanelOpen,
        onClick: onNavigationOpen
    }), /*#__PURE__*/ react.createElement("div", {
        className: mobile_toolbar_styles_css["mobile-bar-breadcrumbs"]
    }, children && /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(app_layout_styles_css.breadcrumbs, test_classes_styles_css.breadcrumbs)
    }, children)), !toolsHide && /*#__PURE__*/ react.createElement(MobileToggle, {
        ref: toggleRefs.tools,
        type: "tools",
        className: (0,clsx_m/* default */.Z)(app_layout_styles_css["tools-toggle"], test_classes_styles_css["tools-toggle"]),
        ariaLabels: ariaLabels,
        disabled: anyPanelOpen,
        onClick: onToolsOpen
    }));
} //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/app-layout/utils/use-focus-control.js
var use_focus_control = __webpack_require__(2129);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/utils/use-window-width.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function useWindowWidth() {
    var _a = (0,react.useState)(function() {
        return  true ? window.innerWidth : 0;
    }), width = _a[0], setWidth = _a[1];
    (0,react.useEffect)(function() {
        var handler = function() {
            return setWidth(window.innerWidth);
        };
        window.addEventListener("resize", handler);
        return function() {
            return window.removeEventListener("resize", handler);
        };
    }, []);
    return width;
} //# sourceMappingURL=use-window-width.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/app-layout/utils/use-observed-element.js
var use_observed_element = __webpack_require__(7616);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/utils/use-content-height.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function useContentHeight(headerSelector, footerSelector, disableBodyScroll) {
    var _a;
    var headerHeight = (0,use_observed_element/* useObservedElement */.x)(headerSelector);
    var footerHeight = (0,use_observed_element/* useObservedElement */.x)(footerSelector);
    var _b = (0,react.useState)(0), headerFooterHeight = _b[0], setHeaderFooterHeight = _b[1];
    // Delay applying changes in header/footer height, as applying them immediately can cause
    // ResizeOberver warnings due to the algorithm thinking that the change might have side-effects
    // further up the tree, therefore blocking notifications to prevent loops
    (0,react.useEffect)(function() {
        var id = requestAnimationFrame(function() {
            return setHeaderFooterHeight(headerHeight + footerHeight);
        });
        return function() {
            return cancelAnimationFrame(id);
        };
    }, [
        headerHeight,
        footerHeight
    ]);
    var heightStyleValue = "calc(100vh - ".concat(headerFooterHeight, "px)");
    return {
        headerHeight: headerHeight,
        footerHeight: footerHeight,
        contentHeightStyle: (_a = {}, _a[disableBodyScroll ? "height" : "minHeight"] = heightStyleValue, _a),
        panelHeightStyle: {
            height: heightStyleValue
        }
    };
} //# sourceMappingURL=use-content-height.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/dom.js
var dom = __webpack_require__(5839);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/context/app-layout-context.js
var app_layout_context = __webpack_require__(129);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/container-queries/use-container-query.js
var use_container_query = __webpack_require__(5382);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-stable-event-handler/index.js
var use_stable_event_handler = __webpack_require__(9728);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/apply-display-name.js
var apply_display_name = __webpack_require__(1651);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/context/split-panel-context.js
var split_panel_context = __webpack_require__(206);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/split-panel/utils/size-utils.js
var size_utils = __webpack_require__(1911);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-base-component/index.js + 2 modules
var use_base_component = __webpack_require__(4656);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-visual-mode/index.js
var use_visual_mode = __webpack_require__(753);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/app-layout/content-wrapper/styles.scoped.css
var content_wrapper_styles_scoped = __webpack_require__(6434);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/content-wrapper/styles.css.js

/* harmony default export */ var content_wrapper_styles_css = ({
    "content-wrapper": "awsui_content-wrapper_zycdx_s6r07_93",
    "content-wrapper-mobile": "awsui_content-wrapper-mobile_zycdx_s6r07_97"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/content-wrapper/index.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var ContentWrapper = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var className = _a.className, children = _a.children, toolsPadding = _a.toolsPadding, disablePaddings = _a.disablePaddings, navigationPadding = _a.navigationPadding, isMobile = _a.isMobile, contentWidthStyles = _a.contentWidthStyles;
    if (disablePaddings) {
        return /*#__PURE__*/ react.createElement("div", {
            className: className,
            ref: ref
        }, children);
    }
    return /*#__PURE__*/ react.createElement("div", {
        ref: ref,
        className: (0,clsx_m/* default */.Z)(className, content_wrapper_styles_css["content-wrapper"], !navigationPadding && content_wrapper_styles_css["content-wrapper-no-navigation-padding"], !toolsPadding && content_wrapper_styles_css["content-wrapper-no-tools-padding"], isMobile && content_wrapper_styles_css["content-wrapper-mobile"]),
        style: contentWidthStyles
    }, children);
});
/* harmony default export */ var content_wrapper = (ContentWrapper); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/motion.js
var motion = __webpack_require__(6279);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-effect-on-update.js
var use_effect_on_update = __webpack_require__(9876);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/drawer.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




// This matches the design token awsui.$border-divider-section-width in Visual Refresh
var BORDER_WIDTH = 2;
// We are using two landmarks per drawer, i.e. two NAVs and two ASIDEs, because of several
// known bugs in NVDA that cause focus changes within a container to sometimes not be
// announced. As a result, we use one region for the open button and one region for the
// actual drawer content, always hiding the other one when it's not visible.
// An alternative solution to follow a more classic implementation here to only have one
// button that triggers the opening/closing of the drawer also did not work due to another
// series of bugs in NVDA (together with Firefox) which prevent the changed expanded state
// from being announced.
// Even with this workaround in place, the announcement of the close button when opening a
// panel in NVDA is not working correctly. The suspected root cause is one of the bugs below
// as well.
// Relevant tickets:
// * https://github.com/nvaccess/nvda/issues/6606
// * https://github.com/nvaccess/nvda/issues/5825
// * https://github.com/nvaccess/nvda/issues/5247
// * https://github.com/nvaccess/nvda/pull/8869 (reverted PR that was going to fix it)
function Drawer(_a) {
    var _b;
    var contentClassName = _a.contentClassName, toggleClassName = _a.toggleClassName, closeClassName = _a.closeClassName, width = _a.width, type = _a.type, toggleRefs = _a.toggleRefs, topOffset = _a.topOffset, bottomOffset = _a.bottomOffset, ariaLabels = _a.ariaLabels, children = _a.children, isOpen = _a.isOpen, isHidden = _a.isHidden, isMobile = _a.isMobile, hasDividerWithSplitPanel = _a.hasDividerWithSplitPanel, onToggle = _a.onToggle, onClick = _a.onClick, onLoseFocus = _a.onLoseFocus, _c = _a.extendRight, extendRight = _c === void 0 ? 0 : _c;
    var _d = togglesConfig[type], TagName = _d.TagName, iconName = _d.iconName, getLabels = _d.getLabels;
    var _e = getLabels(ariaLabels), mainLabel = _e.mainLabel, closeLabel = _e.closeLabel, openLabel = _e.openLabel;
    var hasDividerWithButtonBar = isOpen && extendRight !== 0;
    var drawerContentWidthOpen = isMobile ? undefined : width;
    var drawerContentWidth = isOpen ? drawerContentWidthOpen : undefined;
    var drawerWidth = hasDividerWithButtonBar && drawerContentWidth ? drawerContentWidth + BORDER_WIDTH : drawerContentWidth;
    var closeIconName = "close";
    var regularOpenButton = /*#__PURE__*/ react.createElement(TagName, {
        "aria-label": mainLabel,
        className: app_layout_styles_css.toggle,
        "aria-hidden": isOpen
    }, /*#__PURE__*/ react.createElement(AppLayoutButton, {
        ref: toggleRefs.toggle,
        className: toggleClassName,
        iconName: iconName,
        ariaLabel: openLabel,
        onClick: function() {
            return onToggle(true);
        },
        ariaExpanded: false
    }));
    return /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(app_layout_styles_css.drawer, (_b = {}, _b[app_layout_styles_css["drawer-closed"]] = !isOpen, _b[app_layout_styles_css["drawer-hidden"]] = isHidden, _b[app_layout_styles_css["drawer-mobile"]] = isMobile, _b[app_layout_styles_css["has-divider-with-splitpanel"]] = hasDividerWithSplitPanel, _b[app_layout_styles_css["opaque-background"]] = hasDividerWithButtonBar, _b)),
        style: {
            width: drawerWidth,
            marginRight: isOpen ? -1 * extendRight : 0,
            paddingRight: isOpen ? extendRight : 0
        },
        onBlur: onLoseFocus ? function(e) {
            if (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) {
                onLoseFocus(e);
            }
        } : undefined,
        onClick: function(event) {
            if (onClick) {
                onClick(event);
            }
            if (!isOpen) {
                // to prevent calling onToggle from the drawer when it's called from the toggle button
                if (event.target.tagName !== "BUTTON") {
                    onToggle(true);
                }
            }
        }
    }, /*#__PURE__*/ react.createElement("div", {
        style: {
            width: drawerContentWidth,
            top: topOffset,
            bottom: bottomOffset
        },
        className: (0,clsx_m/* default */.Z)(app_layout_styles_css["drawer-content"], contentClassName)
    }, !isMobile && regularOpenButton, /*#__PURE__*/ react.createElement(TagName, {
        "aria-label": mainLabel,
        "aria-hidden": !isOpen
    }, /*#__PURE__*/ react.createElement(CloseButton, {
        ref: toggleRefs.close,
        className: closeClassName,
        ariaLabel: closeLabel,
        onClick: function() {
            return onToggle(false);
        },
        iconName: closeIconName
    }), children)));
} //# sourceMappingURL=drawer.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/navigation-panel.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





function NavigationPanel(_a) {
    var _b;
    var ariaLabels = _a.ariaLabels, footerHeight = _a.footerHeight, headerHeight = _a.headerHeight, isHidden = _a.isHidden, isMobile = _a.isMobile, navigation = _a.navigation, navigationDrawerWidth = _a.navigationDrawerWidth, navigationWidth = _a.navigationWidth, navigationOpen = _a.navigationOpen, onClick = _a.onClick, onNavigationToggle = _a.onNavigationToggle, panelHeightStyle = _a.panelHeightStyle, toggleRefs = _a.toggleRefs;
    return /*#__PURE__*/ react.createElement("div", {
        className: app_layout_styles_css["navigation-panel"],
        style: {
            width: navigationDrawerWidth
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(app_layout_styles_css["panel-wrapper-outer"], (_b = {}, _b[app_layout_styles_css.mobile] = isMobile, _b[app_layout_styles_css.open] = navigationOpen, _b)),
        style: (0,tslib_es6/* __assign */.pi)({}, isMobile ? {
            top: headerHeight,
            bottom: footerHeight
        } : panelHeightStyle)
    }, /*#__PURE__*/ react.createElement(Drawer, {
        type: "navigation",
        isMobile: isMobile,
        width: navigationWidth,
        isOpen: navigationOpen,
        isHidden: isHidden,
        onToggle: onNavigationToggle,
        toggleRefs: toggleRefs,
        onClick: onClick,
        contentClassName: (0,clsx_m/* default */.Z)(app_layout_styles_css.navigation, test_classes_styles_css.navigation),
        closeClassName: (0,clsx_m/* default */.Z)(app_layout_styles_css["navigation-close"], test_classes_styles_css["navigation-close"]),
        toggleClassName: (0,clsx_m/* default */.Z)(app_layout_styles_css["navigation-toggle"], test_classes_styles_css["navigation-toggle"]),
        topOffset: headerHeight,
        bottomOffset: footerHeight,
        ariaLabels: ariaLabels
    }, navigation)));
} //# sourceMappingURL=navigation-panel.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/tools-and-split-panel.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





function ToolsAndSplitPanel(_a) {
    var _b;
    var ariaLabels = _a.ariaLabels, drawerWidth = _a.drawerWidth, footerHeight = _a.footerHeight, headerHeight = _a.headerHeight, isHidden = _a.isHidden, isMobile = _a.isMobile, onToolsToggle = _a.onToolsToggle, panelHeightStyle = _a.panelHeightStyle, splitPanel = _a.splitPanel, toggleRefs = _a.toggleRefs, onLoseToolsFocus = _a.onLoseToolsFocus, tools = _a.tools, toolsHide = _a.toolsHide, toolsOpen = _a.toolsOpen, toolsWidth = _a.toolsWidth, splitPanelOpen = _a.splitPanelOpen;
    var splitPanelVisible = splitPanelOpen && Boolean(splitPanel);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("div", {
        style: {
            width: drawerWidth
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(app_layout_styles_css["panel-wrapper-outer"], (_b = {}, _b[app_layout_styles_css.mobile] = isMobile, _b[app_layout_styles_css.open] = toolsOpen, _b)),
        style: (0,tslib_es6/* __assign */.pi)({}, isMobile ? {
            top: headerHeight,
            bottom: footerHeight
        } : panelHeightStyle)
    }, splitPanel, !toolsHide && /*#__PURE__*/ react.createElement(Drawer, {
        type: "tools",
        isMobile: isMobile,
        width: toolsWidth,
        isOpen: toolsOpen,
        onToggle: onToolsToggle,
        toggleRefs: toggleRefs,
        onLoseFocus: onLoseToolsFocus,
        isHidden: isHidden,
        externalizedToggle: Boolean(splitPanel),
        contentClassName: (0,clsx_m/* default */.Z)(app_layout_styles_css.tools, test_classes_styles_css.tools),
        closeClassName: (0,clsx_m/* default */.Z)(app_layout_styles_css["tools-close"], test_classes_styles_css["tools-close"]),
        toggleClassName: (0,clsx_m/* default */.Z)(app_layout_styles_css["tools-toggle"], test_classes_styles_css["tools-toggle"]),
        topOffset: headerHeight,
        bottomOffset: footerHeight,
        ariaLabels: ariaLabels,
        extendRight: 0,
        hasDividerWithSplitPanel: splitPanelVisible
    }, tools))));
} //# sourceMappingURL=tools-and-split-panel.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-previous-frame/index.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * This hook provides access to the value of any variable
 * from the previous render frame.
 * Even if multiple effects are flushed in a single render
 * loop, this hook still keeps the original value.
 */ var usePreviousFrameValue = function(value) {
    var ref = (0,react.useRef)();
    (0,react.useEffect)(function() {
        var handle = requestAnimationFrame(function() {
            ref.current = value;
        });
        return function() {
            return cancelAnimationFrame(handle);
        };
    });
    return ref.current;
}; //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/container-queries/use-resize-observer.js
var use_resize_observer = __webpack_require__(913);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/utils/use-content-width.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function useAppLayoutOffsets(element) {
    var _a = (0,react.useState)({
        left: 0,
        right: 0
    }), offsets = _a[0], setOffsets = _a[1];
    var updatePosition = (0,react.useCallback)(function() {
        if (!element) {
            return;
        }
        var _a = element.getBoundingClientRect(), left = _a.left, right = _a.right;
        var bodyWidth = document.body.clientWidth;
        setOffsets({
            left: left,
            right: bodyWidth - right
        });
    }, [
        element
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener("resize", updatePosition);
        return function() {
            return window.removeEventListener("resize", updatePosition);
        };
    }, [
        updatePosition
    ]);
    var getElement = (0,react.useCallback)(function() {
        return element;
    }, [
        element
    ]);
    (0,use_resize_observer/* useResizeObserver */.y)(getElement, updatePosition);
    return offsets;
} //# sourceMappingURL=use-content-width.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/is-development.js
var is_development = __webpack_require__(5856);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/logging.js
var logging = __webpack_require__(3742);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/app-layout/visual-refresh/context.js
var context = __webpack_require__(7919);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/app-layout/visual-refresh/styles.css.js
var visual_refresh_styles_css = __webpack_require__(2415);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/visual-refresh/app-bar.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0







/**
 * The CSS class 'awsui-context-content-header' needs to be added to the root element so
 * that the design tokens used are overridden with the appropriate values.
 */ function AppBar() {
    var _a, _b, _c, _d;
    var _e, _f, _g;
    var _h = (0,react.useContext)(context/* AppLayoutContext */.T), ariaLabels = _h.ariaLabels, breadcrumbs = _h.breadcrumbs, contentHeader = _h.contentHeader, contentType = _h.contentType, dynamicOverlapHeight = _h.dynamicOverlapHeight, handleNavigationClick = _h.handleNavigationClick, handleToolsClick = _h.handleToolsClick, hasNotificationsContent = _h.hasNotificationsContent, hasStickyBackground = _h.hasStickyBackground, isMobile = _h.isMobile, navigationHide = _h.navigationHide, isNavigationOpen = _h.isNavigationOpen, isToolsOpen = _h.isToolsOpen, toolsHide = _h.toolsHide, isAnyPanelOpen = _h.isAnyPanelOpen;
    var focusRefsNav = (0,use_focus_control/* useFocusControl */.c)(isNavigationOpen).refs;
    var focusRefsTools = (0,use_focus_control/* useFocusControl */.c)(isToolsOpen, true).refs;
    if (navigationHide && !breadcrumbs && toolsHide) {
        return null;
    }
    return /*#__PURE__*/ react.createElement("section", {
        "aria-hidden": !isMobile && !breadcrumbs ? true : undefined,
        className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.appbar */.Z.appbar, (_a = {}, _a[visual_refresh_styles_css/* default.has-breadcrumbs */.Z["has-breadcrumbs"]] = breadcrumbs, _a[visual_refresh_styles_css/* default.unfocusable */.Z.unfocusable] = isMobile && isAnyPanelOpen, _a[test_classes_styles_css["mobile-bar"]] = isMobile, _a), "awsui-context-content-header")
    }, !navigationHide && isMobile && /*#__PURE__*/ react.createElement("nav", {
        className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.appbar-nav */.Z["appbar-nav"], (_b = {}, _b[test_classes_styles_css["drawer-closed"]] = !isNavigationOpen, _b)),
        "aria-hidden": isNavigationOpen
    }, /*#__PURE__*/ react.createElement(internal/* InternalButton */.l, {
        ariaLabel: (_e = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigationToggle) !== null && _e !== void 0 ? _e : undefined,
        ariaExpanded: isNavigationOpen,
        iconName: "menu",
        formAction: "none",
        onClick: function() {
            return handleNavigationClick(true);
        },
        variant: "icon",
        className: test_classes_styles_css["navigation-toggle"],
        ref: focusRefsNav.toggle,
        disabled: isAnyPanelOpen,
        __nativeAttributes: {
            "aria-haspopup": true
        }
    })), breadcrumbs && /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.breadcrumbs */.Z.breadcrumbs, visual_refresh_styles_css/* default */.Z["content-type-".concat(contentType)], test_classes_styles_css.breadcrumbs, (_c = {}, _c[visual_refresh_styles_css/* default.has-dynamic-overlap-height */.Z["has-dynamic-overlap-height"]] = dynamicOverlapHeight > 0, _c[visual_refresh_styles_css/* default.has-header */.Z["has-header"]] = contentHeader, _c[visual_refresh_styles_css/* default.has-notifications-content */.Z["has-notifications-content"]] = hasNotificationsContent, _c[visual_refresh_styles_css/* default.has-sticky-background */.Z["has-sticky-background"]] = hasStickyBackground, _c))
    }, breadcrumbs), !toolsHide && isMobile && /*#__PURE__*/ react.createElement("aside", {
        className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.appbar-tools */.Z["appbar-tools"], (_d = {}, _d[test_classes_styles_css["drawer-closed"]] = !isToolsOpen, _d)),
        "aria-hidden": isToolsOpen,
        "aria-label": (_f = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tools) !== null && _f !== void 0 ? _f : undefined
    }, /*#__PURE__*/ react.createElement(internal/* InternalButton */.l, {
        className: test_classes_styles_css["tools-toggle"],
        ariaExpanded: isToolsOpen,
        disabled: isAnyPanelOpen,
        ariaLabel: (_g = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.toolsToggle) !== null && _g !== void 0 ? _g : undefined,
        iconName: "status-info",
        formAction: "none",
        onClick: function() {
            return handleToolsClick(true);
        },
        variant: "icon",
        ref: focusRefsTools.toggle,
        __nativeAttributes: {
            "aria-haspopup": true
        }
    })));
} //# sourceMappingURL=app-bar.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/visual-refresh/background.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




/**
 * The CSS class 'awsui-context-content-header' needs to be added to the root element so
 * that the design tokens used are overridden with the appropriate values.
 */ function Background() {
    var _a, _b;
    var _c = (0,react.useContext)(context/* AppLayoutContext */.T), hasNotificationsContent = _c.hasNotificationsContent, hasStickyBackground = _c.hasStickyBackground, stickyNotifications = _c.stickyNotifications;
    return /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.background */.Z.background, "awsui-context-content-header")
    }, /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.notifications-appbar-header */.Z["notifications-appbar-header"], (_a = {}, _a[visual_refresh_styles_css/* default.has-notifications-content */.Z["has-notifications-content"]] = hasNotificationsContent, _a[visual_refresh_styles_css/* default.has-sticky-background */.Z["has-sticky-background"]] = hasStickyBackground, _a[visual_refresh_styles_css/* default.sticky-notifications */.Z["sticky-notifications"]] = stickyNotifications, _a))
    }), /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.overlap */.Z.overlap, (_b = {}, _b[visual_refresh_styles_css/* default.has-sticky-background */.Z["has-sticky-background"]] = hasStickyBackground, _b))
    }));
} //# sourceMappingURL=background.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/visual-refresh/header.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




/**
 * The CSS class 'awsui-context-content-header' needs to be added to the root element so
 * that the design tokens used are overridden with the appropriate values.
 */ function Header() {
    var _a;
    var _b = (0,react.useContext)(context/* AppLayoutContext */.T), breadcrumbs = _b.breadcrumbs, contentHeader = _b.contentHeader, hasNotificationsContent = _b.hasNotificationsContent;
    if (!contentHeader) {
        return null;
    }
    return /*#__PURE__*/ react.createElement("header", {
        className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.content */.Z.content, (_a = {}, _a[visual_refresh_styles_css/* default.has-breadcrumbs */.Z["has-breadcrumbs"]] = breadcrumbs, _a[visual_refresh_styles_css/* default.has-notifications-content */.Z["has-notifications-content"]] = hasNotificationsContent, _a), "awsui-context-content-header")
    }, contentHeader);
} //# sourceMappingURL=header.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/generated/custom-css-properties/index.js
var custom_css_properties = __webpack_require__(8276);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/visual-refresh/layout.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0







/**
 * The layoutElement ref will be used by the resize observers to calculate the offset from
 * the top and bottom of the viewport based on the header and footer elements. This is to
 * ensure the Layout component minimum height will fill 100% of the viewport less those
 * cumulative heights.
 */ function Layout(_a) {
    var _b, _c, _d, _e, _f, _g;
    var children = _a.children;
    var _h = (0,react.useContext)(context/* AppLayoutContext */.T), contentHeader = _h.contentHeader, contentType = _h.contentType, disableBodyScroll = _h.disableBodyScroll, disableContentHeaderOverlap = _h.disableContentHeaderOverlap, dynamicOverlapHeight = _h.dynamicOverlapHeight, footerHeight = _h.footerHeight, hasNotificationsContent = _h.hasNotificationsContent, headerHeight = _h.headerHeight, isNavigationOpen = _h.isNavigationOpen, isSplitPanelOpen = _h.isSplitPanelOpen, isToolsOpen = _h.isToolsOpen, layoutElement = _h.layoutElement, layoutWidth = _h.layoutWidth, mainOffsetLeft = _h.mainOffsetLeft, maxContentWidth = _h.maxContentWidth, minContentWidth = _h.minContentWidth, navigationHide = _h.navigationHide, notificationsHeight = _h.notificationsHeight, setOffsetBottom = _h.setOffsetBottom, splitPanel = _h.splitPanel, stickyNotifications = _h.stickyNotifications, toolsHide = _h.toolsHide;
    var _j = (0,react.useContext)(split_panel_context/* SplitPanelContext */.C), getSplitPanelHeader = _j.getHeader, splitPanelPosition = _j.position, splitPanelSize = _j.size;
    var isOverlapDisabled = getOverlapDisabled(dynamicOverlapHeight, contentHeader, disableContentHeaderOverlap);
    // Content gaps on the left and right are used with the minmax function in the CSS grid column definition
    var hasContentGapLeft = getContentGapLeft(isNavigationOpen, navigationHide);
    var hasContentGapRight = getContentGapRight(splitPanelPosition, isSplitPanelOpen, isToolsOpen, splitPanel, toolsHide);
    /**
     * Determine the offsetBottom value based on the presence of a footer element and
     * the SplitPanel component. Ignore the SplitPanel if it is not in the bottom
     * position. Use the size property if it is open and the header height if it is closed.
     */ (0,react.useLayoutEffect)(function handleOffsetBottom() {
        var offsetBottom = footerHeight;
        if (splitPanel && splitPanelPosition === "bottom") {
            if (isSplitPanelOpen) {
                offsetBottom += splitPanelSize;
            } else {
                var splitPanelHeader = getSplitPanelHeader();
                offsetBottom += splitPanelHeader ? splitPanelHeader.clientHeight : 0;
            }
        }
        setOffsetBottom(offsetBottom);
    }, [
        footerHeight,
        getSplitPanelHeader,
        isSplitPanelOpen,
        setOffsetBottom,
        splitPanelPosition,
        splitPanel,
        splitPanelSize
    ]);
    return /*#__PURE__*/ react.createElement("main", {
        className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.layout */.Z.layout, visual_refresh_styles_css/* default */.Z["content-type-".concat(contentType)], visual_refresh_styles_css/* default */.Z["split-panel-position-".concat(splitPanelPosition !== null && splitPanelPosition !== void 0 ? splitPanelPosition : "bottom")], (_b = {}, _b[visual_refresh_styles_css/* default.disable-body-scroll */.Z["disable-body-scroll"]] = disableBodyScroll, _b[test_classes_styles_css["disable-body-scroll-root"]] = disableBodyScroll, _b[visual_refresh_styles_css/* default.has-content-gap-left */.Z["has-content-gap-left"]] = hasContentGapLeft, _b[visual_refresh_styles_css/* default.has-content-gap-right */.Z["has-content-gap-right"]] = hasContentGapRight, _b[visual_refresh_styles_css/* default.has-max-content-width */.Z["has-max-content-width"]] = maxContentWidth && maxContentWidth > 0, _b[visual_refresh_styles_css/* default.has-split-panel */.Z["has-split-panel"]] = splitPanel, _b[visual_refresh_styles_css/* default.has-sticky-notifications */.Z["has-sticky-notifications"]] = stickyNotifications && hasNotificationsContent, _b[visual_refresh_styles_css/* default.is-overlap-disabled */.Z["is-overlap-disabled"]] = isOverlapDisabled, _b), test_classes_styles_css.root),
        ref: layoutElement,
        style: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((_c = {}, _c[custom_css_properties/* default.headerHeight */.Z.headerHeight] = "".concat(headerHeight, "px"), _c[custom_css_properties/* default.footerHeight */.Z.footerHeight] = "".concat(footerHeight, "px"), _c[custom_css_properties/* default.layoutWidth */.Z.layoutWidth] = "".concat(layoutWidth, "px"), _c[custom_css_properties/* default.mainOffsetLeft */.Z.mainOffsetLeft] = "".concat(mainOffsetLeft, "px"), _c), maxContentWidth && (_d = {}, _d[custom_css_properties/* default.maxContentWidth */.Z.maxContentWidth] = "".concat(maxContentWidth, "px"), _d)), minContentWidth && (_e = {}, _e[custom_css_properties/* default.minContentWidth */.Z.minContentWidth] = "".concat(minContentWidth, "px"), _e)), (_f = {}, _f[custom_css_properties/* default.notificationsHeight */.Z.notificationsHeight] = "".concat(notificationsHeight, "px"), _f)), !isOverlapDisabled && dynamicOverlapHeight > 0 && (_g = {}, _g[custom_css_properties/* default.overlapHeight */.Z.overlapHeight] = "".concat(dynamicOverlapHeight, "px"), _g))
    }, children);
}
/**
 * When the Navigation and Tools are present the grid definition has the center column
 * touch the first and last columns with no gap. The forms with the circular buttons
 * for Navigation and Tools have internal padding which creates the necessary
 * horizontal space when the drawers are closed. The remaining conditions below
 * determine the necessity of utilizing the content gap left property to create
 * horizontal space between the center column and its adjacent siblings.
 */ function getContentGapRight(splitPanelPosition, isSplitPanelOpen, isToolsOpen, splitPanel, toolsHide) {
    var hasContentGapRight = false;
    // Main is touching the edge of the Layout and needs a content gap
    if (!splitPanel && toolsHide) {
        hasContentGapRight = true;
    }
    // Main is touching the Tools drawer and needs a content gap
    if ((!splitPanel || !isSplitPanelOpen) && !toolsHide && isToolsOpen) {
        hasContentGapRight = true;
    }
    // Main is touching the edge of the Layout and needs a content gap
    if (splitPanel && splitPanelPosition === "bottom" && (isToolsOpen || toolsHide)) {
        hasContentGapRight = true;
    }
    // Main is touching the Split Panel drawer and needs a content gap
    if (splitPanel && isSplitPanelOpen && splitPanelPosition === "side") {
        hasContentGapRight = true;
    }
    return hasContentGapRight;
}
/**
 * Additional function to determine whether or not a content gap is needed
 * on the left (see the getContentGapRight function). The same render logic applies
 * regarding the center column touching an adjacent sibling but the only
 * component state that needs to be tracked is the Navigation.
 */ function getContentGapLeft(isNavigationOpen, navigationHide) {
    return isNavigationOpen || navigationHide ? true : false;
}
/**
 * Determine whether the overlap between the contentHeader and content slots should be disabled.
 * The disableContentHeaderOverlap property is absolute and will always disable the overlap
 * if it is set to true. If there is no contentHeader then the overlap should be disabled
 * unless there is a dynamicOverlapHeight. The dynamicOverlapHeight property is set by a
 * component in the content slot that needs to manually control the overlap height. Components
 * such as the Table (full page variant), Wizard, ContentLayout use this property and will
 * retain the overlap even if there is nothing rendered in the contentHeader slot.
 */ function getOverlapDisabled(dynamicOverlapHeight, contentHeader, disableContentHeaderOverlap) {
    var isOverlapDisabled = false;
    if (disableContentHeaderOverlap) {
        isOverlapDisabled = true;
    } else if (!contentHeader && dynamicOverlapHeight <= 0) {
        isOverlapDisabled = true;
    }
    return isOverlapDisabled;
} //# sourceMappingURL=layout.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/visual-refresh/main.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0







function Main() {
    var _a, _b;
    var _c = (0,react.useContext)(context/* AppLayoutContext */.T), breadcrumbs = _c.breadcrumbs, content = _c.content, contentHeader = _c.contentHeader, contentType = _c.contentType, disableContentPaddings = _c.disableContentPaddings, dynamicOverlapHeight = _c.dynamicOverlapHeight, hasNotificationsContent = _c.hasNotificationsContent, isNavigationOpen = _c.isNavigationOpen, isSplitPanelOpen = _c.isSplitPanelOpen, isToolsOpen = _c.isToolsOpen, isMobile = _c.isMobile, isAnyPanelOpen = _c.isAnyPanelOpen, mainElement = _c.mainElement, splitPanel = _c.splitPanel, offsetBottom = _c.offsetBottom, footerHeight = _c.footerHeight;
    var splitPanelPosition = (0,react.useContext)(split_panel_context/* SplitPanelContext */.C).position;
    var isUnfocusable = isMobile && isAnyPanelOpen;
    var splitPanelHeight = offsetBottom - footerHeight;
    return /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.container */.Z.container, visual_refresh_styles_css/* default */.Z["content-type-".concat(contentType)], visual_refresh_styles_css/* default */.Z["split-panel-position-".concat(splitPanelPosition !== null && splitPanelPosition !== void 0 ? splitPanelPosition : "bottom")], (_a = {}, _a[visual_refresh_styles_css/* default.disable-content-paddings */.Z["disable-content-paddings"]] = disableContentPaddings, _a[visual_refresh_styles_css/* default.has-breadcrumbs */.Z["has-breadcrumbs"]] = breadcrumbs, _a[visual_refresh_styles_css/* default.has-dynamic-overlap-height */.Z["has-dynamic-overlap-height"]] = dynamicOverlapHeight > 0, _a[visual_refresh_styles_css/* default.has-header */.Z["has-header"]] = contentHeader, _a[visual_refresh_styles_css/* default.has-notifications-content */.Z["has-notifications-content"]] = hasNotificationsContent, _a[visual_refresh_styles_css/* default.has-split-panel */.Z["has-split-panel"]] = splitPanel, _a[visual_refresh_styles_css/* default.is-navigation-open */.Z["is-navigation-open"]] = isNavigationOpen, _a[visual_refresh_styles_css/* default.is-tools-open */.Z["is-tools-open"]] = isToolsOpen, _a[visual_refresh_styles_css/* default.is-split-panel-open */.Z["is-split-panel-open"]] = isSplitPanelOpen, _a[visual_refresh_styles_css/* default.unfocusable */.Z.unfocusable] = isUnfocusable, _a), test_classes_styles_css.content),
        ref: mainElement,
        style: (_b = {}, _b[custom_css_properties/* default.splitPanelHeight */.Z.splitPanelHeight] = "".concat(splitPanelHeight, "px"), _b)
    }, content);
} //# sourceMappingURL=main.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/focus-visible/index.js
var focus_visible = __webpack_require__(9297);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/icon/internal.js + 2 modules
var icon_internal = __webpack_require__(776);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/visual-refresh/trigger-button.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





function TriggerButton(_a, ref) {
    var _b;
    var ariaLabel = _a.ariaLabel, iconName = _a.iconName, onClick = _a.onClick, _c = _a.selected, selected = _c === void 0 ? false : _c, className = _a.className;
    var focusVisible = (0,focus_visible/* default */.Z)();
    return /*#__PURE__*/ react.createElement("button", (0,tslib_es6/* __assign */.pi)({
        "aria-label": ariaLabel,
        "aria-expanded": false,
        "aria-haspopup": true,
        className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.trigger */.Z.trigger, (_b = {}, _b[visual_refresh_styles_css/* default.selected */.Z.selected] = selected, _b), className),
        onClick: onClick,
        type: "button",
        ref: ref
    }, focusVisible), /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
        name: iconName
    }));
}
/* harmony default export */ var trigger_button = (/*#__PURE__*/react.forwardRef(TriggerButton)); //# sourceMappingURL=trigger-button.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/transition/index.js
var transition = __webpack_require__(8437);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/visual-refresh/navigation.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0











/**
 * The Navigation component consists of the following elements:
 * the container, or root element, that sits as a direct child to the Layout grid definition;
 * the show navigation form that contains the trigger for the drawer in large viewports;
 * the navigation, or drawer, that contains the hide navigation form and the children
 * passed through the API;
 */ function Navigation() {
    var _a = (0,react.useContext)(context/* AppLayoutContext */.T), ariaLabels = _a.ariaLabels, handleNavigationClick = _a.handleNavigationClick, isMobile = _a.isMobile, isNavigationOpen = _a.isNavigationOpen, navigation = _a.navigation, navigationHide = _a.navigationHide, navigationWidth = _a.navigationWidth, isToolsOpen = _a.isToolsOpen, isAnyPanelOpen = _a.isAnyPanelOpen, toolsHide = _a.toolsHide;
    var focusRefs = (0,use_focus_control/* useFocusControl */.c)(isNavigationOpen).refs;
    if (navigationHide) {
        return null;
    }
    // Close the Navigation drawer on mobile when a user clicks a link inside.
    var onNavigationClick = function(event) {
        var hasLink = (0,dom/* findUpUntil */.jX)(event.target, function(node) {
            return node.tagName === "A" && !!node.href;
        });
        if (hasLink && isMobile) {
            handleNavigationClick(false);
        }
    };
    var isUnfocusable = isMobile && isAnyPanelOpen && isToolsOpen && !toolsHide;
    return /*#__PURE__*/ react.createElement(transition/* Transition */.u, {
        "in": isNavigationOpen
    }, function(state, transitionEventsRef) {
        var _a, _b, _c, _d;
        var _e, _f, _g;
        return /*#__PURE__*/ react.createElement("div", {
            className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.navigation-container */.Z["navigation-container"], (_a = {}, _a[test_classes_styles_css["drawer-closed"]] = !isNavigationOpen, _a[visual_refresh_styles_css/* default.unfocusable */.Z.unfocusable] = isUnfocusable, _a)),
            // Overwrite the default nav width (depends on breakpoints) only when the `navigationWidth` property is set.
            style: (0,tslib_es6/* __assign */.pi)({}, navigationWidth && (_b = {}, _b[custom_css_properties/* default.navigationWidth */.Z.navigationWidth] = "".concat(navigationWidth, "px"), _b))
        }, !isMobile && /*#__PURE__*/ react.createElement("nav", {
            "aria-hidden": isMobile || isNavigationOpen ? true : false,
            "aria-label": (_e = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigation) !== null && _e !== void 0 ? _e : undefined,
            className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.show-navigation */.Z["show-navigation"], (_c = {}, _c[visual_refresh_styles_css/* default.animating */.Z.animating] = state === "exiting", _c[visual_refresh_styles_css/* default.is-navigation-open */.Z["is-navigation-open"]] = isNavigationOpen, _c)),
            ref: state === "exiting" ? transitionEventsRef : undefined
        }, /*#__PURE__*/ react.createElement(trigger_button, {
            ariaLabel: ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigationToggle,
            iconName: "menu",
            className: test_classes_styles_css["navigation-toggle"],
            onClick: function() {
                return handleNavigationClick(true);
            },
            ref: focusRefs.toggle
        })), /*#__PURE__*/ react.createElement("nav", {
            "aria-label": (_f = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigation) !== null && _f !== void 0 ? _f : undefined,
            className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.navigation */.Z.navigation, (_d = {}, _d[visual_refresh_styles_css/* default.animating */.Z.animating] = state === "entering", _d[visual_refresh_styles_css/* default.is-navigation-open */.Z["is-navigation-open"]] = isNavigationOpen, _d), test_classes_styles_css.navigation),
            ref: state !== "exiting" ? transitionEventsRef : undefined,
            "aria-hidden": !isNavigationOpen,
            onClick: function(event) {
                onNavigationClick && onNavigationClick(event);
            }
        }, /*#__PURE__*/ react.createElement("div", {
            className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.animated-content */.Z["animated-content"])
        }, /*#__PURE__*/ react.createElement("div", {
            className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.hide-navigation */.Z["hide-navigation"])
        }, /*#__PURE__*/ react.createElement(internal/* InternalButton */.l, {
            ariaLabel: (_g = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigationClose) !== null && _g !== void 0 ? _g : undefined,
            iconName: isMobile ? "close" : "angle-left",
            onClick: function() {
                return handleNavigationClick(false);
            },
            variant: "icon",
            formAction: "none",
            className: test_classes_styles_css["navigation-close"],
            ref: focusRefs.close,
            ariaExpanded: true,
            __nativeAttributes: {
                "aria-haspopup": true
            }
        })), navigation)));
    });
} //# sourceMappingURL=navigation.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/visual-refresh/notifications.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





/**
 * The CSS class 'awsui-context-content-header' needs to be added to the root element so
 * that the design tokens used are overridden with the appropriate values.
 */ function notifications_Notifications() {
    var _a;
    var _b;
    var _c = (0,react.useContext)(context/* AppLayoutContext */.T), ariaLabels = _c.ariaLabels, hasNotificationsContent = _c.hasNotificationsContent, notifications = _c.notifications, notificationsElement = _c.notificationsElement, stickyNotifications = _c.stickyNotifications;
    if (!notifications) {
        return null;
    }
    return /*#__PURE__*/ react.createElement("div", {
        role: "region",
        "aria-label": (_b = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.notifications) !== null && _b !== void 0 ? _b : undefined,
        className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.notifications */.Z.notifications, (_a = {}, _a[visual_refresh_styles_css/* default.has-notifications-content */.Z["has-notifications-content"]] = hasNotificationsContent, _a[visual_refresh_styles_css/* default.sticky-notifications */.Z["sticky-notifications"]] = stickyNotifications, _a), test_classes_styles_css.notifications, "awsui-context-content-header"),
        ref: notificationsElement
    }, notifications);
} //# sourceMappingURL=notifications.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/app-layout/visual-refresh/split-panel.js
var split_panel = __webpack_require__(9194);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/split-panel/styles.scoped.css
var split_panel_styles_scoped = __webpack_require__(8003);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/split-panel/styles.css.js

/* harmony default export */ var split_panel_styles_css = ({
    "drawer": "awsui_drawer_1r9lg_8m9sl_189",
    "refresh": "awsui_refresh_1r9lg_8m9sl_189",
    "animating": "awsui_animating_1r9lg_8m9sl_203",
    "preference-icon--layout-border": "awsui_preference-icon--layout-border_1r9lg_8m9sl_226",
    "preference-icon--layout-background": "awsui_preference-icon--layout-background_1r9lg_8m9sl_230",
    "preference-icon--layout-header": "awsui_preference-icon--layout-header_1r9lg_8m9sl_233",
    "preference-icon--border": "awsui_preference-icon--border_1r9lg_8m9sl_236",
    "preference-icon--primary-button": "awsui_preference-icon--primary-button_1r9lg_8m9sl_240",
    "preference-icon--secondary": "awsui_preference-icon--secondary_1r9lg_8m9sl_243",
    "preference-icon--disabled-element": "awsui_preference-icon--disabled-element_1r9lg_8m9sl_246",
    "preference-icon--separator": "awsui_preference-icon--separator_1r9lg_8m9sl_249",
    "preference-icon--focus-text": "awsui_preference-icon--focus-text_1r9lg_8m9sl_252",
    "preference-icon-refresh--layout-top": "awsui_preference-icon-refresh--layout-top_1r9lg_8m9sl_256",
    "preference-icon-refresh--layout-main": "awsui_preference-icon-refresh--layout-main_1r9lg_8m9sl_259",
    "preference-icon-refresh--primary": "awsui_preference-icon-refresh--primary_1r9lg_8m9sl_262",
    "preference-icon-refresh--disabled": "awsui_preference-icon-refresh--disabled_1r9lg_8m9sl_265",
    "preference-icon-refresh--column-header": "awsui_preference-icon-refresh--column-header_1r9lg_8m9sl_268",
    "preference-icon-refresh--window": "awsui_preference-icon-refresh--window_1r9lg_8m9sl_271",
    "preference-icon-refresh--secondary": "awsui_preference-icon-refresh--secondary_1r9lg_8m9sl_275",
    "preference-icon-refresh--default": "awsui_preference-icon-refresh--default_1r9lg_8m9sl_278",
    "preference-icon-refresh--separator": "awsui_preference-icon-refresh--separator_1r9lg_8m9sl_281",
    "preference-icon-refresh--input-default": "awsui_preference-icon-refresh--input-default_1r9lg_8m9sl_284",
    "preference-icon-refresh--heading": "awsui_preference-icon-refresh--heading_1r9lg_8m9sl_287",
    "resize-active": "awsui_resize-active_1r9lg_8m9sl_292",
    "resize-side": "awsui_resize-side_1r9lg_8m9sl_298",
    "resize-bottom": "awsui_resize-bottom_1r9lg_8m9sl_301",
    "root": "awsui_root_1r9lg_8m9sl_306",
    "preferences-button": "awsui_preferences-button_1r9lg_8m9sl_317",
    "close-button": "awsui_close-button_1r9lg_8m9sl_321",
    "drawer-closed": "awsui_drawer-closed_1r9lg_8m9sl_332",
    "drawer-content-side": "awsui_drawer-content-side_1r9lg_8m9sl_337",
    "drawer-content-bottom": "awsui_drawer-content-bottom_1r9lg_8m9sl_357",
    "position-bottom": "awsui_position-bottom_1r9lg_8m9sl_366",
    "position-side": "awsui_position-side_1r9lg_8m9sl_393",
    "slider": "awsui_slider_1r9lg_8m9sl_399",
    "slider-side": "awsui_slider-side_1r9lg_8m9sl_428",
    "slider-wrapper-bottom": "awsui_slider-wrapper-bottom_1r9lg_8m9sl_433",
    "slider-wrapper-side": "awsui_slider-wrapper-side_1r9lg_8m9sl_444",
    "open-button": "awsui_open-button_1r9lg_8m9sl_455",
    "open-button-side": "awsui_open-button-side_1r9lg_8m9sl_459",
    "slider-icon": "awsui_slider-icon_1r9lg_8m9sl_466",
    "slider-icon-bottom": "awsui_slider-icon-bottom_1r9lg_8m9sl_472",
    "slider-icon-side": "awsui_slider-icon-side_1r9lg_8m9sl_475",
    "pane-header-wrapper-bottom": "awsui_pane-header-wrapper-bottom_1r9lg_8m9sl_479",
    "drawer-mobile": "awsui_drawer-mobile_1r9lg_8m9sl_489",
    "drawer-disable-content-paddings": "awsui_drawer-disable-content-paddings_1r9lg_8m9sl_492",
    "content-bottom": "awsui_content-bottom_1r9lg_8m9sl_500",
    "pane-bottom-center-align": "awsui_pane-bottom-center-align_1r9lg_8m9sl_511",
    "pane-bottom-content-nav-padding": "awsui_pane-bottom-content-nav-padding_1r9lg_8m9sl_516",
    "pane-bottom-content-tools-padding": "awsui_pane-bottom-content-tools-padding_1r9lg_8m9sl_520",
    "content-bottom-max-width": "awsui_content-bottom-max-width_1r9lg_8m9sl_524",
    "content-side": "awsui_content-side_1r9lg_8m9sl_529",
    "pane-header-wrapper-side": "awsui_pane-header-wrapper-side_1r9lg_8m9sl_540",
    "pane-content-wrapper-side": "awsui_pane-content-wrapper-side_1r9lg_8m9sl_543",
    "header": "awsui_header_1r9lg_8m9sl_548",
    "header-text": "awsui_header-text_1r9lg_8m9sl_557",
    "header-divider": "awsui_header-divider_1r9lg_8m9sl_565",
    "header-actions": "awsui_header-actions_1r9lg_8m9sl_571",
    "divider": "awsui_divider_1r9lg_8m9sl_579"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/visual-refresh/tools.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0











/**
 * The Tools component consists of the following elements:
 * the container, or root element, that sits as a direct child to the Layout grid definition;
 * the split panel, which exists only if there is a split panel in side position;
 * the tools, or drawer, that contains the hide tools form and the children passed through the API;
 * the show tools form that contains the triggers for both the drawer and the
 * split panel in large viewports;
 */ function Tools(_a) {
    var children = _a.children;
    var _b = (0,react.useContext)(context/* AppLayoutContext */.T), ariaLabels = _b.ariaLabels, handleSplitPanelClick = _b.handleSplitPanelClick, handleToolsClick = _b.handleToolsClick, hasDefaultToolsWidth = _b.hasDefaultToolsWidth, isNavigationOpen = _b.isNavigationOpen, isMobile = _b.isMobile, isSplitPanelOpen = _b.isSplitPanelOpen, isToolsOpen = _b.isToolsOpen, splitPanel = _b.splitPanel, tools = _b.tools, toolsHide = _b.toolsHide, toolsWidth = _b.toolsWidth, isAnyPanelOpen = _b.isAnyPanelOpen, navigationHide = _b.navigationHide, toolsFocusControl = _b.toolsFocusControl;
    var _c = (0,react.useContext)(split_panel_context/* SplitPanelContext */.C), splitPanelPosition = _c.position, openButtonAriaLabel = _c.openButtonAriaLabel;
    var hasSplitPanel = getSplitPanelStatus(splitPanel, splitPanelPosition);
    var hasToolsForm = getToolsFormStatus(hasSplitPanel, isMobile, isSplitPanelOpen, isToolsOpen, toolsHide);
    var hasToolsFormPersistence = getToolsFormPersistence(hasSplitPanel, isSplitPanelOpen, isToolsOpen, toolsHide);
    var focusRefs = toolsFocusControl.refs;
    if (toolsHide && !hasSplitPanel) {
        return null;
    }
    var isUnfocusable = isMobile && isAnyPanelOpen && isNavigationOpen && !navigationHide;
    return /*#__PURE__*/ react.createElement(transition/* Transition */.u, {
        "in": isToolsOpen !== null && isToolsOpen !== void 0 ? isToolsOpen : false
    }, function(state, transitionEventsRef) {
        var _a, _b, _c, _d;
        var _e, _f, _g;
        return /*#__PURE__*/ react.createElement("div", {
            className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.tools-container */.Z["tools-container"], (_a = {}, _a[test_classes_styles_css["drawer-closed"]] = !isToolsOpen, _a[visual_refresh_styles_css/* default.unfocusable */.Z.unfocusable] = isUnfocusable, _a)),
            style: (_b = {}, _b[custom_css_properties/* default.toolsAnimationStartingOpacity */.Z.toolsAnimationStartingOpacity] = "".concat(hasSplitPanel && isSplitPanelOpen ? 1 : 0), _b[custom_css_properties/* default.toolsWidth */.Z.toolsWidth] = hasDefaultToolsWidth ? "" : "".concat(toolsWidth, "px"), _b),
            onBlur: function(e) {
                if (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) {
                    toolsFocusControl.loseFocus();
                }
            }
        }, children, !toolsHide && /*#__PURE__*/ react.createElement("aside", {
            "aria-hidden": !isToolsOpen ? true : false,
            "aria-label": (_e = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tools) !== null && _e !== void 0 ? _e : undefined,
            className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.tools */.Z.tools, (_c = {}, _c[visual_refresh_styles_css/* default.animating */.Z.animating] = state === "entering", _c[visual_refresh_styles_css/* default.has-tools-form-persistence */.Z["has-tools-form-persistence"]] = hasToolsFormPersistence, _c[visual_refresh_styles_css/* default.is-tools-open */.Z["is-tools-open"]] = isToolsOpen, _c), test_classes_styles_css.tools),
            ref: state !== "exiting" ? transitionEventsRef : undefined
        }, /*#__PURE__*/ react.createElement("div", {
            className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.animated-content */.Z["animated-content"])
        }, /*#__PURE__*/ react.createElement("div", {
            className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.hide-tools */.Z["hide-tools"])
        }, /*#__PURE__*/ react.createElement(internal/* InternalButton */.l, {
            ariaLabel: (_f = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.toolsClose) !== null && _f !== void 0 ? _f : undefined,
            iconName: isMobile ? "close" : "angle-right",
            onClick: function() {
                return handleToolsClick(false);
            },
            variant: "icon",
            formAction: "none",
            className: test_classes_styles_css["tools-close"],
            ref: focusRefs.close,
            ariaExpanded: true,
            __nativeAttributes: {
                "aria-haspopup": true
            }
        })), tools)), !isMobile && /*#__PURE__*/ react.createElement("aside", {
            "aria-hidden": !hasToolsForm ? true : false,
            "aria-label": (_g = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tools) !== null && _g !== void 0 ? _g : undefined,
            className: (0,clsx_m/* default */.Z)(visual_refresh_styles_css/* default.show-tools */.Z["show-tools"], (_d = {}, _d[visual_refresh_styles_css/* default.animating */.Z.animating] = state === "exiting", _d[visual_refresh_styles_css/* default.has-tools-form */.Z["has-tools-form"]] = hasToolsForm, _d[visual_refresh_styles_css/* default.has-tools-form-persistence */.Z["has-tools-form-persistence"]] = hasToolsFormPersistence, _d), split_panel_styles_css.root),
            ref: state === "exiting" ? transitionEventsRef : undefined
        }, !toolsHide && /*#__PURE__*/ react.createElement(trigger_button, {
            ariaLabel: ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.toolsToggle,
            iconName: "status-info",
            onClick: function() {
                return handleToolsClick(!isToolsOpen);
            },
            selected: hasSplitPanel && isToolsOpen,
            className: test_classes_styles_css["tools-toggle"],
            ref: focusRefs.toggle
        }), hasSplitPanel && /*#__PURE__*/ react.createElement(trigger_button, {
            ariaLabel: openButtonAriaLabel,
            iconName: "view-vertical",
            onClick: function() {
                return handleSplitPanelClick();
            },
            selected: hasSplitPanel && isSplitPanelOpen,
            className: split_panel_styles_css["open-button"]
        })));
    });
}
/**
 * Determine the default state of the Tools component. Mobile viewports should be
 * closed by default under all circumstances. If the toolsOpen prop has not been
 * set then it should be closed as well. Otherwise, default to the toolsOpen prop.
 */ function getToolsDefaultState(isMobile, stateFromProps) {
    var isToolsOpen;
    if (isMobile || stateFromProps === undefined) {
        isToolsOpen = false;
    } else {
        isToolsOpen = stateFromProps;
    }
    return isToolsOpen;
}
/**
 * This simple function returns the presence of the split panel as a child of the
 * Tools component. It must exist and be in side position.
 */ function getSplitPanelStatus(splitPanel, splitPanelPosition) {
    return splitPanel && splitPanelPosition === "side" ? true : false;
}
/**
 * By default the Tools form is styled as display: none; This behavior should
 * be unchanged in mobile viewports where the Tools form is always suppressed.
 * In large viewports, however the Tools form and its corresponding buttons
 * should be present in the UI under the below circumstances.
 */ function getToolsFormStatus(hasSplitPanel, isMobile, isSplitPanelOpen, isToolsOpen, toolsHide) {
    var hasToolsForm = false;
    if (!isMobile) {
        // Both the Split Panel and Tools button are needed
        if (hasSplitPanel && !toolsHide) {
            hasToolsForm = true;
        }
        // The Split Panel button is needed
        if (hasSplitPanel && !isSplitPanelOpen && toolsHide) {
            hasToolsForm = true;
        }
        // The Tools button is needed
        if (!hasSplitPanel && !toolsHide && !isToolsOpen) {
            hasToolsForm = true;
        }
    }
    return hasToolsForm;
}
/**
 * Under two scenarios the Tools form that contains the triggers
 * for the Tools content and the Split Panel may be persistent
 * in the UI (as opposed to disappearing when one of the drawers
 * is open). This will also add a white background as opposed to the
 * default transparent background. The buttons will present and in a
 * selected / not selected state.
 */ function getToolsFormPersistence(hasSplitPanel, isSplitPanelOpen, isToolsOpen, toolsHide) {
    var hasToolsFormPersistence = false;
    // Both Tools and Split Panel exist and one or both is open
    if (hasSplitPanel && !toolsHide && (isSplitPanelOpen || isToolsOpen)) {
        hasToolsFormPersistence = true;
    }
    return hasToolsFormPersistence;
} //# sourceMappingURL=tools.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/visual-refresh/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0











/**
 * In mobile viewports the AppBar position changes to sticky and is placed
 * above the notifications. This is handled by adjusting the row positions
 * in CSS for the AppBar and Notifications components relative to the grid
 * definition in the Layout component. In order to keep alignment between
 * the visual ordering and logical ordering of the document the logical order
 * of these components is also modified in the markup below.
 */ var AppLayoutWithRef = /*#__PURE__*/ react.forwardRef(function AppLayout(props, ref) {
    var isMobile = (0,react.useContext)(context/* AppLayoutContext */.T).isMobile;
    return /*#__PURE__*/ react.createElement(context/* AppLayoutProvider */.w, (0,tslib_es6/* __assign */.pi)({}, props, {
        ref: ref
    }), /*#__PURE__*/ react.createElement(split_panel/* default */.Z, null, /*#__PURE__*/ react.createElement(Layout, null, /*#__PURE__*/ react.createElement(Background, null), /*#__PURE__*/ react.createElement(Navigation, null), isMobile && /*#__PURE__*/ react.createElement(AppBar, null), /*#__PURE__*/ react.createElement(notifications_Notifications, null), !isMobile && /*#__PURE__*/ react.createElement(AppBar, null), /*#__PURE__*/ react.createElement(Header, null), /*#__PURE__*/ react.createElement(Main, null), /*#__PURE__*/ react.createElement(split_panel/* default.Bottom */.Z.Bottom, null), /*#__PURE__*/ react.createElement(Tools, null, /*#__PURE__*/ react.createElement(split_panel/* default.Side */.Z.Side, null)))));
});
/* harmony default export */ var visual_refresh = (AppLayoutWithRef); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-merge-refs/index.js
var use_merge_refs = __webpack_require__(5912);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/app-layout/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


































var AppLayout = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var _b = _a.contentType, contentType = _b === void 0 ? "default" : _b, _c = _a.headerSelector, headerSelector = _c === void 0 ? "#b #h" : _c, _d = _a.footerSelector, footerSelector = _d === void 0 ? "#b #f" : _d, rest = (0,tslib_es6/* __rest */._T)(_a, [
        "contentType",
        "headerSelector",
        "footerSelector"
    ]);
    var __internalRootRef = (0,use_base_component/* default */.Z)("AppLayout").__internalRootRef;
    var isRefresh = (0,use_visual_mode/* useVisualRefresh */.LV)();
    // This re-builds the props including the default values
    var props = (0,tslib_es6/* __assign */.pi)({
        contentType: contentType,
        headerSelector: headerSelector,
        footerSelector: footerSelector
    }, rest);
    var baseProps = (0,base_component/* getBaseProps */.j)(rest);
    return /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({
        ref: __internalRootRef
    }, baseProps), isRefresh ? /*#__PURE__*/ react.createElement(visual_refresh, (0,tslib_es6/* __assign */.pi)({}, props, {
        ref: ref
    })) : /*#__PURE__*/ react.createElement(OldAppLayout, (0,tslib_es6/* __assign */.pi)({}, props, {
        ref: ref
    })));
});
var OldAppLayout = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var _b;
    var _c;
    var navigation = _a.navigation, _d = _a.navigationWidth, navigationWidth = _d === void 0 ? 280 : _d, navigationHide = _a.navigationHide, controlledNavigationOpen = _a.navigationOpen, tools = _a.tools, _e = _a.toolsWidth, toolsWidth = _e === void 0 ? 290 : _e, toolsHide = _a.toolsHide, controlledToolsOpen = _a.toolsOpen, breadcrumbs = _a.breadcrumbs, notifications = _a.notifications, stickyNotifications = _a.stickyNotifications, contentHeader = _a.contentHeader, disableContentHeaderOverlap = _a.disableContentHeaderOverlap, content = _a.content, _f = _a.contentType, contentType = _f === void 0 ? "default" : _f, disableContentPaddings = _a.disableContentPaddings, disableBodyScroll = _a.disableBodyScroll, maxContentWidth = _a.maxContentWidth, minContentWidth = _a.minContentWidth, _g = _a.headerSelector, headerSelector = _g === void 0 ? "#b #h" : _g, _h = _a.footerSelector, footerSelector = _h === void 0 ? "#b #f" : _h, ariaLabels = _a.ariaLabels, splitPanel = _a.splitPanel, controlledSplitPanelSize = _a.splitPanelSize, controlledSplitPanelOpen = _a.splitPanelOpen, controlledSplitPanelPreferences = _a.splitPanelPreferences, onSplitPanelPreferencesChange = _a.onSplitPanelPreferencesChange, onSplitPanelResize = _a.onSplitPanelResize, onSplitPanelToggle = _a.onSplitPanelToggle, onNavigationChange = _a.onNavigationChange, onToolsChange = _a.onToolsChange;
    if (is_development/* isDevelopment */.y) {
        if (controlledToolsOpen && toolsHide) {
            (0,logging/* warnOnce */.O)("AppLayout", "You have enabled both the `toolsOpen` prop and the `toolsHide` prop. This is not supported. Set `toolsOpen` to `false` when you set `toolsHide` to `true`.");
        }
    }
    var rootRef = (0,react.useRef)(null);
    var isMobile = (0,use_mobile/* useMobile */.X)();
    var isMotionEnabled = rootRef.current ? !(0,motion/* isMotionDisabled */.g)(rootRef.current) : false;
    var defaults = (0,app_layout_defaults/* applyDefaults */.k)(contentType, {
        maxContentWidth: maxContentWidth,
        minContentWidth: minContentWidth
    }, false);
    var _j = (0,use_controllable/* useControllable */.q)(controlledNavigationOpen, onNavigationChange, isMobile ? false : defaults.navigationOpen, {
        componentName: "AppLayout",
        controlledProp: "navigationOpen",
        changeHandler: "onNavigationChange"
    }), _k = _j[0], navigationOpen = _k === void 0 ? false : _k, setNavigationOpen = _j[1];
    var _l = (0,use_controllable/* useControllable */.q)(controlledToolsOpen, onToolsChange, isMobile ? false : defaults.toolsOpen, {
        componentName: "AppLayout",
        controlledProp: "toolsOpen",
        changeHandler: "onToolsChange"
    }), _m = _l[0], toolsOpen = _m === void 0 ? false : _m, setToolsOpen = _l[1];
    var onNavigationToggle = (0,react.useCallback)(function(open) {
        setNavigationOpen(open);
        (0,events/* fireNonCancelableEvent */.B4)(onNavigationChange, {
            open: open
        });
    }, [
        setNavigationOpen,
        onNavigationChange
    ]);
    var onToolsToggle = (0,react.useCallback)(function(open) {
        setToolsOpen(open);
        (0,events/* fireNonCancelableEvent */.B4)(onToolsChange, {
            open: open
        });
    }, [
        setToolsOpen,
        onToolsChange
    ]);
    var onNavigationClick = function(event) {
        var hasLink = (0,dom/* findUpUntil */.jX)(event.target, function(node) {
            return node.tagName === "A" && !!node.href;
        });
        if (hasLink) {
            onNavigationToggle(false);
        }
    };
    var navigationVisible = !navigationHide && navigationOpen;
    var toolsVisible = !toolsHide && toolsOpen;
    var _o = useContentHeight(headerSelector, footerSelector, disableBodyScroll), contentHeightStyle = _o.contentHeightStyle, headerHeight = _o.headerHeight, footerHeight = _o.footerHeight, panelHeightStyle = _o.panelHeightStyle;
    var _p = (0,react.useState)(false), isSplitpanelForcedPosition = _p[0], setIsSplitpanelForcedPosition = _p[1];
    var _q = (0,use_container_query/* useContainerQuery */.D)(function(rect) {
        return rect.height;
    }), notificationsHeight = _q[0], notificationsRef = _q[1];
    var _r = (0,use_container_query/* useContainerQuery */.D)(function(rect) {
        return splitPanel ? rect.height : 0;
    }, [
        splitPanel,
        isSplitpanelForcedPosition
    ]), splitPanelHeaderHeight = _r[0], splitPanelHeaderMeasureRef = _r[1];
    var splitPanelHeaderRefObject = (0,react.useRef)(null);
    var splitPanelHeaderRef = (0,use_merge_refs/* useMergeRefs */.q)(splitPanelHeaderMeasureRef, splitPanelHeaderRefObject);
    var anyPanelOpen = navigationVisible || toolsVisible;
    var hasRenderedNotifications = notificationsHeight ? notificationsHeight > 0 : false;
    var stickyNotificationsHeight = stickyNotifications ? notificationsHeight : null;
    var _s = (0,use_controllable/* useControllable */.q)(controlledSplitPanelPreferences, onSplitPanelPreferencesChange, undefined, {
        componentName: "AppLayout",
        controlledProp: "splitPanelPreferences",
        changeHandler: "onSplitPanelPreferencesChange"
    }), splitPanelPreferences = _s[0], setSplitPanelPreferences = _s[1];
    var splitPanelPosition = (splitPanelPreferences === null || splitPanelPreferences === void 0 ? void 0 : splitPanelPreferences.position) || "bottom";
    var _t = (0,use_container_query/* useContainerQuery */.D)(function(rect) {
        return splitPanel ? rect.height : 0;
    }, [
        splitPanel,
        splitPanelPosition,
        isSplitpanelForcedPosition
    ]), splitPanelHeight = _t[0], splitPanelRef = _t[1];
    var closedDrawerWidth = 40;
    var effectiveNavigationWidth = navigationHide ? 0 : navigationOpen ? navigationWidth : closedDrawerWidth;
    var effectiveToolsWidth = toolsHide && (!splitPanel || (splitPanelPreferences === null || splitPanelPreferences === void 0 ? void 0 : splitPanelPreferences.position) !== "side") ? 0 : toolsOpen ? toolsWidth : closedDrawerWidth;
    var defaultSplitPanelSize = (0,size_utils/* getSplitPanelDefaultSize */.LV)(splitPanelPosition);
    var _u = (0,use_controllable/* useControllable */.q)(controlledSplitPanelSize, onSplitPanelResize, defaultSplitPanelSize, {
        componentName: "AppLayout",
        controlledProp: "splitPanelSize",
        changeHandler: "onSplitPanelResize"
    }), _v = _u[0], splitPanelSize = _v === void 0 ? defaultSplitPanelSize : _v, setSplitPanelSize = _u[1];
    var _w = (0,use_controllable/* useControllable */.q)(controlledSplitPanelOpen, onSplitPanelToggle, false, {
        componentName: "AppLayout",
        controlledProp: "splitPanelOpen",
        changeHandler: "onSplitPanelToggle"
    }), _x = _w[0], splitPanelOpen = _x === void 0 ? false : _x, setSplitPanelOpen = _w[1];
    var mainContentRef = (0,react.useRef)(null);
    var legacyScrollRootRef = (0,react.useRef)(null);
    var onSplitPanelPreferencesSet = (0,react.useCallback)(function(detail) {
        setSplitPanelPreferences(detail);
        (0,events/* fireNonCancelableEvent */.B4)(onSplitPanelPreferencesChange, detail);
    }, [
        setSplitPanelPreferences,
        onSplitPanelPreferencesChange
    ]);
    var onSplitPanelSizeSet = (0,react.useCallback)(function(detail) {
        setSplitPanelSize(detail.size);
        (0,events/* fireNonCancelableEvent */.B4)(onSplitPanelResize, detail);
    }, [
        setSplitPanelSize,
        onSplitPanelResize
    ]);
    var onToggle = (0,react.useCallback)(function() {
        setSplitPanelOpen(!splitPanelOpen);
        (0,events/* fireNonCancelableEvent */.B4)(onSplitPanelToggle, {
            open: !splitPanelOpen
        });
    }, [
        setSplitPanelOpen,
        splitPanelOpen,
        onSplitPanelToggle
    ]);
    var getSplitPanelMaxWidth = (0,use_stable_event_handler/* useStableEventHandler */.S)(function() {
        if (!mainContentRef.current || !defaults.minContentWidth) {
            return NaN;
        }
        var width = parseInt(getComputedStyle(mainContentRef.current).width);
        // when disableContentPaddings is true there is less available space,
        // so we subtract space-scaled-2x-xxxl * 2 for left and right padding
        var contentPadding = disableContentPaddings ? 80 : 0;
        var spaceAvailable = width - defaults.minContentWidth - contentPadding;
        var spaceTaken = finalSplitPanePosition === "side" ? splitPanelSize : 0;
        return Math.max(0, spaceTaken + spaceAvailable);
    });
    var getSplitPanelMaxHeight = (0,use_stable_event_handler/* useStableEventHandler */.S)(function() {
        if (typeof document === "undefined") {
            return 0; // render the split panel in its minimum possible size
        } else if (disableBodyScroll && legacyScrollRootRef.current) {
            var availableHeight = legacyScrollRootRef.current.clientHeight;
            return availableHeight < size_utils/* CONSTRAINED_PAGE_HEIGHT */.Zl ? availableHeight : availableHeight - size_utils/* MAIN_PANEL_MIN_HEIGHT */.pV;
        } else {
            var availableHeight = document.documentElement.clientHeight - headerHeight - footerHeight;
            return availableHeight < size_utils/* CONSTRAINED_PAGE_HEIGHT */.Zl ? availableHeight - size_utils/* CONSTRAINED_MAIN_PANEL_MIN_HEIGHT */.lX : availableHeight - size_utils/* MAIN_PANEL_MIN_HEIGHT */.pV;
        }
    });
    var finalSplitPanePosition = isSplitpanelForcedPosition ? "bottom" : splitPanelPosition;
    var splitPaneAvailableOnTheSide = Boolean(splitPanel) && finalSplitPanePosition === "side";
    var splitPanelOpenOnTheSide = splitPaneAvailableOnTheSide && splitPanelOpen;
    var toggleButtonsBarWidth = 0;
    var windowWidth = useWindowWidth();
    var _y = useAppLayoutOffsets(rootRef.current), leftOffset = _y.left, rightOffset = _y.right;
    var contentWidthWithSplitPanel = windowWidth - leftOffset - rightOffset - effectiveToolsWidth - effectiveNavigationWidth - (disableContentPaddings ? 0 : toggleButtonsBarWidth);
    (0,react.useEffect)(function() {
        var contentWidth = contentWidthWithSplitPanel - splitPanelSize;
        setIsSplitpanelForcedPosition(isMobile || (defaults.minContentWidth || 0) > contentWidth);
    // This is a workaround to avoid a forced position due to splitPanelSize, which is
    // user controlled variable.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentWidthWithSplitPanel,
        defaults.minContentWidth,
        isMobile
    ]);
    var navigationClosedWidth = navigationHide || isMobile ? 0 : closedDrawerWidth;
    var toolsClosedWidth = toolsHide || isMobile ? 0 : closedDrawerWidth;
    var _z = (0,react.useState)(), splitPanelLastInteraction = _z[0], setSplitPanelLastInteraction = _z[1];
    (0,use_effect_on_update/* useEffectOnUpdate */.G)(function() {
        return setSplitPanelLastInteraction(splitPanelOpen ? {
            type: "open"
        } : {
            type: "close"
        });
    }, [
        splitPanelOpen
    ]);
    (0,use_effect_on_update/* useEffectOnUpdate */.G)(function() {
        return setSplitPanelLastInteraction({
            type: "position"
        });
    }, [
        splitPanelPosition
    ]);
    var contentMaxWidthStyle = !isMobile ? {
        maxWidth: defaults.maxContentWidth
    } : undefined;
    var _0 = (0,react.useState)(0), splitPanelReportedSize = _0[0], setSplitPanelReportedSize = _0[1];
    var splitPanelContext = {
        topOffset: headerHeight + (finalSplitPanePosition === "bottom" ? stickyNotificationsHeight || 0 : 0),
        bottomOffset: footerHeight,
        leftOffset: leftOffset + (isMobile ? 0 : !navigationHide && navigationOpen ? navigationWidth : navigationClosedWidth),
        rightOffset: rightOffset + (isMobile ? 0 : !toolsHide && toolsOpen ? toolsWidth : toolsClosedWidth),
        position: finalSplitPanePosition,
        size: splitPanelSize,
        getMaxWidth: getSplitPanelMaxWidth,
        getMaxHeight: getSplitPanelMaxHeight,
        getHeader: function() {
            return splitPanelHeaderRefObject.current;
        },
        disableContentPaddings: disableContentPaddings,
        contentWidthStyles: contentMaxWidthStyle,
        isOpen: splitPanelOpen,
        isMobile: isMobile,
        isForcedPosition: isSplitpanelForcedPosition,
        lastInteraction: splitPanelLastInteraction,
        splitPanelRef: splitPanelRef,
        splitPanelHeaderRef: splitPanelHeaderRef,
        onResize: onSplitPanelSizeSet,
        onToggle: onToggle,
        onPreferencesChange: onSplitPanelPreferencesSet,
        reportSize: setSplitPanelReportedSize
    };
    var splitPanelWrapped = splitPanel && /*#__PURE__*/ react.createElement(split_panel_context/* SplitPanelContext.Provider */.C.Provider, {
        value: splitPanelContext
    }, splitPanel);
    var contentWrapperProps = {
        navigationPadding: navigationHide || !!navigationOpen,
        toolsPadding: // 1. Nothing on the that screen edge (no tools panel and no split panel)
        toolsHide && (!splitPanel || finalSplitPanePosition !== "side") || // 2. Tools panel is present and open
        toolsVisible || // 3. Split panel is open in side position
        splitPanelOpenOnTheSide,
        isMobile: isMobile
    };
    var navigationRefs = (0,use_focus_control/* useFocusControl */.c)(navigationOpen).refs;
    var _1 = (0,use_focus_control/* useFocusControl */.c)(toolsOpen, true), toolsRefs = _1.refs, focusToolsClose = _1.setFocus, loseToolsFocus = _1.loseFocus;
    (0,react.useImperativeHandle)(ref, function() {
        return {
            openTools: function() {
                return onToolsToggle(true);
            },
            closeNavigationIfNecessary: function() {
                if (isMobile) {
                    onNavigationToggle(false);
                }
            },
            focusToolsClose: focusToolsClose
        };
    }, [
        isMobile,
        onNavigationToggle,
        onToolsToggle,
        focusToolsClose
    ]);
    var splitPanelBottomOffset = (_c = !splitPanel || finalSplitPanePosition !== "bottom" ? undefined : splitPanelOpen ? splitPanelHeight : splitPanelHeaderHeight) !== null && _c !== void 0 ? _c : undefined;
    var contentWidthStyles = !isMobile ? {
        minWidth: defaults.minContentWidth,
        maxWidth: defaults.maxContentWidth
    } : undefined;
    var isToolsDrawerHidden = disableContentPaddings;
    var toolsDrawerWidth = function() {
        if (isMobile) {
            return 0;
        }
        var toolsPanelWidth = toolsHide ? 0 : toolsOpen ? toolsWidth : closedDrawerWidth;
        var splitPanelWidth = !splitPanel || finalSplitPanePosition !== "side" ? 0 : splitPanelOpen ? splitPanelReportedSize : closedDrawerWidth;
        return toolsPanelWidth + splitPanelWidth;
    }();
    var navigationDrawerWidth = function() {
        if (isMobile) {
            return 0;
        }
        return effectiveNavigationWidth;
    }();
    var previousContentWidth = usePreviousFrameValue(contentWidthWithSplitPanel - (splitPanelOpenOnTheSide ? splitPanelReportedSize : 0));
    var contentScaleX = function() {
        if (isMobile || !isMotionEnabled || !disableContentPaddings || !previousContentWidth) {
            return undefined;
        }
    }();
    return /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(app_layout_styles_css.root, test_classes_styles_css.root, disableBodyScroll && app_layout_styles_css["root-no-scroll"]),
        ref: rootRef
    }, /*#__PURE__*/ react.createElement("div", {
        className: app_layout_styles_css["layout-wrapper"],
        style: contentHeightStyle
    }, isMobile && (!toolsHide || !navigationHide || breadcrumbs) && /*#__PURE__*/ react.createElement(MobileToolbar, {
        anyPanelOpen: anyPanelOpen,
        toggleRefs: {
            navigation: navigationRefs.toggle,
            tools: toolsRefs.toggle
        },
        topOffset: headerHeight,
        ariaLabels: ariaLabels,
        navigationHide: navigationHide,
        toolsHide: toolsHide,
        onNavigationOpen: function() {
            return onNavigationToggle(true);
        },
        onToolsOpen: function() {
            return onToolsToggle(true);
        },
        unfocusable: anyPanelOpen
    }, breadcrumbs), /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(app_layout_styles_css.layout, disableBodyScroll && app_layout_styles_css["layout-no-scroll"])
    }, !navigationHide && /*#__PURE__*/ react.createElement(NavigationPanel, {
        ariaLabels: ariaLabels,
        footerHeight: footerHeight,
        headerHeight: headerHeight,
        isHidden: disableContentPaddings,
        isMobile: isMobile,
        isMotionEnabled: isMotionEnabled,
        navigation: navigation,
        navigationDrawerWidth: navigationDrawerWidth,
        navigationOpen: navigationOpen,
        onClick: isMobile ? onNavigationClick : undefined,
        onNavigationToggle: onNavigationToggle,
        panelHeightStyle: panelHeightStyle,
        toggleRefs: navigationRefs,
        navigationWidth: navigationWidth
    }), /*#__PURE__*/ react.createElement("main", {
        ref: legacyScrollRootRef,
        className: (0,clsx_m/* default */.Z)(app_layout_styles_css["layout-main"], (_b = {}, _b[app_layout_styles_css["layout-main-scrollable"]] = disableBodyScroll, _b[test_classes_styles_css["disable-body-scroll-root"]] = disableBodyScroll, _b[app_layout_styles_css.unfocusable] = isMobile && anyPanelOpen, _b))
    }, /*#__PURE__*/ react.createElement("div", {
        style: {
            marginBottom: splitPanelBottomOffset,
            transform: contentScaleX ? "scaleX(".concat(contentScaleX, ")") : undefined
        }
    }, notifications && /*#__PURE__*/ react.createElement(Notifications, {
        testUtilsClassName: (0,clsx_m/* default */.Z)(app_layout_styles_css.notifications, test_classes_styles_css.notifications),
        labels: ariaLabels,
        topOffset: disableBodyScroll ? 0 : headerHeight,
        sticky: !isMobile && stickyNotifications,
        ref: notificationsRef,
        isMobile: isMobile,
        navigationPadding: contentWrapperProps.navigationPadding,
        toolsPadding: contentWrapperProps.toolsPadding,
        contentWidthStyles: contentWidthStyles
    }, notifications), (!isMobile && breadcrumbs || contentHeader) && /*#__PURE__*/ react.createElement(content_wrapper, (0,tslib_es6/* __assign */.pi)({}, contentWrapperProps, {
        contentWidthStyles: contentWidthStyles
    }), !isMobile && breadcrumbs && /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(app_layout_styles_css.breadcrumbs, test_classes_styles_css.breadcrumbs, app_layout_styles_css["breadcrumbs-desktop"])
    }, breadcrumbs), contentHeader && /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(app_layout_styles_css["content-header-wrapper"], !hasRenderedNotifications && (isMobile || !breadcrumbs) && app_layout_styles_css["content-extra-top-padding"], !hasRenderedNotifications && !breadcrumbs && app_layout_styles_css["content-header-wrapper-first-child"], !disableContentHeaderOverlap && app_layout_styles_css["content-header-wrapper-overlapped"])
    }, contentHeader)), /*#__PURE__*/ react.createElement(content_wrapper, (0,tslib_es6/* __assign */.pi)({}, contentWrapperProps, {
        ref: mainContentRef,
        disablePaddings: disableContentPaddings,
        // eslint-disable-next-line react/forbid-component-props
        className: (0,clsx_m/* default */.Z)(!disableContentPaddings && app_layout_styles_css["content-wrapper"], !disableContentPaddings && (isMobile || !breadcrumbs) && !contentHeader && app_layout_styles_css["content-extra-top-padding"], !hasRenderedNotifications && !breadcrumbs && !isMobile && !contentHeader && app_layout_styles_css["content-wrapper-first-child"])
    }), /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(app_layout_styles_css.content, test_classes_styles_css.content, !disableContentHeaderOverlap && contentHeader && app_layout_styles_css["content-overlapped"]),
        style: contentWidthStyles
    }, /*#__PURE__*/ react.createElement(app_layout_context/* AppLayoutContext.Provider */.T.Provider, {
        value: {
            stickyOffsetTop: (disableBodyScroll ? 0 : headerHeight) + (stickyNotificationsHeight !== null ? stickyNotificationsHeight : 0),
            stickyOffsetBottom: footerHeight + (splitPanelBottomOffset || 0)
        }
    }, content)))), finalSplitPanePosition === "bottom" && splitPanelWrapped), /*#__PURE__*/ react.createElement(ToolsAndSplitPanel, {
        splitPanel: finalSplitPanePosition === "side" ? splitPanelWrapped : undefined,
        ariaLabels: ariaLabels,
        closedDrawerWidth: closedDrawerWidth,
        contentHeightStyle: contentHeightStyle,
        disableContentPaddings: disableContentPaddings,
        drawerWidth: toolsDrawerWidth,
        footerHeight: footerHeight,
        headerHeight: headerHeight,
        isHidden: isToolsDrawerHidden,
        isMobile: isMobile,
        isMotionEnabled: isMotionEnabled,
        onToolsToggle: onToolsToggle,
        panelHeightStyle: panelHeightStyle,
        splitPanelOpen: splitPanelOpenOnTheSide,
        splitPanelReportedSize: splitPanelReportedSize,
        toggleRefs: toolsRefs,
        onLoseToolsFocus: loseToolsFocus,
        tools: tools,
        toolsHide: Boolean(toolsHide),
        toolsOpen: toolsOpen,
        toolsWidth: toolsWidth
    }))));
});
(0,apply_display_name/* applyDisplayName */.b)(AppLayout, "AppLayout");
/* harmony default export */ var app_layout = (AppLayout); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 2129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useFocusControl; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function useFocusControl(isOpen, restoreFocus) {
    if (restoreFocus === void 0) {
        restoreFocus = false;
    }
    var refs = {
        toggle: (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),
        close: (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null)
    };
    var previousFocusedElement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var setFocus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _a, _b;
        // due to mounting/remounting, this hook gets called multiple times for a single change,
        // so we ignore any calls where the refs are undefined
        if (!(refs.toggle.current || refs.close.current)) {
            return;
        }
        if (isOpen) {
            previousFocusedElement.current = document.activeElement;
            (_a = refs.close.current) === null || _a === void 0 ? void 0 : _a.focus();
        } else {
            if (restoreFocus && previousFocusedElement.current && document.contains(previousFocusedElement.current)) {
                previousFocusedElement.current.focus();
                previousFocusedElement.current = undefined;
            } else {
                (_b = refs.toggle.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
        }
    }, [
        isOpen,
        restoreFocus,
        refs.close,
        refs.toggle
    ]);
    var loseFocus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        previousFocusedElement.current = undefined;
    }, []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(setFocus, [
        isOpen,
        restoreFocus
    ]);
    return {
        refs: refs,
        setFocus: setFocus,
        loseFocus: loseFocus
    };
} //# sourceMappingURL=use-focus-control.js.map


/***/ }),

/***/ 7616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useObservedElement; }
/* harmony export */ });
/* harmony import */ var _internal_hooks_container_queries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function useObservedElement(selectorOrRef) {
    var getElement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _a, _b;
        if (typeof selectorOrRef === "string") {
            return document.querySelector(selectorOrRef);
        } else if (typeof selectorOrRef === "function") {
            return (_a = selectorOrRef()) !== null && _a !== void 0 ? _a : null;
        } else {
            return (_b = selectorOrRef === null || selectorOrRef === void 0 ? void 0 : selectorOrRef.current) !== null && _b !== void 0 ? _b : null;
        }
    }, [
        selectorOrRef
    ]);
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), height = _a[0], setHeight = _a[1];
    (0,_internal_hooks_container_queries__WEBPACK_IMPORTED_MODULE_1__/* .useResizeObserver */ .y)(getElement, function(entry) {
        return setHeight(entry.borderBoxHeight);
    });
    return height;
} //# sourceMappingURL=use-observed-element.js.map


/***/ }),

/***/ 7919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ AppLayoutContext; },
/* harmony export */   "w": function() { return /* binding */ AppLayoutProvider; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _internal_events__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6322);
/* harmony import */ var _split_panel__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9194);
/* harmony import */ var _internal_hooks_use_controllable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9276);
/* harmony import */ var _internal_hooks_use_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6670);
/* harmony import */ var _internal_hooks_container_queries__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(913);
/* harmony import */ var _internal_hooks_container_queries__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5382);
/* harmony import */ var _split_panel_utils_size_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1911);
/* harmony import */ var _styles_css_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2415);
/* harmony import */ var _internal_is_development__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5856);
/* harmony import */ var _internal_logging__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3742);
/* harmony import */ var _defaults__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6959);
/* harmony import */ var _utils_use_focus_control__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2129);

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0












// TODO simplify default params + typings
var defaults = {
    breadcrumbs: null,
    content: null,
    contentHeader: null,
    contentType: "default",
    disableBodyScroll: false,
    disableContentHeaderOverlap: false,
    disableContentPaddings: false,
    dynamicOverlapHeight: 0,
    headerHeight: 0,
    footerHeight: 0,
    handleNavigationClick: function(value) {
        return value;
    },
    handleSplitPanelClick: function() {},
    handleSplitPanelPreferencesChange: function() {},
    handleSplitPanelResize: function() {},
    handleToolsClick: function(value) {
        return value;
    },
    hasDefaultToolsWidth: true,
    hasNotificationsContent: false,
    hasStickyBackground: false,
    isAnyPanelOpen: false,
    isMobile: false,
    isNavigationOpen: false,
    isSplitPanelForcedPosition: false,
    isSplitPanelOpen: false,
    isToolsOpen: false,
    // TODO: these refs are currently only instantiated once globally
    layoutElement: /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createRef)(),
    layoutWidth: 0,
    mainElement: /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createRef)(),
    mainOffsetLeft: 0,
    maxContentWidth: 0,
    minContentWidth: 280,
    navigation: null,
    navigationHide: false,
    navigationOpen: false,
    notifications: null,
    notificationsElement: /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createRef)(),
    notificationsHeight: 0,
    offsetBottom: 0,
    onNavigationChange: function() {},
    onSplitPanelResize: function() {},
    onSplitPanelToggle: function() {},
    onSplitPanelPreferencesChange: function() {},
    setDynamicOverlapHeight: function(value) {
        return void value;
    },
    setHasStickyBackground: function(value) {
        return value;
    },
    setIsNavigationOpen: function(value) {
        return value;
    },
    setIsToolsOpen: function(value) {
        return value;
    },
    setOffsetBottom: function(value) {
        return void value;
    },
    setSplitPanelReportedSize: function(value) {
        return void value;
    },
    splitPanelMaxWidth: 280,
    splitPanelMinWidth: 280,
    splitPanelOpen: false,
    splitPanelPosition: "bottom",
    splitPanelPreferences: {
        position: "bottom"
    },
    splitPanelReportedSize: 0,
    splitPanelSize: 0,
    stickyNotifications: false,
    tools: null,
    toolsFocusControl: {}
};
/**
 * The default values are destructured in the context instantiation to
 * prevent downstream Typescript errors. This could likely be replaced
 * by a context interface definition that extends the AppLayout interface.
 */ var AppLayoutContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, defaults));
var AppLayoutProvider = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function(_a, forwardRef) {
    var _b, _c, _d;
    var toolsHide = _a.toolsHide, controlledToolsOpen = _a.toolsOpen, navigationHide = _a.navigationHide, controlledNavigationOpen = _a.navigationOpen, _e = _a.contentType, contentType = _e === void 0 ? "default" : _e, _f = _a.headerSelector, headerSelector = _f === void 0 ? "#b #h" : _f, _g = _a.footerSelector, footerSelector = _g === void 0 ? "#b #h" : _g, children = _a.children, props = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(_a, [
        "toolsHide",
        "toolsOpen",
        "navigationHide",
        "navigationOpen",
        "contentType",
        "headerSelector",
        "footerSelector",
        "children"
    ]);
    var isMobile = (0,_internal_hooks_use_mobile__WEBPACK_IMPORTED_MODULE_2__/* .useMobile */ .X)();
    if (_internal_is_development__WEBPACK_IMPORTED_MODULE_3__/* .isDevelopment */ .y) {
        if (controlledToolsOpen && toolsHide) {
            (0,_internal_logging__WEBPACK_IMPORTED_MODULE_4__/* .warnOnce */ .O)("AppLayout", "You have enabled both the `toolsOpen` prop and the `toolsHide` prop. This is not supported. Set `toolsOpen` to `false` when you set `toolsHide` to `true`.");
        }
    }
    /**
     * The overlap height has a default set in CSS but can also be dynamically overridden
     * for content types (such as Table and Wizard) that have variable size content in the overlap.
     * If a child component utilizes a sticky header the hasStickyBackground property will determine
     * if the background remains in the same vertical position.
     */ var _h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), dynamicOverlapHeight = _h[0], setDynamicOverlapHeight = _h[1];
    var _j = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), hasStickyBackground = _j[0], setHasStickyBackground = _j[1];
    /**
     * Set the default values for minimum and maximum content width.
     */ var geckoMaxCssLength = ((1 << 30) - 1) / 60;
    var halfGeckoMaxCssLength = geckoMaxCssLength / 2;
    // CSS lengths in Gecko are limited to at most (1<<30)-1 app units (Gecko uses 60 as app unit).
    // Limit the maxContentWidth to the half of the upper boundary (≈4230^2) to be on the safe side.
    var maxContentWidth = props.maxContentWidth && props.maxContentWidth > halfGeckoMaxCssLength ? halfGeckoMaxCssLength : (_b = props.maxContentWidth) !== null && _b !== void 0 ? _b : 0;
    var minContentWidth = (_c = props.minContentWidth) !== null && _c !== void 0 ? _c : 280;
    /**
     * Determine the default state of the Navigation and Tools drawers.
     * Mobile viewports should be closed by default under all circumstances.
     * If the navigationOpen prop has been set then that should take precedence
     * over the contentType prop. Desktop viewports that do not have the
     * navigationOpen or contentType props set will use the default contentType.
     */ var contentTypeDefaults = (0,_defaults__WEBPACK_IMPORTED_MODULE_5__/* .applyDefaults */ .k)(contentType, {
        maxContentWidth: maxContentWidth,
        minContentWidth: minContentWidth
    }, true);
    /**
     * The useControllable hook will set the default value and manage either
     * the controlled or uncontrolled state of the Navigation drawer. The logic
     * for determining the default state is colocated with the Navigation component.
     *
     * The callback that will be passed to the Navigation and AppBar
     * components to handle the click events that will change the state
     * of the Navigation drawer. It will set the Navigation state with the
     * useControllable hook and also fire the onNavigationChange function to
     * emit the state change.
     */ var _k = (0,_internal_hooks_use_controllable__WEBPACK_IMPORTED_MODULE_6__/* .useControllable */ .q)(controlledNavigationOpen, props.onNavigationChange, isMobile ? false : contentTypeDefaults.navigationOpen, {
        componentName: "AppLayout",
        controlledProp: "navigationOpen",
        changeHandler: "onNavigationChange"
    }), _l = _k[0], isNavigationOpen = _l === void 0 ? false : _l, setIsNavigationOpen = _k[1];
    var handleNavigationClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function handleNavigationChange(isOpen) {
        setIsNavigationOpen(isOpen);
        (0,_internal_events__WEBPACK_IMPORTED_MODULE_7__/* .fireNonCancelableEvent */ .B4)(props.onNavigationChange, {
            open: isOpen
        });
    }, [
        props.onNavigationChange,
        setIsNavigationOpen
    ]);
    /**
     * The useControllable hook will set the default value and manage either
     * the controlled or uncontrolled state of the Tools drawer. The logic
     * for determining the default state is colocated with the Tools component.
     *
     * The callback that will be passed to the Navigation and AppBar
     * components to handle the click events that will change the state
     * of the Tools drawer. It will set the Tools state with the
     * useControllable hook and also fire the onToolsChange function to
     * emit the state change.
     */ var toolsWidth = (_d = props.toolsWidth) !== null && _d !== void 0 ? _d : 290;
    var hasDefaultToolsWidth = props.toolsWidth === undefined;
    var _m = (0,_internal_hooks_use_controllable__WEBPACK_IMPORTED_MODULE_6__/* .useControllable */ .q)(controlledToolsOpen, props.onToolsChange, isMobile ? false : contentTypeDefaults.toolsOpen, {
        componentName: "AppLayout",
        controlledProp: "toolsOpen",
        changeHandler: "onToolsChange"
    }), _o = _m[0], isToolsOpen = _o === void 0 ? false : _o, setIsToolsOpen = _m[1];
    var toolsFocusControl = (0,_utils_use_focus_control__WEBPACK_IMPORTED_MODULE_8__/* .useFocusControl */ .c)(isToolsOpen, true);
    var handleToolsClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function handleToolsChange(isOpen) {
        setIsToolsOpen(isOpen);
        (0,_internal_events__WEBPACK_IMPORTED_MODULE_7__/* .fireNonCancelableEvent */ .B4)(props.onToolsChange, {
            open: isOpen
        });
    }, [
        props.onToolsChange,
        setIsToolsOpen
    ]);
    var navigationVisible = !navigationHide && isNavigationOpen;
    var toolsVisible = !toolsHide && isToolsOpen;
    var isAnyPanelOpen = navigationVisible || toolsVisible;
    /**
     * On mobile viewports the navigation and tools drawers are adjusted to a fixed position
     * that consumes 100% of the viewport height and width. The body content could potentially
     * be scrollable underneath the drawer. In order to prevent this a CSS class needs to be
     * added to the document body that sets overflow to hidden.
     */ (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function handleBodyScroll() {
        if (isMobile && (isNavigationOpen || isToolsOpen)) {
            document.body.classList.add(_styles_css_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"]["block-body-scroll"] */ .Z["block-body-scroll"]);
        } else {
            document.body.classList.remove(_styles_css_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"]["block-body-scroll"] */ .Z["block-body-scroll"]);
        }
        // Ensure the CSS class is removed from the body on side effect cleanup
        return function cleanup() {
            document.body.classList.remove(_styles_css_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"]["block-body-scroll"] */ .Z["block-body-scroll"]);
        };
    }, [
        isMobile,
        isNavigationOpen,
        isToolsOpen
    ]);
    /**
     * The useImperativeHandle hook in conjunction with the forwardRef function
     * in the AppLayout component definition expose the following callable
     * functions to component consumers when they put a ref as a property on
     * their component implementation.
     */ (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(forwardRef, function createImperativeHandle() {
        return {
            closeNavigationIfNecessary: function() {
                isMobile && handleNavigationClick(false);
            },
            openTools: function() {
                handleToolsClick(true);
            },
            focusToolsClose: toolsFocusControl.setFocus
        };
    }, [
        isMobile,
        handleNavigationClick,
        handleToolsClick,
        toolsFocusControl.setFocus
    ]);
    /**
     * Query the DOM for the header and footer elements based on the selectors provided
     * by the properties and pass the heights to the custom property definitions.
     */ var _p = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), headerHeight = _p[0], setHeaderHeight = _p[1];
    var getHeader = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return document.querySelector(headerSelector);
    }, [
        headerSelector
    ]);
    (0,_internal_hooks_container_queries__WEBPACK_IMPORTED_MODULE_10__/* .useResizeObserver */ .y)(getHeader, function(entry) {
        return setHeaderHeight(entry.borderBoxHeight);
    });
    var _q = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), footerHeight = _q[0], setFooterHeight = _q[1];
    var getFooter = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return document.querySelector(footerSelector);
    }, [
        footerSelector
    ]);
    (0,_internal_hooks_container_queries__WEBPACK_IMPORTED_MODULE_10__/* .useResizeObserver */ .y)(getFooter, function(entry) {
        return setFooterHeight(entry.borderBoxHeight);
    });
    /**
     * Set the default values for the minimum and maximum Split Panel width when it is
     * in the side position. The useLayoutEffect will compute the available space in the
     * DOM for the Split Panel given the current state. The minimum and maximum
     * widths will potentially trigger a side effect that will put the Split Panel into
     * a forced position on the bottom.
     */ var splitPanelMinWidth = 280;
    var _r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(splitPanelMinWidth), splitPanelMaxWidth = _r[0], setSplitPanelMaxWidth = _r[1];
    /**
     * The useControllable hook will set the default value and manage either
     * the controlled or uncontrolled state of the Split Panel. By default
     * the Split Panel should always be closed on page load.
     *
     * The callback that will be passed to the SplitPanel component
     * to handle the click events that will change the state of the SplitPanel
     * to open or closed given the current state. It will set the isSplitPanelOpen
     * controlled state and fire the onSplitPanelToggle event.
     */ var _s = (0,_internal_hooks_use_controllable__WEBPACK_IMPORTED_MODULE_6__/* .useControllable */ .q)(props.splitPanelOpen, props.onSplitPanelToggle, false, {
        componentName: "AppLayout",
        controlledProp: "splitPanelOpen",
        changeHandler: "onSplitPanelToggle"
    }), isSplitPanelOpen = _s[0], setIsSplitPanelOpen = _s[1];
    var handleSplitPanelClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function handleSplitPanelChange() {
        setIsSplitPanelOpen(!isSplitPanelOpen);
        (0,_internal_events__WEBPACK_IMPORTED_MODULE_7__/* .fireNonCancelableEvent */ .B4)(props.onSplitPanelToggle, {
            open: !isSplitPanelOpen
        });
    }, [
        props.onSplitPanelToggle,
        isSplitPanelOpen,
        setIsSplitPanelOpen
    ]);
    /**
     * The useControllable hook will manage the controlled or uncontrolled
     * state of the splitPanelPreferences. By default the splitPanelPreferences
     * is undefined. When set the object shape should have a single key to indicate
     * either bottom or side position.
     *
     * The callback that will handle changes to the splitPanelPreferences
     * object that will determine if the SplitPanel is rendered either on the
     * bottom of the viewport or within the Tools container.
     */ var _t = (0,_internal_hooks_use_controllable__WEBPACK_IMPORTED_MODULE_6__/* .useControllable */ .q)(props.splitPanelPreferences, props.onSplitPanelPreferencesChange, undefined, {
        componentName: "AppLayout",
        controlledProp: "splitPanelPreferences",
        changeHandler: "onSplitPanelPreferencesChange"
    }), splitPanelPreferences = _t[0], setSplitPanelPreferences = _t[1];
    /**
     * The Split Panel will be in forced (bottom) position if the defined minimum width is
     * greater than the maximum width. In other words, the maximum width is the currently
     * available horizontal space based on all other components that are rendered. If the
     * minimum width exceeds this value then there is not enough horizontal space and we must
     * force it to the bottom position.
     */ var _u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isSplitPanelForcedPosition = _u[0], setSplitPanelForcedPosition = _u[1];
    var splitPanelPosition = (0,_split_panel__WEBPACK_IMPORTED_MODULE_11__/* .getSplitPanelPosition */ .P)(isSplitPanelForcedPosition, splitPanelPreferences);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function handleSplitPanelForcePosition() {
        setSplitPanelForcedPosition(splitPanelMinWidth > splitPanelMaxWidth);
    }, [
        splitPanelMaxWidth,
        splitPanelMinWidth
    ]);
    /**
     * The useControllable hook will set the default size of the SplitPanel based
     * on the default position set in the splitPanelPreferences. The logic for the
     * default size is contained in the SplitPanel component. The splitPanelControlledSize
     * will be bound to the size property in the SplitPanel context for rendering.
     *
     * The callback that will be passed to the SplitPanel component
     * to handle the resize events that will change the size of the SplitPanel.
     * It will set the splitPanelControlledSize controlled state and fire the
     * onSplitPanelResize event.
     */ var _v = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), splitPanelReportedSize = _v[0], setSplitPanelReportedSize = _v[1];
    var _w = (0,_internal_hooks_use_controllable__WEBPACK_IMPORTED_MODULE_6__/* .useControllable */ .q)(props.splitPanelSize, props.onSplitPanelResize, (0,_split_panel_utils_size_utils__WEBPACK_IMPORTED_MODULE_12__/* .getSplitPanelDefaultSize */ .LV)(splitPanelPosition), {
        componentName: "AppLayout",
        controlledProp: "splitPanelSize",
        changeHandler: "onSplitPanelResize"
    }), splitPanelSize = _w[0], setSplitPanelSize = _w[1];
    var handleSplitPanelResize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function handleSplitPanelChange(detail) {
        setSplitPanelSize(detail.size);
        (0,_internal_events__WEBPACK_IMPORTED_MODULE_7__/* .fireNonCancelableEvent */ .B4)(props.onSplitPanelResize, detail);
    }, [
        props.onSplitPanelResize,
        setSplitPanelSize
    ]);
    var handleSplitPanelPreferencesChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function handleSplitPanelChange(detail) {
        setSplitPanelPreferences(detail);
        (0,_internal_events__WEBPACK_IMPORTED_MODULE_7__/* .fireNonCancelableEvent */ .B4)(props.onSplitPanelPreferencesChange, detail);
    }, [
        props.onSplitPanelPreferencesChange,
        setSplitPanelPreferences
    ]);
    /**
     * The Layout element is not necessarily synonymous with the client
     * viewport width. There can be content in the horizontal viewport
     * that exists on either side of the AppLayout. This resize observer
     * will set the custom property of the Layout element width that
     * is used for various horizontal constraints such as the maximum
     * allowed width of the Tools container.
     *
     * The offsetLeft of the Main will return the distance that the
     * Main element has from the left edge of the Layout component.
     * The offsetLeft value can vary based on the presence and state
     * of the Navigation as well as content gaps in the grid definition.
     * This value is used to determine the max width constraint calculation
     * for the Tools container.
     */ var _x = (0,_internal_hooks_container_queries__WEBPACK_IMPORTED_MODULE_13__/* .useContainerQuery */ .D)(function(rect) {
        return rect.width;
    }), layoutContainerQuery = _x[0], layoutElement = _x[1];
    var layoutWidth = layoutContainerQuery !== null && layoutContainerQuery !== void 0 ? layoutContainerQuery : 0;
    var mainElement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var _y = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), mainOffsetLeft = _y[0], setMainOffsetLeft = _y[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function handleMainOffsetLeft() {
        var _a, _b;
        setMainOffsetLeft((_b = (_a = mainElement === null || mainElement === void 0 ? void 0 : mainElement.current) === null || _a === void 0 ? void 0 : _a.offsetLeft) !== null && _b !== void 0 ? _b : 0);
    }, [
        layoutWidth,
        isNavigationOpen,
        isToolsOpen,
        splitPanelReportedSize
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function handleSplitPanelMaxWidth() {
        /**
         * Warning! This is a hack! In order to accurately calculate if there is adequate
         * horizontal space for the Split Panel to be in the side position we need two values
         * that are not available in JavaScript.
         *
         * The first is the the content gap on the right which is stored in a design token
         * and applied in the Layout CSS:
         *
         *  $contentGapRight: #{awsui.$space-scaled-2x-xxxl};
         *
         * The second is the width of the element that has the circular buttons for the
         * Tools and Split Panel. This could be suppressed given the state of the Tools
         * drawer returning a zero value. It would, however, be rendered if the Split Panel
         * were to move into the side position. This is calculated in the Tools CSS and
         * the Trigger button CSS with design tokens:
         *
         * padding: awsui.$space-scaled-s awsui.$space-layout-toggle-padding;
         * width: awsui.$space-layout-toggle-diameter;
         *
         * These values will be defined below as static integers that are rough approximations
         * of their computed width when rendered in the DOM, but doubled to ensure adequate
         * spacing for the Split Panel to be in side position.
         */ var contentGapRight = 80; // Approximately 40px when rendered but doubled for safety
        var toolsFormOffsetWidth = 160; // Approximately 80px when rendered but doubled for safety
        var toolsOffsetWidth = isToolsOpen ? toolsWidth : 0;
        setSplitPanelMaxWidth(layoutWidth - mainOffsetLeft - minContentWidth - contentGapRight - toolsOffsetWidth - toolsFormOffsetWidth);
    }, [
        isNavigationOpen,
        isToolsOpen,
        layoutWidth,
        mainOffsetLeft,
        minContentWidth,
        toolsWidth
    ]);
    /**
     * Because the notifications slot does not give us any direction insight into
     * what the state of the child content is we need to have a mechanism for
     * tracking the height of the notifications and whether or not it has content.
     * The height of the notifications is an integer that will be used as a custom
     * property on the Layout component to determine what the sticky offset should
     * be if there are sticky notifications. This could be any number including
     * zero based on how the child content renders. The hasNotificationsContent boolean
     * is simply centralizing the logic of the notifications height being > 0 such
     * that it is not repeated in various components (such as AppBar) that need to
     * know if the notifications slot is empty.
     */ var _z = (0,_internal_hooks_container_queries__WEBPACK_IMPORTED_MODULE_13__/* .useContainerQuery */ .D)(function(rect) {
        return rect.height;
    }), notificationsContainerQuery = _z[0], notificationsElement = _z[1];
    var _0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), notificationsHeight = _0[0], setNotificationsHeight = _0[1];
    var _1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), hasNotificationsContent = _1[0], setHasNotificationsContent = _1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function handleNotificationsContent() {
        setNotificationsHeight(notificationsContainerQuery !== null && notificationsContainerQuery !== void 0 ? notificationsContainerQuery : 0);
        setHasNotificationsContent(notificationsContainerQuery && notificationsContainerQuery > 0 ? true : false);
    }, [
        notificationsContainerQuery
    ]);
    /**
     * The offsetBottom value is used to determine the distance from the bottom of the
     * viewport a sticky element should be placed. A non-zero value means that there
     * is either a footer outside of the AppLayout, a SplitPanel in the bottom position
     * within the AppLayout, or both.
     */ var _2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), offsetBottom = _2[0], setOffsetBottom = _2[1];
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(AppLayoutContext.Provider, {
        value: (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, defaults), props), {
            contentType: contentType,
            dynamicOverlapHeight: dynamicOverlapHeight,
            headerHeight: headerHeight,
            footerHeight: footerHeight,
            hasDefaultToolsWidth: hasDefaultToolsWidth,
            handleNavigationClick: handleNavigationClick,
            handleSplitPanelClick: handleSplitPanelClick,
            handleSplitPanelPreferencesChange: handleSplitPanelPreferencesChange,
            handleSplitPanelResize: handleSplitPanelResize,
            handleToolsClick: handleToolsClick,
            hasNotificationsContent: hasNotificationsContent,
            hasStickyBackground: hasStickyBackground,
            isAnyPanelOpen: isAnyPanelOpen,
            isMobile: isMobile,
            isNavigationOpen: isNavigationOpen !== null && isNavigationOpen !== void 0 ? isNavigationOpen : false,
            isSplitPanelForcedPosition: isSplitPanelForcedPosition,
            isSplitPanelOpen: isSplitPanelOpen,
            isToolsOpen: isToolsOpen,
            layoutElement: layoutElement,
            layoutWidth: layoutWidth,
            mainElement: mainElement,
            mainOffsetLeft: mainOffsetLeft,
            maxContentWidth: maxContentWidth,
            minContentWidth: minContentWidth,
            navigationHide: navigationHide,
            notificationsElement: notificationsElement,
            notificationsHeight: notificationsHeight,
            offsetBottom: offsetBottom,
            setDynamicOverlapHeight: setDynamicOverlapHeight,
            setHasStickyBackground: setHasStickyBackground,
            setOffsetBottom: setOffsetBottom,
            setSplitPanelReportedSize: setSplitPanelReportedSize,
            splitPanelMaxWidth: splitPanelMaxWidth,
            splitPanelMinWidth: splitPanelMinWidth,
            splitPanelPosition: splitPanelPosition,
            splitPanelPreferences: splitPanelPreferences,
            splitPanelReportedSize: splitPanelReportedSize,
            splitPanelSize: splitPanelSize,
            toolsHide: toolsHide,
            toolsOpen: isToolsOpen,
            toolsWidth: toolsWidth,
            toolsFocusControl: toolsFocusControl
        })
    }, children);
}); //# sourceMappingURL=context.js.map


/***/ }),

/***/ 5007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ useDynamicOverlap; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7919);
/* harmony import */ var _internal_hooks_container_queries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5382);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



/**
 * Observes the height of an element referenced by the returning ref and sets the value as overlapping
 * height for the surrounding AppLayout component.
 * @param props.disabled disables hook if not applicable
 * @returns ref to be measured as overlapping height
 */ function useDynamicOverlap(props) {
    var _a;
    var disabled = (_a = props === null || props === void 0 ? void 0 : props.disabled) !== null && _a !== void 0 ? _a : false;
    var setDynamicOverlapHeight = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_1__/* .AppLayoutContext */ .T).setDynamicOverlapHeight;
    var _b = (0,_internal_hooks_container_queries__WEBPACK_IMPORTED_MODULE_2__/* .useContainerQuery */ .D)(function(rect) {
        return rect.height;
    }), overlapContainerQuery = _b[0], overlapElementRef = _b[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function handleDynamicOverlapHeight() {
        if (!disabled) {
            setDynamicOverlapHeight(overlapContainerQuery !== null && overlapContainerQuery !== void 0 ? overlapContainerQuery : 0);
        }
        return function() {
            if (!disabled) {
                setDynamicOverlapHeight(0);
            }
        };
    }, [
        disabled,
        overlapContainerQuery,
        setDynamicOverlapHeight
    ]);
    return overlapElementRef;
} //# sourceMappingURL=use-dynamic-overlap.js.map


/***/ }),

/***/ 9194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ getSplitPanelPosition; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6010);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7919);
/* harmony import */ var _internal_context_split_panel_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(206);
/* harmony import */ var _styles_css_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2415);
/* harmony import */ var _internal_hooks_use_effect_on_update__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9876);
/* harmony import */ var _internal_components_transition__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8437);
/* harmony import */ var _utils_use_observed_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7616);
/* harmony import */ var _internal_generated_custom_css_properties__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8276);

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0









/**
 * If there is no Split Panel in the AppLayout context then the SplitPanel
 * will pass through the AppLayout children without the context.
 */ function SplitPanel(_a) {
    var children = _a.children;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_1__/* .AppLayoutContext */ .T), handleSplitPanelClick = _b.handleSplitPanelClick, handleSplitPanelPreferencesChange = _b.handleSplitPanelPreferencesChange, handleSplitPanelResize = _b.handleSplitPanelResize, isMobile = _b.isMobile, isSplitPanelForcedPosition = _b.isSplitPanelForcedPosition, isSplitPanelOpen = _b.isSplitPanelOpen, setSplitPanelReportedSize = _b.setSplitPanelReportedSize, splitPanelPosition = _b.splitPanelPosition, splitPanelSize = _b.splitPanelSize, headerHeight = _b.headerHeight, footerHeight = _b.footerHeight;
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(undefined), openButtonAriaLabel = _c[0], setOpenButtonAriaLabel = _c[1];
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), splitPanelLastInteraction = _d[0], setSplitPanelLastInteraction = _d[1];
    (0,_internal_hooks_use_effect_on_update__WEBPACK_IMPORTED_MODULE_2__/* .useEffectOnUpdate */ .G)(function() {
        return setSplitPanelLastInteraction(isSplitPanelOpen ? {
            type: "open"
        } : {
            type: "close"
        });
    }, [
        isSplitPanelOpen
    ]);
    (0,_internal_hooks_use_effect_on_update__WEBPACK_IMPORTED_MODULE_2__/* .useEffectOnUpdate */ .G)(function() {
        return setSplitPanelLastInteraction({
            type: "position"
        });
    }, [
        splitPanelPosition
    ]);
    var splitPanelRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var splitPanelHeaderRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var context = {
        bottomOffset: 0,
        getMaxHeight: function() {
            var availableHeight = document.documentElement.clientHeight - headerHeight - footerHeight;
            // If the page is likely zoomed in at 200%, allow the split panel to fill the content area.
            return availableHeight < 400 ? availableHeight - 40 : availableHeight - 250;
        },
        getMaxWidth: function() {
            return document.documentElement.clientWidth;
        },
        getHeader: function() {
            return splitPanelHeaderRef.current;
        },
        isForcedPosition: isSplitPanelForcedPosition,
        isMobile: isMobile,
        isOpen: isSplitPanelOpen,
        leftOffset: 0,
        onPreferencesChange: handleSplitPanelPreferencesChange,
        onResize: handleSplitPanelResize,
        onToggle: handleSplitPanelClick,
        position: splitPanelPosition,
        reportSize: setSplitPanelReportedSize,
        rightOffset: 0,
        size: splitPanelSize || 0,
        splitPanelRef: splitPanelRef,
        splitPanelHeaderRef: splitPanelHeaderRef,
        topOffset: 0,
        openButtonAriaLabel: openButtonAriaLabel,
        setOpenButtonAriaLabel: setOpenButtonAriaLabel,
        lastInteraction: splitPanelLastInteraction
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_context_split_panel_context__WEBPACK_IMPORTED_MODULE_3__/* .SplitPanelContext.Provider */ .C.Provider, {
        value: (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)({}, context)
    }, children);
}
/**
 * This is the render function for the SplitPanel when it is in bottom position.
 * The Split Panel container will be another row entry in the grid definition in
 * the Layout component. The start and finish columns will be variable based
 * on the the presence and state of the Navigation and Tools components.
 */ function SplitPanelBottom() {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_1__/* .AppLayoutContext */ .T), disableBodyScroll = _a.disableBodyScroll, isNavigationOpen = _a.isNavigationOpen, isSplitPanelOpen = _a.isSplitPanelOpen, isToolsOpen = _a.isToolsOpen, splitPanel = _a.splitPanel, splitPanelReportedSize = _a.splitPanelReportedSize;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_internal_context_split_panel_context__WEBPACK_IMPORTED_MODULE_3__/* .SplitPanelContext */ .C), splitPanelPosition = _b.position, getHeader = _b.getHeader;
    var headerHeight = (0,_utils_use_observed_element__WEBPACK_IMPORTED_MODULE_5__/* .useObservedElement */ .x)(getHeader);
    if (!splitPanel) {
        return null;
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_components_transition__WEBPACK_IMPORTED_MODULE_6__/* .Transition */ .u, {
        "in": isSplitPanelOpen !== null && isSplitPanelOpen !== void 0 ? isSplitPanelOpen : false,
        exit: false
    }, function(state, transitionEventsRef) {
        var _a, _b;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("section", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_styles_css_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"]["split-panel-bottom"] */ .Z["split-panel-bottom"], _styles_css_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z["position-".concat(splitPanelPosition)], (_a = {}, _a[_styles_css_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"].animating */ .Z.animating] = state === "entering", _a[_styles_css_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"]["disable-body-scroll"] */ .Z["disable-body-scroll"]] = disableBodyScroll, _a[_styles_css_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"]["is-navigation-open"] */ .Z["is-navigation-open"]] = isNavigationOpen, _a[_styles_css_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"]["is-split-panel-open"] */ .Z["is-split-panel-open"]] = isSplitPanelOpen, _a[_styles_css_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"]["is-tools-open"] */ .Z["is-tools-open"]] = isToolsOpen, _a)),
            ref: transitionEventsRef,
            style: (_b = {}, _b[_internal_generated_custom_css_properties__WEBPACK_IMPORTED_MODULE_9__/* ["default"].splitPanelReportedSize */ .Z.splitPanelReportedSize] = "".concat(splitPanelReportedSize, "px"), _b[_internal_generated_custom_css_properties__WEBPACK_IMPORTED_MODULE_9__/* ["default"].splitPanelReportedHeaderSize */ .Z.splitPanelReportedHeaderSize] = "".concat(headerHeight, "px"), _b)
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SplitPanel, null), splitPanelPosition === "bottom" && splitPanel);
    });
}
/**
 * This is the render function for the SplitPanel when it is side position.
 * The Split Panel will not be within the grid defined in the Layout component
 * but instead a direct child of the Tools component. The width constraints
 * for this position are computed in the Tools component.
 */ function SplitPanelSide() {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_1__/* .AppLayoutContext */ .T), isSplitPanelOpen = _a.isSplitPanelOpen, splitPanel = _a.splitPanel, splitPanelMaxWidth = _a.splitPanelMaxWidth, splitPanelMinWidth = _a.splitPanelMinWidth, splitPanelReportedSize = _a.splitPanelReportedSize;
    var splitPanelPosition = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_internal_context_split_panel_context__WEBPACK_IMPORTED_MODULE_3__/* .SplitPanelContext */ .C).position;
    if (!splitPanel) {
        return null;
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_components_transition__WEBPACK_IMPORTED_MODULE_6__/* .Transition */ .u, {
        "in": isSplitPanelOpen !== null && isSplitPanelOpen !== void 0 ? isSplitPanelOpen : false,
        exit: false
    }, function(state, transitionEventsRef) {
        var _a, _b;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("section", {
            "aria-hidden": !isSplitPanelOpen || splitPanelPosition === "bottom" ? true : false,
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_styles_css_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"]["split-panel-side"] */ .Z["split-panel-side"], _styles_css_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z["position-".concat(splitPanelPosition)], (_a = {}, _a[_styles_css_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"].animating */ .Z.animating] = state === "entering", _a[_styles_css_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"]["is-split-panel-open"] */ .Z["is-split-panel-open"]] = isSplitPanelOpen, _a)),
            ref: transitionEventsRef,
            style: (_b = {}, _b[_internal_generated_custom_css_properties__WEBPACK_IMPORTED_MODULE_9__/* ["default"].splitPanelMaxWidth */ .Z.splitPanelMaxWidth] = "".concat(splitPanelMaxWidth, "px"), _b[_internal_generated_custom_css_properties__WEBPACK_IMPORTED_MODULE_9__/* ["default"].splitPanelMinWidth */ .Z.splitPanelMinWidth] = "".concat(splitPanelMinWidth, "px"), _b[_internal_generated_custom_css_properties__WEBPACK_IMPORTED_MODULE_9__/* ["default"].splitPanelReportedHeaderSize */ .Z.splitPanelReportedHeaderSize] = "".concat(splitPanelReportedSize, "px"), _b)
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_styles_css_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"]["animated-content"] */ .Z["animated-content"])
        }, splitPanelPosition === "side" && splitPanel));
    });
}
/**
 * This logic will determine what the Split Panel position should be. It reconciles the possibility
 * of being in forced position with the current selected position in the settings.
 */ function getSplitPanelPosition(isSplitPanelForcedPosition, splitPanelPreferences) {
    var splitPanelPosition = "bottom";
    if (!isSplitPanelForcedPosition && (splitPanelPreferences === null || splitPanelPreferences === void 0 ? void 0 : splitPanelPreferences.position) === "side") {
        splitPanelPosition = "side";
    }
    return splitPanelPosition;
}
SplitPanel.Bottom = SplitPanelBottom;
SplitPanel.Side = SplitPanelSide;
/* harmony default export */ __webpack_exports__["Z"] = (SplitPanel); //# sourceMappingURL=split-panel.js.map


/***/ }),

/***/ 2415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _styles_scoped_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2177);
/* harmony import */ var _styles_scoped_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_styles_scoped_css__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    "appbar": "awsui_appbar_hyvsj_ecp2y_93",
    "appbar-nav": "awsui_appbar-nav_hyvsj_ecp2y_117",
    "breadcrumbs": "awsui_breadcrumbs_hyvsj_ecp2y_121",
    "appbar-tools": "awsui_appbar-tools_hyvsj_ecp2y_125",
    "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_ecp2y_166",
    "has-notifications-content": "awsui_has-notifications-content_hyvsj_ecp2y_173",
    "has-header": "awsui_has-header_hyvsj_ecp2y_179",
    "has-dynamic-overlap-height": "awsui_has-dynamic-overlap-height_hyvsj_ecp2y_179",
    "content-type-wizard": "awsui_content-type-wizard_hyvsj_ecp2y_180",
    "content-type-cards": "awsui_content-type-cards_hyvsj_ecp2y_183",
    "content-type-table": "awsui_content-type-table_hyvsj_ecp2y_184",
    "has-sticky-background": "awsui_has-sticky-background_hyvsj_ecp2y_187",
    "background": "awsui_background_hyvsj_ecp2y_221",
    "notifications-appbar-header": "awsui_notifications-appbar-header_hyvsj_ecp2y_224",
    "sticky-notifications": "awsui_sticky-notifications_hyvsj_ecp2y_236",
    "overlap": "awsui_overlap_hyvsj_ecp2y_242",
    "content": "awsui_content_hyvsj_ecp2y_180",
    "layout": "awsui_layout_hyvsj_ecp2y_329",
    "has-max-content-width": "awsui_has-max-content-width_hyvsj_ecp2y_411",
    "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_ecp2y_438",
    "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_ecp2y_441",
    "has-sticky-notifications": "awsui_has-sticky-notifications_hyvsj_ecp2y_445",
    "has-split-panel": "awsui_has-split-panel_hyvsj_ecp2y_459",
    "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_ecp2y_459",
    "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_ecp2y_471",
    "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_ecp2y_474",
    "block-body-scroll": "awsui_block-body-scroll_hyvsj_ecp2y_489",
    "container": "awsui_container_hyvsj_ecp2y_497",
    "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_ecp2y_523",
    "is-navigation-open": "awsui_is-navigation-open_hyvsj_ecp2y_528",
    "is-tools-open": "awsui_is-tools-open_hyvsj_ecp2y_531",
    "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_ecp2y_531",
    "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_ecp2y_531",
    "content-type-default": "awsui_content-type-default_hyvsj_ecp2y_551",
    "content-type-form": "awsui_content-type-form_hyvsj_ecp2y_551",
    "unfocusable": "awsui_unfocusable_hyvsj_ecp2y_592",
    "navigation-container": "awsui_navigation-container_hyvsj_ecp2y_600",
    "show-navigation": "awsui_show-navigation_hyvsj_ecp2y_635",
    "animating": "awsui_animating_hyvsj_ecp2y_657",
    "showButtons": "awsui_showButtons_hyvsj_ecp2y_1",
    "navigation": "awsui_navigation_hyvsj_ecp2y_600",
    "openNavigation": "awsui_openNavigation_hyvsj_ecp2y_1",
    "animated-content": "awsui_animated-content_hyvsj_ecp2y_718",
    "hide-navigation": "awsui_hide-navigation_hyvsj_ecp2y_727",
    "notifications": "awsui_notifications_hyvsj_ecp2y_224",
    "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_ecp2y_792",
    "position-bottom": "awsui_position-bottom_hyvsj_ecp2y_838",
    "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_ecp2y_1",
    "split-panel-side": "awsui_split-panel-side_hyvsj_ecp2y_867",
    "position-side": "awsui_position-side_hyvsj_ecp2y_895",
    "openSplitPanelSide": "awsui_openSplitPanelSide_hyvsj_ecp2y_1",
    "tools-container": "awsui_tools-container_hyvsj_ecp2y_932",
    "tools": "awsui_tools_hyvsj_ecp2y_932",
    "openTools": "awsui_openTools_hyvsj_ecp2y_1",
    "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_ecp2y_1017",
    "hide-tools": "awsui_hide-tools_hyvsj_ecp2y_1027",
    "show-tools": "awsui_show-tools_hyvsj_ecp2y_1039",
    "has-tools-form": "awsui_has-tools-form_hyvsj_ecp2y_1017",
    "trigger": "awsui_trigger_hyvsj_ecp2y_1096",
    "selected": "awsui_selected_hyvsj_ecp2y_1135"
});


/***/ }),

/***/ 918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ InternalBox; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/box/styles.scoped.css
var styles_scoped = __webpack_require__(5735);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/box/styles.css.js

/* harmony default export */ var styles_css = ({
    "root": "awsui_root_18wu0_1xtkt_93",
    "box": "awsui_box_18wu0_1xtkt_205",
    "p-variant": "awsui_p-variant_18wu0_1xtkt_205",
    "color-default": "awsui_color-default_18wu0_1xtkt_205",
    "b-variant": "awsui_b-variant_18wu0_1xtkt_205",
    "strong-variant": "awsui_strong-variant_18wu0_1xtkt_205",
    "code-variant": "awsui_code-variant_18wu0_1xtkt_205",
    "pre-variant": "awsui_pre-variant_18wu0_1xtkt_205",
    "samp-variant": "awsui_samp-variant_18wu0_1xtkt_205",
    "h1-variant": "awsui_h1-variant_18wu0_1xtkt_209",
    "h2-variant": "awsui_h2-variant_18wu0_1xtkt_209",
    "h3-variant": "awsui_h3-variant_18wu0_1xtkt_209",
    "h4-variant": "awsui_h4-variant_18wu0_1xtkt_209",
    "h5-variant": "awsui_h5-variant_18wu0_1xtkt_209",
    "small-variant": "awsui_small-variant_18wu0_1xtkt_213",
    "a-variant": "awsui_a-variant_18wu0_1xtkt_217",
    "font-size-default": "awsui_font-size-default_18wu0_1xtkt_221",
    "font-weight-default": "awsui_font-weight-default_18wu0_1xtkt_261",
    "key-label-variant": "awsui_key-label-variant_18wu0_1xtkt_301",
    "value-large-variant": "awsui_value-large-variant_18wu0_1xtkt_306",
    "color-inverted": "awsui_color-inverted_18wu0_1xtkt_314",
    "color-text-label": "awsui_color-text-label_18wu0_1xtkt_317",
    "color-text-body-secondary": "awsui_color-text-body-secondary_18wu0_1xtkt_320",
    "color-text-status-error": "awsui_color-text-status-error_18wu0_1xtkt_323",
    "color-text-status-success": "awsui_color-text-status-success_18wu0_1xtkt_326",
    "color-text-status-info": "awsui_color-text-status-info_18wu0_1xtkt_329",
    "color-text-status-inactive": "awsui_color-text-status-inactive_18wu0_1xtkt_332",
    "color-inherit": "awsui_color-inherit_18wu0_1xtkt_335",
    "font-size-body-s": "awsui_font-size-body-s_18wu0_1xtkt_338",
    "font-size-body-m": "awsui_font-size-body-m_18wu0_1xtkt_343",
    "font-size-heading-xs": "awsui_font-size-heading-xs_18wu0_1xtkt_347",
    "font-size-heading-s": "awsui_font-size-heading-s_18wu0_1xtkt_351",
    "font-size-heading-m": "awsui_font-size-heading-m_18wu0_1xtkt_356",
    "font-size-heading-l": "awsui_font-size-heading-l_18wu0_1xtkt_361",
    "font-size-heading-xl": "awsui_font-size-heading-xl_18wu0_1xtkt_366",
    "font-size-display-l": "awsui_font-size-display-l_18wu0_1xtkt_371",
    "font-weight-light": "awsui_font-weight-light_18wu0_1xtkt_376",
    "font-weight-normal": "awsui_font-weight-normal_18wu0_1xtkt_379",
    "font-weight-bold": "awsui_font-weight-bold_18wu0_1xtkt_382",
    "font-weight-heavy": "awsui_font-weight-heavy_18wu0_1xtkt_385",
    "t-left": "awsui_t-left_18wu0_1xtkt_389",
    "t-right": "awsui_t-right_18wu0_1xtkt_393",
    "t-center": "awsui_t-center_18wu0_1xtkt_397",
    "p-n": "awsui_p-n_18wu0_1xtkt_498",
    "p-top-n": "awsui_p-top-n_18wu0_1xtkt_502",
    "p-vertical-n": "awsui_p-vertical-n_18wu0_1xtkt_503",
    "p-right-n": "awsui_p-right-n_18wu0_1xtkt_507",
    "p-horizontal-n": "awsui_p-horizontal-n_18wu0_1xtkt_508",
    "p-bottom-n": "awsui_p-bottom-n_18wu0_1xtkt_512",
    "p-left-n": "awsui_p-left-n_18wu0_1xtkt_517",
    "p-xxxs": "awsui_p-xxxs_18wu0_1xtkt_522",
    "p-top-xxxs": "awsui_p-top-xxxs_18wu0_1xtkt_526",
    "p-vertical-xxxs": "awsui_p-vertical-xxxs_18wu0_1xtkt_527",
    "p-right-xxxs": "awsui_p-right-xxxs_18wu0_1xtkt_531",
    "p-horizontal-xxxs": "awsui_p-horizontal-xxxs_18wu0_1xtkt_532",
    "p-bottom-xxxs": "awsui_p-bottom-xxxs_18wu0_1xtkt_536",
    "p-left-xxxs": "awsui_p-left-xxxs_18wu0_1xtkt_541",
    "p-xxs": "awsui_p-xxs_18wu0_1xtkt_546",
    "p-top-xxs": "awsui_p-top-xxs_18wu0_1xtkt_550",
    "p-vertical-xxs": "awsui_p-vertical-xxs_18wu0_1xtkt_551",
    "p-right-xxs": "awsui_p-right-xxs_18wu0_1xtkt_555",
    "p-horizontal-xxs": "awsui_p-horizontal-xxs_18wu0_1xtkt_556",
    "p-bottom-xxs": "awsui_p-bottom-xxs_18wu0_1xtkt_560",
    "p-left-xxs": "awsui_p-left-xxs_18wu0_1xtkt_565",
    "p-xs": "awsui_p-xs_18wu0_1xtkt_570",
    "p-top-xs": "awsui_p-top-xs_18wu0_1xtkt_574",
    "p-vertical-xs": "awsui_p-vertical-xs_18wu0_1xtkt_575",
    "p-right-xs": "awsui_p-right-xs_18wu0_1xtkt_579",
    "p-horizontal-xs": "awsui_p-horizontal-xs_18wu0_1xtkt_580",
    "p-bottom-xs": "awsui_p-bottom-xs_18wu0_1xtkt_584",
    "p-left-xs": "awsui_p-left-xs_18wu0_1xtkt_589",
    "p-s": "awsui_p-s_18wu0_1xtkt_594",
    "p-top-s": "awsui_p-top-s_18wu0_1xtkt_598",
    "p-vertical-s": "awsui_p-vertical-s_18wu0_1xtkt_599",
    "p-right-s": "awsui_p-right-s_18wu0_1xtkt_603",
    "p-horizontal-s": "awsui_p-horizontal-s_18wu0_1xtkt_604",
    "p-bottom-s": "awsui_p-bottom-s_18wu0_1xtkt_608",
    "p-left-s": "awsui_p-left-s_18wu0_1xtkt_613",
    "p-m": "awsui_p-m_18wu0_1xtkt_618",
    "p-top-m": "awsui_p-top-m_18wu0_1xtkt_622",
    "p-vertical-m": "awsui_p-vertical-m_18wu0_1xtkt_623",
    "p-right-m": "awsui_p-right-m_18wu0_1xtkt_627",
    "p-horizontal-m": "awsui_p-horizontal-m_18wu0_1xtkt_628",
    "p-bottom-m": "awsui_p-bottom-m_18wu0_1xtkt_632",
    "p-left-m": "awsui_p-left-m_18wu0_1xtkt_637",
    "p-l": "awsui_p-l_18wu0_1xtkt_517",
    "p-top-l": "awsui_p-top-l_18wu0_1xtkt_646",
    "p-vertical-l": "awsui_p-vertical-l_18wu0_1xtkt_647",
    "p-right-l": "awsui_p-right-l_18wu0_1xtkt_651",
    "p-horizontal-l": "awsui_p-horizontal-l_18wu0_1xtkt_652",
    "p-bottom-l": "awsui_p-bottom-l_18wu0_1xtkt_656",
    "p-left-l": "awsui_p-left-l_18wu0_1xtkt_661",
    "p-xl": "awsui_p-xl_18wu0_1xtkt_666",
    "p-top-xl": "awsui_p-top-xl_18wu0_1xtkt_670",
    "p-vertical-xl": "awsui_p-vertical-xl_18wu0_1xtkt_671",
    "p-right-xl": "awsui_p-right-xl_18wu0_1xtkt_675",
    "p-horizontal-xl": "awsui_p-horizontal-xl_18wu0_1xtkt_676",
    "p-bottom-xl": "awsui_p-bottom-xl_18wu0_1xtkt_680",
    "p-left-xl": "awsui_p-left-xl_18wu0_1xtkt_685",
    "p-xxl": "awsui_p-xxl_18wu0_1xtkt_690",
    "p-top-xxl": "awsui_p-top-xxl_18wu0_1xtkt_694",
    "p-vertical-xxl": "awsui_p-vertical-xxl_18wu0_1xtkt_695",
    "p-right-xxl": "awsui_p-right-xxl_18wu0_1xtkt_699",
    "p-horizontal-xxl": "awsui_p-horizontal-xxl_18wu0_1xtkt_700",
    "p-bottom-xxl": "awsui_p-bottom-xxl_18wu0_1xtkt_704",
    "p-left-xxl": "awsui_p-left-xxl_18wu0_1xtkt_709",
    "p-xxxl": "awsui_p-xxxl_18wu0_1xtkt_714",
    "p-top-xxxl": "awsui_p-top-xxxl_18wu0_1xtkt_718",
    "p-vertical-xxxl": "awsui_p-vertical-xxxl_18wu0_1xtkt_719",
    "p-right-xxxl": "awsui_p-right-xxxl_18wu0_1xtkt_723",
    "p-horizontal-xxxl": "awsui_p-horizontal-xxxl_18wu0_1xtkt_724",
    "p-bottom-xxxl": "awsui_p-bottom-xxxl_18wu0_1xtkt_728",
    "p-left-xxxl": "awsui_p-left-xxxl_18wu0_1xtkt_733",
    "m-n": "awsui_m-n_18wu0_1xtkt_738",
    "m-top-n": "awsui_m-top-n_18wu0_1xtkt_742",
    "m-vertical-n": "awsui_m-vertical-n_18wu0_1xtkt_743",
    "m-right-n": "awsui_m-right-n_18wu0_1xtkt_747",
    "m-horizontal-n": "awsui_m-horizontal-n_18wu0_1xtkt_748",
    "m-bottom-n": "awsui_m-bottom-n_18wu0_1xtkt_752",
    "m-left-n": "awsui_m-left-n_18wu0_1xtkt_757",
    "m-xxxs": "awsui_m-xxxs_18wu0_1xtkt_762",
    "m-top-xxxs": "awsui_m-top-xxxs_18wu0_1xtkt_766",
    "m-vertical-xxxs": "awsui_m-vertical-xxxs_18wu0_1xtkt_767",
    "m-right-xxxs": "awsui_m-right-xxxs_18wu0_1xtkt_771",
    "m-horizontal-xxxs": "awsui_m-horizontal-xxxs_18wu0_1xtkt_772",
    "m-bottom-xxxs": "awsui_m-bottom-xxxs_18wu0_1xtkt_776",
    "m-left-xxxs": "awsui_m-left-xxxs_18wu0_1xtkt_781",
    "m-xxs": "awsui_m-xxs_18wu0_1xtkt_786",
    "m-top-xxs": "awsui_m-top-xxs_18wu0_1xtkt_790",
    "m-vertical-xxs": "awsui_m-vertical-xxs_18wu0_1xtkt_791",
    "m-right-xxs": "awsui_m-right-xxs_18wu0_1xtkt_795",
    "m-horizontal-xxs": "awsui_m-horizontal-xxs_18wu0_1xtkt_796",
    "m-bottom-xxs": "awsui_m-bottom-xxs_18wu0_1xtkt_800",
    "m-left-xxs": "awsui_m-left-xxs_18wu0_1xtkt_805",
    "m-xs": "awsui_m-xs_18wu0_1xtkt_810",
    "m-top-xs": "awsui_m-top-xs_18wu0_1xtkt_814",
    "m-vertical-xs": "awsui_m-vertical-xs_18wu0_1xtkt_815",
    "m-right-xs": "awsui_m-right-xs_18wu0_1xtkt_819",
    "m-horizontal-xs": "awsui_m-horizontal-xs_18wu0_1xtkt_820",
    "m-bottom-xs": "awsui_m-bottom-xs_18wu0_1xtkt_824",
    "m-left-xs": "awsui_m-left-xs_18wu0_1xtkt_829",
    "m-s": "awsui_m-s_18wu0_1xtkt_834",
    "m-top-s": "awsui_m-top-s_18wu0_1xtkt_838",
    "m-vertical-s": "awsui_m-vertical-s_18wu0_1xtkt_839",
    "m-right-s": "awsui_m-right-s_18wu0_1xtkt_843",
    "m-horizontal-s": "awsui_m-horizontal-s_18wu0_1xtkt_844",
    "m-bottom-s": "awsui_m-bottom-s_18wu0_1xtkt_848",
    "m-left-s": "awsui_m-left-s_18wu0_1xtkt_853",
    "m-m": "awsui_m-m_18wu0_1xtkt_858",
    "m-top-m": "awsui_m-top-m_18wu0_1xtkt_862",
    "m-vertical-m": "awsui_m-vertical-m_18wu0_1xtkt_863",
    "m-right-m": "awsui_m-right-m_18wu0_1xtkt_867",
    "m-horizontal-m": "awsui_m-horizontal-m_18wu0_1xtkt_868",
    "m-bottom-m": "awsui_m-bottom-m_18wu0_1xtkt_872",
    "m-left-m": "awsui_m-left-m_18wu0_1xtkt_877",
    "m-l": "awsui_m-l_18wu0_1xtkt_757",
    "m-top-l": "awsui_m-top-l_18wu0_1xtkt_886",
    "m-vertical-l": "awsui_m-vertical-l_18wu0_1xtkt_887",
    "m-right-l": "awsui_m-right-l_18wu0_1xtkt_891",
    "m-horizontal-l": "awsui_m-horizontal-l_18wu0_1xtkt_892",
    "m-bottom-l": "awsui_m-bottom-l_18wu0_1xtkt_896",
    "m-left-l": "awsui_m-left-l_18wu0_1xtkt_901",
    "m-xl": "awsui_m-xl_18wu0_1xtkt_906",
    "m-top-xl": "awsui_m-top-xl_18wu0_1xtkt_910",
    "m-vertical-xl": "awsui_m-vertical-xl_18wu0_1xtkt_911",
    "m-right-xl": "awsui_m-right-xl_18wu0_1xtkt_915",
    "m-horizontal-xl": "awsui_m-horizontal-xl_18wu0_1xtkt_916",
    "m-bottom-xl": "awsui_m-bottom-xl_18wu0_1xtkt_920",
    "m-left-xl": "awsui_m-left-xl_18wu0_1xtkt_925",
    "m-xxl": "awsui_m-xxl_18wu0_1xtkt_930",
    "m-top-xxl": "awsui_m-top-xxl_18wu0_1xtkt_934",
    "m-vertical-xxl": "awsui_m-vertical-xxl_18wu0_1xtkt_935",
    "m-right-xxl": "awsui_m-right-xxl_18wu0_1xtkt_939",
    "m-horizontal-xxl": "awsui_m-horizontal-xxl_18wu0_1xtkt_940",
    "m-bottom-xxl": "awsui_m-bottom-xxl_18wu0_1xtkt_944",
    "m-left-xxl": "awsui_m-left-xxl_18wu0_1xtkt_949",
    "m-xxxl": "awsui_m-xxxl_18wu0_1xtkt_954",
    "m-top-xxxl": "awsui_m-top-xxxl_18wu0_1xtkt_958",
    "m-vertical-xxxl": "awsui_m-vertical-xxxl_18wu0_1xtkt_959",
    "m-right-xxxl": "awsui_m-right-xxxl_18wu0_1xtkt_963",
    "m-horizontal-xxxl": "awsui_m-horizontal-xxxl_18wu0_1xtkt_964",
    "m-bottom-xxxl": "awsui_m-bottom-xxxl_18wu0_1xtkt_968",
    "m-left-xxxl": "awsui_m-left-xxxl_18wu0_1xtkt_973",
    "d-block": "awsui_d-block_18wu0_1xtkt_978",
    "d-inline": "awsui_d-inline_18wu0_1xtkt_981",
    "d-inline-block": "awsui_d-inline-block_18wu0_1xtkt_984",
    "d-none": "awsui_d-none_18wu0_1xtkt_987",
    "f-left": "awsui_f-left_18wu0_1xtkt_991",
    "f-right": "awsui_f-right_18wu0_1xtkt_995"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/box/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




function InternalBox(_a) {
    var _b = _a.variant, variant = _b === void 0 ? "div" : _b, tagOverride = _a.tagOverride, _c = _a.margin, margin = _c === void 0 ? {} : _c, _d = _a.padding, padding = _d === void 0 ? {} : _d, display = _a.display, textAlign = _a.textAlign, float = _a.float, fontSize = _a.fontSize, fontWeight = _a.fontWeight, color = _a.color, children = _a.children, _e = _a.__internalRootRef, __internalRootRef = _e === void 0 ? null : _e, props = (0,tslib_es6/* __rest */._T)(_a, [
        "variant",
        "tagOverride",
        "margin",
        "padding",
        "display",
        "textAlign",
        "float",
        "fontSize",
        "fontWeight",
        "color",
        "children",
        "__internalRootRef"
    ]);
    var baseProps = (0,base_component/* getBaseProps */.j)(props);
    var marginsClassNamesSuffices = getClassNamesSuffixes(margin);
    var paddingsClassNamesSuffices = getClassNamesSuffixes(padding);
    // This can be any arbitrary string if passed into tagOverride.
    // We appease the compiler with an incorrect type.
    var Tag = getTag(variant, tagOverride);
    var className = (0,clsx_m/* default */.Z)(baseProps.className, styles_css.root, styles_css.box, styles_css["".concat(variant.replace(/^awsui-/, ""), "-variant")], marginsClassNamesSuffices.map(function(suffix) {
        return styles_css["m-".concat(suffix)];
    }), paddingsClassNamesSuffices.map(function(suffix) {
        return styles_css["p-".concat(suffix)];
    }), styles_css["d-".concat(display)], styles_css["f-".concat(float)], styles_css["color-".concat(color || "default")], styles_css["font-size-".concat(fontSize || "default")], styles_css["font-weight-".concat(fontWeight || "default")], styles_css["t-".concat(textAlign)]);
    return /*#__PURE__*/ react.createElement(Tag, (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        className: className,
        ref: __internalRootRef
    }), children);
}
var getClassNamesSuffixes = function(value) {
    if (typeof value === "string") {
        return [
            value
        ];
    }
    var sides = [
        "top",
        "right",
        "bottom",
        "left",
        "horizontal",
        "vertical"
    ];
    return sides.filter(function(side) {
        return !!value[side];
    }).map(function(side) {
        return "".concat(side, "-").concat(value[side]);
    });
};
var getTag = function(variant, tagOverride) {
    if (tagOverride) {
        return tagOverride;
    }
    if (variant === "awsui-value-large") {
        return "span";
    }
    if (variant === "awsui-key-label") {
        return "div";
    }
    return variant;
}; //# sourceMappingURL=internal.js.map


/***/ }),

/***/ 1753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BreadcrumbGroup; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/apply-display-name.js
var apply_display_name = __webpack_require__(1651);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-base-component/index.js + 2 modules
var use_base_component = __webpack_require__(4656);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/breadcrumb-group/styles.scoped.css
var styles_scoped = __webpack_require__(3313);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/breadcrumb-group/styles.css.js

/* harmony default export */ var styles_css = ({
    "breadcrumb-group": "awsui_breadcrumb-group_d19fg_zzbk1_93",
    "item": "awsui_item_d19fg_zzbk1_105",
    "breadcrumb-group-list": "awsui_breadcrumb-group-list_d19fg_zzbk1_116",
    "ellipsis": "awsui_ellipsis_d19fg_zzbk1_126",
    "icon": "awsui_icon_d19fg_zzbk1_134",
    "mobile": "awsui_mobile_d19fg_zzbk1_138"
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/icon/internal.js + 2 modules
var internal = __webpack_require__(776);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/button-dropdown/internal.js + 18 modules
var button_dropdown_internal = __webpack_require__(4699);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/button/internal.js + 6 modules
var button_internal = __webpack_require__(8145);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/breadcrumb-group/item/styles.scoped.css
var item_styles_scoped = __webpack_require__(7644);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/breadcrumb-group/item/styles.css.js

/* harmony default export */ var item_styles_css = ({
    "link": "awsui_link_1kosq_7k1hd_93",
    "breadcrumb": "awsui_breadcrumb_1kosq_7k1hd_97",
    "icon": "awsui_icon_1kosq_7k1hd_100",
    "anchor": "awsui_anchor_1kosq_7k1hd_104",
    "last": "awsui_last_1kosq_7k1hd_147",
    "compressed": "awsui_compressed_1kosq_7k1hd_157",
    "text": "awsui_text_1kosq_7k1hd_161",
    "virtual-item": "awsui_virtual-item_1kosq_7k1hd_168",
    "item-popover": "awsui_item-popover_1kosq_7k1hd_175"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/focus-visible/index.js
var focus_visible = __webpack_require__(9297);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/events/index.js
var events = __webpack_require__(6322);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/transition/index.js
var transition = __webpack_require__(8437);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/popover/container.js + 1 modules
var container = __webpack_require__(2072);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/popover/body.js + 1 modules
var body = __webpack_require__(9820);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/portal/index.js
var portal = __webpack_require__(1712);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/popover/styles.css.js
var popover_styles_css = __webpack_require__(2577);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/breadcrumb-group/item/item.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0












var BreadcrumbItemWithPopover = function(_a) {
    var item = _a.item, anchorAttributes = (0,tslib_es6/* __rest */._T)(_a, [
        "item"
    ]);
    var focusVisible = (0,focus_visible/* default */.Z)();
    var _b = (0,react.useState)(false), showPopover = _b[0], setShowPopover = _b[1];
    var textRef = (0,react.useRef)(null);
    var virtualTextRef = (0,react.useRef)(null);
    var isTruncated = function(textRef, virtualTextRef) {
        if (!textRef || !virtualTextRef || !textRef.current || !virtualTextRef.current) {
            return false;
        }
        var virtualTextWidth = virtualTextRef.current.getBoundingClientRect().width;
        var textWidth = textRef.current.getBoundingClientRect().width;
        if (virtualTextWidth > textWidth) {
            return true;
        }
        return false;
    };
    var popoverContent = /*#__PURE__*/ react.createElement(portal/* default */.Z, null, /*#__PURE__*/ react.createElement("div", {
        className: item_styles_css["item-popover"]
    }, /*#__PURE__*/ react.createElement(transition/* Transition */.u, {
        "in": true
    }, function() {
        return /*#__PURE__*/ react.createElement(container/* default */.Z, {
            trackRef: textRef,
            size: "small",
            fixedWidth: false,
            position: "bottom",
            arrow: function(position) {
                return /*#__PURE__*/ react.createElement("div", {
                    className: (0,clsx_m/* default */.Z)(popover_styles_css/* default.arrow */.Z.arrow, popover_styles_css/* default */.Z["arrow-position-".concat(position)])
                }, /*#__PURE__*/ react.createElement("div", {
                    className: popover_styles_css/* default.arrow-outer */.Z["arrow-outer"]
                }), /*#__PURE__*/ react.createElement("div", {
                    className: popover_styles_css/* default.arrow-inner */.Z["arrow-inner"]
                }));
            }
        }, /*#__PURE__*/ react.createElement(body/* default */.Z, {
            dismissButton: false,
            dismissAriaLabel: undefined,
            onDismiss: function() {},
            header: undefined
        }, item.text));
    })));
    (0,react.useEffect)(function() {
        var onKeyDown = function(event) {
            if (event.key === "Escape") {
                setShowPopover(false);
            }
        };
        if (showPopover) {
            document.addEventListener("keydown", onKeyDown);
        }
        return function() {
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [
        showPopover
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("a", (0,tslib_es6/* __assign */.pi)({}, focusVisible, anchorAttributes, {
        onFocus: function() {
            isTruncated(textRef, virtualTextRef) && setShowPopover(true);
        },
        onBlur: function() {
            return setShowPopover(false);
        },
        onMouseEnter: function() {
            isTruncated(textRef, virtualTextRef) && setShowPopover(true);
        },
        onMouseLeave: function() {
            return setShowPopover(false);
        }
    }), /*#__PURE__*/ react.createElement("span", {
        className: item_styles_css.text,
        ref: textRef
    }, item.text), /*#__PURE__*/ react.createElement("span", {
        className: item_styles_css["virtual-item"],
        ref: virtualTextRef
    }, item.text)), showPopover && popoverContent);
};
function BreadcrumbItem(_a) {
    var _b;
    var item = _a.item, onClick = _a.onClick, onFollow = _a.onFollow, isDisplayed = _a.isDisplayed, _c = _a.isLast, isLast = _c === void 0 ? false : _c, _d = _a.isCompressed, isCompressed = _d === void 0 ? false : _d;
    var focusVisible = (0,focus_visible/* default */.Z)();
    var preventDefault = function(event) {
        return event.preventDefault();
    };
    var onClickHandler = function(event) {
        if ((0,events/* isPlainLeftClick */.p_)(event)) {
            (0,events/* fireCancelableEvent */.y1)(onFollow, getEventDetail(item), event);
        }
        (0,events/* fireCancelableEvent */.y1)(onClick, getEventDetail(item), event);
    };
    var anchorAttributes = {
        href: isLast ? undefined : item.href || "#",
        className: (0,clsx_m/* default */.Z)(item_styles_css.anchor, (_b = {}, _b[item_styles_css.compressed] = isCompressed, _b)),
        "aria-current": isLast ? "page" : undefined,
        "aria-disabled": isLast && "true",
        onClick: isLast ? preventDefault : onClickHandler,
        tabIndex: isLast ? 0 : undefined
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(item_styles_css.breadcrumb, isLast && item_styles_css.last)
    }, isDisplayed && isCompressed ? /*#__PURE__*/ react.createElement(BreadcrumbItemWithPopover, (0,tslib_es6/* __assign */.pi)({
        item: item
    }, anchorAttributes)) : /*#__PURE__*/ react.createElement("a", (0,tslib_es6/* __assign */.pi)({}, focusVisible, anchorAttributes), /*#__PURE__*/ react.createElement("span", {
        className: item_styles_css.text
    }, item.text)), !isLast ? /*#__PURE__*/ react.createElement("span", {
        className: item_styles_css.icon
    }, /*#__PURE__*/ react.createElement(internal/* default */.Z, {
        name: "angle-right"
    })) : null));
} //# sourceMappingURL=item.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-mobile/index.js
var use_mobile = __webpack_require__(6670);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/check-safe-url.js
var check_safe_url = __webpack_require__(2903);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/breadcrumb-group/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0











var DropdownTrigger = function(clickHandler, ref, isDisabled, isExpanded, ariaLabel) {
    return /*#__PURE__*/ react.createElement(button_internal/* InternalButton */.l, {
        disabled: isDisabled,
        onClick: function(event) {
            event.preventDefault();
            clickHandler();
        },
        ref: ref,
        ariaExpanded: isExpanded,
        "aria-haspopup": true,
        ariaLabel: ariaLabel,
        variant: "breadcrumb-group",
        formAction: "none"
    }, "...");
};
var EllipsisDropdown = function(_a) {
    var ariaLabel = _a.ariaLabel, dropdownItems = _a.dropdownItems, onDropdownItemClick = _a.onDropdownItemClick, onDropdownItemFollow = _a.onDropdownItemFollow;
    return /*#__PURE__*/ react.createElement("li", {
        className: styles_css.ellipsis
    }, /*#__PURE__*/ react.createElement(button_dropdown_internal/* default */.Z, {
        ariaLabel: ariaLabel,
        items: dropdownItems,
        onItemClick: onDropdownItemClick,
        onItemFollow: onDropdownItemFollow,
        customTriggerBuilder: DropdownTrigger
    }), /*#__PURE__*/ react.createElement("span", {
        className: styles_css.icon
    }, /*#__PURE__*/ react.createElement(internal/* default */.Z, {
        name: "angle-right"
    })));
};
var getEventDetail = function(item) {
    return {
        item: item,
        text: item.text,
        href: item.href
    };
};
function InternalBreadcrumbGroup(_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, ariaLabel = _a.ariaLabel, expandAriaLabel = _a.expandAriaLabel, onClick = _a.onClick, onFollow = _a.onFollow, __internalRootRef = _a.__internalRootRef, props = (0,tslib_es6/* __rest */._T)(_a, [
        "items",
        "ariaLabel",
        "expandAriaLabel",
        "onClick",
        "onFollow",
        "__internalRootRef"
    ]);
    for(var _i = 0, items_1 = items; _i < items_1.length; _i++){
        var item = items_1[_i];
        (0,check_safe_url/* checkSafeUrl */.J)("BreadcrumbGroup", item.href);
    }
    var baseProps = (0,base_component/* getBaseProps */.j)(props);
    var isMobile = (0,use_mobile/* useMobile */.X)();
    var breadcrumbItems = items.map(function(item, index) {
        return /*#__PURE__*/ react.createElement("li", {
            className: styles_css.item,
            key: index
        }, /*#__PURE__*/ react.createElement(BreadcrumbItem, {
            item: item,
            onClick: onClick,
            onFollow: onFollow,
            isCompressed: isMobile,
            isLast: index === items.length - 1,
            isDisplayed: !isMobile || index === items.length - 1 || index === 0
        }));
    });
    var getEventItem = function(e) {
        var id = e.detail.id;
        return items[parseInt(id)];
    };
    // Add ellipsis
    if (breadcrumbItems.length >= 3) {
        var dropdownItems = items.slice(1, items.length - 1).map(function(item, index) {
            return {
                id: (index + 1).toString(),
                text: item.text,
                href: item.href || "#"
            };
        });
        breadcrumbItems = (0,tslib_es6/* __spreadArray */.ev)([
            breadcrumbItems[0],
            /*#__PURE__*/ react.createElement(EllipsisDropdown, {
                key: "ellipsis",
                ariaLabel: expandAriaLabel,
                dropdownItems: dropdownItems,
                onDropdownItemClick: function(e) {
                    return (0,events/* fireCancelableEvent */.y1)(onClick, getEventDetail(getEventItem(e)), e);
                },
                onDropdownItemFollow: function(e) {
                    return (0,events/* fireCancelableEvent */.y1)(onFollow, getEventDetail(getEventItem(e)), e);
                }
            })
        ], breadcrumbItems.slice(1), true);
    }
    return /*#__PURE__*/ react.createElement("nav", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        className: (0,clsx_m/* default */.Z)(styles_css["breadcrumb-group"], isMobile && styles_css.mobile, baseProps.className),
        "aria-label": ariaLabel || undefined,
        ref: __internalRootRef
    }), /*#__PURE__*/ react.createElement("ol", {
        className: styles_css["breadcrumb-group-list"]
    }, breadcrumbItems));
} //# sourceMappingURL=internal.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/breadcrumb-group/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




function BreadcrumbGroup(_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, _c = _a.expandAriaLabel, expandAriaLabel = _c === void 0 ? "Show path" : _c, props = (0,tslib_es6/* __rest */._T)(_a, [
        "items",
        "expandAriaLabel"
    ]);
    var baseComponentProps = (0,use_base_component/* default */.Z)("BreadcrumbGroup");
    return /*#__PURE__*/ react.createElement(InternalBreadcrumbGroup, (0,tslib_es6/* __assign */.pi)({
        items: items,
        expandAriaLabel: expandAriaLabel
    }, props, baseComponentProps));
}
(0,apply_display_name/* applyDisplayName */.b)(BreadcrumbGroup, "BreadcrumbGroup"); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 4699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ button_dropdown_internal; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/button-dropdown/styles.css.js
var styles_css = __webpack_require__(3284);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-unique-id/index.js
var use_unique_id = __webpack_require__(6081);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/dropdown/index.js + 2 modules
var dropdown = __webpack_require__(5730);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button-dropdown/utils/utils.js
var isItemGroup = function(item) {
    return item && item.items !== undefined;
};
var isLinkItem = function(item) {
    return item && item.href !== undefined;
};
var getItemTarget = function(item) {
    return item.external ? "_blank" : undefined;
};
function indexIncludes(source, target) {
    for(var index = 0; index < source.length; index++){
        if (source[index] !== target[index]) {
            return false;
        }
    }
    return true;
}
function indexEquals(left, right) {
    if (left.length !== right.length) {
        return false;
    }
    for(var index = 0; index < left.length; index++){
        if (left[index] !== right[index]) {
            return false;
        }
    }
    return true;
} //# sourceMappingURL=utils.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/button-dropdown/item-element/styles.scoped.css
var styles_scoped = __webpack_require__(719);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button-dropdown/item-element/styles.css.js

/* harmony default export */ var item_element_styles_css = ({
    "item-element": "awsui_item-element_93a1u_1lzvl_93",
    "disabled": "awsui_disabled_93a1u_1lzvl_103",
    "last": "awsui_last_93a1u_1lzvl_110",
    "highlighted": "awsui_highlighted_93a1u_1lzvl_113",
    "variant-icon": "awsui_variant-icon_93a1u_1lzvl_117",
    "variant-normal": "awsui_variant-normal_93a1u_1lzvl_117",
    "variant-primary": "awsui_variant-primary_93a1u_1lzvl_117",
    "is-focused": "awsui_is-focused_93a1u_1lzvl_127",
    "variant-navigation": "awsui_variant-navigation_93a1u_1lzvl_131",
    "first": "awsui_first_93a1u_1lzvl_134",
    "has-category-header": "awsui_has-category-header_93a1u_1lzvl_134",
    "menu-item": "awsui_menu-item_93a1u_1lzvl_148",
    "icon": "awsui_icon_93a1u_1lzvl_166",
    "external-icon": "awsui_external-icon_93a1u_1lzvl_171"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/popover/styles.css.js
var popover_styles_css = __webpack_require__(2577);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/popover/arrow.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var Arrow = function(props) {
    return /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(popover_styles_css/* default.arrow */.Z.arrow, props.position && popover_styles_css/* default */.Z["arrow-position-".concat(props.position)])
    }, /*#__PURE__*/ react.createElement("div", {
        className: popover_styles_css/* default.arrow-outer */.Z["arrow-outer"]
    }), /*#__PURE__*/ react.createElement("div", {
        className: popover_styles_css/* default.arrow-inner */.Z["arrow-inner"]
    }));
};
/* harmony default export */ var arrow = (/*#__PURE__*/react.memo(Arrow)); //# sourceMappingURL=arrow.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/popover/container.js + 1 modules
var container = __webpack_require__(2072);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/popover/body.js + 1 modules
var body = __webpack_require__(9820);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/portal/index.js
var portal = __webpack_require__(1712);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-portal-mode-classes/index.js
var use_portal_mode_classes = __webpack_require__(7656);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-visual-mode/index.js
var use_visual_mode = __webpack_require__(753);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button-dropdown/tooltip.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0







var DEFAULT_OPEN_TIMEOUT_IN_MS = 120;
function Tooltip(_a) {
    var children = _a.children, content = _a.content, _b = _a.position, position = _b === void 0 ? "right" : _b;
    var ref = (0,react.useRef)(null);
    var isReducedMotion = (0,use_visual_mode/* useReducedMotion */.JZ)(ref);
    var _c = useTooltipOpen(isReducedMotion ? 0 : DEFAULT_OPEN_TIMEOUT_IN_MS), open = _c.open, triggerProps = _c.triggerProps;
    var portalClasses = (0,use_portal_mode_classes/* usePortalModeClasses */.g)(ref);
    return /*#__PURE__*/ react.createElement("span", (0,tslib_es6/* __assign */.pi)({
        ref: ref
    }, triggerProps), children, open && /*#__PURE__*/ react.createElement(portal/* default */.Z, null, /*#__PURE__*/ react.createElement("span", {
        className: portalClasses
    }, /*#__PURE__*/ react.createElement(container/* default */.Z, {
        size: "small",
        fixedWidth: false,
        position: position,
        trackRef: ref,
        arrow: function(position) {
            return /*#__PURE__*/ react.createElement(arrow, {
                position: position
            });
        },
        renderWithPortal: true,
        zIndex: 7000
    }, /*#__PURE__*/ react.createElement(body/* default */.Z, {
        dismissButton: false,
        dismissAriaLabel: undefined,
        header: null,
        onDismiss: function() {},
        overflowVisible: "both"
    }, /*#__PURE__*/ react.createElement("span", {
        "data-testid": "button-dropdown-disabled-reason",
        role: "tooltip"
    }, content))))));
}
function useTooltipOpen(timeout) {
    var handle = (0,react.useRef)();
    var _a = (0,react.useState)(false), isOpen = _a[0], setIsOpen = _a[1];
    var close = function() {
        clearTimeout(handle.current);
        setIsOpen(false);
    };
    var open = function() {
        return setIsOpen(true);
    };
    var openDelayed = function() {
        handle.current = setTimeout(open, timeout);
    };
    var onKeyDown = function(e) {
        if (isOpen && isEscape(e.key)) {
            e.preventDefault();
            e.stopPropagation();
            close();
        }
    };
    var onFocus = openDelayed;
    var onBlur = close;
    return {
        open: isOpen,
        triggerProps: {
            onBlur: onBlur,
            onFocus: onFocus,
            onKeyDown: onKeyDown
        }
    };
}
var isEscape = function(key) {
    return key === "Escape" || key === "Esc";
}; //# sourceMappingURL=tooltip.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button-dropdown/utils/use-hidden-description.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function useHiddenDescription(description) {
    var id = (0,use_unique_id/* useUniqueId */.L)();
    return {
        targetProps: {
            "aria-describedby": description ? id : undefined
        },
        descriptionEl: description ? /*#__PURE__*/ react.createElement("span", {
            id: id,
            hidden: true
        }, description) : null
    };
} //# sourceMappingURL=use-hidden-description.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/icon/internal.js + 2 modules
var internal = __webpack_require__(776);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/dropdown/context.js
var context = __webpack_require__(6061);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button-dropdown/utils/menu-item.js
/**
 * @returns attributes for a menuitem widget given parameters
 */ var getMenuItemProps = function(_a) {
    var disabled = _a.disabled, parent = _a.parent, expanded = _a.expanded;
    return {
        role: "menuitem",
        "aria-disabled": disabled ? "true" : undefined,
        "aria-haspopup": parent ? "true" : undefined,
        "aria-expanded": expanded ? "true" : parent ? "false" : undefined
    };
}; //# sourceMappingURL=menu-item.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button-dropdown/item-element/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0










var ItemElement = function(_a) {
    var _b;
    var item = _a.item, disabled = _a.disabled, onItemActivate = _a.onItemActivate, highlighted = _a.highlighted, highlightItem = _a.highlightItem, _c = _a.first, first = _c === void 0 ? false : _c, last = _a.last, hasCategoryHeader = _a.hasCategoryHeader, _d = _a.isKeyboardHighlighted, isKeyboardHighlighted = _d === void 0 ? false : _d, _e = _a.variant, variant = _e === void 0 ? "normal" : _e;
    var isLink = isLinkItem(item);
    var onClick = function(event) {
        // Stop propagation to parent node and handle event exclusively in here. This ensures
        // that no group will interfere with the default behavior of links
        event.stopPropagation();
        if (!isLink) {
            event.preventDefault();
        }
        if (!disabled) {
            onItemActivate(item, event);
        }
    };
    var onHover = function(event) {
        event.preventDefault();
        highlightItem(item);
    };
    return /*#__PURE__*/ react.createElement("li", {
        className: (0,clsx_m/* default */.Z)(item_element_styles_css["item-element"], item_element_styles_css["variant-".concat(variant)], (_b = {}, _b[item_element_styles_css.highlighted] = highlighted, _b[item_element_styles_css.disabled] = disabled, _b[item_element_styles_css.first] = first, _b[item_element_styles_css.last] = last, _b[item_element_styles_css["has-category-header"]] = hasCategoryHeader, _b[item_element_styles_css["is-focused"]] = isKeyboardHighlighted, _b)),
        role: "presentation",
        "data-testid": item.id,
        "data-description": item.description,
        onClick: onClick,
        onMouseEnter: onHover,
        onTouchStart: onHover
    }, /*#__PURE__*/ react.createElement(MenuItem, {
        item: item,
        disabled: disabled,
        highlighted: highlighted
    }));
};
function MenuItem(_a) {
    var item = _a.item, disabled = _a.disabled, highlighted = _a.highlighted;
    var menuItemRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (highlighted && menuItemRef.current) {
            menuItemRef.current.focus();
        }
    }, [
        highlighted
    ]);
    var isDisabledWithReason = disabled && item.disabledReason;
    var _b = useHiddenDescription(item.disabledReason), targetProps = _b.targetProps, descriptionEl = _b.descriptionEl;
    var menuItemProps = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({
        className: item_element_styles_css["menu-item"],
        ref: menuItemRef,
        // We are using the roving tabindex technique to manage the focus state of the dropdown.
        // The current element will always have tabindex=0 which means that it can be tabbed to,
        // while all other items have tabindex=-1 so we can focus them when necessary.
        tabIndex: highlighted ? 0 : -1
    }, getMenuItemProps({
        disabled: disabled
    })), isDisabledWithReason ? targetProps : {});
    var menuItem = isLinkItem(item) ? /*#__PURE__*/ react.createElement("a", (0,tslib_es6/* __assign */.pi)({}, menuItemProps, {
        href: !disabled ? item.href : undefined,
        target: getItemTarget(item),
        rel: item.external ? "noopener noreferrer" : undefined
    }), /*#__PURE__*/ react.createElement(MenuItemContent, {
        item: item,
        disabled: disabled
    })) : /*#__PURE__*/ react.createElement("span", (0,tslib_es6/* __assign */.pi)({}, menuItemProps), /*#__PURE__*/ react.createElement(MenuItemContent, {
        item: item,
        disabled: disabled
    }));
    var position = (0,context/* useDropdownContext */.t)().position;
    var tooltipPosition = position === "bottom-left" || position === "top-left" ? "left" : "right";
    return isDisabledWithReason ? /*#__PURE__*/ react.createElement(Tooltip, {
        content: item.disabledReason,
        position: tooltipPosition
    }, menuItem, descriptionEl) : menuItem;
}
var MenuItemContent = function(_a) {
    var item = _a.item, disabled = _a.disabled;
    var hasIcon = !!(item.iconName || item.iconUrl || item.iconSvg);
    var hasExternal = isLinkItem(item) && item.external;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, hasIcon && /*#__PURE__*/ react.createElement(MenuItemIcon, {
        name: item.iconName,
        url: item.iconUrl,
        svg: item.iconSvg,
        alt: item.iconAlt
    }), " ", item.text, " ", hasExternal && /*#__PURE__*/ react.createElement(ExternalIcon, {
        disabled: disabled,
        ariaLabel: item.externalIconAriaLabel
    }));
};
var MenuItemIcon = function(props) {
    return /*#__PURE__*/ react.createElement("span", {
        className: item_element_styles_css.icon
    }, /*#__PURE__*/ react.createElement(internal/* default */.Z, (0,tslib_es6/* __assign */.pi)({}, props)));
};
var ExternalIcon = function(_a) {
    var disabled = _a.disabled, ariaLabel = _a.ariaLabel;
    var icon = /*#__PURE__*/ react.createElement(internal/* default */.Z, {
        variant: disabled ? "disabled" : "normal",
        name: "external"
    });
    return /*#__PURE__*/ react.createElement("span", {
        className: item_element_styles_css["external-icon"],
        role: ariaLabel ? "img" : undefined,
        "aria-label": ariaLabel
    }, icon);
};
/* harmony default export */ var item_element = (ItemElement); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/button-dropdown/category-elements/styles.scoped.css
var category_elements_styles_scoped = __webpack_require__(7744);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button-dropdown/category-elements/styles.css.js

/* harmony default export */ var category_elements_styles_css = ({
    "header": "awsui_header_16mm3_1e3j7_93",
    "disabled": "awsui_disabled_16mm3_1e3j7_108",
    "expandable-header": "awsui_expandable-header_16mm3_1e3j7_112",
    "rolled-down": "awsui_rolled-down_16mm3_1e3j7_123",
    "highlighted": "awsui_highlighted_16mm3_1e3j7_126",
    "is-focused": "awsui_is-focused_16mm3_1e3j7_139",
    "variant-navigation": "awsui_variant-navigation_16mm3_1e3j7_143",
    "category": "awsui_category_16mm3_1e3j7_155",
    "expandable": "awsui_expandable_16mm3_1e3j7_112",
    "expand-icon": "awsui_expand-icon_16mm3_1e3j7_176",
    "expand-icon-up": "awsui_expand-icon-up_16mm3_1e3j7_183",
    "expand-icon-right": "awsui_expand-icon-right_16mm3_1e3j7_186",
    "items-list-container": "awsui_items-list-container_16mm3_1e3j7_200"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button-dropdown/category-elements/expandable-category-element.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0









var ExpandableCategoryElement = function(_a) {
    var _b, _c;
    var item = _a.item, onItemActivate = _a.onItemActivate, onGroupToggle = _a.onGroupToggle, targetItem = _a.targetItem, isHighlighted = _a.isHighlighted, isKeyboardHighlight = _a.isKeyboardHighlight, isExpanded = _a.isExpanded, highlightItem = _a.highlightItem, disabled = _a.disabled, expandToViewport = _a.expandToViewport, variant = _a.variant;
    var highlighted = isHighlighted(item);
    var expanded = isExpanded(item);
    var isKeyboardHighlighted = isKeyboardHighlight(item);
    var triggerRef = react.useRef(null);
    var ref = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (triggerRef.current && highlighted && !expanded) {
            triggerRef.current.focus();
        }
    }, [
        expanded,
        highlighted
    ]);
    var onClick = function(event) {
        var _a;
        if (!disabled) {
            event.preventDefault();
            onGroupToggle(item, event);
            (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    var onHover = function(event) {
        event.preventDefault();
        highlightItem(item);
    };
    var isDisabledWithReason = !!item.disabledReason && item.disabled;
    var _d = useHiddenDescription(item.disabledReason), targetProps = _d.targetProps, descriptionEl = _d.descriptionEl;
    var trigger = item.text && /*#__PURE__*/ react.createElement("span", (0,tslib_es6/* __assign */.pi)({
        className: (0,clsx_m/* default */.Z)(category_elements_styles_css.header, category_elements_styles_css["expandable-header"], category_elements_styles_css["variant-".concat(variant)], (_b = {}, _b[category_elements_styles_css.disabled] = disabled, _b[category_elements_styles_css.highlighted] = highlighted, _b[category_elements_styles_css["is-focused"]] = isKeyboardHighlighted, _b)),
        // We are using the roving tabindex technique to manage the focus state of the dropdown.
        // The current element will always have tabindex=0 which means that it can be tabbed to,
        // while all other items have tabindex=-1 so we can focus them when necessary.
        tabIndex: highlighted ? 0 : -1,
        ref: triggerRef
    }, getMenuItemProps({
        parent: true,
        expanded: expanded,
        disabled: disabled
    }), isDisabledWithReason ? targetProps : {}), item.text, /*#__PURE__*/ react.createElement("span", {
        className: (0,clsx_m/* default */.Z)(category_elements_styles_css["expand-icon"], category_elements_styles_css["expand-icon-right"])
    }, /*#__PURE__*/ react.createElement(internal/* default */.Z, {
        name: "caret-down-filled"
    })));
    var content;
    // If the category element is disabled, we do not render a dropdown.
    // Screenreaders are confused by additional sections
    if (isDisabledWithReason) {
        content = /*#__PURE__*/ react.createElement(Tooltip, {
            content: item.disabledReason
        }, trigger, descriptionEl);
    } else if (disabled) {
        content = trigger;
    } else {
        content = /*#__PURE__*/ react.createElement(dropdown/* default */.Z, {
            open: expanded,
            stretchWidth: false,
            interior: true,
            expandToViewport: expandToViewport,
            trigger: trigger
        }, item.items && expanded && /*#__PURE__*/ react.createElement("ul", {
            role: "menu",
            "aria-label": item.text,
            className: (0,clsx_m/* default */.Z)(category_elements_styles_css["items-list-container"])
        }, /*#__PURE__*/ react.createElement(ItemsList, {
            items: item.items,
            onItemActivate: onItemActivate,
            onGroupToggle: onGroupToggle,
            targetItem: targetItem,
            isHighlighted: isHighlighted,
            isKeyboardHighlight: isKeyboardHighlight,
            isExpanded: isExpanded,
            highlightItem: highlightItem,
            variant: variant
        })));
    }
    return /*#__PURE__*/ react.createElement("li", {
        className: (0,clsx_m/* default */.Z)(category_elements_styles_css.category, category_elements_styles_css["variant-".concat(variant)], category_elements_styles_css.expandable, (_c = {}, _c[category_elements_styles_css.expanded] = expanded, _c[category_elements_styles_css.disabled] = disabled, _c[category_elements_styles_css.highlighted] = highlighted, _c)),
        role: "presentation",
        "data-testid": item.id,
        ref: ref,
        onClick: onClick,
        onMouseEnter: onHover,
        onTouchStart: onHover
    }, content);
};
/* harmony default export */ var expandable_category_element = (ExpandableCategoryElement); //# sourceMappingURL=expandable-category-element.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button-dropdown/category-elements/category-element.js




var CategoryElement = function(_a) {
    var _b;
    var item = _a.item, onItemActivate = _a.onItemActivate, onGroupToggle = _a.onGroupToggle, targetItem = _a.targetItem, isHighlighted = _a.isHighlighted, isKeyboardHighlight = _a.isKeyboardHighlight, isExpanded = _a.isExpanded, highlightItem = _a.highlightItem, disabled = _a.disabled, variant = _a.variant;
    // Hide the category title element from screen readers because it will be
    // provided as an ARIA label.
    return /*#__PURE__*/ react.createElement("li", {
        className: (0,clsx_m/* default */.Z)(category_elements_styles_css.category, category_elements_styles_css["variant-".concat(variant)], disabled && category_elements_styles_css.disabled),
        role: "presentation",
        "aria-disabled": disabled ? "true" : undefined
    }, item.text && /*#__PURE__*/ react.createElement("p", {
        className: (0,clsx_m/* default */.Z)(category_elements_styles_css.header, (_b = {}, _b[category_elements_styles_css.disabled] = disabled, _b)),
        "aria-hidden": "true"
    }, item.text), /*#__PURE__*/ react.createElement("ul", {
        className: (0,clsx_m/* default */.Z)(category_elements_styles_css["items-list-container"]),
        role: "group",
        "aria-label": item.text
    }, item.items && /*#__PURE__*/ react.createElement(ItemsList, {
        items: item.items,
        onItemActivate: onItemActivate,
        onGroupToggle: onGroupToggle,
        targetItem: targetItem,
        isHighlighted: isHighlighted,
        isKeyboardHighlight: isKeyboardHighlight,
        isExpanded: isExpanded,
        highlightItem: highlightItem,
        categoryDisabled: disabled,
        hasCategoryHeader: !!item.text,
        variant: variant
    })));
};
/* harmony default export */ var category_element = (CategoryElement); //# sourceMappingURL=category-element.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-mobile/index.js
var use_mobile = __webpack_require__(6670);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/button-dropdown/mobile-expandable-group/styles.scoped.css
var mobile_expandable_group_styles_scoped = __webpack_require__(6517);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button-dropdown/mobile-expandable-group/styles.css.js

/* harmony default export */ var mobile_expandable_group_styles_css = ({
    "root": "awsui_root_14cnr_zbvdk_93",
    "trigger": "awsui_trigger_14cnr_zbvdk_106",
    "dropdown": "awsui_dropdown_14cnr_zbvdk_109",
    "nowrap": "awsui_nowrap_14cnr_zbvdk_120",
    "open": "awsui_open_14cnr_zbvdk_123"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button-dropdown/mobile-expandable-group/mobile-expandable-group.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var MobileExpandableGroup = function(_a) {
    var _b;
    var children = _a.children, trigger = _a.trigger, open = _a.open;
    return /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(mobile_expandable_group_styles_css.root)
    }, /*#__PURE__*/ react.createElement("div", {
        className: mobile_expandable_group_styles_css.trigger
    }, trigger), /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(mobile_expandable_group_styles_css.dropdown, (_b = {}, _b[mobile_expandable_group_styles_css.open] = open, _b)),
        "data-open": open
    }, children));
};
/* harmony default export */ var mobile_expandable_group = (MobileExpandableGroup); //# sourceMappingURL=mobile-expandable-group.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button-dropdown/category-elements/mobile-expandable-category-element.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0









var MobileExpandableCategoryElement = function(_a) {
    var _b, _c, _d;
    var item = _a.item, onItemActivate = _a.onItemActivate, onGroupToggle = _a.onGroupToggle, targetItem = _a.targetItem, isHighlighted = _a.isHighlighted, isKeyboardHighlight = _a.isKeyboardHighlight, isExpanded = _a.isExpanded, highlightItem = _a.highlightItem, disabled = _a.disabled, variant = _a.variant;
    var highlighted = isHighlighted(item);
    var expanded = isExpanded(item);
    var isKeyboardHighlighted = isKeyboardHighlight(item);
    var triggerRef = react.useRef(null);
    (0,react.useEffect)(function() {
        if (triggerRef.current && highlighted && !expanded) {
            triggerRef.current.focus();
        }
    }, [
        expanded,
        highlighted
    ]);
    var onClick = function(e) {
        if (!disabled) {
            e.preventDefault();
            onGroupToggle(item, e);
        }
    };
    var onHover = function(event) {
        event.preventDefault();
        highlightItem(item);
    };
    var isDisabledWithReason = !!item.disabledReason && item.disabled;
    var _e = useHiddenDescription(item.disabledReason), targetProps = _e.targetProps, descriptionEl = _e.descriptionEl;
    var trigger = item.text && /*#__PURE__*/ react.createElement("span", (0,tslib_es6/* __assign */.pi)({
        className: (0,clsx_m/* default */.Z)(category_elements_styles_css.header, category_elements_styles_css["expandable-header"], category_elements_styles_css["variant-".concat(variant)], (_b = {}, _b[category_elements_styles_css.highlighted] = highlighted, _b[category_elements_styles_css["rolled-down"]] = expanded, _b[category_elements_styles_css.disabled] = disabled, _b[category_elements_styles_css["is-focused"]] = isKeyboardHighlighted, _b)),
        // We are using the roving tabindex technique to manage the focus state of the dropdown.
        // The current element will always have tabindex=0 which means that it can be tabbed to,
        // while all other items have tabindex=-1 so we can focus them when necessary.
        tabIndex: highlighted ? 0 : -1,
        ref: triggerRef
    }, getMenuItemProps({
        parent: true,
        disabled: disabled,
        expanded: expanded
    }), isDisabledWithReason ? targetProps : {}), item.text, /*#__PURE__*/ react.createElement("span", {
        className: (0,clsx_m/* default */.Z)(category_elements_styles_css["expand-icon"], (_c = {}, _c[category_elements_styles_css["expand-icon-up"]] = expanded, _c))
    }, /*#__PURE__*/ react.createElement(internal/* default */.Z, {
        name: "caret-down-filled"
    })));
    var content;
    if (isDisabledWithReason) {
        content = /*#__PURE__*/ react.createElement(react.Fragment, null, descriptionEl, /*#__PURE__*/ react.createElement(Tooltip, {
            content: item.disabledReason
        }, trigger));
    } else if (disabled) {
        content = trigger;
    } else {
        content = /*#__PURE__*/ react.createElement(mobile_expandable_group, {
            open: expanded,
            trigger: trigger
        }, item.items && expanded && /*#__PURE__*/ react.createElement("ul", {
            role: "menu",
            "aria-label": item.text,
            className: (0,clsx_m/* default */.Z)(category_elements_styles_css["items-list-container"])
        }, /*#__PURE__*/ react.createElement(ItemsList, {
            items: item.items,
            onItemActivate: onItemActivate,
            onGroupToggle: onGroupToggle,
            targetItem: targetItem,
            isHighlighted: isHighlighted,
            isKeyboardHighlight: isKeyboardHighlight,
            isExpanded: isExpanded,
            highlightItem: highlightItem,
            hasCategoryHeader: true,
            variant: variant
        })));
    }
    return /*#__PURE__*/ react.createElement("li", {
        className: (0,clsx_m/* default */.Z)(category_elements_styles_css.category, category_elements_styles_css["variant-".concat(variant)], category_elements_styles_css.expandable, (_d = {}, _d[category_elements_styles_css.expanded] = expanded, _d[category_elements_styles_css.disabled] = disabled, _d[category_elements_styles_css.highlighted] = highlighted || expanded, _d[category_elements_styles_css.expandable] = true, _d)),
        role: "presentation",
        onClick: onClick,
        onMouseEnter: onHover,
        onTouchStart: onHover,
        "data-testid": item.id
    }, content);
};
/* harmony default export */ var mobile_expandable_category_element = (MobileExpandableCategoryElement); //# sourceMappingURL=mobile-expandable-category-element.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button-dropdown/items-list.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0







function ItemsList(_a) {
    var items = _a.items, onItemActivate = _a.onItemActivate, onGroupToggle = _a.onGroupToggle, targetItem = _a.targetItem, isHighlighted = _a.isHighlighted, isKeyboardHighlight = _a.isKeyboardHighlight, isExpanded = _a.isExpanded, highlightItem = _a.highlightItem, _b = _a.categoryDisabled, categoryDisabled = _b === void 0 ? false : _b, _c = _a.hasExpandableGroups, hasExpandableGroups = _c === void 0 ? false : _c, _d = _a.hasCategoryHeader, hasCategoryHeader = _d === void 0 ? false : _d, _e = _a.expandToViewport, expandToViewport = _e === void 0 ? false : _e, _f = _a.variant, variant = _f === void 0 ? "normal" : _f;
    var isMobile = (0,use_mobile/* useMobile */.X)();
    var elements = items.map(function(item, index) {
        var _a, _b, _c, _d;
        if (!isItemGroup(item)) {
            return /*#__PURE__*/ react.createElement(item_element, {
                key: index,
                item: item,
                onItemActivate: onItemActivate,
                disabled: (_a = item.disabled) !== null && _a !== void 0 ? _a : categoryDisabled,
                highlighted: isHighlighted(item),
                isKeyboardHighlighted: isKeyboardHighlight(item),
                highlightItem: highlightItem,
                first: index === 0 || isItemGroup(items[index - 1]),
                last: index === items.length - 1 || isItemGroup(items[index + 1]),
                hasCategoryHeader: hasCategoryHeader,
                variant: variant
            });
        }
        if (hasExpandableGroups) {
            return item.text ? isMobile ? /*#__PURE__*/ react.createElement(mobile_expandable_category_element, {
                key: index,
                item: item,
                onItemActivate: onItemActivate,
                onGroupToggle: onGroupToggle,
                targetItem: targetItem,
                isHighlighted: isHighlighted,
                isKeyboardHighlight: isKeyboardHighlight,
                isExpanded: isExpanded,
                highlightItem: highlightItem,
                disabled: (_b = item.disabled) !== null && _b !== void 0 ? _b : false,
                variant: variant
            }) : /*#__PURE__*/ react.createElement(expandable_category_element, {
                key: index,
                item: item,
                onItemActivate: onItemActivate,
                onGroupToggle: onGroupToggle,
                targetItem: targetItem,
                isHighlighted: isHighlighted,
                isKeyboardHighlight: isKeyboardHighlight,
                isExpanded: isExpanded,
                highlightItem: highlightItem,
                disabled: (_c = item.disabled) !== null && _c !== void 0 ? _c : false,
                expandToViewport: expandToViewport,
                variant: variant
            }) : null;
        }
        return /*#__PURE__*/ react.createElement(category_element, {
            key: index,
            item: item,
            onItemActivate: onItemActivate,
            onGroupToggle: onGroupToggle,
            targetItem: targetItem,
            isHighlighted: isHighlighted,
            isKeyboardHighlight: isKeyboardHighlight,
            isExpanded: isExpanded,
            highlightItem: highlightItem,
            disabled: (_d = item.disabled) !== null && _d !== void 0 ? _d : false,
            variant: variant
        });
    });
    return /*#__PURE__*/ react.createElement(react.Fragment, null, elements);
} //# sourceMappingURL=items-list.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/options-list/utils/use-open-state.js
var use_open_state = __webpack_require__(9190);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/events/index.js
var events = __webpack_require__(6322);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/keycode.js
var keycode = __webpack_require__(6221);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button-dropdown/utils/create-items-tree.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function createItemsTree(items) {
    var itemToIndex = new Map();
    var indexToItem = new Map();
    var flatIndices = [];
    traverseItems(items, function(item, index) {
        var indexKey = stringifyIndex(index);
        itemToIndex.set(item, indexKey);
        indexToItem.set(indexKey, item);
        flatIndices.push(indexKey);
    });
    return {
        getItem: function(index) {
            var indexKey = stringifyIndex(index);
            return indexToItem.get(indexKey) || null;
        },
        getItemIndex: function(item) {
            var indexKey = itemToIndex.get(item);
            if (!indexKey) {
                throw new Error("Invariant violation: item is not found.");
            }
            return parseIndex(indexKey);
        },
        getSequentialIndex: function(index, direction) {
            var indexKey = stringifyIndex(index);
            var position = flatIndices.indexOf(indexKey);
            var nextIndexKey = flatIndices[position + direction];
            if (!nextIndexKey) {
                return null;
            }
            return parseIndex(nextIndexKey);
        },
        getParentIndex: function(item) {
            var indexKey = itemToIndex.get(item);
            if (!indexKey) {
                throw new Error("Invariant violation: item is not found.");
            }
            var index = parseIndex(indexKey);
            // No parent
            if (index.length === 1) {
                return null;
            }
            return index.slice(0, index.length - 1);
        }
    };
}
function traverseItems(items, act, parentIndex) {
    if (parentIndex === void 0) {
        parentIndex = [];
    }
    items.forEach(function(item, index) {
        var itemIndex = (0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)([], parentIndex, true), [
            index
        ], false);
        act(item, itemIndex);
        if (isItemGroup(item)) {
            traverseItems(item.items, act, itemIndex);
        }
    });
}
function stringifyIndex(index) {
    return index.join("-");
}
function parseIndex(index) {
    return index.split("-").map(function(it) {
        return parseInt(it);
    });
} //# sourceMappingURL=create-items-tree.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button-dropdown/utils/move-highlight.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function move_highlight_moveHighlight(_a) {
    var startIndex = _a.startIndex, expandedIndex = _a.expandedIndex, getNext = _a.getNext, hasExpandableGroups = _a.hasExpandableGroups, isInRestrictedView = _a.isInRestrictedView;
    var tryMove = function(currentIndex) {
        var _a;
        var next = getNext(currentIndex);
        if (!next) {
            return null;
        }
        // Prevents stepping into disabled expandable groups. However,
        // it's possible to navigate nested groups.
        if (((_a = next.parent) === null || _a === void 0 ? void 0 : _a.disabled) && hasExpandableGroups) {
            return tryMove(next.index);
        }
        // it is not allowed to highlight groups when non-expandable
        if (isItemGroup(next.item) && !hasExpandableGroups) {
            return tryMove(next.index);
        }
        // can only move within same parent unless is in restricted view
        if (hasExpandableGroups && !isInRestrictedView && !isSameParent(startIndex, next.index)) {
            return tryMove(next.index);
        }
        // in restricted view can only navigate to children if group is expanded
        if (hasExpandableGroups && isInRestrictedView && !isSameLevel(next.index, expandedIndex) && !isIncluded(expandedIndex, next.index)) {
            return tryMove(next.index);
        }
        return next.index;
    };
    return tryMove(startIndex);
}
function isSameParent(left, right) {
    return indexEquals(left.slice(0, -1), right.slice(0, -1));
}
function isSameLevel(left, right) {
    return left.length === right.length;
}
function isIncluded(parent, child) {
    return indexEquals(parent, child.slice(0, -1));
} //# sourceMappingURL=move-highlight.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button-dropdown/utils/use-highlighted-menu.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




function useHighlightedMenu(_a) {
    var items = _a.items, hasExpandableGroups = _a.hasExpandableGroups, _b = _a.isInRestrictedView, isInRestrictedView = _b === void 0 ? false : _b;
    var _c = (0,react.useState)([]), targetIndex = _c[0], setTargetIndex = _c[1];
    var _d = (0,react.useState)([]), expandedIndex = _d[0], setExpandedIndex = _d[1];
    var _e = (0,react.useState)(true), isUsingMouse = _e[0], setIsUsingMouse = _e[1];
    var _f = (0,react.useMemo)(function() {
        return createItemsTree(items);
    }, [
        items
    ]), getItem = _f.getItem, getItemIndex = _f.getItemIndex, getSequentialIndex = _f.getSequentialIndex, getParentIndex = _f.getParentIndex;
    var targetItem = (0,react.useMemo)(function() {
        return getItem(targetIndex);
    }, [
        targetIndex,
        getItem
    ]);
    var isHighlighted = (0,react.useCallback)(function(item) {
        var index = getItemIndex(item);
        return indexIncludes(index, targetIndex);
    }, [
        targetIndex,
        getItemIndex
    ]);
    // check if keyboard focus is on the element
    var isKeyboardHighlight = (0,react.useCallback)(function(item) {
        var index = getItemIndex(item);
        return !isUsingMouse && indexEquals(index, targetIndex);
    }, [
        targetIndex,
        getItemIndex,
        isUsingMouse
    ]);
    var isExpanded = (0,react.useCallback)(function(group) {
        var index = getItemIndex(group);
        return indexIncludes(index, expandedIndex);
    }, [
        expandedIndex,
        getItemIndex
    ]);
    var moveHighlight = (0,react.useCallback)(function(direction) {
        var getNext = function(index) {
            var nextIndex = getSequentialIndex(index, direction);
            var item = getItem(nextIndex || [
                -1
            ]);
            if (!nextIndex || !item) {
                return null;
            }
            var parentIndex = getParentIndex(item);
            var parentItem = parentIndex && getItem(parentIndex);
            return {
                index: nextIndex,
                item: item,
                parent: parentItem || undefined
            };
        };
        var nextIndex = move_highlight_moveHighlight({
            startIndex: targetIndex,
            expandedIndex: expandedIndex,
            getNext: getNext,
            hasExpandableGroups: hasExpandableGroups,
            isInRestrictedView: isInRestrictedView
        });
        if (nextIndex) {
            setTargetIndex(nextIndex);
        }
    }, [
        targetIndex,
        expandedIndex,
        getItem,
        getSequentialIndex,
        getParentIndex,
        hasExpandableGroups,
        isInRestrictedView
    ]);
    var highlightItem = (0,react.useCallback)(function(item) {
        setTargetIndex(getItemIndex(item));
    }, [
        getItemIndex
    ]);
    var expandGroup = (0,react.useCallback)(function(group) {
        var groupIndex = group ? getItemIndex(group) : targetIndex;
        var firstChildIndex = (0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)([], groupIndex, true), [
            0
        ], false);
        // move to the first child item unless in restricted mode
        setTargetIndex(isInRestrictedView ? groupIndex : firstChildIndex);
        setExpandedIndex(groupIndex);
    }, [
        targetIndex,
        getItemIndex,
        isInRestrictedView
    ]);
    var collapseGroup = (0,react.useCallback)(function() {
        if (expandedIndex.length > 0) {
            setTargetIndex(expandedIndex);
            setExpandedIndex(expandedIndex.slice(0, -1));
        }
    }, [
        expandedIndex
    ]);
    var reset = (0,react.useCallback)(function() {
        setTargetIndex([]);
        setExpandedIndex([]);
    }, []);
    return {
        targetItem: targetItem,
        isHighlighted: isHighlighted,
        isKeyboardHighlight: isKeyboardHighlight,
        isExpanded: isExpanded,
        moveHighlight: moveHighlight,
        highlightItem: highlightItem,
        expandGroup: expandGroup,
        collapseGroup: collapseGroup,
        reset: reset,
        setIsUsingMouse: setIsUsingMouse
    };
} //# sourceMappingURL=use-highlighted-menu.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button-dropdown/utils/use-button-dropdown.js






function useButtonDropdown(_a) {
    var items = _a.items, onItemClick = _a.onItemClick, onItemFollow = _a.onItemFollow, onReturnFocus = _a.onReturnFocus, hasExpandableGroups = _a.hasExpandableGroups, _b = _a.isInRestrictedView, isInRestrictedView = _b === void 0 ? false : _b, _c = _a.expandToViewport, expandToViewport = _c === void 0 ? false : _c;
    var _d = useHighlightedMenu({
        items: items,
        hasExpandableGroups: hasExpandableGroups,
        isInRestrictedView: isInRestrictedView
    }), targetItem = _d.targetItem, isHighlighted = _d.isHighlighted, isKeyboardHighlight = _d.isKeyboardHighlight, isExpanded = _d.isExpanded, highlightItem = _d.highlightItem, moveHighlight = _d.moveHighlight, expandGroup = _d.expandGroup, collapseGroup = _d.collapseGroup, reset = _d.reset, setIsUsingMouse = _d.setIsUsingMouse;
    var _e = (0,use_open_state/* useOpenState */.Z)({
        onClose: reset
    }), isOpen = _e.isOpen, closeDropdown = _e.closeDropdown, openStateProps = (0,tslib_es6/* __rest */._T)(_e, [
        "isOpen",
        "closeDropdown"
    ]);
    var toggleDropdown = function(options) {
        var _a;
        if (options === void 0) {
            options = {};
        }
        var moveHighlightOnOpen = (_a = options.moveHighlightOnOpen) !== null && _a !== void 0 ? _a : true;
        if (!isOpen && moveHighlightOnOpen) {
            moveHighlight(1);
        }
        openStateProps.toggleDropdown();
    };
    var onGroupToggle = function(item) {
        return !isExpanded(item) ? expandGroup(item) : collapseGroup();
    };
    var onItemActivate = function(item, event) {
        var details = {
            id: item.id || "undefined",
            href: item.href,
            external: item.external,
            target: getItemTarget(item)
        };
        if (onItemFollow && item.href && (0,events/* isPlainLeftClick */.p_)(event)) {
            (0,events/* fireCancelableEvent */.y1)(onItemFollow, details, event);
        }
        if (onItemClick) {
            (0,events/* fireCancelableEvent */.y1)(onItemClick, details, event);
        }
        onReturnFocus();
        closeDropdown();
    };
    var doVerticalNavigation = function(direction) {
        if (isOpen) {
            moveHighlight(direction);
        }
    };
    var openAndSelectFirst = function(event) {
        toggleDropdown();
        event.preventDefault();
    };
    var actOnParentDropdown = function(event) {
        // if there is no highlighted item we act on the trigger by opening or closing dropdown
        if (!targetItem) {
            if (isOpen && !isInRestrictedView) {
                toggleDropdown();
            } else {
                openAndSelectFirst(event);
            }
        } else {
            if (isItemGroup(targetItem)) {
                onGroupToggle(targetItem, event);
            } else {
                onItemActivate(targetItem, event);
            }
        }
    };
    var activate = function(event, isEnter) {
        setIsUsingMouse(false);
        // if item is a link we rely on default behavior of an anchor, no need to prevent
        if (targetItem && isLinkItem(targetItem) && isEnter) {
            return;
        }
        event.preventDefault();
        actOnParentDropdown(event);
    };
    var onKeyDown = function(event) {
        setIsUsingMouse(false);
        switch(event.keyCode){
            case keycode/* KeyCode.down */.V.down:
                {
                    doVerticalNavigation(1);
                    event.preventDefault();
                    break;
                }
            case keycode/* KeyCode.up */.V.up:
                {
                    doVerticalNavigation(-1);
                    event.preventDefault();
                    break;
                }
            case keycode/* KeyCode.space */.V.space:
                {
                    // Prevent scrolling the list of items and highlighting the trigger
                    event.preventDefault();
                    break;
                }
            case keycode/* KeyCode.enter */.V.enter:
                {
                    if (!(targetItem === null || targetItem === void 0 ? void 0 : targetItem.disabled)) {
                        activate(event, true);
                    }
                    break;
                }
            case keycode/* KeyCode.left */.V.left:
            case keycode/* KeyCode.right */.V.right:
                {
                    if (targetItem && !targetItem.disabled && isItemGroup(targetItem) && !isExpanded(targetItem)) {
                        expandGroup();
                    } else if (hasExpandableGroups) {
                        collapseGroup();
                    }
                    event.preventDefault();
                    break;
                }
            case keycode/* KeyCode.escape */.V.escape:
                {
                    onReturnFocus();
                    closeDropdown();
                    event.preventDefault();
                    break;
                }
            case keycode/* KeyCode.tab */.V.tab:
                {
                    // When expanded to viewport the focus can't move naturally to the next element.
                    // Returning the focus to the trigger instead.
                    if (expandToViewport) {
                        onReturnFocus();
                    }
                    closeDropdown();
                    break;
                }
        }
    };
    var onKeyUp = function(event) {
        // We need to handle activating items with Space separately because there is a bug
        // in Firefox where changing the focus during a Space keydown event it will trigger
        // unexpected click events on the new element: https://bugzilla.mozilla.org/show_bug.cgi?id=1220143
        if (event.keyCode === keycode/* KeyCode.space */.V.space && !(targetItem === null || targetItem === void 0 ? void 0 : targetItem.disabled)) {
            activate(event);
        }
    };
    return {
        isOpen: isOpen,
        targetItem: targetItem,
        isHighlighted: isHighlighted,
        isKeyboardHighlight: isKeyboardHighlight,
        isExpanded: isExpanded,
        highlightItem: highlightItem,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onItemActivate: onItemActivate,
        onGroupToggle: onGroupToggle,
        toggleDropdown: toggleDropdown,
        setIsUsingMouse: setIsUsingMouse
    };
} //# sourceMappingURL=use-button-dropdown.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/options-list/index.js + 1 modules
var options_list = __webpack_require__(7906);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/button/internal.js + 6 modules
var button_internal = __webpack_require__(8145);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/forward-focus/index.js
var forward_focus = __webpack_require__(9283);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/box/internal.js + 1 modules
var box_internal = __webpack_require__(918);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/check-safe-url.js
var check_safe_url = __webpack_require__(2903);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button-dropdown/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0














var InternalButtonDropdown = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var items = _a.items, _b = _a.variant, variant = _b === void 0 ? "normal" : _b, _c = _a.loading, loading = _c === void 0 ? false : _c, loadingText = _a.loadingText, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.expandableGroups, expandableGroups = _e === void 0 ? false : _e, children = _a.children, onItemClick = _a.onItemClick, onItemFollow = _a.onItemFollow, customTriggerBuilder = _a.customTriggerBuilder, expandToViewport = _a.expandToViewport, ariaLabel = _a.ariaLabel, title = _a.title, description = _a.description, preferCenter = _a.preferCenter, __internalRootRef = _a.__internalRootRef, props = (0,tslib_es6/* __rest */._T)(_a, [
        "items",
        "variant",
        "loading",
        "loadingText",
        "disabled",
        "expandableGroups",
        "children",
        "onItemClick",
        "onItemFollow",
        "customTriggerBuilder",
        "expandToViewport",
        "ariaLabel",
        "title",
        "description",
        "preferCenter",
        "__internalRootRef"
    ]);
    var isInRestrictedView = (0,use_mobile/* useMobile */.X)();
    var dropdownId = (0,use_unique_id/* useUniqueId */.L)("dropdown");
    for(var _i = 0, items_1 = items; _i < items_1.length; _i++){
        var item = items_1[_i];
        (0,check_safe_url/* checkSafeUrl */.J)("ButtonDropdown", item.href);
    }
    var _f = useButtonDropdown({
        items: items,
        onItemClick: onItemClick,
        onItemFollow: onItemFollow,
        onReturnFocus: function() {
            var _a;
            return (_a = dropdownRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        },
        expandToViewport: expandToViewport,
        hasExpandableGroups: expandableGroups,
        isInRestrictedView: isInRestrictedView
    }), isOpen = _f.isOpen, targetItem = _f.targetItem, isHighlighted = _f.isHighlighted, isKeyboardHighlight = _f.isKeyboardHighlight, isExpanded = _f.isExpanded, highlightItem = _f.highlightItem, onKeyDown = _f.onKeyDown, onKeyUp = _f.onKeyUp, onItemActivate = _f.onItemActivate, onGroupToggle = _f.onGroupToggle, toggleDropdown = _f.toggleDropdown, setIsUsingMouse = _f.setIsUsingMouse;
    var handleMouseEvent = function() {
        setIsUsingMouse(true);
    };
    var baseProps = (0,base_component/* getBaseProps */.j)(props);
    var dropdownRef = (0,react.useRef)(null);
    (0,forward_focus/* default */.Z)(ref, dropdownRef);
    var clickHandler = function() {
        if (!loading && !disabled) {
            // Prevent moving highlight on mobiles to avoid disabled state reason popup if defined.
            toggleDropdown({
                moveHighlightOnOpen: !isInRestrictedView
            });
        }
    };
    var canBeOpened = !loading && !disabled;
    var triggerVariant = variant === "navigation" ? undefined : variant;
    var iconProps = variant === "icon" ? {
        iconName: "ellipsis"
    } : {
        iconName: "caret-down-filled",
        iconAlign: "right",
        __iconClass: canBeOpened && isOpen ? styles_css/* default.rotate-up */.Z["rotate-up"] : styles_css/* default.rotate-down */.Z["rotate-down"]
    };
    var trigger = customTriggerBuilder ? customTriggerBuilder(clickHandler, dropdownRef, disabled, isOpen, ariaLabel) : /*#__PURE__*/ react.createElement(button_internal/* InternalButton */.l, (0,tslib_es6/* __assign */.pi)({
        ref: dropdownRef
    }, iconProps, {
        variant: triggerVariant,
        loading: loading,
        loadingText: loadingText,
        disabled: disabled,
        onClick: function(event) {
            event.preventDefault();
            clickHandler();
        },
        ariaLabel: ariaLabel,
        "aria-haspopup": true,
        ariaExpanded: canBeOpened && isOpen,
        formAction: "none"
    }), children);
    var hasHeader = title || description;
    var headerId = (0,use_unique_id/* useUniqueId */.L)("awsui-button-dropdown__header");
    return /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseDown: handleMouseEvent,
        onMouseMove: handleMouseEvent,
        className: (0,clsx_m/* default */.Z)(styles_css/* default.button-dropdown */.Z["button-dropdown"], styles_css/* default */.Z["variant-".concat(variant)], baseProps.className),
        "aria-owns": expandToViewport && isOpen ? dropdownId : undefined,
        ref: __internalRootRef
    }), /*#__PURE__*/ react.createElement(dropdown/* default */.Z, {
        open: canBeOpened && isOpen,
        stretchWidth: false,
        stretchTriggerHeight: variant === "navigation",
        expandToViewport: expandToViewport,
        preferCenter: preferCenter,
        onDropdownClose: function() {
            return toggleDropdown();
        },
        trigger: trigger,
        dropdownId: dropdownId
    }, hasHeader && /*#__PURE__*/ react.createElement("div", {
        className: styles_css/* default.header */.Z.header,
        id: headerId
    }, title && /*#__PURE__*/ react.createElement("div", {
        className: styles_css/* default.title */.Z.title
    }, /*#__PURE__*/ react.createElement(box_internal/* default */.Z, {
        fontSize: "heading-s",
        fontWeight: "bold",
        color: "inherit",
        tagOverride: "h3",
        margin: {
            vertical: "n",
            horizontal: "n"
        }
    }, title)), description && /*#__PURE__*/ react.createElement(box_internal/* default */.Z, {
        fontSize: "body-s"
    }, /*#__PURE__*/ react.createElement("span", {
        className: styles_css/* default.description */.Z.description
    }, description))), /*#__PURE__*/ react.createElement(options_list/* default */.Z, {
        open: canBeOpened && isOpen,
        position: "static",
        role: "menu",
        decreaseTopMargin: true,
        ariaLabelledby: hasHeader ? headerId : undefined
    }, /*#__PURE__*/ react.createElement(ItemsList, {
        items: items,
        onItemActivate: onItemActivate,
        onGroupToggle: onGroupToggle,
        hasExpandableGroups: expandableGroups,
        targetItem: targetItem,
        isHighlighted: isHighlighted,
        isKeyboardHighlight: isKeyboardHighlight,
        isExpanded: isExpanded,
        highlightItem: highlightItem,
        expandToViewport: expandToViewport,
        variant: variant
    }))));
});
/* harmony default export */ var button_dropdown_internal = (InternalButtonDropdown); //# sourceMappingURL=internal.js.map


/***/ }),

/***/ 3284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _styles_scoped_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6374);
/* harmony import */ var _styles_scoped_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_styles_scoped_css__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    "button-dropdown": "awsui_button-dropdown_sne0l_1gwdq_93",
    "items-list-container": "awsui_items-list-container_sne0l_1gwdq_97",
    "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_sne0l_1gwdq_1",
    "rotate-up": "awsui_rotate-up_sne0l_1gwdq_114",
    "rotate-down": "awsui_rotate-down_sne0l_1gwdq_129",
    "header": "awsui_header_sne0l_1gwdq_144",
    "title": "awsui_title_sne0l_1gwdq_153",
    "description": "awsui_description_sne0l_1gwdq_154"
});


/***/ }),

/***/ 7140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _internal_base_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8312);
/* harmony import */ var _internal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8145);
/* harmony import */ var _internal_utils_apply_display_name__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1651);
/* harmony import */ var _internal_hooks_use_base_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4656);

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





var Button = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function(_a, ref) {
    var children = _a.children, iconName = _a.iconName, _b = _a.iconAlign, iconAlign = _b === void 0 ? "left" : _b, iconUrl = _a.iconUrl, iconSvg = _a.iconSvg, iconAlt = _a.iconAlt, _c = _a.variant, variant = _c === void 0 ? "normal" : _c, _d = _a.loading, loading = _d === void 0 ? false : _d, loadingText = _a.loadingText, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.wrapText, wrapText = _f === void 0 ? true : _f, href = _a.href, target = _a.target, download = _a.download, _g = _a.formAction, formAction = _g === void 0 ? "submit" : _g, ariaLabel = _a.ariaLabel, onClick = _a.onClick, onFollow = _a.onFollow, ariaExpanded = _a.ariaExpanded, props = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(_a, [
        "children",
        "iconName",
        "iconAlign",
        "iconUrl",
        "iconSvg",
        "iconAlt",
        "variant",
        "loading",
        "loadingText",
        "disabled",
        "wrapText",
        "href",
        "target",
        "download",
        "formAction",
        "ariaLabel",
        "onClick",
        "onFollow",
        "ariaExpanded"
    ]);
    var baseComponentProps = (0,_internal_hooks_use_base_component__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("Button");
    var baseProps = (0,_internal_base_component__WEBPACK_IMPORTED_MODULE_1__/* .getBaseProps */ .j)(props);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal__WEBPACK_IMPORTED_MODULE_4__/* .InternalButton */ .l, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, baseProps, baseComponentProps, {
        ref: ref,
        iconName: iconName,
        iconAlign: iconAlign,
        iconUrl: iconUrl,
        iconSvg: iconSvg,
        iconAlt: iconAlt,
        variant: variant,
        loading: loading,
        loadingText: loadingText,
        disabled: disabled,
        wrapText: wrapText,
        href: href,
        target: target,
        download: download,
        formAction: formAction,
        ariaLabel: ariaLabel,
        onClick: onClick,
        onFollow: onFollow,
        ariaExpanded: ariaExpanded
    }), children);
});
(0,_internal_utils_apply_display_name__WEBPACK_IMPORTED_MODULE_5__/* .applyDisplayName */ .b)(Button, "Button");
/* harmony default export */ __webpack_exports__["Z"] = (Button); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 8145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ InternalButton; },
  "Z": function() { return /* binding */ button_internal; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/events/index.js
var events = __webpack_require__(6322);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/focus-visible/index.js
var focus_visible = __webpack_require__(9297);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/forward-focus/index.js
var forward_focus = __webpack_require__(9283);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/button/styles.scoped.css
var styles_scoped = __webpack_require__(5082);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button/styles.css.js

/* harmony default export */ var styles_css = ({
    "content": "awsui_content_vjswe_19wtj_97",
    "button": "awsui_button_vjswe_19wtj_101",
    "variant-normal": "awsui_variant-normal_vjswe_19wtj_122",
    "is-activated": "awsui_is-activated_vjswe_19wtj_135",
    "variant-icon": "awsui_variant-icon_vjswe_19wtj_162",
    "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_19wtj_162",
    "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_19wtj_162",
    "variant-inline-icon": "awsui_variant-inline-icon_vjswe_19wtj_180",
    "disabled": "awsui_disabled_vjswe_19wtj_198",
    "variant-primary": "awsui_variant-primary_vjswe_19wtj_206",
    "variant-link": "awsui_variant-link_vjswe_19wtj_290",
    "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_19wtj_710",
    "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_19wtj_797",
    "button-no-text": "awsui_button-no-text_vjswe_19wtj_881",
    "button-no-wrap": "awsui_button-no-wrap_vjswe_19wtj_885",
    "icon-left": "awsui_icon-left_vjswe_19wtj_901",
    "icon-right": "awsui_icon-right_vjswe_19wtj_906",
    "icon": "awsui_icon_vjswe_19wtj_901"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/icon/internal.js + 2 modules
var internal = __webpack_require__(776);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/spinner/internal.js + 1 modules
var spinner_internal = __webpack_require__(1970);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button/icon-helper.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





function getIconAlign(props) {
    var standalone = props.variant === "icon" || props.variant === "inline-icon";
    return standalone ? "left" : props.iconAlign;
}
function IconWrapper(_a) {
    var iconName = _a.iconName, iconUrl = _a.iconUrl, iconAlt = _a.iconAlt, iconSvg = _a.iconSvg, iconSize = _a.iconSize, props = (0,tslib_es6/* __rest */._T)(_a, [
        "iconName",
        "iconUrl",
        "iconAlt",
        "iconSvg",
        "iconSize"
    ]);
    if (!iconName && !iconUrl && !iconSvg) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(internal/* default */.Z, {
        className: (0,clsx_m/* default */.Z)(styles_css.icon, styles_css["icon-".concat(getIconAlign(props))], props.iconClass),
        name: iconName,
        url: iconUrl,
        svg: iconSvg,
        alt: iconAlt,
        size: iconSize
    });
}
function LeftIcon(props) {
    if (props.loading) {
        return /*#__PURE__*/ react.createElement(spinner_internal/* default */.Z, {
            className: (0,clsx_m/* default */.Z)(styles_css.icon, styles_css["icon-left"])
        });
    } else if (getIconAlign(props) === "left") {
        return /*#__PURE__*/ react.createElement(IconWrapper, (0,tslib_es6/* __assign */.pi)({}, props));
    }
    return null;
}
function RightIcon(props) {
    if (getIconAlign(props) === "right") {
        return /*#__PURE__*/ react.createElement(IconWrapper, (0,tslib_es6/* __assign */.pi)({}, props));
    }
    return null;
} //# sourceMappingURL=icon-helper.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/check-safe-url.js
var check_safe_url = __webpack_require__(2903);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-merge-refs/index.js
var use_merge_refs = __webpack_require__(5912);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/live-region/utils.js
/**
 * Updates text of the target node if it's differ from source node.
 * @param targetRef - Ref to the element with aria-live
 * @param sourceRef - Ref to the element to be announced
 */ function updateLiveRegion(targetRef, sourceRef) {
    if (targetRef.current && sourceRef.current) {
        var sourceContent = extractInnerText(sourceRef.current);
        var targetContent = extractInnerText(targetRef.current);
        if (targetContent !== sourceContent) {
            // The aria-atomic does not work properly in Voice Over, causing
            // certain parts of the content to be ignored. To fix that,
            // we assign the source text content as a single node.
            targetRef.current.innerText = sourceContent;
        }
    }
}
// This only extracts text content from the node including all its children which is enough for now.
// To make it more powerful, it is possible to create a more sophisticated extractor with respect to
// ARIA properties to ignore aria-hidden nodes and read ARIA labels from the live content.
function extractInnerText(node) {
    return (node.innerText || "").replace(/\s+/g, " ").trim();
} //# sourceMappingURL=utils.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/screenreader-only/index.js + 1 modules
var screenreader_only = __webpack_require__(1304);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/live-region/styles.scoped.css
var live_region_styles_scoped = __webpack_require__(604);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/live-region/styles.css.js

/* harmony default export */ var live_region_styles_css = ({
    "root": "awsui_root_3bgfn_im8v7_5"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/live-region/aria-liva-tag.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/* eslint-disable @cloudscape-design/prefer-live-region */ 



/* harmony default export */ var aria_liva_tag = (/*#__PURE__*/(0,react.memo)(AriaLiveTag));
function AriaLiveTag(_a) {
    var _b = _a.assertive, assertive = _b === void 0 ? false : _b, _c = _a.visible, visible = _c === void 0 ? false : _c, targetRef = _a.targetRef, sourceRef = _a.sourceRef, children = _a.children, restProps = (0,tslib_es6/* __rest */._T)(_a, [
        "assertive",
        "visible",
        "targetRef",
        "sourceRef",
        "children"
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, visible && /*#__PURE__*/ react.createElement("span", {
        ref: sourceRef
    }, children), /*#__PURE__*/ react.createElement(screenreader_only/* default */.Z, (0,tslib_es6/* __assign */.pi)({}, restProps, {
        className: (0,clsx_m/* default */.Z)(live_region_styles_css.root, restProps.className)
    }), !visible && /*#__PURE__*/ react.createElement("span", {
        ref: sourceRef,
        "aria-hidden": "true"
    }, children), /*#__PURE__*/ react.createElement("span", {
        ref: targetRef,
        "aria-atomic": "true",
        "aria-live": assertive ? "assertive" : "polite"
    })));
} //# sourceMappingURL=aria-liva-tag.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/live-region/index.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/* eslint-disable @cloudscape-design/prefer-live-region */ 


/**
 * The live region is hidden in the layout, but visible for screen readers.
 * It's purpose it to announce changes e.g. when custom navigation logic is used.
 *
 * The way live region works differently in different browsers and screen readers and
 * it is recommended to manually test every new implementation.
 *
 * If you notice there are different words being merged together,
 * check if there are text nodes not being wrapped in elements, like:
 * <LiveRegion>
 *   {title}
 *   <span><Details /></span>
 * </LiveRegion>
 *
 * To fix, wrap "title" in an element:
 * <LiveRegion>
 *   <span>{title}</span>
 *   <span><Details /></span>
 * </LiveRegion>
 *
 * Or create a single text node if possible:
 * <LiveRegion>
 *   {`${title} ${details}`}
 * </LiveRegion>
 *
 * The live region is always atomic, because non-atomic regions can be treated by screen readers
 * differently and produce unexpected results. To imitate non-atomic announcements simply use
 * multiple live regions:
 * <>
 *   <LiveRegion>{title}</LiveRegion>
 *   <LiveRegion><Details /></LiveRegion>
 * </>
 */ /* harmony default export */ var live_region = (/*#__PURE__*/(0,react.memo)(LiveRegion));
function LiveRegion(_a) {
    var _b = _a.delay, delay = _b === void 0 ? 10 : _b, children = _a.children, restProps = (0,tslib_es6/* __rest */._T)(_a, [
        "delay",
        "children"
    ]);
    var sourceRef = (0,react.useRef)(null);
    var targetRef = (0,react.useRef)(null);
    /*
      When React state changes, React often produces too many DOM updates, causing NVDA to
      issue many announcements for the same logical event (See https://github.com/nvaccess/nvda/issues/7996).
  
      The code below imitates a debouncing, scheduling a callback every time new React state
      update is detected. When a callback resolves, it copies content from a muted element
      to the live region, which is recognized by screen readers as an update.
  
      If the use case requires no announcement to be ignored, use delay = 0, but ensure it
      does not impact the performance. If it does, prefer using a string as children prop.
    */ (0,react.useEffect)(function() {
        var timeoutId;
        if (delay) {
            timeoutId = setTimeout(function() {
                return updateLiveRegion(targetRef, sourceRef);
            }, delay);
        } else {
            updateLiveRegion(targetRef, sourceRef);
        }
        return function() {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    });
    return /*#__PURE__*/ react.createElement(aria_liva_tag, (0,tslib_es6/* __assign */.pi)({
        targetRef: targetRef,
        sourceRef: sourceRef
    }, restProps), children);
} //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/button/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0










var InternalButton = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var _b;
    var children = _a.children, iconName = _a.iconName, __iconClass = _a.__iconClass, onClick = _a.onClick, onFollow = _a.onFollow, _c = _a.iconAlign, iconAlign = _c === void 0 ? "left" : _c, iconUrl = _a.iconUrl, iconSvg = _a.iconSvg, iconAlt = _a.iconAlt, _d = _a.variant, variant = _d === void 0 ? "normal" : _d, _e = _a.loading, loading = _e === void 0 ? false : _e, loadingText = _a.loadingText, _f = _a.disabled, disabled = _f === void 0 ? false : _f, _g = _a.wrapText, wrapText = _g === void 0 ? true : _g, href = _a.href, target = _a.target, download = _a.download, _h = _a.formAction, formAction = _h === void 0 ? "submit" : _h, ariaLabel = _a.ariaLabel, ariaExpanded = _a.ariaExpanded, __nativeAttributes = _a.__nativeAttributes, _j = _a.__internalRootRef, __internalRootRef = _j === void 0 ? null : _j, _k = _a.__activated, __activated = _k === void 0 ? false : _k, props = (0,tslib_es6/* __rest */._T)(_a, [
        "children",
        "iconName",
        "__iconClass",
        "onClick",
        "onFollow",
        "iconAlign",
        "iconUrl",
        "iconSvg",
        "iconAlt",
        "variant",
        "loading",
        "loadingText",
        "disabled",
        "wrapText",
        "href",
        "target",
        "download",
        "formAction",
        "ariaLabel",
        "ariaExpanded",
        "__nativeAttributes",
        "__internalRootRef",
        "__activated"
    ]);
    (0,check_safe_url/* checkSafeUrl */.J)("Button", href);
    var focusVisible = (0,focus_visible/* default */.Z)();
    var isAnchor = Boolean(href);
    var isDisabled = loading || disabled;
    var shouldHaveContent = children && [
        "icon",
        "inline-icon",
        "flashbar-icon",
        "modal-dismiss"
    ].indexOf(variant) === -1;
    var buttonRef = (0,react.useRef)(null);
    (0,forward_focus/* default */.Z)(ref, buttonRef);
    var handleClick = (0,react.useCallback)(function(event) {
        if (isAnchor && isDisabled) {
            return event.preventDefault();
        }
        if (isAnchor && (0,events/* isPlainLeftClick */.p_)(event)) {
            (0,events/* fireCancelableEvent */.y1)(onFollow, null, event);
        }
        var altKey = event.altKey, button = event.button, ctrlKey = event.ctrlKey, metaKey = event.metaKey, shiftKey = event.shiftKey;
        (0,events/* fireCancelableEvent */.y1)(onClick, {
            altKey: altKey,
            button: button,
            ctrlKey: ctrlKey,
            metaKey: metaKey,
            shiftKey: shiftKey
        }, event);
    }, [
        isAnchor,
        isDisabled,
        onClick,
        onFollow
    ]);
    var buttonClass = (0,clsx_m/* default */.Z)(props.className, styles_css.button, styles_css["variant-".concat(variant)], (_b = {}, _b[styles_css.disabled] = isDisabled, _b[styles_css["button-no-wrap"]] = !wrapText, _b[styles_css["button-no-text"]] = !shouldHaveContent, _b[styles_css["is-activated"]] = __activated, _b));
    var buttonProps = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, props), focusVisible), __nativeAttributes), {
        // https://github.com/microsoft/TypeScript/issues/36659
        ref: (0,use_merge_refs/* useMergeRefs */.q)(buttonRef, __internalRootRef),
        "aria-label": ariaLabel,
        "aria-expanded": ariaExpanded,
        className: buttonClass,
        onClick: handleClick
    });
    var iconProps = {
        loading: loading,
        iconName: iconName,
        iconAlign: iconAlign,
        iconUrl: iconUrl,
        iconSvg: iconSvg,
        iconAlt: iconAlt,
        variant: variant,
        iconClass: __iconClass,
        iconSize: variant === "modal-dismiss" ? "medium" : "normal"
    };
    var buttonContent = /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(LeftIcon, (0,tslib_es6/* __assign */.pi)({}, iconProps)), shouldHaveContent && /*#__PURE__*/ react.createElement("span", {
        className: styles_css.content
    }, children), /*#__PURE__*/ react.createElement(RightIcon, (0,tslib_es6/* __assign */.pi)({}, iconProps)));
    if (isAnchor) {
        return(// eslint-disable-next-line react/jsx-no-target-blank
        /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("a", (0,tslib_es6/* __assign */.pi)({}, buttonProps, {
            href: href,
            target: target,
            // security recommendation: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target
            rel: target === "_blank" ? "noopener noreferrer" : undefined,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled ? true : undefined,
            download: download
        }), buttonContent), loading && loadingText && /*#__PURE__*/ react.createElement(live_region, null, loadingText)));
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("button", (0,tslib_es6/* __assign */.pi)({}, buttonProps, {
        type: formAction === "none" ? "button" : "submit",
        disabled: isDisabled
    }), buttonContent), loading && loadingText && /*#__PURE__*/ react.createElement(live_region, null, loadingText));
});
/* harmony default export */ var button_internal = (InternalButton); //# sourceMappingURL=internal.js.map


/***/ }),

/***/ 9684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _internal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7887);
/* harmony import */ var _internal_utils_external_props__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6464);
/* harmony import */ var _internal_utils_apply_display_name__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1651);
/* harmony import */ var _internal_hooks_use_base_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4656);

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





function Container(_a) {
    var _b = _a.variant, variant = _b === void 0 ? "default" : _b, _c = _a.disableHeaderPaddings, disableHeaderPaddings = _c === void 0 ? false : _c, _d = _a.disableContentPaddings, disableContentPaddings = _d === void 0 ? false : _d, props = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(_a, [
        "variant",
        "disableHeaderPaddings",
        "disableContentPaddings"
    ]);
    var baseComponentProps = (0,_internal_hooks_use_base_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("Container");
    var externalProps = (0,_internal_utils_external_props__WEBPACK_IMPORTED_MODULE_3__/* .getExternalProps */ .x)(props);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({
        variant: variant,
        disableHeaderPaddings: disableHeaderPaddings,
        disableContentPaddings: disableContentPaddings
    }, externalProps, baseComponentProps));
}
(0,_internal_utils_apply_display_name__WEBPACK_IMPORTED_MODULE_5__/* .applyDisplayName */ .b)(Container, "Container"); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 7887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ InternalContainer; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/app-layout/visual-refresh/context.js
var context = __webpack_require__(7919);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/container/use-sticky-header.js
var use_sticky_header = __webpack_require__(7804);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/app-layout/visual-refresh/hooks/use-dynamic-overlap.js
var use_dynamic_overlap = __webpack_require__(5007);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-merge-refs/index.js
var use_merge_refs = __webpack_require__(5912);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-visual-mode/index.js
var use_visual_mode = __webpack_require__(753);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/container/styles.scoped.css
var styles_scoped = __webpack_require__(8998);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/container/styles.css.js

/* harmony default export */ var styles_css = ({
    "root": "awsui_root_14iqq_uvfcm_97",
    "variant-default": "awsui_variant-default_14iqq_uvfcm_110",
    "variant-stacked": "awsui_variant-stacked_14iqq_uvfcm_110",
    "header": "awsui_header_14iqq_uvfcm_133",
    "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_uvfcm_139",
    "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_uvfcm_143",
    "header-stuck": "awsui_header-stuck_14iqq_uvfcm_149",
    "header-dynamic-height": "awsui_header-dynamic-height_14iqq_uvfcm_154",
    "with-paddings": "awsui_with-paddings_14iqq_uvfcm_160",
    "with-hidden-content": "awsui_with-hidden-content_14iqq_uvfcm_163",
    "header-variant-cards": "awsui_header-variant-cards_14iqq_uvfcm_167",
    "header-variant-full-page": "awsui_header-variant-full-page_14iqq_uvfcm_191",
    "dark-header": "awsui_dark-header_14iqq_uvfcm_209",
    "content": "awsui_content_14iqq_uvfcm_213",
    "footer": "awsui_footer_14iqq_uvfcm_223",
    "with-divider": "awsui_with-divider_14iqq_uvfcm_229"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/container/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0









function InternalContainer(_a) {
    var _b, _c, _d;
    var header = _a.header, footer = _a.footer, children = _a.children, _e = _a.variant, variant = _e === void 0 ? "default" : _e, _f = _a.disableHeaderPaddings, disableHeaderPaddings = _f === void 0 ? false : _f, _g = _a.disableContentPaddings, disableContentPaddings = _g === void 0 ? false : _g, __stickyOffset = _a.__stickyOffset, _h = _a.__stickyHeader, __stickyHeader = _h === void 0 ? false : _h, _j = _a.__internalRootRef, __internalRootRef = _j === void 0 ? null : _j, _k = _a.__disableFooterDivider, __disableFooterDivider = _k === void 0 ? false : _k, _l = _a.__disableFooterPaddings, __disableFooterPaddings = _l === void 0 ? false : _l, _m = _a.__hiddenContent, __hiddenContent = _m === void 0 ? false : _m, __headerRef = _a.__headerRef, __headerId = _a.__headerId, _o = _a.__darkHeader, __darkHeader = _o === void 0 ? false : _o, restProps = (0,tslib_es6/* __rest */._T)(_a, [
        "header",
        "footer",
        "children",
        "variant",
        "disableHeaderPaddings",
        "disableContentPaddings",
        "__stickyOffset",
        "__stickyHeader",
        "__internalRootRef",
        "__disableFooterDivider",
        "__disableFooterPaddings",
        "__hiddenContent",
        "__headerRef",
        "__headerId",
        "__darkHeader"
    ]);
    var baseProps = (0,base_component/* getBaseProps */.j)(restProps);
    var rootRef = (0,react.useRef)(null);
    var headerRef = (0,react.useRef)(null);
    var _p = (0,use_sticky_header/* useStickyHeader */._T)(rootRef, headerRef, __stickyHeader, __stickyOffset), isSticky = _p.isSticky, isStuck = _p.isStuck, stickyStyles = _p.stickyStyles;
    var setHasStickyBackground = (0,react.useContext)(context/* AppLayoutContext */.T).setHasStickyBackground;
    var isRefresh = (0,use_visual_mode/* useVisualRefresh */.LV)();
    var hasDynamicHeight = isRefresh && variant === "full-page";
    var overlapElement = (0,use_dynamic_overlap/* useDynamicOverlap */.B)({
        disabled: !hasDynamicHeight || !__darkHeader
    });
    var mergedRef = (0,use_merge_refs/* useMergeRefs */.q)(rootRef, __internalRootRef);
    var headerMergedRef = (0,use_merge_refs/* useMergeRefs */.q)(headerRef, overlapElement, __headerRef);
    var headerIdProp = __headerId ? {
        id: __headerId
    } : {};
    /**
     * The visual refresh AppLayout component needs to know if a child component
     * has a high constrast sticky header. This is to make sure the background element
     * stays in the same vertical position as the header content.
     */ (0,react.useEffect)(function handleHasStickyBackground() {
        var shouldUpdateStickyBackground = isRefresh && isSticky && variant === "full-page";
        if (shouldUpdateStickyBackground) {
            setHasStickyBackground(true);
        }
        return function cleanup() {
            if (shouldUpdateStickyBackground) {
                setHasStickyBackground(false);
            }
        };
    }, [
        isRefresh,
        isSticky,
        setHasStickyBackground,
        variant
    ]);
    return /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        className: (0,clsx_m/* default */.Z)(baseProps.className, styles_css.root, styles_css["variant-".concat(variant)]),
        ref: mergedRef
    }), header && /*#__PURE__*/ react.createElement(use_sticky_header/* StickyHeaderContext.Provider */.d5.Provider, {
        value: {
            isStuck: isStuck
        }
    }, /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({
        className: (0,clsx_m/* default */.Z)(styles_css.header, styles_css["header-variant-".concat(variant)], (_b = {}, _b[styles_css["header-sticky-disabled"]] = __stickyHeader && !isSticky, _b[styles_css["header-sticky-enabled"]] = isSticky, _b[styles_css["header-dynamic-height"]] = hasDynamicHeight, _b[styles_css["header-stuck"]] = isStuck, _b[styles_css["with-paddings"]] = !disableHeaderPaddings, _b[styles_css["with-hidden-content"]] = __hiddenContent, _b))
    }, headerIdProp, stickyStyles, {
        ref: headerMergedRef
    }), __darkHeader ? /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(styles_css["dark-header"], "awsui-context-content-header")
    }, header) : header)), /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(styles_css.content, (_c = {}, _c[styles_css["with-paddings"]] = !disableContentPaddings, _c))
    }, children), footer && /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(styles_css.footer, (_d = {}, _d[styles_css["with-divider"]] = !__disableFooterDivider, _d[styles_css["with-paddings"]] = !__disableFooterPaddings, _d))
    }, footer));
} //# sourceMappingURL=internal.js.map


/***/ }),

/***/ 7804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_T": function() { return /* binding */ useStickyHeader; },
/* harmony export */   "d5": function() { return /* binding */ StickyHeaderContext; }
/* harmony export */ });
/* unused harmony export useSupportsStickyHeader */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _internal_context_app_layout_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(129);
/* harmony import */ var _internal_hooks_use_mobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6670);
/* harmony import */ var _internal_utils_dom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5839);
/* harmony import */ var _internal_utils_scrollable_containers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(764);
/* harmony import */ var _internal_hooks_use_visual_mode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(753);
/* harmony import */ var _internal_generated_custom_css_properties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8276);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0







var StickyHeaderContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    isStuck: false
});
var useStickyHeader = function(rootRef, headerRef, __stickyHeader, __stickyOffset) {
    var currentRootRef = rootRef.current;
    var currentHeaderRef = headerRef.current;
    var totalBorder = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var containerRootBorder = currentRootRef ? parseInt(getComputedStyle(currentRootRef).getPropertyValue("border-top-width"), 10) : 0;
        var headerBorder = currentHeaderRef ? parseInt(getComputedStyle(currentHeaderRef).getPropertyValue("border-top-width"), 10) : 0;
        return containerRootBorder + headerBorder;
    }, [
        currentRootRef,
        currentHeaderRef
    ]);
    // We reach into AppLayoutContext in case sticky header needs to be offset down by the height
    // of other sticky elements positioned on top of the view.
    var stickyOffsetTop = (0,_internal_context_app_layout_context__WEBPACK_IMPORTED_MODULE_1__/* .useAppLayoutContext */ .b)().stickyOffsetTop;
    var isSticky = useSupportsStickyHeader() && !!__stickyHeader;
    var isRefresh = (0,_internal_hooks_use_visual_mode__WEBPACK_IMPORTED_MODULE_2__/* .useVisualRefresh */ .LV)();
    // If it has overflow parents inside the app layout, we shouldn't apply a sticky offset.
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), hasInnerOverflowParents = _a[0], setHasInnerOverflowParents = _a[1];
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isStuck = _b[0], setIsStuck = _b[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function() {
        if (rootRef.current) {
            var overflowParents = (0,_internal_utils_scrollable_containers__WEBPACK_IMPORTED_MODULE_3__/* .getOverflowParents */ .Et)(rootRef.current);
            var mainElement = (0,_internal_utils_dom__WEBPACK_IMPORTED_MODULE_4__/* .findUpUntil */ .jX)(rootRef.current, function(elem) {
                return elem.tagName === "MAIN";
            });
            // In both versions of the app layout, the scrolling element for disableBodyScroll
            // is the <main>. If the closest overflow parent is also the closest <main> and we have
            // offset values, it's safe to assume that it's the app layout scroll root and we
            // should stop there.
            setHasInnerOverflowParents(overflowParents.length > 0 && overflowParents[0] !== mainElement);
        }
    }, [
        rootRef
    ]);
    var effectiveStickyOffset = __stickyOffset !== null && __stickyOffset !== void 0 ? __stickyOffset : hasInnerOverflowParents ? 0 : stickyOffsetTop;
    /**
     * The AppLayout refactor removed the need for passing the sticky offset in px all the time through the
     * AppLayoutDomContext provider because that information already exists on the DOM in a custom property
     * on the Layout subcomponent. Thus, if the Container header is sticky, we are in Visual Refresh and use
     * body scroll then we will use that property. When a component is used outside AppLayout, we fall back
     * to the default offset calculated in AppLayoutDomContext.
     */ var computedOffset = "".concat(effectiveStickyOffset - totalBorder, "px");
    if (isRefresh && !hasInnerOverflowParents) {
        computedOffset = "var(".concat(_internal_generated_custom_css_properties__WEBPACK_IMPORTED_MODULE_5__/* ["default"].offsetTopWithNotifications */ .Z.offsetTopWithNotifications, ", ").concat(computedOffset, ")");
    }
    var stickyStyles = isSticky ? {
        style: {
            top: computedOffset
        }
    } : {};
    // "stuck" state, when the header has moved from its original posititon has a
    // box-shadow, applied here by a "header-stuck" className
    var checkIfStuck = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (rootRef.current && headerRef.current) {
            var rootTop = rootRef.current.getBoundingClientRect().top;
            var headerTop = headerRef.current.getBoundingClientRect().top;
            if (rootTop + totalBorder < headerTop) {
                setIsStuck(true);
            } else {
                setIsStuck(false);
            }
        }
    }, [
        rootRef,
        headerRef,
        totalBorder
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isSticky) {
            window.addEventListener("scroll", checkIfStuck, true);
            window.addEventListener("resize", checkIfStuck);
            return function() {
                window.removeEventListener("scroll", checkIfStuck, true);
                window.removeEventListener("resize", checkIfStuck);
            };
        }
    }, [
        isSticky,
        checkIfStuck
    ]);
    return {
        isSticky: isSticky,
        isStuck: isStuck,
        stickyStyles: stickyStyles
    };
};
function useSupportsStickyHeader() {
    var isMobile = (0,_internal_hooks_use_mobile__WEBPACK_IMPORTED_MODULE_6__/* .useMobile */ .X)();
    return (0,_internal_utils_dom__WEBPACK_IMPORTED_MODULE_4__/* .supportsStickyPosition */ .eN)() && !isMobile;
} //# sourceMappingURL=use-sticky-header.js.map


/***/ }),

/***/ 1993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ContentLayout; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/app-layout/visual-refresh/context.js
var context = __webpack_require__(7919);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/apply-display-name.js
var apply_display_name = __webpack_require__(1651);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-base-component/index.js + 2 modules
var use_base_component = __webpack_require__(4656);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/app-layout/visual-refresh/hooks/use-dynamic-overlap.js
var use_dynamic_overlap = __webpack_require__(5007);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-merge-refs/index.js
var use_merge_refs = __webpack_require__(5912);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-visual-mode/index.js
var use_visual_mode = __webpack_require__(753);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/content-layout/styles.scoped.css
var styles_scoped = __webpack_require__(8878);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/content-layout/styles.css.js

/* harmony default export */ var styles_css = ({
    "layout": "awsui_layout_5gtk3_1onm4_99",
    "is-visual-refresh": "awsui_is-visual-refresh_5gtk3_1onm4_99",
    "background": "awsui_background_5gtk3_1onm4_102",
    "header": "awsui_header_5gtk3_1onm4_105",
    "is-overlap-disabled": "awsui_is-overlap-disabled_5gtk3_1onm4_115",
    "has-breadcrumbs": "awsui_has-breadcrumbs_5gtk3_1onm4_132",
    "content": "awsui_content_5gtk3_1onm4_141"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/content-layout/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0










function ContentLayout(_a) {
    var _b, _c, _d;
    var children = _a.children, disableOverlap = _a.disableOverlap, header = _a.header, rest = (0,tslib_es6/* __rest */._T)(_a, [
        "children",
        "disableOverlap",
        "header"
    ]);
    var baseProps = (0,base_component/* getBaseProps */.j)(rest);
    var breadcrumbs = (0,react.useContext)(context/* AppLayoutContext */.T).breadcrumbs;
    var rootElement = (0,react.useRef)(null);
    var __internalRootRef = (0,use_base_component/* default */.Z)("ContentLayout").__internalRootRef;
    var mergedRef = (0,use_merge_refs/* useMergeRefs */.q)(rootElement, __internalRootRef);
    var overlapElement = (0,use_dynamic_overlap/* useDynamicOverlap */.B)();
    var isVisualRefresh = (0,use_visual_mode/* useVisualRefresh */.LV)();
    /**
     * Disable the overlap if the component is missing either a header or child
     * content. If the component is not using visual refresh then the overlap
     * will not be displayed at all. This is handled in the CSS not the JavaScript.
     */ var isOverlapDisabled = !children || !header || disableOverlap;
    return /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        className: (0,clsx_m/* default */.Z)(baseProps.className, styles_css.layout, (_b = {}, _b[styles_css["is-overlap-disabled"]] = isOverlapDisabled, _b[styles_css["is-visual-refresh"]] = isVisualRefresh, _b)),
        ref: mergedRef
    }), /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(styles_css.background, (_c = {}, _c[styles_css["is-overlap-disabled"]] = isOverlapDisabled, _c), "awsui-context-content-header"),
        ref: overlapElement
    }), header && /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(styles_css.header, (_d = {}, _d[styles_css["has-breadcrumbs"]] = breadcrumbs, _d), "awsui-context-content-header")
    }, header), /*#__PURE__*/ react.createElement("div", {
        className: styles_css.content
    }, children));
}
(0,apply_display_name/* applyDisplayName */.b)(ContentLayout, "ContentLayout"); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FormField; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/context/form-field-context.js
var form_field_context = __webpack_require__(2308);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-unique-id/index.js
var use_unique_id = __webpack_require__(6081);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-visual-mode/index.js
var use_visual_mode = __webpack_require__(753);
// EXTERNAL MODULE: ./node_modules/react-keyed-flatten-children/index.js
var react_keyed_flatten_children = __webpack_require__(3262);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/breakpoints.js
var breakpoints = __webpack_require__(739);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/is-development.js
var is_development = __webpack_require__(5856);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/logging.js
var logging = __webpack_require__(3742);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/grid/styles.scoped.css
var styles_scoped = __webpack_require__(9);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/grid/styles.css.js

/* harmony default export */ var styles_css = ({
    "grid": "awsui_grid_14yj0_1ecf3_93",
    "no-gutters": "awsui_no-gutters_14yj0_1ecf3_107",
    "grid-column": "awsui_grid-column_14yj0_1ecf3_111",
    "colspan-1": "awsui_colspan-1_14yj0_1ecf3_120",
    "push-1": "awsui_push-1_14yj0_1ecf3_124",
    "pull-1": "awsui_pull-1_14yj0_1ecf3_127",
    "colspan-2": "awsui_colspan-2_14yj0_1ecf3_130",
    "push-2": "awsui_push-2_14yj0_1ecf3_134",
    "pull-2": "awsui_pull-2_14yj0_1ecf3_137",
    "colspan-3": "awsui_colspan-3_14yj0_1ecf3_140",
    "push-3": "awsui_push-3_14yj0_1ecf3_144",
    "pull-3": "awsui_pull-3_14yj0_1ecf3_147",
    "colspan-4": "awsui_colspan-4_14yj0_1ecf3_150",
    "push-4": "awsui_push-4_14yj0_1ecf3_154",
    "pull-4": "awsui_pull-4_14yj0_1ecf3_157",
    "colspan-5": "awsui_colspan-5_14yj0_1ecf3_160",
    "push-5": "awsui_push-5_14yj0_1ecf3_164",
    "pull-5": "awsui_pull-5_14yj0_1ecf3_167",
    "colspan-6": "awsui_colspan-6_14yj0_1ecf3_170",
    "push-6": "awsui_push-6_14yj0_1ecf3_174",
    "pull-6": "awsui_pull-6_14yj0_1ecf3_177",
    "colspan-7": "awsui_colspan-7_14yj0_1ecf3_180",
    "push-7": "awsui_push-7_14yj0_1ecf3_184",
    "pull-7": "awsui_pull-7_14yj0_1ecf3_187",
    "colspan-8": "awsui_colspan-8_14yj0_1ecf3_190",
    "push-8": "awsui_push-8_14yj0_1ecf3_194",
    "pull-8": "awsui_pull-8_14yj0_1ecf3_197",
    "colspan-9": "awsui_colspan-9_14yj0_1ecf3_200",
    "push-9": "awsui_push-9_14yj0_1ecf3_204",
    "pull-9": "awsui_pull-9_14yj0_1ecf3_207",
    "colspan-10": "awsui_colspan-10_14yj0_1ecf3_210",
    "push-10": "awsui_push-10_14yj0_1ecf3_214",
    "pull-10": "awsui_pull-10_14yj0_1ecf3_217",
    "colspan-11": "awsui_colspan-11_14yj0_1ecf3_220",
    "push-11": "awsui_push-11_14yj0_1ecf3_224",
    "pull-11": "awsui_pull-11_14yj0_1ecf3_227",
    "colspan-12": "awsui_colspan-12_14yj0_1ecf3_230",
    "push-12": "awsui_push-12_14yj0_1ecf3_234",
    "pull-12": "awsui_pull-12_14yj0_1ecf3_237",
    "push-0": "awsui_push-0_14yj0_1ecf3_240",
    "pull-0": "awsui_pull-0_14yj0_1ecf3_243",
    "offset-1": "awsui_offset-1_14yj0_1ecf3_246",
    "offset-2": "awsui_offset-2_14yj0_1ecf3_249",
    "offset-3": "awsui_offset-3_14yj0_1ecf3_252",
    "offset-4": "awsui_offset-4_14yj0_1ecf3_255",
    "offset-5": "awsui_offset-5_14yj0_1ecf3_258",
    "offset-6": "awsui_offset-6_14yj0_1ecf3_261",
    "offset-7": "awsui_offset-7_14yj0_1ecf3_264",
    "offset-8": "awsui_offset-8_14yj0_1ecf3_267",
    "offset-9": "awsui_offset-9_14yj0_1ecf3_270",
    "offset-10": "awsui_offset-10_14yj0_1ecf3_273",
    "offset-11": "awsui_offset-11_14yj0_1ecf3_276",
    "restore-pointer-events": "awsui_restore-pointer-events_14yj0_1ecf3_280"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/container-queries/use-container-breakpoints.js
var use_container_breakpoints = __webpack_require__(8289);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-merge-refs/index.js
var use_merge_refs = __webpack_require__(5912);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/grid/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0










var InternalGrid = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var _b;
    var __breakpoint = _a.__breakpoint, _c = _a.gridDefinition, gridDefinition = _c === void 0 ? [] : _c, _d = _a.disableGutters, disableGutters = _d === void 0 ? false : _d, children = _a.children, __responsiveClassName = _a.__responsiveClassName, _e = _a.__internalRootRef, __internalRootRef = _e === void 0 ? null : _e, restProps = (0,tslib_es6/* __rest */._T)(_a, [
        "__breakpoint",
        "gridDefinition",
        "disableGutters",
        "children",
        "__responsiveClassName",
        "__internalRootRef"
    ]);
    var _f = (0,use_container_breakpoints/* useContainerBreakpoints */.d)(undefined), defaultBreakpoint = _f[0], defaultRef = _f[1];
    if (__breakpoint !== undefined) {
        defaultBreakpoint = __breakpoint;
        defaultRef = ref;
    }
    var baseProps = (0,base_component/* getBaseProps */.j)(restProps);
    /*
   Flattening the children allows us to "see through" React Fragments and nested arrays.
   */ var flattenedChildren = (0,react_keyed_flatten_children/* default */.Z)(children);
    if (is_development/* isDevelopment */.y) {
        var columnCount = gridDefinition.length;
        var childCount = flattenedChildren.length;
        if (columnCount !== childCount) {
            logging/* warnOnce */.O("Grid", "The number of children (".concat(childCount, ") does not match the number of columns defined (").concat(columnCount, ")."));
        }
    }
    var mergedRef = (0,use_merge_refs/* useMergeRefs */.q)(defaultRef, __internalRootRef);
    return /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        className: (0,clsx_m/* default */.Z)(styles_css.grid, baseProps.className, (_b = {}, _b[styles_css["no-gutters"]] = disableGutters, _b), __responsiveClassName ? __responsiveClassName(defaultBreakpoint) : null),
        ref: mergedRef
    }), flattenedChildren.map(function(child, i) {
        var _a, _b, _c, _d;
        // If this react child is a primitive value, the key will be undefined
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var key = child.key;
        return /*#__PURE__*/ react.createElement("div", {
            key: key,
            className: (0,clsx_m/* default */.Z)(styles_css["grid-column"], getColumnClassNames("colspan", (_a = gridDefinition[i]) === null || _a === void 0 ? void 0 : _a.colspan, defaultBreakpoint), getColumnClassNames("offset", (_b = gridDefinition[i]) === null || _b === void 0 ? void 0 : _b.offset, defaultBreakpoint), getColumnClassNames("pull", (_c = gridDefinition[i]) === null || _c === void 0 ? void 0 : _c.pull, defaultBreakpoint), getColumnClassNames("push", (_d = gridDefinition[i]) === null || _d === void 0 ? void 0 : _d.push, defaultBreakpoint))
        }, /*#__PURE__*/ react.createElement("div", {
            className: styles_css["restore-pointer-events"]
        }, child));
    }));
});
function getColumnClassNames(prop, mapping, breakpoint) {
    if (typeof mapping === "number") {
        return styles_css["".concat(prop, "-").concat(mapping)];
    }
    if (breakpoint === null || mapping === undefined) {
        return null;
    }
    return styles_css["".concat(prop, "-").concat((0,breakpoints/* matchBreakpointMapping */.Zz)(mapping, breakpoint))];
}
/* harmony default export */ var internal = (InternalGrid); //# sourceMappingURL=internal.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/icon/internal.js + 2 modules
var icon_internal = __webpack_require__(776);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/form-field/util.js
function makeSlotId(prop, formFieldId, propName) {
    if (!prop) {
        return undefined;
    }
    return "".concat(formFieldId, "-").concat(propName);
}
function getSlotIds(formFieldId, label, description, constraintText, errorText) {
    var ids = {
        label: makeSlotId(label, formFieldId, "label"),
        description: makeSlotId(description, formFieldId, "description"),
        constraint: makeSlotId(constraintText, formFieldId, "constraint"),
        error: makeSlotId(errorText, formFieldId, "error")
    };
    return ids;
}
function getAriaDescribedBy(_a) {
    var error = _a.error, description = _a.description, constraint = _a.constraint;
    var describedByAttributes = [
        error,
        description,
        constraint
    ].filter(function(e) {
        return !!e;
    });
    var describedBy = describedByAttributes.length ? describedByAttributes.join(" ") : undefined;
    return describedBy;
}
function getGridDefinition(stretch, secondaryControlPresent, isRefresh) {
    var columns;
    if (stretch) {
        columns = [
            {
                colspan: 12
            },
            {
                colspan: 12
            }
        ];
    } else if (isRefresh) {
        columns = [
            {
                colspan: {
                    "default": 12,
                    xs: 8
                }
            },
            {
                colspan: {
                    "default": 12,
                    xs: 4
                }
            }
        ];
    } else {
        columns = [
            {
                colspan: {
                    "default": 12,
                    xs: 9
                }
            },
            {
                colspan: {
                    "default": 12,
                    xs: 3
                }
            }
        ];
    }
    if (!secondaryControlPresent) {
        return [
            columns[0]
        ];
    }
    return columns;
} //# sourceMappingURL=util.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/form-field/styles.scoped.css
var form_field_styles_scoped = __webpack_require__(6561);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/form-field/styles.css.js

/* harmony default export */ var form_field_styles_css = ({
    "error-icon-shake-wrapper": "awsui_error-icon-shake-wrapper_14mhv_yshzd_97",
    "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_14mhv_yshzd_1",
    "error-icon-scale-wrapper": "awsui_error-icon-scale-wrapper_14mhv_yshzd_124",
    "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_14mhv_yshzd_1",
    "error": "awsui_error_14mhv_yshzd_97",
    "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_14mhv_yshzd_1",
    "root": "awsui_root_14mhv_yshzd_168",
    "label": "awsui_label_14mhv_yshzd_180",
    "info": "awsui_info_14mhv_yshzd_193",
    "description": "awsui_description_14mhv_yshzd_198",
    "constraint": "awsui_constraint_14mhv_yshzd_199",
    "hints": "awsui_hints_14mhv_yshzd_206",
    "constraint-has-error": "awsui_constraint-has-error_14mhv_yshzd_207",
    "secondary-control": "awsui_secondary-control_14mhv_yshzd_211",
    "controls": "awsui_controls_14mhv_yshzd_215",
    "label-hidden": "awsui_label-hidden_14mhv_yshzd_215",
    "control": "awsui_control_14mhv_yshzd_215",
    "error__message": "awsui_error__message_14mhv_yshzd_234",
    "visually-hidden": "awsui_visually-hidden_14mhv_yshzd_238"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/strings/join-strings.js
var join_strings = __webpack_require__(4906);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/form-field/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0











var FormFieldError = function(_a) {
    var id = _a.id, children = _a.children, errorIconAriaLabel = _a.errorIconAriaLabel;
    return /*#__PURE__*/ react.createElement("div", {
        id: id,
        className: form_field_styles_css.error
    }, /*#__PURE__*/ react.createElement("div", {
        className: form_field_styles_css["error-icon-shake-wrapper"]
    }, /*#__PURE__*/ react.createElement("div", {
        role: "img",
        "aria-label": errorIconAriaLabel,
        className: form_field_styles_css["error-icon-scale-wrapper"]
    }, /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
        name: "status-warning",
        size: "small"
    }))), /*#__PURE__*/ react.createElement("span", {
        className: form_field_styles_css.error__message
    }, children));
};
function InternalFormField(_a) {
    var controlId = _a.controlId, _b = _a.stretch, stretch = _b === void 0 ? false : _b, label = _a.label, info = _a.info, i18nStrings = _a.i18nStrings, children = _a.children, secondaryControl = _a.secondaryControl, description = _a.description, constraintText = _a.constraintText, errorText = _a.errorText, __hideLabel = _a.__hideLabel, _c = _a.__internalRootRef, __internalRootRef = _c === void 0 ? null : _c, rest = (0,tslib_es6/* __rest */._T)(_a, [
        "controlId",
        "stretch",
        "label",
        "info",
        "i18nStrings",
        "children",
        "secondaryControl",
        "description",
        "constraintText",
        "errorText",
        "__hideLabel",
        "__internalRootRef"
    ]);
    var baseProps = (0,base_component/* getBaseProps */.j)(rest);
    var isRefresh = (0,use_visual_mode/* useVisualRefresh */.LV)();
    var instanceUniqueId = (0,use_unique_id/* useUniqueId */.L)("formField");
    var generatedControlId = controlId || instanceUniqueId;
    var formFieldId = controlId || generatedControlId;
    var slotIds = getSlotIds(formFieldId, label, description, constraintText, errorText);
    var ariaDescribedBy = getAriaDescribedBy(slotIds);
    var gridDefinition = getGridDefinition(stretch, !!secondaryControl, isRefresh);
    var _d = (0,form_field_context/* useFormFieldContext */.e)({}), parentAriaLabelledby = _d.ariaLabelledby, parentAriaDescribedby = _d.ariaDescribedby, parentInvalid = _d.invalid;
    var contextValuesWithoutControlId = {
        ariaLabelledby: (0,join_strings/* joinStrings */.M)(parentAriaLabelledby, slotIds.label) || undefined,
        ariaDescribedby: (0,join_strings/* joinStrings */.M)(parentAriaDescribedby, ariaDescribedBy) || undefined,
        invalid: !!errorText || !!parentInvalid
    };
    return /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        className: (0,clsx_m/* default */.Z)(baseProps.className, form_field_styles_css.root),
        ref: __internalRootRef
    }), /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(__hideLabel && form_field_styles_css["visually-hidden"])
    }, label && /*#__PURE__*/ react.createElement("label", {
        className: form_field_styles_css.label,
        id: slotIds.label,
        htmlFor: generatedControlId
    }, label), !__hideLabel && info && /*#__PURE__*/ react.createElement("span", {
        className: form_field_styles_css.info
    }, info)), description && /*#__PURE__*/ react.createElement("div", {
        className: form_field_styles_css.description,
        id: slotIds.description
    }, description), /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(form_field_styles_css.controls, __hideLabel && form_field_styles_css["label-hidden"])
    }, /*#__PURE__*/ react.createElement(internal, {
        gridDefinition: gridDefinition
    }, /*#__PURE__*/ react.createElement(form_field_context/* FormFieldContext.Provider */.u.Provider, {
        value: (0,tslib_es6/* __assign */.pi)({
            controlId: generatedControlId
        }, contextValuesWithoutControlId)
    }, children && /*#__PURE__*/ react.createElement("div", {
        className: form_field_styles_css.control
    }, children)), secondaryControl && /*#__PURE__*/ react.createElement(form_field_context/* FormFieldContext.Provider */.u.Provider, {
        value: contextValuesWithoutControlId
    }, /*#__PURE__*/ react.createElement("div", {
        className: form_field_styles_css["secondary-control"]
    }, secondaryControl)))), (constraintText || errorText) && /*#__PURE__*/ react.createElement("div", {
        className: form_field_styles_css.hints
    }, errorText && /*#__PURE__*/ react.createElement(FormFieldError, {
        id: slotIds.error,
        errorIconAriaLabel: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.errorIconAriaLabel
    }, errorText), constraintText && /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(form_field_styles_css.constraint, errorText && form_field_styles_css["constraint-has-error"]),
        id: slotIds.constraint
    }, constraintText)));
} //# sourceMappingURL=internal.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/apply-display-name.js
var apply_display_name = __webpack_require__(1651);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-base-component/index.js + 2 modules
var use_base_component = __webpack_require__(4656);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/form-field/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




function FormField(_a) {
    var _b = _a.stretch, stretch = _b === void 0 ? false : _b, props = (0,tslib_es6/* __rest */._T)(_a, [
        "stretch"
    ]);
    var baseComponentProps = (0,use_base_component/* default */.Z)("FormField");
    return /*#__PURE__*/ react.createElement(InternalFormField, (0,tslib_es6/* __assign */.pi)({
        stretch: stretch
    }, props, {
        __hideLabel: false
    }, baseComponentProps));
}
(0,apply_display_name/* applyDisplayName */.b)(FormField, "FormField"); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 2646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _internal_utils_apply_display_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1651);
/* harmony import */ var _internal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8782);
/* harmony import */ var _internal_hooks_use_base_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4656);

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




function Header(_a) {
    var _b = _a.variant, variant = _b === void 0 ? "h2" : _b, props = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(_a, [
        "variant"
    ]);
    var baseComponentProps = (0,_internal_hooks_use_base_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("Header");
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({
        variant: variant
    }, props, baseComponentProps));
}
(0,_internal_utils_apply_display_name__WEBPACK_IMPORTED_MODULE_4__/* .applyDisplayName */ .b)(Header, "Header"); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 8782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ InternalHeader; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/container/use-sticky-header.js
var use_sticky_header = __webpack_require__(7804);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-visual-mode/index.js
var use_visual_mode = __webpack_require__(753);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/header/styles.scoped.css
var styles_scoped = __webpack_require__(2079);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/header/styles.css.js

/* harmony default export */ var styles_css = ({
    "root": "awsui_root_2qdw9_1s542_93",
    "root-no-actions": "awsui_root-no-actions_2qdw9_1s542_108",
    "root-variant-h1": "awsui_root-variant-h1_2qdw9_1s542_108",
    "root-variant-h1-refresh": "awsui_root-variant-h1-refresh_2qdw9_1s542_111",
    "root-variant-h2": "awsui_root-variant-h2_2qdw9_1s542_114",
    "root-has-description": "awsui_root-has-description_2qdw9_1s542_114",
    "root-variant-h2-refresh": "awsui_root-variant-h2-refresh_2qdw9_1s542_117",
    "root-variant-h3": "awsui_root-variant-h3_2qdw9_1s542_120",
    "root-variant-h3-refresh": "awsui_root-variant-h3-refresh_2qdw9_1s542_123",
    "root-no-wrap": "awsui_root-no-wrap_2qdw9_1s542_126",
    "main": "awsui_main_2qdw9_1s542_130",
    "main-variant-h1": "awsui_main-variant-h1_2qdw9_1s542_138",
    "main-variant-h1-refresh": "awsui_main-variant-h1-refresh_2qdw9_1s542_141",
    "main-variant-h2": "awsui_main-variant-h2_2qdw9_1s542_147",
    "main-variant-h3": "awsui_main-variant-h3_2qdw9_1s542_147",
    "main-variant-h2-refresh": "awsui_main-variant-h2-refresh_2qdw9_1s542_153",
    "actions": "awsui_actions_2qdw9_1s542_160",
    "actions-variant-h1": "awsui_actions-variant-h1_2qdw9_1s542_164",
    "actions-variant-h1-refresh": "awsui_actions-variant-h1-refresh_2qdw9_1s542_167",
    "actions-variant-h2": "awsui_actions-variant-h2_2qdw9_1s542_170",
    "actions-variant-h3": "awsui_actions-variant-h3_2qdw9_1s542_170",
    "actions-variant-h2-refresh": "awsui_actions-variant-h2-refresh_2qdw9_1s542_176",
    "actions-variant-h3-refresh": "awsui_actions-variant-h3-refresh_2qdw9_1s542_179",
    "title": "awsui_title_2qdw9_1s542_183",
    "title-variant-h2": "awsui_title-variant-h2_2qdw9_1s542_189",
    "title-variant-h3": "awsui_title-variant-h3_2qdw9_1s542_189",
    "title-variant-h2-refresh": "awsui_title-variant-h2-refresh_2qdw9_1s542_198",
    "info": "awsui_info_2qdw9_1s542_208",
    "description": "awsui_description_2qdw9_1s542_212",
    "description-variant-h1": "awsui_description-variant-h1_2qdw9_1s542_217",
    "description-variant-h1-refresh": "awsui_description-variant-h1-refresh_2qdw9_1s542_222",
    "description-variant-h2": "awsui_description-variant-h2_2qdw9_1s542_225",
    "description-variant-h3": "awsui_description-variant-h3_2qdw9_1s542_230",
    "description-variant-h3-refresh": "awsui_description-variant-h3-refresh_2qdw9_1s542_236",
    "heading": "awsui_heading_2qdw9_1s542_240",
    "heading-variant-h1": "awsui_heading-variant-h1_2qdw9_1s542_249",
    "heading-variant-h2": "awsui_heading-variant-h2_2qdw9_1s542_255",
    "heading-variant-h3": "awsui_heading-variant-h3_2qdw9_1s542_259",
    "heading-text": "awsui_heading-text_2qdw9_1s542_264",
    "counter": "awsui_counter_2qdw9_1s542_268"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/header/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0






function InternalHeader(_a) {
    var variant = _a.variant, headingTagOverride = _a.headingTagOverride, children = _a.children, actions = _a.actions, counter = _a.counter, description = _a.description, info = _a.info, _b = _a.__internalRootRef, __internalRootRef = _b === void 0 ? null : _b, __disableActionsWrapping = _a.__disableActionsWrapping, restProps = (0,tslib_es6/* __rest */._T)(_a, [
        "variant",
        "headingTagOverride",
        "children",
        "actions",
        "counter",
        "description",
        "info",
        "__internalRootRef",
        "__disableActionsWrapping"
    ]);
    var HeadingTag = headingTagOverride !== null && headingTagOverride !== void 0 ? headingTagOverride : variant === "awsui-h1-sticky" ? "h1" : variant;
    var isStuck = (0,react.useContext)(use_sticky_header/* StickyHeaderContext */.d5).isStuck;
    var baseProps = (0,base_component/* getBaseProps */.j)(restProps);
    var isRefresh = (0,use_visual_mode/* useVisualRefresh */.LV)();
    var dynamicVariant = isStuck ? "h2" : "h1";
    var variantOverride = variant === "awsui-h1-sticky" ? isRefresh ? dynamicVariant : "h2" : variant;
    return /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        className: (0,clsx_m/* default */.Z)(styles_css.root, baseProps.className, styles_css["root-variant-".concat(variantOverride)], isRefresh && styles_css["root-variant-".concat(variantOverride, "-refresh")], !actions && [
            styles_css["root-no-actions"]
        ], description && [
            styles_css["root-has-description"]
        ], __disableActionsWrapping && [
            styles_css["root-no-wrap"]
        ]),
        ref: __internalRootRef
    }), /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(styles_css.main, styles_css["main-variant-".concat(variantOverride)], isRefresh && styles_css["main-variant-".concat(variantOverride, "-refresh")])
    }, /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(styles_css.title, styles_css["title-variant-".concat(variantOverride)], isRefresh && styles_css["title-variant-".concat(variantOverride, "-refresh")])
    }, /*#__PURE__*/ react.createElement(HeadingTag, {
        className: (0,clsx_m/* default */.Z)(styles_css.heading, styles_css["heading-variant-".concat(variantOverride)])
    }, /*#__PURE__*/ react.createElement("span", {
        className: styles_css["heading-text"]
    }, children), counter !== undefined && /*#__PURE__*/ react.createElement("span", {
        className: styles_css.counter
    }, " ", counter)), info && /*#__PURE__*/ react.createElement("span", {
        className: styles_css.info
    }, info)), description && /*#__PURE__*/ react.createElement("p", {
        className: (0,clsx_m/* default */.Z)(styles_css.description, styles_css["description-variant-".concat(variantOverride)], isRefresh && styles_css["description-variant-".concat(variantOverride, "-refresh")])
    }, description)), actions && /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(styles_css.actions, styles_css["actions-variant-".concat(variantOverride)], isRefresh && styles_css["actions-variant-".concat(variantOverride, "-refresh")])
    }, actions));
} //# sourceMappingURL=internal.js.map


/***/ }),

/***/ 776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ internal; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/logging.js
var logging = __webpack_require__(3742);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/icon/styles.scoped.css
var styles_scoped = __webpack_require__(2455);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/icon/styles.css.js

/* harmony default export */ var styles_css = ({
    "icon": "awsui_icon_h11ix_k54ie_98",
    "icon-flex-height": "awsui_icon-flex-height_h11ix_k54ie_104",
    "size-small": "awsui_size-small_h11ix_k54ie_129",
    "size-small-mapped-height": "awsui_size-small-mapped-height_h11ix_k54ie_133",
    "size-normal": "awsui_size-normal_h11ix_k54ie_147",
    "size-normal-mapped-height": "awsui_size-normal-mapped-height_h11ix_k54ie_151",
    "size-medium": "awsui_size-medium_h11ix_k54ie_165",
    "size-medium-mapped-height": "awsui_size-medium-mapped-height_h11ix_k54ie_169",
    "size-big": "awsui_size-big_h11ix_k54ie_183",
    "size-big-mapped-height": "awsui_size-big-mapped-height_h11ix_k54ie_187",
    "size-large": "awsui_size-large_h11ix_k54ie_201",
    "size-large-mapped-height": "awsui_size-large-mapped-height_h11ix_k54ie_205",
    "variant-normal": "awsui_variant-normal_h11ix_k54ie_219",
    "variant-disabled": "awsui_variant-disabled_h11ix_k54ie_222",
    "variant-inverted": "awsui_variant-inverted_h11ix_k54ie_225",
    "variant-subtle": "awsui_variant-subtle_h11ix_k54ie_228",
    "variant-warning": "awsui_variant-warning_h11ix_k54ie_231",
    "variant-error": "awsui_variant-error_h11ix_k54ie_234",
    "variant-success": "awsui_variant-success_h11ix_k54ie_237",
    "variant-link": "awsui_variant-link_h11ix_k54ie_240",
    "badge": "awsui_badge_h11ix_k54ie_244"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/icon/icons.js
/* harmony default export */ var icons = ({
    "add-plus": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path d="M8 1v14M15 8H1"/></svg>',
    "angle-down": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path d="m1 4 7 7 7-7"/></svg>',
    "angle-left-double": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path d="M14 1 7 8l7 7"/><path d="M9 1 2 8l7 7"/></svg>',
    "angle-left": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path d="M12 1 5 8l7 7"/></svg>',
    "angle-right-double": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path d="m2 1 7 7-7 7"/><path d="m7 1 7 7-7 7"/></svg>',
    "angle-right": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path d="m4 1 7 7-7 7"/></svg>',
    "angle-up": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path d="m1 12 7-7 7 7"/></svg>',
    "arrow-left": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path d="M9 1 2 8l7 7M2 8h13"/></svg>',
    "audio-full": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M7 15V1L1 6v4l6 5ZM15 3v10M11 5v6"/></svg>',
    "audio-half": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M7 15V1L1 6v4l6 5ZM11 5v6"/></svg>',
    "audio-off": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M7 15V1L1 6v4l6 5Z"/><path d="m15.01 5.75-4.5 4.5M15.01 10.25l-4.5-4.5"/></svg>',
    "bug": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M5 5h6a1 1 0 0 1 1 1v5.5A3.5 3.5 0 0 1 8.5 15h-1A3.5 3.5 0 0 1 4 11.5V6a1 1 0 0 1 1-1ZM5 5a3 3 0 0 1 6 0"/><path d="M12 9h3M1 9h3M12 12h2l1 2M4 12H2l-1 2M12 6h2l1-2M4 6H2L1 4"/></svg>',
    "calendar": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M2 2h12v12H2z"/><path d="M4.99 8H5v.01h-.01zM7.99 8H8v.01h-.01zM10.99 8H11v.01h-.01zM4.99 5H5v.01h-.01zM7.99 5H8v.01h-.01zM10.99 5H11v.01h-.01zM4.99 11H5v.01h-.01zM7.99 11H8v.01h-.01z"/></svg>',
    "call": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path d="M9 2c2.8 0 5 2.2 5 5M7.9 13c1.3 1.3 3.5 1.3 4.8 0l1-1c.4-.4.4-1 0-1.4l-1.5-1.5c-.3-.3-1-.2-1.3.1l-.1.1c-.5.5-1.4.5-2 0L6.6 7.2c-.5-.5-.5-1.4 0-2l.1-.1c.3-.3.4-1 .1-1.3L5.3 2.3c-.3-.4-1-.4-1.3 0l-1 1C1.7 4.6 1.7 6.7 3 8.1L7.9 13z"/></svg>',
    "caret-down-filled": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="filled stroke-linejoin-round" d="M4 5h8l-4 6-4-6z"/></svg>',
    "caret-down": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M4 5h8l-4 6-4-6z"/></svg>',
    "caret-left-filled": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="filled stroke-linejoin-round" d="M11 4v8L5 8l6-4z"/></svg>',
    "caret-right-filled": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="filled stroke-linejoin-round" d="M5 4v8l6-4-6-4z"/></svg>',
    "caret-up-filled": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="filled stroke-linejoin-round" d="M4 11h8L8 5l-4 6z"/></svg>',
    "caret-up": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M4 11h8L8 5l-4 6z"/></svg>',
    "check": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path d="m14.254 4.254-8.25 8.25L6 12.5l-.004.004-4.25-4.25.008-.008L6 12.493l8.246-8.247.008.008Z"/></svg>',
    "close": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path d="m2 2 12 12M14 2 2 14"/></svg>',
    "contact": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round stroke-linecap-round" d="M2 12.286h5.143L8.857 14l1.714-1.714H14V2H2v10.286z"/><path class="stroke-linecap-round" d="M4.99 7H5v.01h-.01zM7.99 7H8v.01h-.01zM10.99 7H11v.01h-.01z"/></svg>',
    "copy": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M2 5h9v9H2z"/><path class="stroke-linejoin-round" d="M5 5V2h9v9h-3"/></svg>',
    "delete-marker": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M3 8V1h6l5 5v9H9"/><path d="M8 1v6h6"/><path class="stroke-linejoin-round" d="m6.87 14.38-4.24-4.25M2.63 14.38l4.24-4.25"/></svg>',
    "download": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M11 2h3v12H2V2h3"/><path d="m4 6 4 4 4-4M8 1v9"/></svg>',
    "edit": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M13 8v6H3V2h6.5M6 10l8-8"/></svg>',
    "ellipsis": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><circle class="filled" cx="8" cy="2.5" r=".5"/><circle class="filled" cx="8" cy="8" r=".5"/><circle class="filled" cx="8" cy="13.5" r=".5"/></svg>',
    "envelope": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M1 2h14v12H1z"/><path class="stroke-linejoin-round" d="m1 4 7 6 7-6"/></svg>',
    "expand": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path d="M9 2h5v5M7 2H2v5M7 14H2V9M9 14h5V9M2 2l12 12M14 2 2 14"/></svg>',
    "external": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linecap-square" d="M10 2h4v4"/><path d="m6 10 8-8"/><path class="stroke-linejoin-round" d="M14 9.048V14H2V2h5"/></svg>',
    "file-open": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path d="M8 1v4a1 1 0 0 0 1 1h4"/><path class="stroke-linejoin-round" d="M3 15h10V5L9 1H3v14z"/><path d="m3 8 7 7"/></svg>',
    "file": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M8 1v5h5"/><path class="stroke-linejoin-round" d="M3 15V1h6l4 4v10H3z"/></svg>',
    "filter": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M15 2H1l5 6v7h4V8l5-6z"/></svg>',
    "flag": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="m2.71 9.18 1.11-.39C5.2 8.3 6.74 8.44 8 9.18c1.27.74 2.8.89 4.18.39l1.11-.39v-6l-1.11.39c-1.38.49-2.92.35-4.18-.39-1.27-.74-2.8-.89-4.18-.39l-1.11.39v11.83"/></svg>',
    "folder-open": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M2 7V2h7l1 2h5v9a1 1 0 0 1-1 1H3L1 7h10l2.006 7"/></svg>',
    "folder": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M14 14H2V2h5.143L9 5h5v9z"/></svg>',
    "group-active": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M14 4a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM9 11v3h6v-3c0-1.66-1.34-3-3-3s-3 1.34-3 3Z"/><path class="filled stroke-linejoin-round" d="M6 4a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM1 11v3h6v-3c0-1.66-1.34-3-3-3s-3 1.34-3 3Z"/></svg>',
    "group": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M14 4a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM9 11v3h6v-3c0-1.66-1.34-3-3-3s-3 1.34-3 3ZM6 4a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM1 11v3h6v-3c0-1.66-1.34-3-3-3s-3 1.34-3 3Z"/></svg>',
    "heart": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path d="M13.92 3.061a3.729 3.729 0 0 0-5.21 0L8 3.76l-.71-.699a3.729 3.729 0 0 0-5.21 0 3.58 3.58 0 0 0 0 5.123l5.21 5.124.003-.004L8 14l.707-.696.004.004 5.21-5.124a3.58 3.58 0 0 0 0-5.123Z"/></svg>',
    "insert-row": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M15 6V3H1v9h5M16 11H8M12 15V7"/></svg>',
    "key": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M9 10a5.023 5.023 0 0 1 0 1 3.996 3.996 0 1 1-3-3.874L13 1h2v5h-2v2h-2l.016 1.983Z"/><path d="M4.99 11H5v.01h-.01z"/></svg>',
    "keyboard": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M15 2H1v12h14V2Z"/><path d="M6 5H4M9 5H7M12 5h-2M6 8H4M12 11H4M9 8H7M12 8h-2"/></svg>',
    "lock-private": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M2 7h12v7H2z"/><path d="M4 7V5a4 4 0 0 1 8 0v2"/></svg>',
    "menu": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path d="M15 8H1M15 3H1M15 13H1"/></svg>',
    "microphone-off": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M13.76 1.34 2.11 12.98M4.75 10.8A5.002 5.002 0 0 0 13 7V6M8 15v-3M3 15h10"/><path class="filled" d="M8 1c-1.1 0-2 .9-2 2v1.09l2.88-2.88C8.61 1.08 8.32 1 8 1ZM6.64 8.46A2 2 0 0 0 8 9c1.1 0 2-.9 2-2V5.09L6.64 8.45v.01Z"/><path class="stroke-linejoin-round" d="M3.37 8.53C3.024 8.184 3 7.537 3 7V6"/></svg>',
    "microphone": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><rect class="stroke-linejoin-round" x="6" y="1" width="4" height="8" rx="2"/><path class="stroke-linejoin-round" d="M3 6v1a5 5 0 0 0 10 0V6M8 12v3M3 15h10"/></svg>',
    "multiscreen": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M11 5H1v7h10V5Z"/><path class="stroke-linejoin-round" d="M11 8.229h4v-7H5V5M1 15h10M6 15v-3"/></svg>',
    "notification": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M8 2.167c-3.5 0-3.5 4.666-3.5 4.666L1 11.5h14l-3.5-4.667s0-4.666-3.5-4.666ZM5.667 11.5v1.167a2.333 2.333 0 0 0 4.666 0V11.5"/><path class="stroke-linecap-round" d="M8 1v1.167"/></svg>',
    "redo": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M12 5H6.38c-4.5 0-4.5 8 0 8H13"/><path class="stroke-linejoin-round" d="m10 8 3-3-3-3"/></svg>',
    "refresh": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path d="M10 5h5V0"/><path d="M15 8a6.957 6.957 0 0 1-7 7 6.957 6.957 0 0 1-7-7 6.957 6.957 0 0 1 7-7 6.87 6.87 0 0 1 6.3 4"/></svg>',
    "remove": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="m3 3 1 11h8l1-11H3ZM1 3h14M10 2H6v1h4V2Z"/></svg>',
    "script": '<svg viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="m9.53 4.397-3.06 7.4M4.5 11.597 1 8.097l3.5-3.5M11.5 11.597l3.5-3.5-3.5-3.5"/></svg>',
    "search": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><circle cx="7" cy="7" r="5"/><path d="m15 15-4.5-4.5"/></svg>',
    "security": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M8 14.83s-6-1.925-6-6.74V3.265c3.31 0 5.99-1.916 5.99-1.916s2.7 1.916 6.01 1.916V8.09c0 4.815-6 6.74-6 6.74Z"/><path d="M2 8.09V3.265c3.31 0 5.99-1.916 5.99-1.916M13.99 8.09V3.265C10.68 3.265 8 1.35 8 1.35"/><path class="stroke-linejoin-round" d="M8 4v5M8 10v2"/></svg>',
    "settings": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path d="M13.33 5.792a1.942 1.942 0 0 1 .287-1.97 6.984 6.984 0 0 0-1.44-1.439 1.943 1.943 0 0 1-3.159-1.308 6.965 6.965 0 0 0-2.037 0 1.943 1.943 0 0 1-3.158 1.308 6.962 6.962 0 0 0-1.44 1.44 1.943 1.943 0 0 1-1.308 3.158 6.972 6.972 0 0 0 0 2.037 1.943 1.943 0 0 1 1.308 3.159 6.952 6.952 0 0 0 1.44 1.44 1.942 1.942 0 0 1 3.159 1.308 6.962 6.962 0 0 0 2.036 0 1.942 1.942 0 0 1 3.159-1.308 6.974 6.974 0 0 0 1.44-1.44 1.943 1.943 0 0 1 1.308-3.159 6.974 6.974 0 0 0 0-2.037 1.942 1.942 0 0 1-1.596-1.189Z"/><circle cx="8" cy="8" r="2"/></svg>',
    "share": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><circle cx="11" cy="4" r="2"/><circle cx="4" cy="8" r="2"/><circle cx="11" cy="12" r="2"/><path d="M9.2 4.9 5.8 7.1M9.2 11.1 5.8 8.9"/></svg>',
    "shrink": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path d="M10 1v5h5M10 6l5-5M6 15v-5H1M6 10l-5 5"/></svg>',
    "status-in-progress": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><circle class="stroke-linejoin-round" cx="8" cy="8" r="7"/><path class="stroke-linecap-round" d="M4.99 7.995H5v.01h-.01zM7.99 7.995H8v.01h-.01zM10.99 7.995H11v.01h-.01z"/></svg>',
    "status-info": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><circle class="stroke-linejoin-round" cx="8" cy="8" r="7"/><path d="M8 11V8H6"/><path class="stroke-linejoin-round" d="M10 11H6"/><path d="M7.99 5H8v.01h-.01z"/></svg>',
    "status-negative": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><circle class="stroke-linejoin-round" cx="8" cy="8" r="7"/><path d="m10.828 5.172-5.656 5.656M10.828 10.828 5.172 5.172"/></svg>',
    "status-pending": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><circle class="stroke-linejoin-round" cx="8" cy="8" r="7"/><path class="stroke-linecap-square" d="M8 5v4H5"/></svg>',
    "status-positive": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><circle class="stroke-linejoin-round" cx="8" cy="8" r="7"/><path class="stroke-linecap-square" d="m5 8 2 2 3.521-3.521"/></svg>',
    "status-stopped": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><circle class="stroke-linejoin-round" cx="8" cy="8" r="7"/><path class="stroke-linecap-square" d="M11 8H5"/></svg>',
    "status-warning": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="m8 1 7 14H1L8 1z"/><path d="M7.99 12H8v.01h-.01zM8 6v4"/></svg>',
    "suggestions": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M6 14h4"/><path d="M8 11h1c0-1.53 3-2.46 3-5.24.02-1.36-.61-2.4-1.57-3.09a4.208 4.208 0 0 0-4.86 0C4.61 3.36 3.98 4.4 4 5.76 4 8.54 7 9.47 7 11h1Z"/></svg>',
    "thumbs-down-filled": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="filled stroke-linejoin-round" d="M6 9.58c0 .27.06.55.19.79l1.64 3.28c.1.21.32.34.55.34.34 0 .62-.28.62-.62v-3.33h3.44a2 2 0 0 0 1.94-2.48l-1.01-4.05a2 2 0 0 0-1.94-1.52H6v7.59Z"/><path class="stroke-linejoin-round" d="M6 2H2v7h4"/></svg>',
    "thumbs-down": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M6 9.58c0 .27.06.55.19.79l1.64 3.28c.1.21.32.34.55.34.34 0 .62-.28.62-.62v-3.33h3.44a2 2 0 0 0 1.94-2.48l-1.01-4.05a2 2 0 0 0-1.94-1.52H6v7.59ZM6 2H2v7h4"/></svg>',
    "thumbs-up-filled": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="filled stroke-linejoin-round" d="M6 6.42c0-.27.06-.55.19-.79l1.64-3.28c.1-.21.32-.34.55-.34.34 0 .62.28.62.62v3.33h3.44a2 2 0 0 1 1.94 2.48l-1.01 4.05a2 2 0 0 1-1.94 1.52H6V6.42Z"/><path class="stroke-linejoin-round" d="M6 14H2V7h4"/></svg>',
    "thumbs-up": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M6 6.42c0-.27.06-.55.19-.79l1.64-3.28c.1-.21.32-.34.55-.34.34 0 .62.28.62.62v3.33h3.44a2 2 0 0 1 1.94 2.48l-1.01 4.05a2 2 0 0 1-1.94 1.52H6V6.42ZM6 14H2V7h4"/></svg>',
    "ticket": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M8 4.275a2 2 0 0 1-2-2H3v12h3a2 2 0 1 1 4 0h3v-12h-3a2 2 0 0 1-2 2Z"/></svg>',
    "treeview-collapse": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M5 8h6M2 2h12v12H2z"/></svg>',
    "treeview-expand": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M5 8h6M8 11V5M2 2h12v12H2z"/></svg>',
    "undo": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M4 13h5.625c4.5 0 4.5-8 0-8H3"/><path class="stroke-linejoin-round" d="M6 2 3 5l3 3"/></svg>',
    "unlocked": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M2 7h12v7H2z"/><path d="M11.874 4A4 4 0 0 0 4 5v2"/></svg>',
    "upload-download": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path d="M11 13.701v-10M8 6.702l3-3 3 3M4.98 2.662v10.04M7.98 9.662l-3 3-3-3"/></svg>',
    "upload": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M5 14H2V2h12v12h-3"/><path d="M12 10 8 6l-4 4M8 6v9"/></svg>',
    "user-profile-active": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="filled stroke-linejoin-round" d="M4.61 4.39C4.61 2.52 6.13 1 8 1s3.39 1.52 3.39 3.39S9.87 7.78 8 7.78 4.61 6.26 4.61 4.39M2.05 14.08h11.91c0-2.25-1.17-4.23-2.9-5.3A5.77 5.77 0 0 0 8 7.91c-3.29 0-5.95 2.76-5.95 6.17z"/></svg>',
    "user-profile": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M4.61 4.39C4.61 2.52 6.13 1 8 1s3.39 1.52 3.39 3.39S9.87 7.78 8 7.78 4.61 6.26 4.61 4.39M2.05 14.08h11.91c0-2.25-1.17-4.23-2.9-5.3A5.77 5.77 0 0 0 8 7.91c-3.29 0-5.95 2.76-5.95 6.17z"/></svg>',
    "video-off": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M3 15h10M8 15v-3M8 12A5 5 0 1 0 8 2a5 5 0 0 0 0 10ZM6 5l4 4M10 5 6 9"/></svg>',
    "video-on": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M3 15h10M8 15v-3M8 12A5 5 0 1 0 8 2a5 5 0 0 0 0 10Z"/><path class="stroke-linejoin-round" d="M8 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/></svg>',
    "video-unavailable": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path class="stroke-linejoin-round" d="M3 15h10M8 15v-3M8 12A5 5 0 1 0 8 2a5 5 0 0 0 0 10ZM5.5 7h5"/></svg>',
    "view-full": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="filled" d="M5 5h6v6H5z"/><path class="stroke-linejoin-round" d="M2 2h12v12H2z"/></svg>',
    "view-horizontal": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="filled" d="M5 9h6v2H5z"/><path class="stroke-linejoin-round" d="M2 2h12v12H2z"/></svg>',
    "view-vertical": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path class="filled" d="M11 5v6H9V5z"/><path class="stroke-linejoin-round" d="M2 2h12v12H2z"/></svg>',
    "zoom-in": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><circle cx="6.885" cy="6.885" r="5.385"/><path d="m14.5 14.5-3.846-3.846M7 4v6M10 7H4"/></svg>',
    "zoom-out": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><circle cx="6.885" cy="6.885" r="5.385"/><path d="m14.5 14.5-3.846-3.846M10 7H4"/></svg>',
    "zoom-to-fit": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path d="M14 11v3h-4M2 11v3h4M2 5V2h4M14 5V2h-4M10 6H6v4h4V6Z"/></svg>'
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-merge-refs/index.js
var use_merge_refs = __webpack_require__(5912);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-visual-mode/index.js
var use_visual_mode = __webpack_require__(753);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/icon/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0








function iconSizeMap(height) {
    if (height === null) {
        // This is the best guess for the contextual height while server rendering.
        return "normal";
    }
    if (height >= 50) {
        return "large";
    } else if (height >= 36) {
        return "big";
    } else if (height >= 24) {
        return "medium";
    } else if (height <= 16) {
        return "small";
    } else {
        return "normal";
    }
}
var InternalIcon = function(_a) {
    var name = _a.name, _b = _a.size, size = _b === void 0 ? "normal" : _b, _c = _a.variant, variant = _c === void 0 ? "normal" : _c, url = _a.url, alt = _a.alt, svg = _a.svg, badge = _a.badge, _d = _a.__internalRootRef, __internalRootRef = _d === void 0 ? null : _d, props = (0,tslib_es6/* __rest */._T)(_a, [
        "name",
        "size",
        "variant",
        "url",
        "alt",
        "svg",
        "badge",
        "__internalRootRef"
    ]);
    var iconRef = (0,react.useRef)(null);
    // To ensure a re-render is triggered on visual mode changes
    (0,use_visual_mode/* useVisualRefresh */.LV)();
    var _e = (0,react.useState)(null), parentHeight = _e[0], setParentHeight = _e[1];
    var contextualSize = size === "inherit";
    var iconSize = contextualSize ? iconSizeMap(parentHeight) : size;
    var inlineStyles = contextualSize && parentHeight !== null ? {
        height: "".concat(parentHeight, "px")
    } : {};
    var baseProps = (0,base_component/* getBaseProps */.j)(props);
    baseProps.className = (0,clsx_m/* default */.Z)(baseProps.className, styles_css.icon, contextualSize && styles_css["icon-flex-height"], badge && styles_css.badge, !contextualSize && styles_css["size-".concat(iconSize, "-mapped-height")], styles_css["size-".concat(iconSize)], styles_css["variant-".concat(variant)]);
    // Possible infinite loop is not a concern here because line
    // height should not change without an external state update.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0,react.useLayoutEffect)(function() {
        if (!contextualSize || !iconRef.current) {
            return;
        }
        var lineHeight = getComputedStyle(iconRef.current).lineHeight;
        var newParentHeight = parseInt(lineHeight, 10);
        setParentHeight(newParentHeight);
    });
    var mergedRef = (0,use_merge_refs/* useMergeRefs */.q)(iconRef, __internalRootRef);
    if (svg) {
        if (url) {
            (0,logging/* warnOnce */.O)("Icon", "You have specified both `url` and `svg`. `svg` will take precedence and `url` will be ignored.");
        }
        return /*#__PURE__*/ react.createElement("span", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
            ref: mergedRef,
            "aria-hidden": "true",
            style: inlineStyles
        }), svg);
    }
    if (url) {
        return /*#__PURE__*/ react.createElement("span", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
            ref: mergedRef,
            style: inlineStyles
        }), /*#__PURE__*/ react.createElement("img", {
            src: url,
            alt: alt
        }));
    }
    var validIcon = name && Object.prototype.hasOwnProperty.call(icons, name);
    return /*#__PURE__*/ react.createElement("span", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        // dangerouslySetInnerHTML is safe here, as we control the content coming from `icons`
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: validIcon ? {
            __html: icons[name]
        } : undefined,
        ref: mergedRef,
        style: inlineStyles
    }));
};
/* harmony default export */ var internal = (InternalIcon); //# sourceMappingURL=internal.js.map


/***/ }),

/***/ 6648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(655);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _internal_base_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8312);
/* harmony import */ var _internal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6640);
/* harmony import */ var _styles_css_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7152);
/* harmony import */ var _internal_utils_apply_display_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1651);
/* harmony import */ var _internal_hooks_use_base_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4656);

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0







var Input = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function(_a, ref) {
    var value = _a.value, _b = _a.type, type = _b === void 0 ? "text" : _b, step = _a.step, inputMode = _a.inputMode, _c = _a.autoComplete, autoComplete = _c === void 0 ? true : _c, spellcheck = _a.spellcheck, disabled = _a.disabled, readOnly = _a.readOnly, disableBrowserAutocorrect = _a.disableBrowserAutocorrect, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, ariaRequired = _a.ariaRequired, name = _a.name, placeholder = _a.placeholder, autoFocus = _a.autoFocus, ariaLabel = _a.ariaLabel, ariaLabelledby = _a.ariaLabelledby, ariaDescribedby = _a.ariaDescribedby, invalid = _a.invalid, controlId = _a.controlId, rest = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(_a, [
        "value",
        "type",
        "step",
        "inputMode",
        "autoComplete",
        "spellcheck",
        "disabled",
        "readOnly",
        "disableBrowserAutocorrect",
        "onKeyDown",
        "onKeyUp",
        "onChange",
        "onBlur",
        "onFocus",
        "ariaRequired",
        "name",
        "placeholder",
        "autoFocus",
        "ariaLabel",
        "ariaLabelledby",
        "ariaDescribedby",
        "invalid",
        "controlId"
    ]);
    var baseComponentProps = (0,_internal_hooks_use_base_component__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("Input");
    var baseProps = (0,_internal_base_component__WEBPACK_IMPORTED_MODULE_1__/* .getBaseProps */ .j)(rest);
    var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(ref, function() {
        return {
            focus: function() {
                var _a;
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++){
                    args[_i] = arguments[_i];
                }
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus.apply(_a, args);
            },
            select: function() {
                var _a;
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.select();
            }
        };
    }, [
        inputRef
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({
        ref: inputRef
    }, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, baseProps), baseComponentProps), {
        autoComplete: autoComplete,
        ariaLabel: ariaLabel,
        ariaRequired: ariaRequired,
        autoFocus: autoFocus,
        disabled: disabled,
        disableBrowserAutocorrect: disableBrowserAutocorrect,
        name: name,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        placeholder: placeholder,
        readOnly: readOnly,
        type: type,
        step: step,
        inputMode: inputMode,
        spellcheck: spellcheck,
        value: value,
        ariaDescribedby: ariaDescribedby,
        ariaLabelledby: ariaLabelledby,
        invalid: invalid,
        controlId: controlId
    }), {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_styles_css_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"].root */ .Z.root, baseProps.className),
        __inheritFormFieldProps: true
    }));
});
(0,_internal_utils_apply_display_name__WEBPACK_IMPORTED_MODULE_7__/* .applyDisplayName */ .b)(Input, "Input");
/* harmony default export */ __webpack_exports__["Z"] = (Input); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 6640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6010);
/* harmony import */ var _internal_hooks_use_merge_refs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5912);
/* harmony import */ var _icon_internal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(776);
/* harmony import */ var _styles_css_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7152);
/* harmony import */ var _internal_events__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6322);
/* harmony import */ var _internal_base_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8312);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6990);
/* harmony import */ var _internal_hooks_use_debounce_callback__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7933);
/* harmony import */ var _internal_context_form_field_context__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2308);

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0










var iconClassName = function(position, hasHandler) {
    var _a;
    return (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_styles_css_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"]["input-icon"] */ .Z["input-icon"], _styles_css_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z["input-icon-".concat(position)], (_a = {}, _a[_styles_css_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"]["input-icon-hoverable"] */ .Z["input-icon-hoverable"]] = hasHandler, _a));
};
var preventMouseDown = function(e) {
    return e.preventDefault();
};
function InternalInput(_a, ref) {
    var _b;
    var _c = _a.type, type = _c === void 0 ? "text" : _c, step = _a.step, inputMode = _a.inputMode, _d = _a.autoComplete, autoComplete = _d === void 0 ? true : _d, ariaLabel = _a.ariaLabel, name = _a.name, value = _a.value, placeholder = _a.placeholder, autoFocus = _a.autoFocus, disabled = _a.disabled, readOnly = _a.readOnly, disableBrowserAutocorrect = _a.disableBrowserAutocorrect, spellcheck = _a.spellcheck, __noBorderRadius = _a.__noBorderRadius, __leftIcon = _a.__leftIcon, _e = _a.__leftIconVariant, __leftIconVariant = _e === void 0 ? "subtle" : _e, __onLeftIconClick = _a.__onLeftIconClick, ariaRequired = _a.ariaRequired, __rightIcon = _a.__rightIcon, _f = _a.__rightIconVariant, __rightIconVariant = _f === void 0 ? "normal" : _f, __onRightIconClick = _a.__onRightIconClick, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onChange = _a.onChange, __onDelayedInput = _a.__onDelayedInput, __onBlurWithDetail = _a.__onBlurWithDetail, onBlur = _a.onBlur, onFocus = _a.onFocus, __nativeAttributes = _a.__nativeAttributes, __internalRootRef = _a.__internalRootRef, __inheritFormFieldProps = _a.__inheritFormFieldProps, rest = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__rest */ ._T)(_a, [
        "type",
        "step",
        "inputMode",
        "autoComplete",
        "ariaLabel",
        "name",
        "value",
        "placeholder",
        "autoFocus",
        "disabled",
        "readOnly",
        "disableBrowserAutocorrect",
        "spellcheck",
        "__noBorderRadius",
        "__leftIcon",
        "__leftIconVariant",
        "__onLeftIconClick",
        "ariaRequired",
        "__rightIcon",
        "__rightIconVariant",
        "__onRightIconClick",
        "onKeyDown",
        "onKeyUp",
        "onChange",
        "__onDelayedInput",
        "__onBlurWithDetail",
        "onBlur",
        "onFocus",
        "__nativeAttributes",
        "__internalRootRef",
        "__inheritFormFieldProps"
    ]);
    var baseProps = (0,_internal_base_component__WEBPACK_IMPORTED_MODULE_1__/* .getBaseProps */ .j)(rest);
    var fireDelayedInput = (0,_internal_hooks_use_debounce_callback__WEBPACK_IMPORTED_MODULE_5__/* .useDebounceCallback */ .S)(function(value) {
        return (0,_internal_events__WEBPACK_IMPORTED_MODULE_6__/* .fireNonCancelableEvent */ .B4)(__onDelayedInput, {
            value: value
        });
    });
    var handleChange = function(value) {
        fireDelayedInput(value);
        (0,_internal_events__WEBPACK_IMPORTED_MODULE_6__/* .fireNonCancelableEvent */ .B4)(onChange, {
            value: value
        });
    };
    var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var searchProps = (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .useSearchProps */ .M)(type, disabled, readOnly, value, inputRef, handleChange);
    __leftIcon = __leftIcon !== null && __leftIcon !== void 0 ? __leftIcon : searchProps.__leftIcon;
    __rightIcon = __rightIcon !== null && __rightIcon !== void 0 ? __rightIcon : searchProps.__rightIcon;
    __onRightIconClick = __onRightIconClick !== null && __onRightIconClick !== void 0 ? __onRightIconClick : searchProps.__onRightIconClick;
    var formFieldContext = (0,_internal_context_form_field_context__WEBPACK_IMPORTED_MODULE_8__/* .useFormFieldContext */ .e)(rest);
    var _g = __inheritFormFieldProps ? formFieldContext : rest, ariaLabelledby = _g.ariaLabelledby, ariaDescribedby = _g.ariaDescribedby, controlId = _g.controlId, invalid = _g.invalid;
    var attributes = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)({
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby,
        name: name,
        placeholder: placeholder,
        autoFocus: autoFocus,
        id: controlId,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_styles_css_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].input */ .Z.input, type && _styles_css_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z["input-type-".concat(type)], __rightIcon && _styles_css_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"]["input-has-icon-right"] */ .Z["input-has-icon-right"], __leftIcon && _styles_css_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"]["input-has-icon-left"] */ .Z["input-has-icon-left"], __noBorderRadius && _styles_css_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"]["input-has-no-border-radius"] */ .Z["input-has-no-border-radius"], (_b = {}, _b[_styles_css_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"]["input-readonly"] */ .Z["input-readonly"]] = readOnly, _b[_styles_css_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"]["input-invalid"] */ .Z["input-invalid"]] = invalid, _b)),
        autoComplete: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertAutoComplete */ .q)(autoComplete),
        disabled: disabled,
        readOnly: readOnly,
        type: type,
        step: step,
        inputMode: inputMode,
        spellCheck: spellcheck,
        onKeyDown: onKeyDown && function(event) {
            return (0,_internal_events__WEBPACK_IMPORTED_MODULE_6__/* .fireKeyboardEvent */ .nm)(onKeyDown, event);
        },
        onKeyUp: onKeyUp && function(event) {
            return (0,_internal_events__WEBPACK_IMPORTED_MODULE_6__/* .fireKeyboardEvent */ .nm)(onKeyUp, event);
        },
        // We set a default value on the component in order to force it into the controlled mode.
        value: value !== null && value !== void 0 ? value : "",
        onChange: onChange && function(event) {
            return handleChange(event.target.value);
        },
        onBlur: function(e) {
            onBlur && (0,_internal_events__WEBPACK_IMPORTED_MODULE_6__/* .fireNonCancelableEvent */ .B4)(onBlur);
            __onBlurWithDetail && (0,_internal_events__WEBPACK_IMPORTED_MODULE_6__/* .fireNonCancelableEvent */ .B4)(__onBlurWithDetail, {
                relatedTarget: e.relatedTarget
            });
        },
        onFocus: onFocus && function() {
            return (0,_internal_events__WEBPACK_IMPORTED_MODULE_6__/* .fireNonCancelableEvent */ .B4)(onFocus);
        }
    }, __nativeAttributes);
    if (type === "number") {
        // Chrome and Safari have a weird built-in behavior of letting focused
        // number inputs be controlled by scrolling on them. However, they don't
        // lock the browser's scroll, so it's very easy to accidentally increment
        // the input while scrolling down the page.
        attributes.onWheel = function(event) {
            return event.currentTarget.blur();
        };
    }
    if (disableBrowserAutocorrect) {
        attributes.autoCorrect = "off";
        attributes.autoCapitalize = "off";
    }
    // ensure aria properties are string literal "true"
    if (ariaRequired) {
        attributes["aria-required"] = "true";
    }
    if (invalid) {
        attributes["aria-invalid"] = "true";
    }
    var mergedRef = (0,_internal_hooks_use_merge_refs__WEBPACK_IMPORTED_MODULE_9__/* .useMergeRefs */ .q)(ref, inputRef);
    // type = "visualSearch" renders a type="text' input
    if (attributes.type === "visualSearch") {
        attributes.type = "text";
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)({}, baseProps, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(baseProps.className, _styles_css_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"]["input-container"] */ .Z["input-container"]),
        ref: __internalRootRef
    }), __leftIcon && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
        onClick: __onLeftIconClick,
        className: iconClassName("left", !!__onLeftIconClick)
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icon_internal__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        name: __leftIcon,
        variant: disabled ? "disabled" : __leftIconVariant
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)({
        ref: mergedRef
    }, attributes)), __rightIcon && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
        onClick: __onRightIconClick,
        onMouseDown: preventMouseDown,
        className: iconClassName("right", !!__onRightIconClick)
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icon_internal__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        name: __rightIcon,
        variant: disabled ? "disabled" : __rightIconVariant
    })));
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(InternalInput)); //# sourceMappingURL=internal.js.map


/***/ }),

/***/ 7152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _styles_scoped_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9692);
/* harmony import */ var _styles_scoped_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_styles_scoped_css__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    "root": "awsui_root_2rhyz_crhmh_93",
    "input": "awsui_input_2rhyz_crhmh_97",
    "input-readonly": "awsui_input-readonly_2rhyz_crhmh_118",
    "input-invalid": "awsui_input-invalid_2rhyz_crhmh_179",
    "input-has-icon-left": "awsui_input-has-icon-left_2rhyz_crhmh_190",
    "input-type-search": "awsui_input-type-search_2rhyz_crhmh_195",
    "input-has-icon-right": "awsui_input-has-icon-right_2rhyz_crhmh_211",
    "input-has-no-border-radius": "awsui_input-has-no-border-radius_2rhyz_crhmh_214",
    "input-container": "awsui_input-container_2rhyz_crhmh_218",
    "input-icon": "awsui_input-icon_2rhyz_crhmh_223",
    "input-icon-hoverable": "awsui_input-icon-hoverable_2rhyz_crhmh_226",
    "input-icon-left": "awsui_input-icon-left_2rhyz_crhmh_230",
    "input-icon-right": "awsui_input-icon-right_2rhyz_crhmh_235"
});


/***/ }),

/***/ 6990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ useSearchProps; },
/* harmony export */   "q": function() { return /* binding */ convertAutoComplete; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var useSearchProps = function(type, disabled, readOnly, value, inputRef, onChange) {
    var searchProps = {};
    var handleIconClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        onChange("");
    }, [
        inputRef,
        onChange
    ]);
    if (type === "search" || type === "visualSearch") {
        searchProps.__leftIcon = "search";
        if (!disabled && !readOnly && value) {
            searchProps.__rightIcon = "close";
            searchProps.__onRightIconClick = handleIconClick;
        }
    }
    return searchProps;
};
/**
 * Converts the boolean or string value of the `autoComplete` property to the correct `autocomplete` attribute value.
 */ var convertAutoComplete = function(propertyValue) {
    if (propertyValue === void 0) {
        propertyValue = false;
    }
    if (propertyValue === true) {
        return "on";
    }
    return propertyValue || "off";
}; //# sourceMappingURL=utils.js.map


/***/ }),

/***/ 8312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ getBaseProps; }
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/styles.scoped.css
var styles_scoped = __webpack_require__(6382);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/base-component/styles.css.js

/* harmony default export */ var styles_css = ({});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/environment.js
var environment = __webpack_require__(1461);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// these styles needed to be imported for every public component


// expose version info, so it can be checked using the browser devtools
if (true) {
    if (!window.awsuiVersions) {
        window.awsuiVersions = {};
    }
    if (!window.awsuiVersions.components) {
        window.awsuiVersions.components = [];
    }
    window.awsuiVersions.components.push(environment/* PACKAGE_VERSION */.ll);
}
function getBaseProps(props) {
    var baseProps = {};
    Object.keys(props).forEach(function(prop) {
        if (prop === "id" || prop === "className" || prop.match(/^data-/)) {
            baseProps[prop] = props[prop];
        }
    });
    return baseProps;
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Il": function() { return /* binding */ mobileBreakpoint; },
/* harmony export */   "Zz": function() { return /* binding */ matchBreakpointMapping; },
/* harmony export */   "zm": function() { return /* binding */ getMatchingBreakpoint; }
/* harmony export */ });
var BREAKPOINT_MAPPING = [
    [
        "xl",
        1840
    ],
    [
        "l",
        1320
    ],
    [
        "m",
        1120
    ],
    [
        "s",
        912
    ],
    [
        "xs",
        688
    ],
    [
        "xxs",
        465
    ],
    [
        "default",
        -1
    ]
];
var mobileBreakpoint = BREAKPOINT_MAPPING.filter(function(b) {
    return b[0] === "xs";
})[0][1];
var BREAKPOINTS_DESCENDING = BREAKPOINT_MAPPING.map(function(_a) {
    var bp = _a[0];
    return bp;
});
/**
 * Take a breakpoint mapping and return the breakpoint value that most closely matches the actual breakpoint.
 */ function matchBreakpointMapping(subset, actual) {
    var qualifyingBreakpoints = BREAKPOINT_MAPPING.slice(BREAKPOINTS_DESCENDING.indexOf(actual));
    for(var _i = 0, qualifyingBreakpoints_1 = qualifyingBreakpoints; _i < qualifyingBreakpoints_1.length; _i++){
        var breakpoint = qualifyingBreakpoints_1[_i][0];
        var breakpointValue = subset[breakpoint];
        if (breakpointValue !== undefined) {
            return breakpointValue;
        }
    }
    return null;
}
/**
 * Get the named breakpoint for a provided width, optionally filtering to a subset of breakpoints.
 */ function getMatchingBreakpoint(width, breakpointFilter) {
    for(var _i = 0, BREAKPOINT_MAPPING_1 = BREAKPOINT_MAPPING; _i < BREAKPOINT_MAPPING_1.length; _i++){
        var _a = BREAKPOINT_MAPPING_1[_i], breakpoint = _a[0], breakpointWidth = _a[1];
        if (width > breakpointWidth && (!breakpointFilter || breakpointFilter.indexOf(breakpoint) !== -1)) {
            return breakpoint;
        }
    }
    return "default";
} //# sourceMappingURL=breakpoints.js.map


/***/ }),

/***/ 7230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AbstractSwitch; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/abstract-switch/styles.scoped.css
var styles_scoped = __webpack_require__(4544);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/abstract-switch/styles.css.js

/* harmony default export */ var styles_css = ({
    "content": "awsui_content_1wepg_3hhd4_93",
    "description": "awsui_description_1wepg_3hhd4_94",
    "label": "awsui_label_1wepg_3hhd4_95",
    "outline": "awsui_outline_1wepg_3hhd4_99",
    "native-input": "awsui_native-input_1wepg_3hhd4_103",
    "wrapper": "awsui_wrapper_1wepg_3hhd4_110",
    "label-wrapper": "awsui_label-wrapper_1wepg_3hhd4_117",
    "empty-content": "awsui_empty-content_1wepg_3hhd4_129",
    "description-bottom-padding": "awsui_description-bottom-padding_1wepg_3hhd4_139",
    "label-disabled": "awsui_label-disabled_1wepg_3hhd4_147",
    "description-disabled": "awsui_description-disabled_1wepg_3hhd4_148",
    "control": "awsui_control_1wepg_3hhd4_153"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/focus-visible/index.js
var focus_visible = __webpack_require__(9297);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-unique-id/index.js
var use_unique_id = __webpack_require__(6081);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/abstract-switch/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





function joinString(values) {
    return values.filter(function(value) {
        return !!value;
    }).join(" ");
}
function AbstractSwitch(_a) {
    var _b, _c;
    var controlId = _a.controlId, controlClassName = _a.controlClassName, outlineClassName = _a.outlineClassName, disabled = _a.disabled, nativeControl = _a.nativeControl, styledControl = _a.styledControl, label = _a.label, description = _a.description, descriptionBottomPadding = _a.descriptionBottomPadding, ariaLabel = _a.ariaLabel, ariaLabelledby = _a.ariaLabelledby, ariaDescribedby = _a.ariaDescribedby, onClick = _a.onClick, __internalRootRef = _a.__internalRootRef, rest = (0,tslib_es6/* __rest */._T)(_a, [
        "controlId",
        "controlClassName",
        "outlineClassName",
        "disabled",
        "nativeControl",
        "styledControl",
        "label",
        "description",
        "descriptionBottomPadding",
        "ariaLabel",
        "ariaLabelledby",
        "ariaDescribedby",
        "onClick",
        "__internalRootRef"
    ]);
    var uniqueId = (0,use_unique_id/* useUniqueId */.L)();
    var id = controlId || uniqueId;
    var focusVisible = (0,focus_visible/* default */.Z)();
    var labelId = "".concat(id, "-label");
    var descriptionId = "".concat(id, "-description");
    var ariaLabelledByIds = [];
    if (label) {
        ariaLabelledByIds.push(labelId);
    }
    if (ariaLabelledby) {
        ariaLabelledByIds.push(ariaLabelledby);
    }
    var ariaDescriptons = [];
    if (ariaDescribedby) {
        ariaDescriptons.push(ariaDescribedby);
    }
    if (description) {
        ariaDescriptons.push(descriptionId);
    }
    return /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({}, rest, {
        className: (0,clsx_m/* default */.Z)(styles_css.wrapper, rest.className),
        ref: __internalRootRef
    }), /*#__PURE__*/ react.createElement("div", {
        className: styles_css["label-wrapper"],
        "aria-disabled": disabled ? "true" : undefined,
        onClick: disabled ? undefined : onClick
    }, /*#__PURE__*/ react.createElement("span", {
        className: (0,clsx_m/* default */.Z)(styles_css.control, controlClassName)
    }, styledControl, nativeControl((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, focusVisible), {
        id: id,
        disabled: disabled,
        className: styles_css["native-input"],
        "aria-describedby": ariaDescriptons.length ? joinString(ariaDescriptons) : undefined,
        "aria-labelledby": ariaLabelledByIds.length ? joinString(ariaLabelledByIds) : undefined,
        "aria-label": ariaLabel
    })), /*#__PURE__*/ react.createElement("span", {
        className: (0,clsx_m/* default */.Z)(styles_css.outline, outlineClassName)
    })), /*#__PURE__*/ react.createElement("span", {
        className: (0,clsx_m/* default */.Z)(styles_css.content, !label && !description && styles_css["empty-content"])
    }, label && /*#__PURE__*/ react.createElement("span", {
        id: labelId,
        className: (0,clsx_m/* default */.Z)(styles_css.label, (_b = {}, _b[styles_css["label-disabled"]] = disabled, _b))
    }, label), description && /*#__PURE__*/ react.createElement("span", {
        id: descriptionId,
        className: (0,clsx_m/* default */.Z)(styles_css.description, (_c = {}, _c[styles_css["description-disabled"]] = disabled, _c[styles_css["description-bottom-padding"]] = descriptionBottomPadding, _c))
    }, description))));
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 6061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ DropdownContextProvider; },
/* harmony export */   "t": function() { return /* binding */ useDropdownContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var DropdownContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    position: "bottom-right"
});
function DropdownContextProvider(_a) {
    var children = _a.children, _b = _a.position, position = _b === void 0 ? "bottom-right" : _b;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DropdownContext.Provider, {
        value: {
            position: position
        }
    }, children);
}
function useDropdownContext() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(DropdownContext);
} //# sourceMappingURL=context.js.map


/***/ }),

/***/ 5730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ dropdown; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/dropdown/styles.scoped.css
var styles_scoped = __webpack_require__(895);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/dropdown/styles.css.js

/* harmony default export */ var styles_css = ({
    "dropdown-content-wrapper": "awsui_dropdown-content-wrapper_qwoo0_1aum0_93",
    "awsui-motion-fade-in-dropdown": "awsui_awsui-motion-fade-in-dropdown_qwoo0_1aum0_1",
    "refresh": "awsui_refresh_qwoo0_1aum0_114",
    "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_qwoo0_1aum0_1",
    "root": "awsui_root_qwoo0_1aum0_143",
    "interior": "awsui_interior_qwoo0_1aum0_155",
    "dropdown": "awsui_dropdown_qwoo0_1aum0_93",
    "use-portal": "awsui_use-portal_qwoo0_1aum0_166",
    "dropdown-drop-up": "awsui_dropdown-drop-up_qwoo0_1aum0_211",
    "with-limited-width": "awsui_with-limited-width_qwoo0_1aum0_215",
    "dropdown-drop-left": "awsui_dropdown-drop-left_qwoo0_1aum0_218",
    "dropdown-drop-right": "awsui_dropdown-drop-right_qwoo0_1aum0_221",
    "occupy-entire-width": "awsui_occupy-entire-width_qwoo0_1aum0_224",
    "hide-upper-border": "awsui_hide-upper-border_qwoo0_1aum0_227",
    "open": "awsui_open_qwoo0_1aum0_234",
    "nowrap": "awsui_nowrap_qwoo0_1aum0_243",
    "is-empty": "awsui_is-empty_qwoo0_1aum0_247",
    "dropdown-content": "awsui_dropdown-content_qwoo0_1aum0_93",
    "ie11-wrapper": "awsui_ie11-wrapper_qwoo0_1aum0_257",
    "stretch-trigger-height": "awsui_stretch-trigger-height_qwoo0_1aum0_261"
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-merge-refs/index.js
var use_merge_refs = __webpack_require__(5912);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(3935);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/events/index.js
var events = __webpack_require__(6322);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/scrollable-containers.js
var scrollable_containers = __webpack_require__(764);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/dropdown/dropdown-fit-handler.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var AVAILABLE_SPACE_RESERVE_DEFAULT = 50;
var AVAILABLE_SPACE_RESERVE_MOBILE_VERTICAL = 19; // 50 - 31
var AVAILABLE_SPACE_RESERVE_MOBILE_HORIZONTAL = 20;
var getClosestParentDimensions = function(element) {
    var parents = (0,scrollable_containers/* getOverflowParents */.Et)(element).map(function(el) {
        var _a = el.getBoundingClientRect(), height = _a.height, width = _a.width, top = _a.top, left = _a.left;
        return {
            height: height,
            width: width,
            top: top,
            left: left
        };
    });
    return parents.shift();
};
var getAvailableSpace = function(trigger, dropdown, overflowParents, stretchWidth, stretchHeight, isMobile) {
    if (stretchWidth === void 0) {
        stretchWidth = false;
    }
    if (stretchHeight === void 0) {
        stretchHeight = false;
    }
    var availableSpaceReserveVertical = stretchHeight ? 0 : isMobile ? AVAILABLE_SPACE_RESERVE_MOBILE_VERTICAL : AVAILABLE_SPACE_RESERVE_DEFAULT;
    var availableSpaceReserveHorizontal = stretchWidth ? 0 : isMobile ? AVAILABLE_SPACE_RESERVE_MOBILE_HORIZONTAL : AVAILABLE_SPACE_RESERVE_DEFAULT;
    var _a = trigger.getBoundingClientRect(), triggerBottom = _a.bottom, triggerLeft = _a.left, triggerRight = _a.right;
    return overflowParents.reduce(function(_a, overflowParent) {
        var above = _a.above, below = _a.below, left = _a.left, right = _a.right;
        var offsetTop = triggerBottom - overflowParent.top;
        var currentAbove = offsetTop - trigger.offsetHeight - availableSpaceReserveVertical;
        var currentBelow = overflowParent.height - offsetTop - availableSpaceReserveVertical;
        var currentLeft = triggerRight - overflowParent.left - availableSpaceReserveHorizontal;
        var currentRight = overflowParent.left + overflowParent.width - triggerLeft - availableSpaceReserveHorizontal;
        return {
            above: Math.min(above, currentAbove),
            below: Math.min(below, currentBelow),
            left: Math.min(left, currentLeft),
            right: Math.min(right, currentRight)
        };
    }, {
        above: Number.MAX_VALUE,
        below: Number.MAX_VALUE,
        left: Number.MAX_VALUE,
        right: Number.MAX_VALUE
    });
};
var getInteriorAvailableSpace = function(trigger, dropdown, overflowParents, isMobile) {
    var AVAILABLE_SPACE_RESERVE_VERTICAL = isMobile ? AVAILABLE_SPACE_RESERVE_MOBILE_VERTICAL : AVAILABLE_SPACE_RESERVE_DEFAULT;
    var AVAILABLE_SPACE_RESERVE_HORIZONTAL = isMobile ? AVAILABLE_SPACE_RESERVE_MOBILE_HORIZONTAL : AVAILABLE_SPACE_RESERVE_DEFAULT;
    var _a = trigger.getBoundingClientRect(), triggerBottom = _a.bottom, triggerTop = _a.top, triggerLeft = _a.left, triggerRight = _a.right;
    return overflowParents.reduce(function(_a, overflowParent) {
        var above = _a.above, below = _a.below, left = _a.left, right = _a.right;
        var currentAbove = triggerBottom - overflowParent.top - AVAILABLE_SPACE_RESERVE_VERTICAL;
        var currentBelow = overflowParent.height - triggerTop + overflowParent.top - AVAILABLE_SPACE_RESERVE_VERTICAL;
        var currentLeft = triggerLeft - overflowParent.left - AVAILABLE_SPACE_RESERVE_HORIZONTAL;
        var currentRight = overflowParent.left + overflowParent.width - triggerRight - AVAILABLE_SPACE_RESERVE_HORIZONTAL;
        return {
            above: Math.min(above, currentAbove),
            below: Math.min(below, currentBelow),
            left: Math.min(left, currentLeft),
            right: Math.min(right, currentRight)
        };
    }, {
        above: Number.MAX_VALUE,
        below: Number.MAX_VALUE,
        left: Number.MAX_VALUE,
        right: Number.MAX_VALUE
    });
};
var getDropdownPosition = function(trigger, dropdown, overflowParents, minWidth, preferCenter, stretchWidth, stretchHeight, isMobile) {
    if (preferCenter === void 0) {
        preferCenter = false;
    }
    if (stretchWidth === void 0) {
        stretchWidth = false;
    }
    if (stretchHeight === void 0) {
        stretchHeight = false;
    }
    var availableSpace = getAvailableSpace(trigger, dropdown, overflowParents, stretchWidth, stretchHeight, isMobile);
    var triggerWidth = trigger.getBoundingClientRect().width;
    minWidth = minWidth ? Math.min(triggerWidth, minWidth) : triggerWidth;
    var requiredWidth = dropdown.getBoundingClientRect().width;
    // dropdown should not be smaller than the trigger
    var idealWidth = Math.max(requiredWidth, minWidth);
    var dropLeft;
    var left = null;
    var width = idealWidth;
    //1. Can it be positioned with ideal width to the right?
    if (idealWidth <= availableSpace.right) {
        dropLeft = false;
    //2. Can it be positioned with ideal width to the left?
    } else if (idealWidth <= availableSpace.left) {
        dropLeft = true;
    //3. Fit into biggest available space either on left or right
    } else {
        dropLeft = availableSpace.left > availableSpace.right;
        width = Math.max(availableSpace.left, availableSpace.right, minWidth);
    }
    if (preferCenter) {
        var spillOver = (idealWidth - triggerWidth) / 2;
        // availableSpace always includes the trigger width, but we want to exclude that
        var availableOutsideLeft = availableSpace.left - triggerWidth;
        var availableOutsideRight = availableSpace.right - triggerWidth;
        var fitsInCenter = availableOutsideLeft >= spillOver && availableOutsideRight >= spillOver;
        if (fitsInCenter) {
            left = -spillOver;
        }
    }
    var dropUp = availableSpace.below < dropdown.offsetHeight && availableSpace.above > availableSpace.below;
    var availableHeight = dropUp ? availableSpace.above : availableSpace.below;
    // Try and crop the bottom item when all options can't be displayed, affordance for "there's more"
    var croppedHeight = stretchHeight ? availableHeight : Math.floor(availableHeight / 31) * 31 + 16;
    return {
        dropUp: dropUp,
        dropLeft: dropLeft,
        left: left === null ? "auto" : "".concat(left, "px"),
        height: "".concat(croppedHeight, "px"),
        width: "".concat(width, "px")
    };
};
var getInteriorDropdownPosition = function(trigger, dropdown, overflowParents, isMobile) {
    var availableSpace = getInteriorAvailableSpace(trigger, dropdown, overflowParents, isMobile);
    var _a = trigger.getBoundingClientRect(), triggerBottom = _a.bottom, triggerTop = _a.top, triggerWidth = _a.width;
    var _b = getClosestParentDimensions(trigger), parentDropdownTop = _b.top, parentDropdownHeight = _b.height;
    var dropLeft;
    var width = dropdown.getBoundingClientRect().width;
    var top = triggerTop - parentDropdownTop;
    if (width <= availableSpace.right) {
        dropLeft = false;
    } else if (width <= availableSpace.left) {
        dropLeft = true;
    } else {
        dropLeft = availableSpace.left > availableSpace.right;
        width = Math.max(availableSpace.left, availableSpace.right);
    }
    var left = dropLeft ? 0 - width : triggerWidth;
    var dropUp = availableSpace.below < dropdown.offsetHeight && availableSpace.above > availableSpace.below;
    var bottom = dropUp ? parentDropdownTop + parentDropdownHeight - triggerBottom : 0;
    var availableHeight = dropUp ? availableSpace.above : availableSpace.below;
    // Try and crop the bottom item when all options can't be displayed, affordance for "there's more"
    var croppedHeight = Math.floor(availableHeight / 31) * 31 + 16;
    return {
        dropUp: dropUp,
        dropLeft: dropLeft,
        height: "".concat(croppedHeight, "px"),
        width: "".concat(width, "px"),
        top: "".concat(top, "px"),
        bottom: "".concat(bottom, "px"),
        left: "".concat(left, "px")
    };
};
var calculatePosition = function(dropdownElement, triggerElement, verticalContainerElement, interior, expandToViewport, preferCenter, stretchWidth, stretchHeight, isMobile, minWidth) {
    // cleaning previously assigned values,
    // so that they are not reused in case of screen resize and similar events
    verticalContainerElement.style.maxHeight = "";
    dropdownElement.style.width = "";
    dropdownElement.style.top = "";
    dropdownElement.style.bottom = "";
    dropdownElement.style.left = "";
    dropdownElement.classList.remove(styles_css["dropdown-drop-left"]);
    dropdownElement.classList.remove(styles_css["dropdown-drop-right"]);
    dropdownElement.classList.remove(styles_css["dropdown-drop-up"]);
    var overflowParents = (0,scrollable_containers/* getOverflowParentDimensions */.YA)(dropdownElement, interior, expandToViewport, stretchHeight);
    var position = interior ? getInteriorDropdownPosition(triggerElement, dropdownElement, overflowParents, isMobile) : getDropdownPosition(triggerElement, dropdownElement, overflowParents, minWidth, preferCenter, stretchWidth, stretchHeight, isMobile);
    var triggerBox = triggerElement.getBoundingClientRect();
    return [
        position,
        triggerBox
    ];
}; //# sourceMappingURL=dropdown-fit-handler.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/transition/index.js
var transition = __webpack_require__(8437);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-visual-mode/index.js
var use_visual_mode = __webpack_require__(753);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-portal-mode-classes/index.js
var use_portal_mode_classes = __webpack_require__(7656);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/dropdown/context.js
var context = __webpack_require__(6061);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-mobile/index.js
var use_mobile = __webpack_require__(6670);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/tab-trap/index.js
var tab_trap = __webpack_require__(8605);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/focus-lock/utils.js
var utils = __webpack_require__(5500);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/dropdown/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0














var DropdownContainer = function(_a) {
    var children = _a.children, _b = _a.renderWithPortal, renderWithPortal = _b === void 0 ? false : _b, id = _a.id, open = _a.open;
    if (renderWithPortal) {
        if (open) {
            return /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ react.createElement("div", {
                id: id
            }, children), document.body);
        } else {
            return null;
        }
    } else {
        return /*#__PURE__*/ react.createElement(react.Fragment, null, children);
    }
};
var TransitionContent = function(_a) {
    var _b;
    var state = _a.state, transitionRef = _a.transitionRef, dropdownClasses = _a.dropdownClasses, stretchWidth = _a.stretchWidth, interior = _a.interior, isRefresh = _a.isRefresh, dropdownRef = _a.dropdownRef, verticalContainerRef = _a.verticalContainerRef, expandToViewport = _a.expandToViewport, header = _a.header, children = _a.children, footer = _a.footer, position = _a.position, open = _a.open, onMouseDown = _a.onMouseDown;
    var contentRef = (0,use_merge_refs/* useMergeRefs */.q)(dropdownRef, transitionRef);
    return /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(styles_css.dropdown, dropdownClasses, (_b = {}, _b[styles_css.open] = open, _b[styles_css["with-limited-width"]] = !stretchWidth, _b[styles_css["hide-upper-border"]] = stretchWidth, _b[styles_css.interior] = interior, _b[styles_css["is-empty"]] = !header && !children, _b[styles_css.refresh] = isRefresh, _b[styles_css["use-portal"]] = expandToViewport && !interior, _b)),
        ref: contentRef,
        "data-open": open,
        "data-animating": state !== "exited",
        "aria-hidden": !open,
        onMouseDown: onMouseDown
    }, /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(styles_css["dropdown-content-wrapper"], isRefresh && styles_css.refresh)
    }, /*#__PURE__*/ react.createElement("div", {
        className: styles_css["ie11-wrapper"]
    }, /*#__PURE__*/ react.createElement("div", {
        ref: verticalContainerRef,
        className: styles_css["dropdown-content"]
    }, /*#__PURE__*/ react.createElement(context/* DropdownContextProvider */.q, {
        position: position
    }, header, children, footer)))));
};
var Dropdown = function(_a) {
    var children = _a.children, trigger = _a.trigger, open = _a.open, onDropdownClose = _a.onDropdownClose, onMouseDown = _a.onMouseDown, header = _a.header, footer = _a.footer, dropdownId = _a.dropdownId, _b = _a.stretchTriggerHeight, stretchTriggerHeight = _b === void 0 ? false : _b, _c = _a.stretchWidth, stretchWidth = _c === void 0 ? true : _c, _d = _a.stretchHeight, stretchHeight = _d === void 0 ? false : _d, _e = _a.stretchToTriggerWidth, stretchToTriggerWidth = _e === void 0 ? true : _e, _f = _a.expandToViewport, expandToViewport = _f === void 0 ? false : _f, _g = _a.preferCenter, preferCenter = _g === void 0 ? false : _g, _h = _a.interior, interior = _h === void 0 ? false : _h, minWidth = _a.minWidth, _j = _a.scrollable, scrollable = _j === void 0 ? true : _j, _k = _a.loopFocus, loopFocus = _k === void 0 ? expandToViewport : _k, onFocus = _a.onFocus, onBlur = _a.onBlur, contentKey = _a.contentKey;
    var wrapperRef = (0,react.useRef)(null);
    var triggerRef = (0,react.useRef)(null);
    var dropdownRef = (0,react.useRef)(null);
    var dropdownContainerRef = (0,react.useRef)(null);
    // This container is only needed to apply max-height to. We can't move max-height to it's parent
    // because of an IE11 issue with flexbox. https://github.com/philipwalton/flexbugs/issues/216
    var verticalContainerRef = (0,react.useRef)(null);
    // To keep track of the initial position (drop up/down) which is kept the same during fixed repositioning
    var fixedPosition = (0,react.useRef)(null);
    var isRefresh = (0,use_visual_mode/* useVisualRefresh */.LV)();
    var dropdownClasses = (0,use_portal_mode_classes/* usePortalModeClasses */.g)(triggerRef);
    var _l = (0,react.useState)("bottom-right"), position = _l[0], setPosition = _l[1];
    var isMobile = (0,use_mobile/* useMobile */.X)();
    var setDropdownPosition = function(position, triggerBox, target, verticalContainer) {
        var entireWidth = !interior && stretchWidth;
        if (!stretchWidth) {
            // 1px offset for dropdowns where the dropdown itself needs a border, rather than on the items
            verticalContainer.style.maxHeight = "".concat(parseInt(position.height) + 1, "px");
        } else {
            verticalContainer.style.maxHeight = position.height;
        }
        if (entireWidth && !expandToViewport) {
            if (stretchToTriggerWidth) {
                target.classList.add(styles_css["occupy-entire-width"]);
            }
        } else {
            target.style.width = position.width;
        }
        // Using styles for main dropdown to adjust its position as preferred alternative
        if (position.dropUp && !interior) {
            target.classList.add(styles_css["dropdown-drop-up"]);
            if (!expandToViewport) {
                target.style.bottom = "100%";
            }
        } else {
            target.classList.remove(styles_css["dropdown-drop-up"]);
        }
        target.classList.add(position.dropLeft ? styles_css["dropdown-drop-left"] : styles_css["dropdown-drop-right"]);
        if (position.left && position.left !== "auto") {
            target.style.left = position.left;
        }
        // Position normal overflow dropdowns with fixed positioning relative to viewport
        if (expandToViewport && !interior) {
            target.style.position = "fixed";
            if (position.dropUp) {
                target.style.bottom = "calc(100% - ".concat(triggerBox.top, "px)");
            } else {
                target.style.top = "".concat(triggerBox.bottom, "px");
            }
            if (position.dropLeft) {
                target.style.left = "calc(".concat(triggerBox.right, "px - ").concat(position.width, ")");
            } else {
                target.style.left = "".concat(triggerBox.left, "px");
            }
            // Keep track of the initial dropdown position and direction.
            // Dropdown direction doesn't need to change as the user scrolls, just needs to stay attached to the trigger.
            fixedPosition.current = position;
            return;
        }
        // For an interior dropdown (the fly out) we need exact values for positioning
        // and classes are not enough
        // usage of relative position is impossible due to overwrite of overflow-x
        if (interior && isInteriorPosition(position)) {
            if (position.dropUp) {
                target.style.bottom = position.bottom;
            } else {
                target.style.top = position.top;
            }
            target.style.left = position.left;
        }
        if (position.dropUp && position.dropLeft) {
            setPosition("top-left");
        } else if (position.dropUp) {
            setPosition("top-right");
        } else if (position.dropLeft) {
            setPosition("bottom-left");
        } else {
            setPosition("bottom-right");
        }
    };
    var isOutsideDropdown = function(element) {
        return (!wrapperRef.current || !wrapperRef.current.contains(element)) && (!dropdownContainerRef.current || !dropdownContainerRef.current.contains(element));
    };
    var focusHandler = function(event) {
        if (!event.relatedTarget || isOutsideDropdown(event.relatedTarget)) {
            (0,events/* fireNonCancelableEvent */.B4)(onFocus, event);
        }
    };
    var blurHandler = function(event) {
        if (!event.relatedTarget || isOutsideDropdown(event.relatedTarget)) {
            (0,events/* fireNonCancelableEvent */.B4)(onBlur, event);
        }
    };
    (0,react.useLayoutEffect)(function() {
        var onDropdownOpen = function() {
            if (open && dropdownRef.current && triggerRef.current && verticalContainerRef.current) {
                // calculate scroll width only for dropdowns that has a scrollbar and ignore it for date picker components
                if (scrollable) {
                    dropdownRef.current.classList.add(styles_css.nowrap);
                }
                setDropdownPosition.apply(void 0, (0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)([], calculatePosition(dropdownRef.current, triggerRef.current, verticalContainerRef.current, interior, expandToViewport, preferCenter, stretchWidth, stretchHeight, isMobile, minWidth), false), [
                    dropdownRef.current,
                    verticalContainerRef.current
                ], false));
                if (scrollable) {
                    dropdownRef.current.classList.remove(styles_css.nowrap);
                }
            }
        };
        onDropdownOpen();
        if (open) {
            // window may scroll when dropdown opens, for example when soft keyboard shows up
            window.addEventListener("scroll", onDropdownOpen);
            // only listen to window scroll within very short time after the dropdown opens
            // do not want to interfere dropdown position on scroll afterwards
            var timeoutId_1 = setTimeout(function() {
                window.removeEventListener("scroll", onDropdownOpen);
            }, 500);
            return function() {
                clearTimeout(timeoutId_1);
                window.removeEventListener("scroll", onDropdownOpen);
            };
        }
    // See AWSUI-13040
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open,
        dropdownRef,
        triggerRef,
        verticalContainerRef,
        interior,
        stretchWidth,
        isMobile,
        contentKey
    ]);
    // subscribe to outside click
    (0,react.useEffect)(function() {
        if (!open) {
            return;
        }
        var clickListener = function(e) {
            var _a;
            if (!((_a = dropdownRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
                (0,events/* fireNonCancelableEvent */.B4)(onDropdownClose);
            }
        };
        window.addEventListener("click", clickListener, true);
        return function() {
            window.removeEventListener("click", clickListener, true);
        };
    }, [
        open,
        onDropdownClose
    ]);
    // sync dropdown position on scroll and resize
    (0,react.useLayoutEffect)(function() {
        if (!expandToViewport || !open) {
            return;
        }
        var updateDropdownPosition = function() {
            if (triggerRef.current && dropdownRef.current && verticalContainerRef.current) {
                var triggerRect = triggerRef.current.getBoundingClientRect();
                var target = dropdownRef.current;
                if (fixedPosition.current) {
                    if (fixedPosition.current.dropUp) {
                        dropdownRef.current.style.bottom = "calc(100% - ".concat(triggerRect.top, "px)");
                    } else {
                        target.style.top = "".concat(triggerRect.bottom, "px");
                    }
                    if (fixedPosition.current.dropLeft) {
                        target.style.left = "calc(".concat(triggerRect.right, "px - ").concat(fixedPosition.current.width, ")");
                    } else {
                        target.style.left = "".concat(triggerRect.left, "px");
                    }
                }
            }
        };
        updateDropdownPosition();
        window.addEventListener("scroll", updateDropdownPosition, true);
        window.addEventListener("resize", updateDropdownPosition, true);
        return function() {
            window.removeEventListener("scroll", updateDropdownPosition, true);
            window.removeEventListener("resize", updateDropdownPosition, true);
        };
    }, [
        open,
        expandToViewport
    ]);
    return /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(styles_css.root, interior && styles_css.interior, stretchTriggerHeight && styles_css["stretch-trigger-height"]),
        ref: wrapperRef,
        onFocus: focusHandler,
        onBlur: blurHandler
    }, /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(stretchTriggerHeight && styles_css["stretch-trigger-height"]),
        ref: triggerRef
    }, trigger), /*#__PURE__*/ react.createElement(tab_trap/* default */.Z, {
        focusNextCallback: function() {
            var _a;
            return dropdownRef.current && ((_a = (0,utils/* getFirstFocusable */.ft)(dropdownRef.current)) === null || _a === void 0 ? void 0 : _a.focus());
        },
        disabled: !open || !loopFocus
    }), /*#__PURE__*/ react.createElement(DropdownContainer, {
        renderWithPortal: expandToViewport && !interior,
        id: dropdownId,
        open: open
    }, /*#__PURE__*/ react.createElement(transition/* Transition */.u, {
        "in": open !== null && open !== void 0 ? open : false,
        exit: false
    }, function(state, ref) {
        return /*#__PURE__*/ react.createElement("div", {
            ref: dropdownContainerRef
        }, /*#__PURE__*/ react.createElement(tab_trap/* default */.Z, {
            focusNextCallback: function() {
                var _a;
                return triggerRef.current && ((_a = (0,utils/* getLastFocusable */.TE)(triggerRef.current)) === null || _a === void 0 ? void 0 : _a.focus());
            },
            disabled: !open || !loopFocus
        }), /*#__PURE__*/ react.createElement(TransitionContent, {
            state: state,
            transitionRef: ref,
            dropdownClasses: dropdownClasses,
            open: open,
            stretchWidth: stretchWidth,
            interior: interior,
            header: header,
            expandToViewport: expandToViewport,
            footer: footer,
            onMouseDown: onMouseDown,
            isRefresh: isRefresh,
            dropdownRef: dropdownRef,
            verticalContainerRef: verticalContainerRef,
            position: position
        }, children), /*#__PURE__*/ react.createElement(tab_trap/* default */.Z, {
            focusNextCallback: function() {
                var _a;
                return triggerRef.current && ((_a = (0,utils/* getFirstFocusable */.ft)(triggerRef.current)) === null || _a === void 0 ? void 0 : _a.focus());
            },
            disabled: !open || !loopFocus
        }));
    })));
};
var isInteriorPosition = function(position) {
    return position.bottom !== undefined;
};
/* harmony default export */ var dropdown = (Dropdown); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 5500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TE": function() { return /* binding */ getLastFocusable; },
/* harmony export */   "ft": function() { return /* binding */ getFirstFocusable; }
/* harmony export */ });
/* unused harmony export getFocusables */
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Credits to
// https://github.com/theKashey/focus-lock/blob/33f8b4bd9675d2605b15e2e4015b77fe35fbd6d0/src/utils/tabbables.ts
var tabbables = [
    "button:enabled",
    "select:enabled",
    "textarea:enabled",
    "input:enabled",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[tabindex]",
    "[contenteditable]",
    "[autofocus]"
].join(",");
function getFocusables(container) {
    return Array.prototype.slice.call(container.querySelectorAll(tabbables)).filter(function(element) {
        return element.tabIndex !== -1;
    });
}
function getFirstFocusable(container) {
    var _a;
    var focusables = getFocusables(container);
    return (_a = focusables[0]) !== null && _a !== void 0 ? _a : null;
}
function getLastFocusable(container) {
    var _a;
    var focusables = getFocusables(container);
    return (_a = focusables[focusables.length - 1]) !== null && _a !== void 0 ? _a : null;
} //# sourceMappingURL=utils.js.map


/***/ }),

/***/ 7906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ options_list; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-merge-refs/index.js
var use_merge_refs = __webpack_require__(5912);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/events/index.js
var events = __webpack_require__(6322);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/dom.js
var dom = __webpack_require__(5839);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/options-list/styles.scoped.css
var styles_scoped = __webpack_require__(705);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/options-list/styles.css.js

/* harmony default export */ var styles_css = ({
    "options-list": "awsui_options-list_19gcf_fc5oi_93",
    "decrease-top-margin": "awsui_decrease-top-margin_19gcf_fc5oi_113"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/options-list/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0







var BOTTOM_TRIGGER_OFFSET = 80;
var getItemIndex = function(containerRef, event) {
    var target = (0,dom/* findUpUntil */.jX)(event.target, function(element) {
        return element === containerRef.current || !!element.dataset.mouseTarget;
    });
    var mouseTarget = target === null || target === void 0 ? void 0 : target.dataset.mouseTarget;
    return mouseTarget ? parseInt(mouseTarget) : -1;
};
var OptionsList = function(_a, ref) {
    var _b;
    var open = _a.open, children = _a.children, _c = _a.nativeAttributes, nativeAttributes = _c === void 0 ? {} : _c, onKeyDown = _a.onKeyDown, onBlur = _a.onBlur, onFocus = _a.onFocus, onLoadMore = _a.onLoadMore, onMouseUp = _a.onMouseUp, onMouseMove = _a.onMouseMove, _d = _a.position, position = _d === void 0 ? "relative" : _d, _e = _a.role, role = _e === void 0 ? "listbox" : _e, _f = _a.decreaseTopMargin, decreaseTopMargin = _f === void 0 ? false : _f, ariaLabelledby = _a.ariaLabelledby, restProps = (0,tslib_es6/* __rest */._T)(_a, [
        "open",
        "children",
        "nativeAttributes",
        "onKeyDown",
        "onBlur",
        "onFocus",
        "onLoadMore",
        "onMouseUp",
        "onMouseMove",
        "position",
        "role",
        "decreaseTopMargin",
        "ariaLabelledby"
    ]);
    var baseProps = (0,base_component/* getBaseProps */.j)(restProps);
    var menuRef = (0,react.useRef)(null);
    var handleScroll = function() {
        var scrollContainer = menuRef === null || menuRef === void 0 ? void 0 : menuRef.current;
        if (scrollContainer) {
            var bottomEdgePosition = scrollContainer.scrollTop + scrollContainer.clientHeight;
            var remainingScrollHeight = scrollContainer.scrollHeight - bottomEdgePosition;
            if (remainingScrollHeight < BOTTOM_TRIGGER_OFFSET) {
                (0,events/* fireNonCancelableEvent */.B4)(onLoadMore);
            }
        }
    };
    (0,react.useEffect)(function() {
        if (!open) {
            return;
        }
        handleScroll();
    });
    var className = (0,clsx_m/* default */.Z)(styles_css["options-list"], (_b = {}, _b[styles_css["decrease-top-margin"]] = decreaseTopMargin, _b));
    var mergedRef = (0,use_merge_refs/* useMergeRefs */.q)(ref, menuRef);
    return /*#__PURE__*/ react.createElement("ul", (0,tslib_es6/* __assign */.pi)({}, baseProps, nativeAttributes, {
        className: className,
        ref: mergedRef,
        style: {
            position: position
        },
        role: role,
        onScroll: handleScroll,
        onKeyDown: function(event) {
            return onKeyDown && (0,events/* fireKeyboardEvent */.nm)(onKeyDown, event);
        },
        onMouseMove: function(event) {
            return onMouseMove === null || onMouseMove === void 0 ? void 0 : onMouseMove(getItemIndex(menuRef, event));
        },
        onMouseUp: function(event) {
            return onMouseUp === null || onMouseUp === void 0 ? void 0 : onMouseUp(getItemIndex(menuRef, event));
        },
        onBlur: function(event) {
            return (0,events/* fireNonCancelableEvent */.B4)(onBlur, {
                relatedTarget: event.relatedTarget
            });
        },
        onFocus: function() {
            return (0,events/* fireNonCancelableEvent */.B4)(onFocus);
        },
        tabIndex: -1,
        "aria-labelledby": ariaLabelledby
    }), open && children);
};
/* harmony default export */ var options_list = (/*#__PURE__*/react.forwardRef(OptionsList)); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 9190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useOpenState; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var useOpenState = function(_a) {
    var onOpen = _a.onOpen, onClose = _a.onClose;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isOpen = _b[0], setIsOpen = _b[1];
    var openDropdown = function() {
        if (!isOpen) {
            setIsOpen(true);
            onOpen === null || onOpen === void 0 ? void 0 : onOpen();
        }
    };
    var closeDropdown = function() {
        if (isOpen) {
            setIsOpen(false);
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
    };
    var toggleDropdown = function() {
        if (isOpen) {
            closeDropdown();
        } else {
            openDropdown();
        }
    };
    return {
        isOpen: isOpen,
        openDropdown: openDropdown,
        closeDropdown: closeDropdown,
        toggleDropdown: toggleDropdown
    };
}; //# sourceMappingURL=use-open-state.js.map


/***/ }),

/***/ 1712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Portal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3935);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


/**
 * A safe react portal component that renders to a provided node.
 * If a node isn't provided, it creates one under document.body.
 */ function Portal(_a) {
    var container = _a.container, children = _a.children;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(container !== null && container !== void 0 ? container : null), activeContainer = _b[0], setActiveContainer = _b[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function() {
        if (container) {
            setActiveContainer(container);
            return;
        }
        var newContainer = document.createElement("div");
        document.body.appendChild(newContainer);
        setActiveContainer(newContainer);
        return function() {
            document.body.removeChild(newContainer);
            setActiveContainer(null);
        };
    }, [
        container
    ]);
    return activeContainer && /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal)(children, activeContainer);
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 1304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ScreenreaderOnly; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/screenreader-only/styles.scoped.css
var styles_scoped = __webpack_require__(1760);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/screenreader-only/styles.css.js

/* harmony default export */ var styles_css = ({
    "root": "awsui_root_xttbq_1yl3y_93"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/screenreader-only/index.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




/**
 * Makes content now shown on a screen but still announced by screen-reader users.
 * The component is suitable when the aria-label cannot be used, e.g. to avoid elemnts being announced as "blank".
 *
 * To exclude screenreader-only content use `:not(.${screenreaderOnlyStyles.root})` selector, for example:
 *
 * ```
 * import screenreaderOnlyStyles from '~internal/components/screenreader-only/styles.css.js'
 *
 * let visibleContent = wrapper.find(`${styles.label}`).find(`:not(.${screenreaderOnlyStyles.root})`).getElement().textContent
 *
 * let screenreaderContent = wrapper.find(`${styles.label}`).find(`.${screenreaderOnlyStyles.root}`).getElement().textContent
 * ```
 */ function ScreenreaderOnly(props) {
    return /*#__PURE__*/ react.createElement("span", (0,tslib_es6/* __assign */.pi)({}, props, {
        className: (0,clsx_m/* default */.Z)(styles_css.root, props.className)
    }));
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 8605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TabTrap; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// This component handles focus-forwarding when navigating through the calendar grid.
// When the customer focuses that component the `next` callback function is called
// with forwards the focus.
function TabTrap(_a) {
    var focusNextCallback = _a.focusNextCallback, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        tabIndex: disabled ? -1 : 0,
        onFocus: focusNextCallback
    });
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 8437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Transition; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9325);
/* harmony import */ var _hooks_use_visual_mode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(753);

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




/**
 * This component is a wrapper around the CSSTransition component.
 *
 * It provides a second parameter in its rendering function that must be
 * attached to the node that is transitioning.
 */ function Transition(_a) {
    var isIn = _a["in"], children = _a.children, _b = _a.exit, exit = _b === void 0 ? true : _b, _c = _a.onStatusChange, onStatusChange = _c === void 0 ? function() {
        return void 0;
    } : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, transitionChangeDelay = _a.transitionChangeDelay, rest = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(_a, [
        "in",
        "children",
        "exit",
        "onStatusChange",
        "disabled",
        "transitionChangeDelay"
    ]);
    var transitionRootElement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    // the initial state of the transition should be either 'exited' or 'entered' depending
    // on the `in` property, this mimicks how internally the Transition component works here:
    // https://github.com/reactjs/react-transition-group/blob/6cbd6aaedaf8e9472007640b429ddb48c6c24158/src/Transition.js#L121
    var _e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isIn ? "entered" : "exited"), transitionState = _e[0], setTransitionState = _e[1];
    var motionDisabled = (0,_hooks_use_visual_mode__WEBPACK_IMPORTED_MODULE_2__/* .useReducedMotion */ .JZ)(transitionRootElement) || disabled;
    var addTransitionEndListener = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(done) {
        var node = transitionRootElement.current;
        if (node === null) {
            return;
        }
        var listener = function(e) {
            if (e.target === node) {
                node.removeEventListener("transitionend", listener);
                node.removeEventListener("animationend", listener);
                done();
            }
        };
        node.addEventListener("transitionend", listener);
        node.addEventListener("animationend", listener);
    }, []);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_transition_group__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({
        addEndListener: addTransitionEndListener,
        timeout: motionDisabled ? 0 : undefined,
        "in": isIn,
        nodeRef: transitionRootElement,
        exit: exit,
        onEnter: function(isAppearing) {
            if (!isAppearing) {
                setTransitionState("enter");
                onStatusChange("enter");
            }
        },
        onEntering: function(isAppearing) {
            var _a;
            if (!isAppearing) {
                // This line forces the browser to recalculate the layout because we want the starting state in the 'enter' style
                // to be applied before the animation starts.
                void ((_a = transitionRootElement.current) === null || _a === void 0 ? void 0 : _a.offsetHeight);
                if (transitionChangeDelay === null || transitionChangeDelay === void 0 ? void 0 : transitionChangeDelay.entering) {
                    setTimeout(function() {
                        setTransitionState("entering");
                        onStatusChange("entering");
                    }, transitionChangeDelay === null || transitionChangeDelay === void 0 ? void 0 : transitionChangeDelay.entering);
                } else {
                    setTransitionState("entering");
                    onStatusChange("entering");
                }
            }
        },
        onEntered: function(isAppearing) {
            if (!isAppearing) {
                setTransitionState("entered");
                onStatusChange("entered");
            }
        },
        onExit: function() {
            setTransitionState("exit");
            onStatusChange("exit");
        },
        onExiting: function() {
            setTransitionState("exiting");
            onStatusChange("exiting");
        },
        onExited: function() {
            setTransitionState("exited");
            onStatusChange("exited");
        }
    }, rest), function() {
        return children(transitionState, transitionRootElement);
    });
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 1469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ VisualContext; },
/* harmony export */   "rr": function() { return /* binding */ useVisualContext; }
/* harmony export */ });
/* unused harmony export getVisualContextClassname */
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _hooks_use_mutation_observer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7431);
/* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5839);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




var useVisualContext = function(elementRef) {
    var contextMatch = /awsui-context-([\w-]+)/;
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), value = _a[0], setValue = _a[1];
    (0,_hooks_use_mutation_observer__WEBPACK_IMPORTED_MODULE_1__/* .useMutationObserver */ .I)(elementRef, function(node) {
        var contextParent = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_2__/* .findUpUntil */ .jX)(node, function(node) {
            return !!node.className.match(contextMatch);
        });
        setValue(contextParent ? contextParent.className.match(contextMatch)[1] : "");
    });
    return value;
};
/**
 * This function returns only the className string needed to apply a
 * visual context to the DOM. It is used by the default export but
 * can also be imported directly for situations where the insertion
 * of a <div> node creates style problems.
 */ function getVisualContextClassname(contextName) {
    return "awsui-context-".concat(contextName);
}
function VisualContext(_a) {
    var contextName = _a.contextName, className = _a.className, children = _a.children;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(getVisualContextClassname(contextName), className)
    }, children);
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ AppLayoutContext; },
/* harmony export */   "b": function() { return /* binding */ useAppLayoutContext; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var AppLayoutContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    stickyOffsetTop: 0,
    stickyOffsetBottom: 0
});
function useAppLayoutContext() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AppLayoutContext);
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, context);
} //# sourceMappingURL=app-layout-context.js.map


/***/ }),

/***/ 2308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ useFormFieldContext; },
/* harmony export */   "u": function() { return /* binding */ FormFieldContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var FormFieldContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
function applyDefault(fields, defaults, keys) {
    var result = {};
    keys.forEach(function(key) {
        result[key] = fields[key] === undefined ? defaults[key] : fields[key];
    });
    return result;
}
function useFormFieldContext(props) {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(FormFieldContext);
    return applyDefault(props, context, [
        "invalid",
        "controlId",
        "ariaLabelledby",
        "ariaDescribedby"
    ]);
} //# sourceMappingURL=form-field-context.js.map


/***/ }),

/***/ 206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ SplitPanelContext; }
/* harmony export */ });
/* unused harmony export useSplitPanelContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var SplitPanelContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    topOffset: 0,
    bottomOffset: 0,
    leftOffset: 0,
    rightOffset: 0,
    position: "bottom",
    size: 0,
    getMaxWidth: function() {
        return 0;
    },
    getMaxHeight: function() {
        return 0;
    },
    getHeader: function() {
        return null;
    },
    isOpen: true,
    isMobile: false,
    isForcedPosition: false,
    lastInteraction: undefined,
    splitPanelRef: undefined,
    splitPanelHeaderRef: undefined,
    onResize: function() {},
    onToggle: function() {},
    onPreferencesChange: function() {},
    reportSize: function() {}
});
function useSplitPanelContext() {
    return useContext(SplitPanelContext);
} //# sourceMappingURL=split-panel-context.js.map


/***/ }),

/***/ 1461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C6": function() { return /* binding */ THEME; },
/* harmony export */   "Jp": function() { return /* binding */ ALWAYS_VISUAL_REFRESH; },
/* harmony export */   "ll": function() { return /* binding */ PACKAGE_VERSION; }
/* harmony export */ });
var PACKAGE_VERSION = "3.0.0 (33dfd90)";
var THEME = "open-source-visual-refresh";
var ALWAYS_VISUAL_REFRESH = true;


/***/ }),

/***/ 6322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B4": function() { return /* binding */ fireNonCancelableEvent; },
/* harmony export */   "nm": function() { return /* binding */ fireKeyboardEvent; },
/* harmony export */   "p_": function() { return /* binding */ isPlainLeftClick; },
/* harmony export */   "y1": function() { return /* binding */ fireCancelableEvent; }
/* harmony export */ });
/* unused harmony export createCustomEvent */
var CustomEventStub = /** @class */ function() {
    function CustomEventStub(cancelable, detail) {
        if (cancelable === void 0) {
            cancelable = false;
        }
        if (detail === void 0) {
            detail = null;
        }
        this.cancelable = cancelable;
        this.detail = detail;
        this.defaultPrevented = false;
        this.cancelBubble = false;
    }
    CustomEventStub.prototype.preventDefault = function() {
        this.defaultPrevented = true;
    };
    CustomEventStub.prototype.stopPropagation = function() {
        this.cancelBubble = true;
    };
    return CustomEventStub;
}();
function createCustomEvent(_a) {
    var cancelable = _a.cancelable, detail = _a.detail;
    return new CustomEventStub(cancelable, detail);
}
function fireNonCancelableEvent(handler, detail) {
    if (!handler) {
        return;
    }
    var event = createCustomEvent({
        cancelable: false,
        detail: detail
    });
    handler(event);
}
function fireCancelableEvent(handler, detail, sourceEvent) {
    if (!handler) {
        return false;
    }
    var event = createCustomEvent({
        cancelable: true,
        detail: detail
    });
    handler(event);
    if (event.defaultPrevented && sourceEvent) {
        sourceEvent.preventDefault();
    }
    if (event.cancelBubble && sourceEvent) {
        sourceEvent.stopPropagation();
    }
    return event.defaultPrevented;
}
function fireKeyboardEvent(handler, reactEvent) {
    return fireCancelableEvent(handler, {
        keyCode: reactEvent.keyCode,
        key: reactEvent.key,
        ctrlKey: reactEvent.ctrlKey,
        shiftKey: reactEvent.shiftKey,
        altKey: reactEvent.altKey,
        metaKey: reactEvent.metaKey
    }, reactEvent);
}
var isMouseEvent = function(e) {
    return e.button !== undefined;
};
function isPlainLeftClick(event) {
    return event && (!isMouseEvent(event) || event.button === 0) && !event.ctrlKey && !event.altKey && !event.shiftKey && !event.metaKey;
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 8276:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var customCSSPropertiesMap = {
    offsetTop: "--awsui-offset-top-5mks97",
    offsetTopWithNotifications: "--awsui-offset-top-with-notifications-5mks97",
    contentGapLeft: "--awsui-content-gap-left-5mks97",
    contentGapRight: "--awsui-content-gap-right-5mks97",
    contentHeight: "--awsui-content-height-5mks97",
    defaultMaxContentWidth: "--awsui-default-max-content-width-5mks97",
    defaultMinContentWidth: "--awsui-default-min-content-width-5mks97",
    footerHeight: "--awsui-footer-height-5mks97",
    headerHeight: "--awsui-header-height-5mks97",
    layoutWidth: "--awsui-layout-width-5mks97",
    mainOffsetLeft: "--awsui-main-offset-left-5mks97",
    maxContentWidth: "--awsui-max-content-width-5mks97",
    minContentWidth: "--awsui-min-content-width-5mks97",
    notificationsHeight: "--awsui-notifications-height-5mks97",
    overlapHeight: "--awsui-overlap-height-5mks97",
    navigationWidth: "--awsui-navigation-width-5mks97",
    splitPanelReportedHeaderSize: "--awsui-split-panel-reported-header-size-5mks97",
    splitPanelReportedSize: "--awsui-split-panel-reported-size-5mks97",
    splitPanelHeight: "--awsui-split-panel-height-5mks97",
    splitPanelMinWidth: "--awsui-split-panel-min-width-5mks97",
    splitPanelMaxWidth: "--awsui-split-panel-max-width-5mks97",
    toolsMaxWidth: "--awsui-tools-max-width-5mks97",
    toolsWidth: "--awsui-tools-width-5mks97",
    toolsAnimationStartingOpacity: "--awsui-tools-animation-starting-opacity-5mks97",
    contentScrollMargin: "--awsui-content-scroll-margin-5mks97",
    flashbarStackDepth: "--awsui-flashbar-stack-depth-5mks97",
    flashbarStackIndex: "--awsui-flashbar-stack-index-5mks97"
};
/* harmony default export */ __webpack_exports__["Z"] = (customCSSPropertiesMap); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 8289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useContainerBreakpoints; }
/* harmony export */ });
/* harmony import */ var _use_container_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5382);
/* harmony import */ var _breakpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(739);


/**
 * Re-renders the component when the breakpoint for the component changes. Scopes the re-renders to the specific
 * breakpoints you want to break at. "default" is always included as a fallback, so ["xs"] would trigger for
 * "default" and "xs".
 *
 * @param triggers The relevant breakpoints to trigger for.
 */ function useContainerBreakpoints(triggers) {
    // triggers.join() gives us a stable value to use for the dependencies argument
    var triggersDep = triggers === null || triggers === void 0 ? void 0 : triggers.join();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0,_use_container_query__WEBPACK_IMPORTED_MODULE_0__/* .useContainerQuery */ .D)(function(rect) {
        return (0,_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .getMatchingBreakpoint */ .zm)(rect.width, triggers);
    }, [
        triggersDep
    ]);
} //# sourceMappingURL=use-container-breakpoints.js.map


/***/ }),

/***/ 5382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useContainerQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _use_resize_observer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


/**
 * Attaches resize-observer to the referenced element and keeps last observation in state.
 * The hook allows to limit the amount of re-renders to only when the observed value changes.
 *
 * Examples:
 *    // Switching display mode under a given condition (only re-renders when mode changes):
 *    const [smallMode, ref] = useContainerQuery(entry => entry.contentBoxHeight <= smallModeHeight, [smallModeHeight]);
 *
 *    // Obtain observer entity (re-renders with each observation):
 *    const [entry, ref] = useContainerQuery(entry => entry);
 *
 *    // Using prevState to avoid unnecessary re-renders:
 *    const [value, ref] = useContainerQuery((entry, prevValue) => shouldUpdate(entry) ? getValue(entry) : prevValue);
 *
 * @param mapFn Function to convert ContainerQueryEntry to a custom type S
 * @param deps Dependency list to indicate when the mapFn changes
 * @returns A tuple of observation value and a reference to be attached to the target element.
 */ function useContainerQuery(mapFn, deps) {
    if (deps === void 0) {
        deps = [];
    }
    var elementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), state = _a[0], setState = _a[1];
    // Update getElement when deps change to trigger new observation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var getElement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return elementRef.current;
    }, deps);
    (0,_use_resize_observer__WEBPACK_IMPORTED_MODULE_1__/* .useResizeObserver */ .y)(getElement, function(entry) {
        return setState(function(prevState) {
            return mapFn(entry, prevState);
        });
    });
    return [
        state,
        elementRef
    ];
} //# sourceMappingURL=use-container-query.js.map


/***/ }),

/***/ 913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useResizeObserver; }
/* harmony export */ });
/* harmony import */ var _juggle_resize_observer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8354);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _use_stable_event_handler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9728);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



/**
 * Attaches resize-observer to the referenced element.
 *
 * Examples:
 *     // With React reference
 *     const ref = useRef(null)
 *     useResizeObserver(ref, (entry) => setState(getWidth(entry)))
 *
 *     // With ID reference
 *     const getElement = useCallback(() => document.getElementById(id), [id])
 *     useResizeObserver(getElement, (entry) => setState(getWidth(entry)))
 *
 * @param elementRef React reference or memoized getter for the target element
 * @param onObserve Function to fire when observation occurs
 */ function useResizeObserver(elementRef, onObserve) {
    var stableOnObserve = (0,_use_stable_event_handler__WEBPACK_IMPORTED_MODULE_2__/* .useStableEventHandler */ .S)(onObserve);
    // This effect provides a synchronous update required to prevent flakiness when initial state and first observed state are different.
    // Can potentially conflict with React concurrent mode: https://17.reactjs.org/docs/concurrent-mode-intro.html.
    // A possible solution would be to make consumers not render any content until the first (asynchronous) observation is available.
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(function() {
        var element = typeof elementRef === "function" ? elementRef() : elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        if (element) {
            onObserve(convertResizeObserverEntry(new _juggle_resize_observer__WEBPACK_IMPORTED_MODULE_0__/* .ResizeObserverEntry */ .AL(element)));
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var element = typeof elementRef === "function" ? elementRef() : elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        if (element) {
            var connected_1 = true;
            var observer_1 = new _juggle_resize_observer__WEBPACK_IMPORTED_MODULE_0__/* .ResizeObserver */ ["do"](function(entries) {
                // Prevent observe notifications on already unmounted component.
                if (connected_1) {
                    stableOnObserve(convertResizeObserverEntry(entries[0]));
                }
            });
            observer_1.observe(element);
            return function() {
                connected_1 = false;
                observer_1.disconnect();
            };
        }
    }, [
        elementRef,
        stableOnObserve
    ]);
}
function convertResizeObserverEntry(entry) {
    return {
        target: entry.target,
        contentBoxWidth: entry.contentBoxSize[0].inlineSize,
        contentBoxHeight: entry.contentBoxSize[0].blockSize,
        borderBoxWidth: entry.borderBoxSize[0].inlineSize,
        borderBoxHeight: entry.borderBoxSize[0].blockSize,
        width: entry.contentBoxSize[0].inlineSize,
        height: entry.contentBoxSize[0].blockSize
    };
} //# sourceMappingURL=use-resize-observer.js.map


/***/ }),

/***/ 9297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useFocusVisible; }
/* harmony export */ });
/* harmony import */ var _keycode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6221);
/* harmony import */ var _use_singleton_handler__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3273);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var useFocusSingleton = (0,_use_singleton_handler__WEBPACK_IMPORTED_MODULE_0__/* .createSingletonState */ .M)({
    initialState: false,
    factory: function(setIsKeyboard) {
        var handleMousedown = function() {
            return setIsKeyboard(false);
        };
        var handleKeydown = function(event) {
            // we do not want to highlight focused element
            // when special keys are pressed
            var isSpecialKey = [
                _keycode__WEBPACK_IMPORTED_MODULE_1__/* .KeyCode.shift */ .V.shift,
                _keycode__WEBPACK_IMPORTED_MODULE_1__/* .KeyCode.alt */ .V.alt,
                _keycode__WEBPACK_IMPORTED_MODULE_1__/* .KeyCode.control */ .V.control,
                _keycode__WEBPACK_IMPORTED_MODULE_1__/* .KeyCode.meta */ .V.meta
            ].indexOf(event.keyCode) > -1;
            if (!isSpecialKey) {
                setIsKeyboard(true);
            }
        };
        document.addEventListener("mousedown", handleMousedown);
        document.addEventListener("keydown", handleKeydown);
        return function() {
            document.removeEventListener("mousedown", handleMousedown);
            document.removeEventListener("keydown", handleKeydown);
        };
    }
});
function useFocusVisible() {
    var visible = useFocusSingleton();
    return visible ? {
        "data-awsui-focus-visible": visible
    } : {};
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 9283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useForwardFocus; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function useForwardFocus(mainRef, controlRef) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(mainRef, function() {
        return {
            focus: function() {
                var _a;
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++){
                    args[_i] = arguments[_i];
                }
                (_a = controlRef.current) === null || _a === void 0 ? void 0 : _a.focus.apply(_a, args);
            }
        };
    }, [
        controlRef
    ]);
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 4656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useBaseComponent; }
});

// UNUSED EXPORTS: COMPONENT_METADATA_KEY

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/environment.js
var environment = __webpack_require__(1461);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/metrics.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var oneTimeMetrics = {};
var buildMetricHash = function(_a) {
    var source = _a.source, action = _a.action;
    return [
        "src".concat(source),
        "action".concat(action)
    ].join("_");
};
var getMajorVersion = function(versionString) {
    var majorVersionMatch = versionString.match(/^(\d+\.\d+)/);
    return majorVersionMatch ? majorVersionMatch[1] : "";
};
var formatMajorVersionForMetricDetail = function(version) {
    return version.replace(/\s/g, "");
};
var formatVersionForMetricName = function(theme, version) {
    return "".concat(theme.charAt(0)).concat(getMajorVersion(version).replace(".", ""));
};
var buildMetricDetail = function(_a) {
    var source = _a.source, action = _a.action, version = _a.version;
    var metricOrigin = typeof AWSUI_METRIC_ORIGIN !== "undefined" ? AWSUI_METRIC_ORIGIN : "main";
    var detailObject = {
        o: metricOrigin,
        s: source,
        t: environment/* THEME */.C6,
        a: action,
        f: framework,
        v: formatMajorVersionForMetricDetail(version)
    };
    return JSON.stringify(detailObject);
};
var buildMetricName = function(_a) {
    var source = _a.source, version = _a.version;
    return [
        "awsui",
        source,
        "".concat(formatVersionForMetricName(environment/* THEME */.C6, version))
    ].join("_");
};
var findPanorama = function(currentWindow) {
    try {
        if (typeof (currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.panorama) === "function") {
            return currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.panorama;
        }
        if (!currentWindow || currentWindow.parent === currentWindow) {
            // When the window has no more parents, it references itself
            return undefined;
        }
        return findPanorama(currentWindow.parent);
    } catch (ex) {
        // Most likely a cross-origin access error
        return undefined;
    }
};
var findAWSC = function(currentWindow) {
    try {
        if (typeof (currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.AWSC) === "object") {
            return currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.AWSC;
        }
        if (!currentWindow || currentWindow.parent === currentWindow) {
            // When the window has no more parents, it references itself
            return undefined;
        }
        return findAWSC(currentWindow.parent);
    } catch (ex) {
        // Most likely a cross-origin access error
        return undefined;
    }
};
// react is the default framework we're logging, for angular we need to set it explicitly
var framework = "react";
function setFramework(fwk) {
    framework = fwk;
}
var Metrics = {
    initMetrics: function(fwk) {
        setFramework(fwk);
    },
    /**
     * Calls Console Platform's client logging JS API with provided metric name, value, and detail.
     * Does nothing if Console Platform client logging JS is not present in page.
     */ sendMetric: function(metricName, value, detail) {
        if (!metricName || !/^[a-zA-Z0-9_-]{1,32}$/.test(metricName)) {
            console.error("Invalid metric name: ".concat(metricName));
            return;
        }
        if (detail && detail.length > 200) {
            console.error("Detail for metric ".concat(metricName, " is too long: ").concat(detail));
            return;
        }
        var AWSC = findAWSC(window);
        if (typeof AWSC === "object" && typeof AWSC.Clog === "object" && typeof AWSC.Clog.log === "function") {
            AWSC.Clog.log(metricName, value, detail);
        }
    },
    /**
     * Calls Console Platform's client v2 logging JS API with provided metric name and detail.
     * Does nothing if Console Platform client logging JS is not present in page.
     */ sendPanoramaMetric: function(metricName, metric) {
        if (!metricName || !/^[a-zA-Z0-9_-]{1,32}$/.test(metricName)) {
            console.error("Invalid metric name: ".concat(metricName));
            return;
        }
        if (typeof metric.eventDetail === "object") {
            metric.eventDetail = JSON.stringify(metric.eventDetail);
        }
        if (metric.eventDetail && metric.eventDetail.length > 200) {
            console.error("Detail for metric ".concat(metricName, " is too long: ").concat(metric.eventDetail));
            return;
        }
        if (typeof metric.eventValue === "object") {
            metric.eventValue = JSON.stringify(metric.eventValue);
        }
        var panorama = findPanorama(window);
        if (typeof panorama === "function") {
            panorama(metricName, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, metric), {
                timestamp: Date.now()
            }));
        }
    },
    sendMetricObject: function(metric, value) {
        this.sendMetric(buildMetricName(metric), value, buildMetricDetail(metric));
    },
    sendMetricObjectOnce: function(metric, value) {
        var metricHash = buildMetricHash(metric);
        if (!oneTimeMetrics[metricHash]) {
            this.sendMetricObject(metric, value);
            oneTimeMetrics[metricHash] = true;
        }
    },
    /*
     * Calls Console Platform's client logging only the first time the provided metricName is used.
     * Subsequent calls with the same metricName are ignored.
     */ sendMetricOnce: function(metricName, value, detail) {
        if (!oneTimeMetrics[metricName]) {
            this.sendMetric(metricName, value, detail);
            oneTimeMetrics[metricName] = true;
        }
    },
    /*
     * Reports a metric value 1 to Console Platform's client logging service to indicate that the
     * component was loaded. The component load event will only be reported as used to client logging
     * service once per page view.
     */ logComponentLoaded: function() {
        this.sendMetricObjectOnce({
            source: "components",
            action: "loaded",
            version: environment/* PACKAGE_VERSION */.ll
        }, 1);
    },
    /*
     * Reports a metric value 1 to Console Platform's client logging service to indicate that the
     * component was used in the page.  A component will only be reported as used to client logging
     * service once per page view.
     */ logComponentUsed: function(componentName) {
        this.sendMetricObjectOnce({
            source: componentName,
            action: "used",
            version: environment/* PACKAGE_VERSION */.ll
        }, 1);
    }
};
var MetricsTestHelper = {
    resetOneTimeMetricsCache: function() {
        for(var prop in oneTimeMetrics){
            delete oneTimeMetrics[prop];
        }
    },
    formatMajorVersionForMetricDetail: formatMajorVersionForMetricDetail,
    formatVersionForMetricName: formatVersionForMetricName
}; //# sourceMappingURL=metrics.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-telemetry/index.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function useTelemetry(componentName) {
    (0,react.useEffect)(function() {
        if (true) {
            Metrics.sendMetricOnce("awsui-viewport-width", window.innerWidth || 0);
            Metrics.sendMetricOnce("awsui-viewport-height", window.innerHeight || 0);
        }
        Metrics.logComponentLoaded();
        Metrics.logComponentUsed(componentName.toLowerCase());
    // Components do not change the name dynamically. Explicit empty array to prevent accidential double metrics
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
} //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-base-component/index.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var COMPONENT_METADATA_KEY = "__awsuiMetadata__";
/**
 * This hook is used for components which are exported to customers. The returned __internalRootRef needs to be
 * attached to the (internal) component's root DOM node. The hook takes care of attaching the metadata to this
 * root DOM node and emits the telemetry for this component.
 */ function useBaseComponent(componentName) {
    var elementRef = (0,react.useRef)(null);
    useTelemetry(componentName);
    useComponentMetadata(componentName, elementRef);
    return {
        __internalRootRef: elementRef
    };
}
function useComponentMetadata(componentName, elementRef) {
    (0,react.useEffect)(function() {
        if (elementRef.current && !Object.prototype.hasOwnProperty.call(elementRef.current, COMPONENT_METADATA_KEY)) {
            var node = elementRef.current;
            var metadata = {
                name: componentName,
                version: environment/* PACKAGE_VERSION */.ll
            };
            Object.freeze(metadata);
            Object.defineProperty(node, COMPONENT_METADATA_KEY, {
                value: metadata,
                writable: false
            });
        }
    // Some component refs change dynamically. E.g. The Modal component where
    // the content gets rendered conditionally inside a Portal.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        elementRef.current
    ]);
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 9276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useControllable; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _is_development__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5856);
/* harmony import */ var _logging__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3742);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



/**
 * This hook allows you to make a component that can be used both in controlled mode and uncontrolled mode.
 * Pass in your component's props, and then implement your component as if it was only controlled.
 * When calling onChange callbacks (or the equivalent for your property), you need to call both the callback returned by this function
 * as well as the callback provided in your component's props.
 *
 * A component determines its mode (either controlled or uncontrolled) on the first render and keeps it for its lifetime. The mode cannot
 * be switched later.
 *
 *
 * Example usage:
 * ```jsx
 * const [checked, setChecked] = useControllable(
 *     props,
 *     props.defaultEnabled ?? false,
 *     {
 *        componentName: 'MyCheckboxComponent',
 *        controlledProp: 'enabled',
 *        changeHandler: 'onCheckedStatusChange'
 *     }
 * )
 *
 * return
 *  <input
 *   type="checkbox"
 *   checked={checked}
 *   onChange={event => {
 *    setChecked(event.target.checked);
 *    fireNonCancelableEvent(props.onCheckedStatusChange, { checked: event.target.checked })
 *   }} />
 * ```
 *
 * @param controlledValue value for the controlled mode
 * @param handler update handler for controlled mode
 * @param defaultValue initial value for uncontrolled mode
 * @param description property metadata
 */ function useControllable(controlledValue, handler, defaultValue, _a) {
    var componentName = _a.componentName, changeHandler = _a.changeHandler, controlledProp = _a.controlledProp;
    // The decision whether a component is controlled or uncontrolled is made on its first render and cannot be changed afterwards.
    var isControlled = react__WEBPACK_IMPORTED_MODULE_0__.useState(controlledValue !== undefined)[0];
    if (_is_development__WEBPACK_IMPORTED_MODULE_1__/* .isDevelopment */ .y) {
        // Print a warning if the component switches between controlled and uncontrolled mode.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
            if (isControlled && handler === undefined) {
                (0,_logging__WEBPACK_IMPORTED_MODULE_2__/* .warnOnce */ .O)(componentName, "You provided a `".concat(controlledProp, "` prop without an `").concat(changeHandler, "` handler. This will render a non-interactive component."));
            }
        }, [
            handler,
            isControlled,
            componentName,
            changeHandler,
            controlledProp
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
            var isControlledNow = controlledValue !== undefined;
            if (isControlled !== isControlledNow) {
                var initialMode = isControlled ? "controlled" : "uncontrolled";
                var modeNow = isControlledNow ? "controlled" : "uncontrolled";
                (0,_logging__WEBPACK_IMPORTED_MODULE_2__/* .warnOnce */ .O)(componentName, "A component tried to change ".concat(initialMode, " '").concat(controlledProp, "' property to be ").concat(modeNow, ". ") + "This is not supported. Properties should not switch from ".concat(initialMode, " to ").concat(modeNow, " (or vice versa). ") + "Decide between using a controlled or uncontrolled mode for the lifetime of the component. " + "More info: https://fb.me/react-controlled-components");
            }
        }, [
            isControlled,
            controlledProp,
            componentName,
            controlledValue
        ]);
    }
    // This is the value that is used if the component is uncontrolled.
    var _b = react__WEBPACK_IMPORTED_MODULE_0__.useState(defaultValue), valueState = _b[0], setValue = _b[1];
    var _c = react__WEBPACK_IMPORTED_MODULE_0__.useState(false), valueHasBeenSet = _c[0], setValueHasBeenSet = _c[1];
    // We track changes to the defaultValue
    var currentUncontrolledValue = valueHasBeenSet ? valueState : defaultValue;
    var setUncontrolledValue = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function(newValue) {
        setValue(newValue);
        setValueHasBeenSet(true);
    }, [
        setValue,
        setValueHasBeenSet
    ]);
    if (isControlled) {
        return [
            controlledValue,
            defaultCallback
        ];
    } else {
        return [
            currentUncontrolledValue,
            setUncontrolledValue
        ];
    }
}
function defaultCallback() {
    return void 0;
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 7933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ useDebounceCallback; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/debounce.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// default delay for components defined by UX
var DEBOUNCE_DEFAULT_DELAY = 200;
// instead of using this function directly, consider using useDebounceCallback hook
function debounce(func, delay) {
    if (delay === void 0) {
        delay = DEBOUNCE_DEFAULT_DELAY;
    }
    var timeout;
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++){
            args[_i] = arguments[_i];
        }
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(function() {
            timeout = null;
            func.apply(void 0, args);
        }, delay);
    };
} //# sourceMappingURL=debounce.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-debounce-callback/index.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function useDebounceCallback(callback, delay) {
    var callbackRef = (0,react.useRef)();
    callbackRef.current = callback;
    // ESLint rule requires an inline function which we cannot provide here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0,react.useCallback)(debounce(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++){
            args[_i] = arguments[_i];
        }
        if (callbackRef.current) {
            callbackRef.current.apply(callbackRef, args);
        }
    }, delay), []);
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 9876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ useEffectOnUpdate; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// useEffect, which skips the initial render
function useEffectOnUpdate(callback, deps) {
    var isFirstRender = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isFirstRender.current) {
            isFirstRender.current = false;
        } else {
            return callback();
        }
    // This is a useEffect extension, will be validated at the call site
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
} //# sourceMappingURL=use-effect-on-update.js.map


/***/ }),

/***/ 5912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useMergeRefs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * useMergeRefs merges multiple refs into single ref callback.
 *
 * For example
 *  const mergedRef = useMergeRefs(ref1, ref2, ref3)
 *  <div ref={refs}>...</div>
 */ function useMergeRefs() {
    var refs = [];
    for(var _i = 0; _i < arguments.length; _i++){
        refs[_i] = arguments[_i];
    }
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (refs.every(function(ref) {
            return ref === null || ref === undefined;
        })) {
            return null;
        }
        return function(value) {
            refs.forEach(function(ref) {
                if (typeof ref === "function") {
                    ref(value);
                } else if (ref !== null && ref !== undefined) {
                    ref.current = value;
                }
            });
        };
    // ESLint expects an array literal which we can not provide here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 6670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useMobile; }
/* harmony export */ });
/* harmony import */ var _breakpoints__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(739);
/* harmony import */ var _use_singleton_handler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3273);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function getIsMobile() {
    if (false) {}
    if (window.matchMedia) {
        /**
         * Some browsers include the scrollbar width in their media query calculations, but
         * some browsers don't. Thus we can't use `window.innerWidth` or
         * `document.documentElement.clientWidth` to get a very accurate result (since we
         * wouldn't know which one of them to use).
         * Instead, we use the media query here in JS too.
         */ return window.matchMedia("(max-width: ".concat(_breakpoints__WEBPACK_IMPORTED_MODULE_0__/* .mobileBreakpoint */ .Il, "px)")).matches;
    }
    return (0,_breakpoints__WEBPACK_IMPORTED_MODULE_0__/* .getMatchingBreakpoint */ .zm)(window.innerWidth, [
        "xs"
    ]) !== "xs";
}
var useMobile = (0,_use_singleton_handler__WEBPACK_IMPORTED_MODULE_1__/* .createSingletonState */ .M)({
    initialState: function() {
        return getIsMobile();
    },
    factory: function(handler) {
        var listener = function() {
            return handler(getIsMobile());
        };
        window.addEventListener("resize", listener);
        return function() {
            window.removeEventListener("resize", listener);
        };
    }
}); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 7431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useMutationObserver; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _use_stable_event_handler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9728);
/* harmony import */ var _use_singleton_handler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3273);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var useMutationSingleton = (0,_use_singleton_handler__WEBPACK_IMPORTED_MODULE_1__/* .createSingletonHandler */ ._)(function(handler) {
    var observer = new MutationObserver(function() {
        return handler();
    });
    observer.observe(document.body, {
        attributes: true,
        subtree: true
    });
    return function() {
        return observer.disconnect();
    };
});
/**
 * Fires onChange with the given target element as an argument every time any DOM node attribute changes.
 *
 * @deprecated The hook has performance implications. Consider alternatives.
 */ function useMutationObserver(elementRef, onChange) {
    var handler = (0,_use_stable_event_handler__WEBPACK_IMPORTED_MODULE_2__/* .useStableEventHandler */ .S)(function() {
        if (elementRef.current) {
            onChange(elementRef.current);
        }
    });
    useMutationSingleton(handler);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        handler();
    }, [
        handler
    ]);
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 7656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ usePortalModeClasses; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6010);
/* harmony import */ var _components_visual_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1469);
/* harmony import */ var _use_visual_mode__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(753);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



function usePortalModeClasses(ref) {
    var _a;
    var colorMode = (0,_use_visual_mode__WEBPACK_IMPORTED_MODULE_0__/* .useCurrentMode */ .DY)(ref);
    var densityMode = (0,_use_visual_mode__WEBPACK_IMPORTED_MODULE_0__/* .useDensityMode */ .v6)(ref);
    var context = (0,_components_visual_context__WEBPACK_IMPORTED_MODULE_1__/* .useVisualContext */ .rr)(ref);
    var visualRefresh = (0,_use_visual_mode__WEBPACK_IMPORTED_MODULE_0__/* .useVisualRefresh */ .LV)();
    return (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_a = {
        "awsui-polaris-dark-mode awsui-dark-mode": colorMode === "dark",
        "awsui-polaris-compact-mode awsui-compact-mode": densityMode === "compact",
        "awsui-visual-refresh": visualRefresh
    }, _a["awsui-context-".concat(context)] = context, _a));
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 3273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ createSingletonState; },
/* harmony export */   "_": function() { return /* binding */ createSingletonHandler; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3935);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function createSingletonHandler(factory) {
    var listeners = [];
    var callback = function(value) {
        (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.unstable_batchedUpdates)(function() {
            for(var _i = 0, listeners_1 = listeners; _i < listeners_1.length; _i++){
                var listener = listeners_1[_i];
                listener(value);
            }
        });
    };
    var cleanup;
    return function useSingleton(listener) {
        (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
            if (listeners.length === 0) {
                cleanup = factory(callback);
            }
            listeners.push(listener);
            return function() {
                listeners.splice(listeners.indexOf(listener), 1);
                if (listeners.length === 0) {
                    cleanup();
                    cleanup = undefined;
                }
            };
        // register handlers only on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
    };
}
function createSingletonState(_a) {
    var factory = _a.factory, initialState = _a.initialState;
    var useSingleton = createSingletonHandler(factory);
    var value = initialState;
    return function useSingletonState() {
        var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), state = _a[0], setState = _a[1];
        useSingleton(function(newValue) {
            value = newValue;
            setState(newValue);
        });
        return state;
    };
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 9728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useStableEventHandler; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * A callback that stays stable between renders even as the dependencies change.
 * Not a recommended React pattern, so it should be used sparingly and only if
 * the callback is an event handler (i.e. not used during rendering) and causing
 * clear performance issues.
 *
 * @see https://reactjs.org/docs/hooks-faq.html#how-to-read-an-often-changing-value-from-usecallback
 */ function useStableEventHandler(fn) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        ref.current = fn;
    });
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++){
            args[_i] = arguments[_i];
        }
        return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.apply(undefined, args);
    }, []);
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 6081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useUniqueId; },
/* harmony export */   "l": function() { return /* binding */ generateUniqueId; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var counter = 0;
function generateUniqueId(prefix) {
    return "".concat(prefix ? prefix : "").concat(counter++, "-").concat(Date.now(), "-").concat(Math.round(Math.random() * 10000));
}
function useUniqueId(prefix) {
    var idRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    if (!idRef.current) {
        idRef.current = generateUniqueId(prefix);
    }
    return idRef.current;
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DY": function() { return /* binding */ useCurrentMode; },
/* harmony export */   "JZ": function() { return /* binding */ useReducedMotion; },
/* harmony export */   "LV": function() { return /* binding */ useVisualRefresh; },
/* harmony export */   "v6": function() { return /* binding */ useDensityMode; }
/* harmony export */ });
/* unused harmony exports clearVisualRefreshState, useVisualRefreshDynamic */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1461);
/* harmony import */ var _motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6279);
/* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5839);
/* harmony import */ var _use_mutation_observer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7431);
/* harmony import */ var _is_development__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5856);
/* harmony import */ var _logging__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3742);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0







function useCurrentMode(elementRef) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("light"), value = _a[0], setValue = _a[1];
    (0,_use_mutation_observer__WEBPACK_IMPORTED_MODULE_1__/* .useMutationObserver */ .I)(elementRef, function(node) {
        var darkModeParent = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_2__/* .findUpUntil */ .jX)(node, function(node) {
            return node.classList.contains("awsui-polaris-dark-mode") || node.classList.contains("awsui-dark-mode");
        });
        setValue(darkModeParent ? "dark" : "light");
    });
    return value;
}
function useDensityMode(elementRef) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("comfortable"), value = _a[0], setValue = _a[1];
    (0,_use_mutation_observer__WEBPACK_IMPORTED_MODULE_1__/* .useMutationObserver */ .I)(elementRef, function(node) {
        var compactModeParent = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_2__/* .findUpUntil */ .jX)(node, function(node) {
            return node.classList.contains("awsui-polaris-compact-mode") || node.classList.contains("awsui-compact-mode");
        });
        setValue(compactModeParent ? "compact" : "comfortable");
    });
    return value;
}
var useVisualRefresh = _environment__WEBPACK_IMPORTED_MODULE_3__/* .ALWAYS_VISUAL_REFRESH */ .Jp ? function() {
    return true;
} : useVisualRefreshDynamic;
// We expect VR is to be set only once and before the application is rendered.
var visualRefreshState = undefined;
// for testing
function clearVisualRefreshState() {
    visualRefreshState = undefined;
}
function detectVisualRefresh() {
    return typeof document !== "undefined" && !!document.querySelector(".awsui-visual-refresh");
}
function useVisualRefreshDynamic() {
    if (visualRefreshState === undefined) {
        visualRefreshState = detectVisualRefresh();
    }
    if (_is_development__WEBPACK_IMPORTED_MODULE_4__/* .isDevelopment */ .y) {
        var newVisualRefreshState = detectVisualRefresh();
        if (newVisualRefreshState !== visualRefreshState) {
            (0,_logging__WEBPACK_IMPORTED_MODULE_5__/* .warnOnce */ .O)("Visual Refresh", "Dynamic visual refresh change detected. This is not supported. " + "Make sure `awsui-visual-refresh` is attached to the `<body>` element before initial React render");
        }
    }
    return visualRefreshState;
}
function useReducedMotion(elementRef) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), value = _a[0], setValue = _a[1];
    (0,_use_mutation_observer__WEBPACK_IMPORTED_MODULE_1__/* .useMutationObserver */ .I)(elementRef, function(node) {
        setValue((0,_motion__WEBPACK_IMPORTED_MODULE_6__/* .isMotionDisabled */ .g)(node));
    });
    return value;
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 5856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ isDevelopment; }
/* harmony export */ });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Whether the bundle is a development bundle.
 * Only use this in an if condition and on its own! This will help bundlers find
 * and remove the conditional statement for production bundles.
 */ var isDevelopment = "production" !== "production"; //# sourceMappingURL=is-development.js.map


/***/ }),

/***/ 6221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ KeyCode; }
/* harmony export */ });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// When updating the list of key codes, don't forget
// to modify corresponding list in test-utils
// to avoid failing unit tests
var KeyCode;
(function(KeyCode) {
    KeyCode[KeyCode["pageUp"] = 33] = "pageUp";
    KeyCode[KeyCode["pageDown"] = 34] = "pageDown";
    KeyCode[KeyCode["end"] = 35] = "end";
    KeyCode[KeyCode["home"] = 36] = "home";
    KeyCode[KeyCode["backspace"] = 8] = "backspace";
    KeyCode[KeyCode["space"] = 32] = "space";
    KeyCode[KeyCode["down"] = 40] = "down";
    KeyCode[KeyCode["left"] = 37] = "left";
    KeyCode[KeyCode["right"] = 39] = "right";
    KeyCode[KeyCode["up"] = 38] = "up";
    KeyCode[KeyCode["escape"] = 27] = "escape";
    KeyCode[KeyCode["enter"] = 13] = "enter";
    KeyCode[KeyCode["tab"] = 9] = "tab";
    KeyCode[KeyCode["shift"] = 16] = "shift";
    KeyCode[KeyCode["control"] = 17] = "control";
    KeyCode[KeyCode["alt"] = 18] = "alt";
    KeyCode[KeyCode["meta"] = 91] = "meta";
})(KeyCode || (KeyCode = {})); //# sourceMappingURL=keycode.js.map


/***/ }),

/***/ 3742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ warnOnce; }
/* harmony export */ });
/* harmony import */ var _is_development__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5856);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var messageCache = {};
function warnOnce(component, message) {
    if (_is_development__WEBPACK_IMPORTED_MODULE_0__/* .isDevelopment */ .y) {
        var warning = "[AwsUi] [".concat(component, "] ").concat(message);
        if (!messageCache[warning]) {
            messageCache[warning] = true;
            console.warn(warning);
        }
    }
} //# sourceMappingURL=logging.js.map


/***/ }),

/***/ 6279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ isMotionDisabled; }
/* harmony export */ });
/* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5839);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var isMotionDisabled = function(element) {
    var _a;
    return !!(0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* .findUpUntil */ .jX)(element, function(node) {
        return node.classList.contains("awsui-motion-disabled");
    }) || window.matchMedia && ((_a = window.matchMedia("(prefers-reduced-motion: reduce)")) === null || _a === void 0 ? void 0 : _a.matches);
}; //# sourceMappingURL=motion.js.map


/***/ }),

/***/ 1651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ applyDisplayName; }
/* harmony export */ });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function applyDisplayName(component, displayName) {
    component.displayName = displayName;
} //# sourceMappingURL=apply-display-name.js.map


/***/ }),

/***/ 4014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ calculateOnce; }
/* harmony export */ });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function calculateOnce(callback) {
    var result = undefined;
    return function() {
        if (result === undefined) {
            result = callback();
        }
        return result;
    };
} //# sourceMappingURL=calculate-once.js.map


/***/ }),

/***/ 2903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ checkSafeUrl; }
/* harmony export */ });
/* harmony import */ var _logging__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3742);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var allowedJavascriptUrls = [
    "javascript:void(0)",
    "javascript:void(0);",
    "javascript:;"
];
function checkSafeUrl(component, url) {
    if (!url) {
        return;
    }
    if (allowedJavascriptUrls.indexOf(url.toLowerCase()) !== -1) {
        return;
    }
    var parsedUrl;
    try {
        parsedUrl = new URL(url);
    } catch (e) {
        // If the URL cannot be parsed by the browser, it likely does not pose a security risk.
        return;
    }
    if (parsedUrl.protocol === "javascript:") {
        (0,_logging__WEBPACK_IMPORTED_MODULE_0__/* .warnOnce */ .O)(component, 'A javascript: URL was blocked as a security precaution. The URL was "'.concat(url, '".'));
        // This mirrors the error message that React will use:
        // https://github.com/facebook/react/blob/a724a3b578dce77d427bef313102a4d0e978d9b4/packages/react-dom/src/shared/sanitizeURL.js#L30
        throw new Error("A javascript: URL was blocked as a security precaution.");
    }
    return;
} //# sourceMappingURL=check-safe-url.js.map


/***/ }),

/***/ 5839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bE": function() { return /* binding */ nodeContains; },
/* harmony export */   "eN": function() { return /* binding */ supportsStickyPosition; },
/* harmony export */   "gQ": function() { return /* binding */ getContainingBlock; },
/* harmony export */   "jX": function() { return /* binding */ findUpUntil; }
/* harmony export */ });
/* unused harmony exports parseCssVariable, containsOrEqual */
/* harmony import */ var balanced_match__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5623);
/* harmony import */ var balanced_match__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(balanced_match__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _calculate_once__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4014);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function findUpUntil(node, callback) {
    var current = node;
    while(current && !callback(current)){
        current = current.parentElement;
        // If a component is used within an svg (i.e. as foreignObject), then it will
        // have some ancestor nodes that are SVGElement. We want to skip those,
        // as they have very different properties to HTLMElements.
        while(current && !(current instanceof HTMLElement)){
            current = current.parentElement;
        }
    }
    return current;
}
/**
 * Returns whether the browser supports CSS position sticky.
 * In our list of supported browsers, only returns false for IE11.
 */ function supportsStickyPosition() {
    var _a, _b, _c;
    if (false) {}
    return (_c = (_b = (_a = window.CSS) === null || _a === void 0 ? void 0 : _a.supports) === null || _b === void 0 ? void 0 : _b.call(_a, "position", "sticky")) !== null && _c !== void 0 ? _c : false;
}
/**
 * Returns whether `position: fixed` can be relative to transformed parents or
 * whether it's always relative to the viewport. Returns `true` on all browsers
 * except IE.
 */ var supportsContainingBlockPositioning = (0,_calculate_once__WEBPACK_IMPORTED_MODULE_1__/* .calculateOnce */ .k)(function() {
    var parent = document.createElement("div");
    parent.style.transform = "translateY(5px)";
    document.body.appendChild(parent);
    var child = document.createElement("div");
    child.style.position = "fixed";
    child.style.top = "0";
    parent.appendChild(child);
    var result = parent.getBoundingClientRect().top === child.getBoundingClientRect().top;
    document.body.removeChild(parent);
    return result;
});
/**
 * Returns an element that is used to position the given element.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block
 */ function getContainingBlock(startElement) {
    if (!startElement.parentElement) {
        return null;
    }
    return supportsContainingBlockPositioning() ? findUpUntil(startElement.parentElement, function(element) {
        var computedStyle = getComputedStyle(element);
        return !!computedStyle.transform && computedStyle.transform !== "none" || !!computedStyle.perspective && computedStyle.perspective !== "none";
    }) : null;
}
var cssVariableExpression = /--.+?\s*,\s*(.+)/;
/**
 * Parses a CSS color value that might contain CSS Custom Properties
 * and returns a value that will be understood by the browser, no matter of support level.
 * If the browser support CSS Custom Properties, the value will be return as is. Otherwise,
 * the fallback value will be extracted and returned instead.
 */ function parseCssVariable(value) {
    var _a, _b, _c;
    if ((_c = (_b = (_a = window.CSS) === null || _a === void 0 ? void 0 : _a.supports) === null || _b === void 0 ? void 0 : _b.call(_a, "color", "var(--dummy, #000)")) !== null && _c !== void 0 ? _c : false) {
        return value;
    }
    var varIndex = value.lastIndexOf("var(");
    if (varIndex === -1) {
        return value;
    }
    var expr = balanced("(", ")", value.substr(varIndex));
    if (!expr) {
        return value;
    }
    var match = expr.body.match(cssVariableExpression);
    return match ? match[1] : value;
}
/**
 * Checks whether the given node is a parent of the other descendant node.
 * This utility is helpful when the parent might be an SVG element,
 * which doesn't have a native `contains` implementation on some browsers like IE11.
 * @param parent Parent node
 * @param descendant Node that is checked to be a descendant of the parent node
 */ function nodeContains(parent, descendant) {
    if (!parent || !descendant) {
        return false;
    }
    // Use the native `contains` method when available
    if (parent.contains && descendant.nodeType === Node.ELEMENT_NODE) {
        return parent === descendant || parent.contains(descendant);
    }
    // Fall back to a simple upwards tree traversal
    var upperNode = descendant;
    while(upperNode && parent !== upperNode){
        upperNode = upperNode.parentNode;
    }
    return upperNode === parent;
}
/**
 * Checks whether the given node is a descendant of a container.
 * @param container Container node
 * @param node Node that is checked to be a descendant of the container
 */ function containsOrEqual(container, node) {
    if (container === null) {
        return false;
    }
    return container === node || container.contains(node);
} //# sourceMappingURL=dom.js.map


/***/ }),

/***/ 6464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ getExternalProps; }
/* harmony export */ });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Method to filter out internal properties prefixed by "__"
 */ var getExternalProps = function(props) {
    var externalPropNames = Object.keys(props).filter(function(propName) {
        return propName.indexOf("__") !== 0;
    });
    return externalPropNames.reduce(function(acc, propName) {
        acc[propName] = props[propName];
        return acc;
    }, {});
}; //# sourceMappingURL=external-props.js.map


/***/ }),

/***/ 764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Et": function() { return /* binding */ getOverflowParents; },
/* harmony export */   "YA": function() { return /* binding */ getOverflowParentDimensions; },
/* harmony export */   "bx": function() { return /* binding */ scrollElementIntoView; }
/* harmony export */ });
var getOverflowParents = function(element) {
    var parents = [];
    var node = element;
    while((node = node.parentElement) && node !== document.body){
        getComputedStyle(node).overflow !== "visible" && parents.push(node);
    }
    return parents;
};
var getOverflowParentDimensions = function(element, excludeClosestParent, expandToViewport, canExpandOutsideViewport) {
    if (excludeClosestParent === void 0) {
        excludeClosestParent = false;
    }
    if (expandToViewport === void 0) {
        expandToViewport = false;
    }
    if (canExpandOutsideViewport === void 0) {
        canExpandOutsideViewport = false;
    }
    var parents = expandToViewport ? [] : getOverflowParents(element).map(function(el) {
        var _a = el.getBoundingClientRect(), height = _a.height, width = _a.width, top = _a.top, left = _a.left;
        return {
            // Treat the whole scrollable area as the available height
            // if we're allowed to expand past the viewport.
            height: canExpandOutsideViewport ? el.scrollHeight : height,
            width: width,
            top: top,
            left: left
        };
    });
    if (canExpandOutsideViewport && !expandToViewport) {
        var documentDimensions = document.documentElement.getBoundingClientRect();
        parents.push({
            width: Math.max(documentDimensions.width, document.documentElement.clientWidth),
            height: Math.max(documentDimensions.height, document.documentElement.clientHeight),
            top: documentDimensions.top,
            left: documentDimensions.left
        });
    } else {
        parents.push({
            height: window.innerHeight,
            width: window.innerWidth,
            top: 0,
            left: 0
        });
    }
    if (excludeClosestParent && !expandToViewport) {
        parents.shift();
    }
    return parents;
};
/**
 * Calls `scrollIntoView` on the provided element with sensible defaults. If
 * the element does not existed or does not support the `scrollIntoView`
 * method, it will do nothing. This wrapper is created to support environments
 * where the native function is not available like JSDom (feature request:
 * https://github.com/jsdom/jsdom/issues/1422).
 *
 * @param element to be scrolled into view
 * @param options native options for `scrollIntoView`
 */ function scrollElementIntoView(element, options) {
    var _a;
    if (options === void 0) {
        options = {
            block: "nearest",
            inline: "nearest"
        };
    }
    (_a = element === null || element === void 0 ? void 0 : element.scrollIntoView) === null || _a === void 0 ? void 0 : _a.call(element, options);
} //# sourceMappingURL=scrollable-containers.js.map


/***/ }),

/***/ 4906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ joinStrings; }
/* harmony export */ });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Joins strings with a whitespace, discarding empty strings. Useful to combine multiple aria-labels.
 */ function joinStrings() {
    var strings = [];
    for(var _i = 0; _i < arguments.length; _i++){
        strings[_i] = arguments[_i];
    }
    return strings.filter(Boolean).join(" ") || undefined;
} //# sourceMappingURL=join-strings.js.map


/***/ }),

/***/ 1902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _internal_hooks_use_base_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4656);
/* harmony import */ var _internal_utils_apply_display_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1651);
/* harmony import */ var _internal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8791);

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




var Link = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function(_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? "secondary" : _b, _c = _a.fontSize, fontSize = _c === void 0 ? "body-m" : _c, _d = _a.color, color = _d === void 0 ? "normal" : _d, _e = _a.external, external = _e === void 0 ? false : _e, props = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(_a, [
        "variant",
        "fontSize",
        "color",
        "external"
    ]);
    var baseComponentProps = (0,_internal_hooks_use_base_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("Link");
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({
        variant: variant,
        fontSize: fontSize,
        color: color,
        external: external
    }, props, baseComponentProps, {
        ref: ref
    }));
});
(0,_internal_utils_apply_display_name__WEBPACK_IMPORTED_MODULE_4__/* .applyDisplayName */ .b)(Link, "Link");
/* harmony default export */ __webpack_exports__["Z"] = (Link); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 8791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ link_internal; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/icon/internal.js + 2 modules
var internal = __webpack_require__(776);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/link/styles.scoped.css
var styles_scoped = __webpack_require__(7808);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/link/styles.css.js

/* harmony default export */ var styles_css = ({
    "link": "awsui_link_4c84z_1c30c_93",
    "variant-secondary": "awsui_variant-secondary_4c84z_1c30c_138",
    "variant-primary": "awsui_variant-primary_4c84z_1c30c_173",
    "variant-info": "awsui_variant-info_4c84z_1c30c_208",
    "variant-value-large": "awsui_variant-value-large_4c84z_1c30c_243",
    "variant-top-navigation": "awsui_variant-top-navigation_4c84z_1c30c_277",
    "variant-recovery": "awsui_variant-recovery_4c84z_1c30c_312",
    "button": "awsui_button_4c84z_1c30c_347",
    "color-inverted": "awsui_color-inverted_4c84z_1c30c_382",
    "font-size-body-s": "awsui_font-size-body-s_4c84z_1c30c_401",
    "font-size-body-m": "awsui_font-size-body-m_4c84z_1c30c_406",
    "font-size-heading-xs": "awsui_font-size-heading-xs_4c84z_1c30c_410",
    "font-size-heading-s": "awsui_font-size-heading-s_4c84z_1c30c_414",
    "font-size-heading-m": "awsui_font-size-heading-m_4c84z_1c30c_419",
    "font-size-heading-l": "awsui_font-size-heading-l_4c84z_1c30c_424",
    "font-size-heading-xl": "awsui_font-size-heading-xl_4c84z_1c30c_429",
    "font-size-display-l": "awsui_font-size-display-l_4c84z_1c30c_434",
    "font-size-inherit": "awsui_font-size-inherit_4c84z_1c30c_439",
    "icon-wrapper": "awsui_icon-wrapper_4c84z_1c30c_445",
    "icon": "awsui_icon_4c84z_1c30c_445"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/focus-visible/index.js
var focus_visible = __webpack_require__(9297);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/events/index.js
var events = __webpack_require__(6322);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/forward-focus/index.js
var forward_focus = __webpack_require__(9283);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/keycode.js
var keycode = __webpack_require__(6221);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-merge-refs/index.js
var use_merge_refs = __webpack_require__(5912);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-visual-mode/index.js
var use_visual_mode = __webpack_require__(753);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/check-safe-url.js
var check_safe_url = __webpack_require__(2903);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/link/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0












var InternalLink = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? "secondary" : _b, _c = _a.fontSize, fontSize = _c === void 0 ? "body-m" : _c, _d = _a.color, color = _d === void 0 ? "normal" : _d, _e = _a.external, external = _e === void 0 ? false : _e, target = _a.target, href = _a.href, rel = _a.rel, ariaLabel = _a.ariaLabel, externalIconAriaLabel = _a.externalIconAriaLabel, onFollow = _a.onFollow, children = _a.children, _f = _a.__internalRootRef, __internalRootRef = _f === void 0 ? null : _f, props = (0,tslib_es6/* __rest */._T)(_a, [
        "variant",
        "fontSize",
        "color",
        "external",
        "target",
        "href",
        "rel",
        "ariaLabel",
        "externalIconAriaLabel",
        "onFollow",
        "children",
        "__internalRootRef"
    ]);
    (0,check_safe_url/* checkSafeUrl */.J)("Link", href);
    var isButton = !href;
    var specialStyles = [
        "top-navigation",
        "link",
        "recovery"
    ];
    var hasSpecialStyle = specialStyles.indexOf(variant) > -1;
    var focusVisible = (0,focus_visible/* default */.Z)();
    var baseProps = (0,base_component/* getBaseProps */.j)(props);
    var anchorTarget = target !== null && target !== void 0 ? target : external ? "_blank" : undefined;
    var anchorRel = rel !== null && rel !== void 0 ? rel : anchorTarget === "_blank" ? "noopener noreferrer" : undefined;
    var fireFollowEvent = function(event) {
        (0,events/* fireCancelableEvent */.y1)(onFollow, {
            href: href,
            external: external,
            target: anchorTarget
        }, event);
    };
    var handleLinkClick = function(event) {
        if ((0,events/* isPlainLeftClick */.p_)(event)) {
            fireFollowEvent(event);
        }
    };
    var handleButtonClick = function(event) {
        fireFollowEvent(event);
    };
    var handleButtonKeyDown = function(event) {
        if (event.keyCode === keycode/* KeyCode.space */.V.space || event.keyCode === keycode/* KeyCode.enter */.V.enter) {
            event.preventDefault();
            fireFollowEvent(event);
        }
    };
    var linkRef = (0,react.useRef)(null);
    var isVisualRefresh = (0,use_visual_mode/* useVisualRefresh */.LV)();
    (0,forward_focus/* default */.Z)(ref, linkRef);
    // Visual refresh should only add styles to buttons that don't already have unique styles (e.g. primary/secondary variants)
    var applyButtonStyles = isButton && isVisualRefresh && !hasSpecialStyle;
    var sharedProps = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, focusVisible), baseProps), {
        // https://github.com/microsoft/TypeScript/issues/36659
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ref: (0,use_merge_refs/* useMergeRefs */.q)(linkRef, __internalRootRef),
        className: (0,clsx_m/* default */.Z)(styles_css.link, baseProps.className, applyButtonStyles ? styles_css.button : null, styles_css[getVariantStyle(variant)], styles_css[getFontSizeStyle(variant, fontSize)], styles_css[getColorStyle(variant, color)]),
        "aria-label": ariaLabel
    });
    var content = /*#__PURE__*/ react.createElement(react.Fragment, null, children, external && /*#__PURE__*/ react.createElement("span", {
        className: styles_css["icon-wrapper"]
    }, "\xa0", /*#__PURE__*/ react.createElement("span", {
        className: styles_css.icon,
        "aria-label": externalIconAriaLabel,
        role: externalIconAriaLabel ? "img" : undefined
    }, /*#__PURE__*/ react.createElement(internal/* default */.Z, {
        name: "external",
        size: "inherit"
    }))));
    if (isButton) {
        return /*#__PURE__*/ react.createElement("a", (0,tslib_es6/* __assign */.pi)({}, sharedProps, {
            role: "button",
            tabIndex: 0,
            onKeyDown: handleButtonKeyDown,
            onClick: handleButtonClick
        }), content);
    }
    return(// eslint-disable-next-line react/jsx-no-target-blank
    /*#__PURE__*/ react.createElement("a", (0,tslib_es6/* __assign */.pi)({}, sharedProps, {
        target: anchorTarget,
        rel: anchorRel,
        href: href,
        onClick: handleLinkClick
    }), content));
});
function getVariantStyle(variant) {
    return "variant-".concat(variant.replace(/^awsui-/, ""));
}
function getFontSizeStyle(variant, fontSize) {
    switch(variant){
        case "info":
            return "font-size-body-s";
        case "awsui-value-large":
            return "font-size-display-l";
        default:
            return "font-size-".concat(fontSize);
    }
}
function getColorStyle(variant, color) {
    return "color-".concat(variant === "info" ? "normal" : color);
}
/* harmony default export */ var link_internal = (InternalLink); //# sourceMappingURL=internal.js.map


/***/ }),

/***/ 9820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PopoverBody; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/keycode.js
var keycode = __webpack_require__(6221);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-unique-id/index.js
var use_unique_id = __webpack_require__(6081);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/button/internal.js + 6 modules
var internal = __webpack_require__(8145);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/tab-trap/index.js
var tab_trap = __webpack_require__(8605);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/focus-lock/utils.js
var utils = __webpack_require__(5500);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/focus-lock/index.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



function FocusLock(_a) {
    var className = _a.className, disabled = _a.disabled, autoFocus = _a.autoFocus, children = _a.children;
    var containerRef = (0,react.useRef)(null);
    var focusFirst = function() {
        var _a;
        if (containerRef.current) {
            (_a = (0,utils/* getFirstFocusable */.ft)(containerRef.current)) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    var focusLast = function() {
        var _a;
        if (containerRef.current) {
            (_a = (0,utils/* getLastFocusable */.TE)(containerRef.current)) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    (0,react.useEffect)(function() {
        if (autoFocus) {
            focusFirst();
        }
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(tab_trap/* default */.Z, {
        disabled: disabled,
        focusNextCallback: focusLast
    }), /*#__PURE__*/ react.createElement("div", {
        className: className,
        ref: containerRef
    }, children), /*#__PURE__*/ react.createElement(tab_trap/* default */.Z, {
        disabled: disabled,
        focusNextCallback: focusFirst
    }));
} //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/popover/styles.css.js
var styles_css = __webpack_require__(2577);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/popover/body.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0







function PopoverBody(_a) {
    var _b, _c;
    var showDismissButton = _a.dismissButton, dismissAriaLabel = _a.dismissAriaLabel, header = _a.header, children = _a.children, onDismiss = _a.onDismiss, variant = _a.variant, overflowVisible = _a.overflowVisible, className = _a.className, ariaLabelledby = _a.ariaLabelledby;
    var labelledById = (0,use_unique_id/* useUniqueId */.L)("awsui-popover-");
    var dismissButtonFocused = (0,react.useRef)(false);
    var dismissButtonRef = (0,react.useRef)(null);
    var onKeyDown = (0,react.useCallback)(function(event) {
        if (event.keyCode === keycode/* KeyCode.escape */.V.escape) {
            onDismiss();
        }
    }, [
        onDismiss
    ]);
    // Implement our own auto-focus rather than using FocusLock's,
    // because we also want to focus the dismiss button when it
    // is added dyamically (e.g. in chart popovers)
    (0,react.useEffect)(function() {
        var _a;
        if (showDismissButton && !dismissButtonFocused.current) {
            (_a = dismissButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus({
                preventScroll: true
            });
        }
        dismissButtonFocused.current = showDismissButton;
    }, [
        showDismissButton
    ]);
    var dismissButton = (showDismissButton !== null && showDismissButton !== void 0 ? showDismissButton : null) && /*#__PURE__*/ react.createElement("div", {
        className: styles_css/* default.dismiss */.Z.dismiss
    }, /*#__PURE__*/ react.createElement(internal/* InternalButton */.l, {
        variant: "icon",
        formAction: "none",
        iconName: "close",
        className: styles_css/* default.dismiss-control */.Z["dismiss-control"],
        ariaLabel: dismissAriaLabel,
        onClick: function() {
            return onDismiss();
        },
        ref: dismissButtonRef
    }));
    return /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(styles_css/* default.body */.Z.body, className, (_b = {}, _b[styles_css/* default.body-overflow-visible */.Z["body-overflow-visible"]] = overflowVisible === "both", _b)),
        role: header ? "dialog" : undefined,
        onKeyDown: onKeyDown,
        "aria-modal": showDismissButton && variant !== "annotation" ? true : undefined,
        "aria-labelledby": ariaLabelledby !== null && ariaLabelledby !== void 0 ? ariaLabelledby : header ? labelledById : undefined
    }, /*#__PURE__*/ react.createElement(FocusLock, {
        disabled: variant === "annotation" || !showDismissButton,
        autoFocus: false
    }, header && /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(styles_css/* default.header-row */.Z["header-row"], showDismissButton && styles_css/* default.has-dismiss */.Z["has-dismiss"])
    }, dismissButton, /*#__PURE__*/ react.createElement("div", {
        className: styles_css/* default.header */.Z.header,
        id: labelledById
    }, /*#__PURE__*/ react.createElement("h2", null, header))), /*#__PURE__*/ react.createElement("div", {
        className: !header && showDismissButton ? styles_css/* default.has-dismiss */.Z["has-dismiss"] : undefined
    }, !header && dismissButton, /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(styles_css/* default.content */.Z.content, (_c = {}, _c[styles_css/* default.content-overflow-visible */.Z["content-overflow-visible"]] = !!overflowVisible, _c))
    }, children))));
} //# sourceMappingURL=body.js.map


/***/ }),

/***/ 2072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PopoverContainer; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/dom.js
var dom = __webpack_require__(5839);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/container-queries/use-resize-observer.js
var use_resize_observer = __webpack_require__(913);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/popover/utils/positions.js
var ARROW_OFFSET = 12;
var PRIORITY_MAPPING = {
    top: [
        "top-center",
        "top-right",
        "top-left",
        "bottom-center",
        "bottom-right",
        "bottom-left",
        "right-top",
        "right-bottom",
        "left-top",
        "left-bottom"
    ],
    bottom: [
        "bottom-center",
        "bottom-right",
        "bottom-left",
        "top-center",
        "top-right",
        "top-left",
        "right-top",
        "right-bottom",
        "left-top",
        "left-bottom"
    ],
    left: [
        "left-top",
        "left-bottom",
        "right-top",
        "right-bottom",
        "bottom-center",
        "top-center",
        "bottom-left",
        "top-left",
        "bottom-right",
        "top-right"
    ],
    right: [
        "right-top",
        "right-bottom",
        "left-top",
        "left-bottom",
        "bottom-center",
        "top-center",
        "bottom-right",
        "top-right",
        "bottom-left",
        "top-left"
    ]
};
var RECTANGLE_CALCULATIONS = {
    "top-center": function(_a) {
        var body = _a.body, trigger = _a.trigger, arrow = _a.arrow;
        return {
            top: trigger.top - body.height - arrow.height,
            left: trigger.left + trigger.width / 2 - body.width / 2,
            width: body.width,
            height: body.height
        };
    },
    "top-right": function(_a) {
        var body = _a.body, trigger = _a.trigger, arrow = _a.arrow;
        return {
            top: trigger.top - body.height - arrow.height,
            left: trigger.left,
            width: body.width,
            height: body.height
        };
    },
    "top-left": function(_a) {
        var body = _a.body, trigger = _a.trigger, arrow = _a.arrow;
        return {
            top: trigger.top - body.height - arrow.height,
            left: trigger.left + trigger.width - body.width,
            width: body.width,
            height: body.height
        };
    },
    "bottom-center": function(_a) {
        var body = _a.body, trigger = _a.trigger, arrow = _a.arrow;
        return {
            top: trigger.top + trigger.height + arrow.height,
            left: trigger.left + trigger.width / 2 - body.width / 2,
            width: body.width,
            height: body.height
        };
    },
    "bottom-right": function(_a) {
        var body = _a.body, trigger = _a.trigger, arrow = _a.arrow;
        return {
            top: trigger.top + trigger.height + arrow.height,
            left: trigger.left,
            width: body.width,
            height: body.height
        };
    },
    "bottom-left": function(_a) {
        var body = _a.body, trigger = _a.trigger, arrow = _a.arrow;
        return {
            top: trigger.top + trigger.height + arrow.height,
            left: trigger.left + trigger.width - body.width,
            width: body.width,
            height: body.height
        };
    },
    "right-top": function(_a) {
        var body = _a.body, trigger = _a.trigger, arrow = _a.arrow;
        return {
            top: trigger.top + trigger.height / 2 - ARROW_OFFSET - arrow.height,
            left: trigger.left + trigger.width + arrow.height,
            width: body.width,
            height: body.height
        };
    },
    "right-bottom": function(_a) {
        var body = _a.body, trigger = _a.trigger, arrow = _a.arrow;
        return {
            top: trigger.top + trigger.height / 2 - body.height + ARROW_OFFSET + arrow.height,
            left: trigger.left + trigger.width + arrow.height,
            width: body.width,
            height: body.height
        };
    },
    "left-top": function(_a) {
        var body = _a.body, trigger = _a.trigger, arrow = _a.arrow;
        return {
            top: trigger.top + trigger.height / 2 - ARROW_OFFSET - arrow.height,
            left: trigger.left - body.width - arrow.height,
            width: body.width,
            height: body.height
        };
    },
    "left-bottom": function(_a) {
        var body = _a.body, trigger = _a.trigger, arrow = _a.arrow;
        return {
            top: trigger.top + trigger.height / 2 - body.height + ARROW_OFFSET + arrow.height,
            left: trigger.left - body.width - arrow.height,
            width: body.width,
            height: body.height
        };
    }
};
/**
 * Returns whether one rectangle fits in another.
 */ function canRectFit(inner, outer) {
    return inner.left >= outer.left && inner.top >= outer.top && inner.left + inner.width <= outer.left + outer.width && inner.top + inner.height <= outer.top + outer.height;
}
function fitIntoContainer(inner, outer) {
    var left = inner.left, width = inner.width, top = inner.top, height = inner.height;
    // Adjust left boundary.
    if (left < outer.left) {
        width = left + width - outer.left;
        left = outer.left;
    } else if (left + width > outer.left + outer.width) {
        width = outer.left + outer.width - left;
    }
    // Adjust top boundary.
    if (top < outer.top) {
        height = top + height - outer.top;
        top = outer.top;
    } else if (top + height > outer.top + outer.height) {
        height = outer.top + outer.height - top;
    }
    return {
        left: left,
        width: width,
        top: top,
        height: height
    };
}
function getLargestRect(rect1, rect2) {
    var area1 = rect1.height * rect1.width;
    var area2 = rect2.height * rect2.width;
    return area1 >= area2 ? rect1 : rect2;
}
/**
 * Returns the area of the intersection of passed in rectangles or a null, if there is no intersection
 */ function intersectRectangles(rectangles) {
    var boundingOffset = null;
    for(var _i = 0, rectangles_1 = rectangles; _i < rectangles_1.length; _i++){
        var currentRect = rectangles_1[_i];
        if (!boundingOffset) {
            boundingOffset = currentRect;
            continue;
        }
        var left = Math.max(boundingOffset.left, currentRect.left);
        var top_1 = Math.max(boundingOffset.top, currentRect.top);
        var right = Math.min(boundingOffset.left + boundingOffset.width, currentRect.left + currentRect.width);
        var bottom = Math.min(boundingOffset.top + boundingOffset.height, currentRect.top + currentRect.height);
        if (right < left || bottom < top_1) {
            return null;
        }
        boundingOffset = {
            left: left,
            top: top_1,
            width: right - left,
            height: bottom - top_1
        };
    }
    return boundingOffset && boundingOffset.height * boundingOffset.width;
}
/**
 * A functions that returns the correct popover position based on screen dimensions.
 */ function calculatePosition(preferred, trigger, arrow, body, container, viewport, renderWithPortal) {
    var bestPositionOutsideViewport = null;
    var largestArea = 0;
    // Attempt to position the popover based on the priority list for this position,
    // trying to fit it inside the container and inside the viewport.
    for(var _i = 0, _a = PRIORITY_MAPPING[preferred]; _i < _a.length; _i++){
        var internalPosition_1 = _a[_i];
        var boundingOffset = RECTANGLE_CALCULATIONS[internalPosition_1]({
            body: body,
            trigger: trigger,
            arrow: arrow
        });
        var fitsInContainer = renderWithPortal || canRectFit(boundingOffset, container);
        var fitsInViewport = canRectFit(boundingOffset, viewport);
        if (fitsInContainer && fitsInViewport) {
            return {
                internalPosition: internalPosition_1,
                boundingOffset: boundingOffset
            };
        }
        var boundingRectangles = [
            boundingOffset,
            viewport
        ];
        if (!renderWithPortal) {
            boundingRectangles.push(container);
        }
        var availableArea = intersectRectangles(boundingRectangles);
        if (availableArea && availableArea > largestArea) {
            bestPositionOutsideViewport = {
                internalPosition: internalPosition_1,
                boundingOffset: boundingOffset
            };
            largestArea = availableArea;
        }
    }
    // Use best possible placement.
    var internalPosition = (bestPositionOutsideViewport === null || bestPositionOutsideViewport === void 0 ? void 0 : bestPositionOutsideViewport.internalPosition) || "right-top";
    // Get default rect for that placement.
    var defaultOffset = RECTANGLE_CALCULATIONS[internalPosition]({
        body: body,
        trigger: trigger,
        arrow: arrow
    });
    // Get largest possible rect that fits into viewport or container.
    var optimisedOffset = fitIntoContainer(defaultOffset, renderWithPortal ? viewport : getLargestRect(container, viewport));
    // If largest possible rect is smaller than original - set body scroll.
    var scrollable = optimisedOffset.height < defaultOffset.height;
    return {
        internalPosition: internalPosition,
        boundingOffset: optimisedOffset,
        scrollable: scrollable
    };
} //# sourceMappingURL=positions.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/popover/styles.css.js
var styles_css = __webpack_require__(2577);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-visual-mode/index.js
var use_visual_mode = __webpack_require__(753);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/popover/container.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0







var INITIAL_STYLES = {
    position: "absolute",
    top: -9999,
    left: -9999
};
function PopoverContainer(_a) {
    var _b;
    var position = _a.position, trackRef = _a.trackRef, trackKey = _a.trackKey, arrow = _a.arrow, children = _a.children, zIndex = _a.zIndex, renderWithPortal = _a.renderWithPortal, size = _a.size, fixedWidth = _a.fixedWidth, variant = _a.variant;
    var bodyRef = (0,react.useRef)(null);
    var contentRef = (0,react.useRef)(null);
    var popoverRef = (0,react.useRef)(null);
    var arrowRef = (0,react.useRef)(null);
    var _c = (0,react.useState)(INITIAL_STYLES), popoverStyle = _c[0], setPopoverStyle = _c[1];
    var _d = (0,react.useState)(null), internalPosition = _d[0], setInternalPosition = _d[1];
    var isRefresh = (0,use_visual_mode/* useVisualRefresh */.LV)();
    // Store the handler in a ref so that it can still be replaced from outside of the listener closure.
    var positionHandlerRef = (0,react.useRef)(function() {});
    // Updates the position handler.
    var updatePositionHandler = (0,react.useCallback)(function() {
        if (!trackRef.current || !popoverRef.current || !bodyRef.current || !contentRef.current || !arrowRef.current) {
            return;
        }
        // Get important elements
        var popover = popoverRef.current;
        var body = bodyRef.current;
        var arrow = arrowRef.current;
        var document = popover.ownerDocument;
        var track = trackRef.current;
        // If the popover body isn't being rendered for whatever reason (e.g. "display: none" or JSDOM),
        // or track does not belong to the document - bail on calculating dimensions.
        if (popover.offsetWidth === 0 || popover.offsetHeight === 0 || !(0,dom/* nodeContains */.bE)(document.body, track)) {
            return;
        }
        // Imperatively move body off-screen to give it room to expand.
        // Not doing this in React because this recalculation should happen
        // in the span of a single frame without rerendering anything.
        var prevTop = popover.style.top;
        var prevLeft = popover.style.left;
        popover.style.top = "0";
        popover.style.left = "0";
        // Imperatively remove body styles that can remain from the previous computation.
        body.style.maxHeight = "";
        body.style.overflowX = "";
        body.style.overflowY = "";
        // Get rects representing key elements
        // Use getComputedStyle for arrowRect to avoid modifications made by transform
        var viewportRect = getViewportRect(document.defaultView);
        var trackRect = track.getBoundingClientRect();
        var arrowRect = {
            width: parseFloat(getComputedStyle(arrow).width),
            height: parseFloat(getComputedStyle(arrow).height)
        };
        var containingBlock = (0,dom/* getContainingBlock */.gQ)(popover);
        var containingBlockRect = containingBlock ? containingBlock.getBoundingClientRect() : viewportRect;
        var bodyBorderWidth = getBorderWidth(body);
        var contentRect = contentRef.current.getBoundingClientRect();
        var contentBoundingBox = {
            width: contentRect.width + 2 * bodyBorderWidth,
            height: contentRect.height + 2 * bodyBorderWidth
        };
        // Calculate the arrow direction and viewport-relative position of the popover.
        var _a = calculatePosition(position, trackRect, arrowRect, contentBoundingBox, containingBlock ? containingBlockRect : getDocumentRect(document), viewportRect, renderWithPortal), scrollable = _a.scrollable, newInternalPosition = _a.internalPosition, boundingOffset = _a.boundingOffset;
        // Get the position of the popover relative to the offset parent.
        var popoverOffset = toRelativePosition(boundingOffset, containingBlockRect);
        // Cache the distance between the trigger and the popover (which stays the same as you scroll),
        // and use that to recalculate the new popover position.
        var trackRelativeOffset = toRelativePosition(popoverOffset, toRelativePosition(trackRect, containingBlockRect));
        // Bring back the container to its original position to prevent any flashing.
        popover.style.top = prevTop;
        popover.style.left = prevLeft;
        // Allow popover body to scroll if can't fit the popover into the container/viewport otherwise.
        if (scrollable) {
            body.style.maxHeight = boundingOffset.height + "px";
            body.style.overflowX = "hidden";
            body.style.overflowY = "auto";
        }
        // Position the popover
        setInternalPosition(newInternalPosition);
        setPopoverStyle({
            top: popoverOffset.top,
            left: popoverOffset.left
        });
        positionHandlerRef.current = function() {
            var newTrackOffset = toRelativePosition(track.getBoundingClientRect(), containingBlock ? containingBlock.getBoundingClientRect() : viewportRect);
            setPopoverStyle({
                top: newTrackOffset.top + trackRelativeOffset.top,
                left: newTrackOffset.left + trackRelativeOffset.left
            });
        };
    }, [
        position,
        trackRef,
        renderWithPortal
    ]);
    // Recalculate position when properties change.
    (0,react.useLayoutEffect)(function() {
        updatePositionHandler();
    }, [
        updatePositionHandler,
        trackKey
    ]);
    // Recalculate position when content size changes.
    (0,use_resize_observer/* useResizeObserver */.y)(contentRef, function() {
        return updatePositionHandler();
    });
    // Recalculate position on DOM events.
    (0,react.useLayoutEffect)(function() {
        /*
          This is a heuristic. Some layout changes are caused by user clicks (e.g. toggling the tools panel, submitting a form),
          and by tracking the click event we can adapt the popover's position to the new layout.
    
          TODO: extend this to Enter and Spacebar?
        */ var updatePosition = function() {
            return requestAnimationFrame(function() {
                return updatePositionHandler();
            });
        };
        var refreshPosition = function() {
            return requestAnimationFrame(function() {
                return positionHandlerRef.current();
            });
        };
        window.addEventListener("click", updatePosition);
        window.addEventListener("resize", updatePosition);
        window.addEventListener("scroll", refreshPosition, true);
        return function() {
            window.removeEventListener("click", updatePosition);
            window.removeEventListener("resize", updatePosition);
            window.removeEventListener("scroll", refreshPosition, true);
        };
    }, [
        updatePositionHandler
    ]);
    return /*#__PURE__*/ react.createElement("div", {
        ref: popoverRef,
        style: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, popoverStyle), {
            zIndex: zIndex
        }),
        className: (0,clsx_m/* default */.Z)(styles_css/* default.container */.Z.container, isRefresh && styles_css/* default.refresh */.Z.refresh)
    }, /*#__PURE__*/ react.createElement("div", {
        ref: arrowRef,
        className: (0,clsx_m/* default */.Z)(styles_css/* default.container-arrow */.Z["container-arrow"], styles_css/* default */.Z["container-arrow-position-".concat(internalPosition)]),
        "aria-hidden": true
    }, arrow(internalPosition)), /*#__PURE__*/ react.createElement("div", {
        ref: bodyRef,
        className: (0,clsx_m/* default */.Z)(styles_css/* default.container-body */.Z["container-body"], styles_css/* default */.Z["container-body-size-".concat(size)], (_b = {}, _b[styles_css/* default.fixed-width */.Z["fixed-width"]] = fixedWidth, _b[styles_css/* default */.Z["container-body-variant-".concat(variant)]] = variant, _b))
    }, /*#__PURE__*/ react.createElement("div", {
        ref: contentRef
    }, children)));
}
function getBorderWidth(element) {
    return parseInt(getComputedStyle(element).borderWidth) || 0;
}
/**
 * Convert a viewport-relative offset to an element-relative offset.
 */ function toRelativePosition(element, parent) {
    return {
        top: element.top - parent.top,
        left: element.left - parent.left
    };
}
/**
 * Get a BoundingOffset that represents the visible viewport.
 */ function getViewportRect(window1) {
    return {
        top: 0,
        left: 0,
        width: window1.innerWidth,
        height: window1.innerHeight
    };
}
function getDocumentRect(document) {
    var _a = document.documentElement.getBoundingClientRect(), top = _a.top, left = _a.left;
    return {
        top: top,
        left: left,
        width: document.documentElement.scrollWidth,
        height: document.documentElement.scrollHeight
    };
} //# sourceMappingURL=container.js.map


/***/ }),

/***/ 2577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _styles_scoped_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4245);
/* harmony import */ var _styles_scoped_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_styles_scoped_css__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    "arrow": "awsui_arrow_xjuzf_10pru_185",
    "arrow-outer": "awsui_arrow-outer_xjuzf_10pru_189",
    "arrow-inner": "awsui_arrow-inner_xjuzf_10pru_189",
    "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_10pru_220",
    "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_10pru_220",
    "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_10pru_223",
    "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_10pru_223",
    "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_10pru_226",
    "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_10pru_226",
    "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_10pru_226",
    "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_10pru_226",
    "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_10pru_229",
    "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_10pru_229",
    "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_10pru_229",
    "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_10pru_229",
    "body": "awsui_body_xjuzf_10pru_325",
    "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_10pru_339",
    "has-dismiss": "awsui_has-dismiss_xjuzf_10pru_343",
    "dismiss": "awsui_dismiss_xjuzf_10pru_348",
    "dismiss-control": "awsui_dismiss-control_xjuzf_10pru_355",
    "header-row": "awsui_header-row_xjuzf_10pru_359",
    "header": "awsui_header_xjuzf_10pru_359",
    "content": "awsui_content_xjuzf_10pru_381",
    "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_10pru_388",
    "container": "awsui_container_xjuzf_10pru_484",
    "container-body": "awsui_container-body_xjuzf_10pru_492",
    "container-body-variant-annotation": "awsui_container-body-variant-annotation_xjuzf_10pru_507",
    "container-body-size-small": "awsui_container-body-size-small_xjuzf_10pru_512",
    "fixed-width": "awsui_fixed-width_xjuzf_10pru_515",
    "container-body-size-medium": "awsui_container-body-size-medium_xjuzf_10pru_519",
    "container-body-size-large": "awsui_container-body-size-large_xjuzf_10pru_526",
    "container-arrow": "awsui_container-arrow_xjuzf_10pru_538",
    "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_10pru_542",
    "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_10pru_542",
    "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_10pru_554",
    "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_10pru_554",
    "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_10pru_566",
    "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_10pru_566",
    "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_10pru_566",
    "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_10pru_566",
    "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_10pru_582",
    "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_10pru_586",
    "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_10pru_590",
    "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_10pru_1",
    "refresh": "awsui_refresh_xjuzf_10pru_708",
    "root": "awsui_root_xjuzf_10pru_730",
    "trigger": "awsui_trigger_xjuzf_10pru_743",
    "trigger-type-text": "awsui_trigger-type-text_xjuzf_10pru_750",
    "trigger-inner-text": "awsui_trigger-inner-text_xjuzf_10pru_779",
    "popover-content": "awsui_popover-content_xjuzf_10pru_783"
});


/***/ }),

/***/ 1456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SpaceBetween; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/apply-display-name.js
var apply_display_name = __webpack_require__(1651);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/space-between/styles.scoped.css
var styles_scoped = __webpack_require__(4722);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/space-between/styles.css.js

/* harmony default export */ var styles_css = ({
    "root": "awsui_root_18582_66aol_93",
    "child": "awsui_child_18582_66aol_97",
    "horizontal": "awsui_horizontal_18582_66aol_108",
    "horizontal-xxxs": "awsui_horizontal-xxxs_18582_66aol_112",
    "horizontal-xxs": "awsui_horizontal-xxs_18582_66aol_116",
    "horizontal-xs": "awsui_horizontal-xs_18582_66aol_120",
    "horizontal-s": "awsui_horizontal-s_18582_66aol_124",
    "horizontal-m": "awsui_horizontal-m_18582_66aol_128",
    "horizontal-l": "awsui_horizontal-l_18582_66aol_132",
    "horizontal-xl": "awsui_horizontal-xl_18582_66aol_136",
    "horizontal-xxl": "awsui_horizontal-xxl_18582_66aol_140",
    "child-horizontal-xxxs": "awsui_child-horizontal-xxxs_18582_66aol_145",
    "child-horizontal-xxs": "awsui_child-horizontal-xxs_18582_66aol_151",
    "child-horizontal-xs": "awsui_child-horizontal-xs_18582_66aol_157",
    "child-horizontal-s": "awsui_child-horizontal-s_18582_66aol_163",
    "child-horizontal-m": "awsui_child-horizontal-m_18582_66aol_169",
    "child-horizontal-l": "awsui_child-horizontal-l_18582_66aol_175",
    "child-horizontal-xl": "awsui_child-horizontal-xl_18582_66aol_181",
    "child-horizontal-xxl": "awsui_child-horizontal-xxl_18582_66aol_187",
    "vertical": "awsui_vertical_18582_66aol_196",
    "child-vertical-xxxs": "awsui_child-vertical-xxxs_18582_66aol_200",
    "child-vertical-xxs": "awsui_child-vertical-xxs_18582_66aol_204",
    "child-vertical-xs": "awsui_child-vertical-xs_18582_66aol_208",
    "child-vertical-s": "awsui_child-vertical-s_18582_66aol_212",
    "child-vertical-m": "awsui_child-vertical-m_18582_66aol_216",
    "child-vertical-l": "awsui_child-vertical-l_18582_66aol_220",
    "child-vertical-xl": "awsui_child-vertical-xl_18582_66aol_224",
    "child-vertical-xxl": "awsui_child-vertical-xxl_18582_66aol_228"
});

// EXTERNAL MODULE: ./node_modules/react-keyed-flatten-children/index.js
var react_keyed_flatten_children = __webpack_require__(3262);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/space-between/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





function InternalSpaceBetween(_a) {
    var _b = _a.direction, direction = _b === void 0 ? "vertical" : _b, size = _a.size, children = _a.children, __internalRootRef = _a.__internalRootRef, props = (0,tslib_es6/* __rest */._T)(_a, [
        "direction",
        "size",
        "children",
        "__internalRootRef"
    ]);
    var baseProps = (0,base_component/* getBaseProps */.j)(props);
    /*
     Flattening the children allows us to "see through" React Fragments and nested arrays.
     */ var flattenedChildren = (0,react_keyed_flatten_children/* default */.Z)(children);
    return /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        className: (0,clsx_m/* default */.Z)(baseProps.className, styles_css.root, styles_css[direction], styles_css["".concat(direction, "-").concat(size)]),
        ref: __internalRootRef
    }), flattenedChildren.map(function(child) {
        // If this react child is a primitive value, the key will be undefined
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var key = child.key;
        return /*#__PURE__*/ react.createElement("div", {
            key: key,
            className: (0,clsx_m/* default */.Z)(styles_css.child, styles_css["child-".concat(direction, "-").concat(size)])
        }, child);
    }));
} //# sourceMappingURL=internal.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-base-component/index.js + 2 modules
var use_base_component = __webpack_require__(4656);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/space-between/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




function SpaceBetween(_a) {
    var _b = _a.direction, direction = _b === void 0 ? "vertical" : _b, props = (0,tslib_es6/* __rest */._T)(_a, [
        "direction"
    ]);
    var baseComponentProps = (0,use_base_component/* default */.Z)("SpaceBetween");
    return /*#__PURE__*/ react.createElement(InternalSpaceBetween, (0,tslib_es6/* __assign */.pi)({
        direction: direction
    }, props, baseComponentProps));
}
(0,apply_display_name/* applyDisplayName */.b)(SpaceBetween, "SpaceBetween"); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 1970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ InternalSpinner; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/spinner/styles.scoped.css
var styles_scoped = __webpack_require__(6666);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/spinner/styles.css.js

/* harmony default export */ var styles_css = ({
    "root": "awsui_root_1612d_9hw1o_127",
    "spinner-rotator": "awsui_spinner-rotator_1612d_9hw1o_1",
    "size-normal": "awsui_size-normal_1612d_9hw1o_135",
    "size-big": "awsui_size-big_1612d_9hw1o_143",
    "size-large": "awsui_size-large_1612d_9hw1o_151",
    "variant-normal": "awsui_variant-normal_1612d_9hw1o_159",
    "variant-disabled": "awsui_variant-disabled_1612d_9hw1o_162",
    "variant-inverted": "awsui_variant-inverted_1612d_9hw1o_165",
    "circle": "awsui_circle_1612d_9hw1o_169",
    "circle-left": "awsui_circle-left_1612d_9hw1o_193",
    "spinner-line-left": "awsui_spinner-line-left_1612d_9hw1o_1",
    "circle-right": "awsui_circle-right_1612d_9hw1o_198",
    "spinner-line-right": "awsui_spinner-line-right_1612d_9hw1o_1"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/spinner/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




function InternalSpinner(_a) {
    var _b = _a.size, size = _b === void 0 ? "normal" : _b, _c = _a.variant, variant = _c === void 0 ? "normal" : _c, __internalRootRef = _a.__internalRootRef, props = (0,tslib_es6/* __rest */._T)(_a, [
        "size",
        "variant",
        "__internalRootRef"
    ]);
    var baseProps = (0,base_component/* getBaseProps */.j)(props);
    return /*#__PURE__*/ react.createElement("span", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        className: (0,clsx_m/* default */.Z)(baseProps.className, styles_css.root, styles_css["size-".concat(size)], styles_css["variant-".concat(variant)]),
        ref: __internalRootRef
    }), /*#__PURE__*/ react.createElement("span", {
        className: (0,clsx_m/* default */.Z)(styles_css.circle, styles_css["circle-left"])
    }), /*#__PURE__*/ react.createElement("span", {
        className: (0,clsx_m/* default */.Z)(styles_css.circle, styles_css["circle-right"])
    }));
} //# sourceMappingURL=internal.js.map


/***/ }),

/***/ 1911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LV": function() { return /* binding */ getSplitPanelDefaultSize; },
/* harmony export */   "Zl": function() { return /* binding */ CONSTRAINED_PAGE_HEIGHT; },
/* harmony export */   "lX": function() { return /* binding */ CONSTRAINED_MAIN_PANEL_MIN_HEIGHT; },
/* harmony export */   "pV": function() { return /* binding */ MAIN_PANEL_MIN_HEIGHT; }
/* harmony export */ });
/* unused harmony export getLimitedValue */
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The page height where the page is considered constrained.
 */ var CONSTRAINED_PAGE_HEIGHT = 400;
/**
 * Based on approximate height of breadcrumb, table header, and the first table row
 */ var MAIN_PANEL_MIN_HEIGHT = 250;
/**
 * Based on approximate height of app bar on comfortable mode on mobile.
 */ var CONSTRAINED_MAIN_PANEL_MIN_HEIGHT = 40;
/**
 * Estimate a default split panel size for the first render based on the document size.
 */ function getSplitPanelDefaultSize(position) {
    if (typeof document === "undefined") {
        return 0; // render the split panel in its minimum possible size
    }
    return position === "side" ? document.documentElement.clientWidth / 3 : document.documentElement.clientHeight / 2;
}
function getLimitedValue(min, value, max) {
    if (min > max) {
        return min;
    }
    if (value < min) {
        return min;
    }
    if (value > max) {
        return max;
    }
    return value;
} //# sourceMappingURL=size-utils.js.map


/***/ }),

/***/ 6434:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 8922:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5038:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2672:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 1065:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 4496:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2177:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5735:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7644:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 3313:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7744:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 719:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6517:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6374:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5082:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 8998:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 8878:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2457:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6561:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2079:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2455:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9692:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6382:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 4544:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 895:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 604:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2426:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 705:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 1760:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7808:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 4200:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 4245:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 8559:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6931:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 4722:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6666:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 8003:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5405:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6589:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);